/* eslint-disable prettier */
/* eslint-disable max-len */
/**
 * ZH TR resource file
 */

import {
	ArcTimeLineValidationTypes,
	ArcTimelineGroups,
	Entity,
	GAComponentDocumentStatus,
	GALinkStatus,
	GARoleTypeId,
	TaskListTypes,
	actionTypes,
	activityType,
	assignmentTypes,
	bulkAssignment,
	bulkAssignmentConstants,
	clientRequestNoteTab,
	confidentialityTypes,
	filters,
	financialStatementType,
	gaRecommendationType,
	gaScopes,
	groupSummaryTabs,
	independenceActionIds,
	instructionStatus,
	instructionType,
	ipFilterType,
	ipInputType,
	linkType,
	milestoneBuildTaskIds,
	notesFilter,
	reviewNoteRoutes,
	rnhFilterTypeQuery,
	rnhQuickFilter,
	snapshotComparisonIds,
	syncStatus,
	todoListTimeframeOptions,
	trialBalanceType,
	uiViews,
	receiveInstructionSwitcherIds
} from "../util/uiconstants";

export const labels = {

	//Review notes tile 2

	reviewNoteTileGraphHeader: "Open review notes by due date",
	reviewNoteTileGraphHeaderAssignedToMe: "Open review notes assigned to me, by due date",
	reviewNoteTileGraphHeaderAuthoredByMe: 'Authored open notes, by due date',
	reviewNoteYAxisLabel: "Review notes",
	overDueCatFirst: "Overdue >90",
	overDueCatSecond: "Overdue 31-90",
	overDueCatThird: "Overdue 10-30",
	overDueCatFourth: "Overdue <10",
	catFifth: '<10',
	catSixth: '10-30',
	catSeventh: '31-90',
	catEighth: '>90',
	noNotesAvailable: "No notes available",


	//ReviewNoteTiles
	totalOpen: "Total open",
	totalCleared: "Total cleared",
	changeDueDate: "Change due date",
	reviewNoteHashValue: '#',

	//Rejected PSPs
	rejectedPSPsTitle: 'Rejected PSPs',
	noRejectedPSPs: 'No rejected PSPs',
	updateRejectedPSPs: 'Update rejected PSPs',


	//CRA Build Step 2 Labels
	inherentRiskTypeId: 'Inherent risk assessment',
	controlRiskTypeId: 'Control risk assessment',
	viewUnRelatedWCGWs: 'View unrelated WCGWs',
	unrelatedWCGWsInstruction: "The WCGWs listed below are not related to any assertions. They should be related to at least one assertion or deleted. To easily find these WCGWs in the 'Relate WCGWs to assertions' modal, select \'Unrelated WCGWs'\ from the SCOTs dropdown. If the WCGW is no longer relevant or needs to be edited, click the \'Identify WCGWs and controls'\ link on the underlying page to make those changes.",
	relatedWCGWsInstruction: "Relate WCGWs to the selected assertion. Select a SCOT to relate WCGWs from a specific SCOT, or select an option from All SCOTs. For a list of WCGWs that need to be related to an assertion, select \'Unrelated WCGWs'\.",
	allScots: " All SCOTs",
	allWCGWs: "All WCGWs",
	unRelatedWCGWs: " Unrelated WCGWs",
	//CRA Build Step 4 Header Label
	craValue: "CRA",
	incompleteCraValue: 'Incomplete CRA',
	// Panel Headers
	taskCategories: "任務瀏覽",
	taskCategoryExecution: "執行",
	taskList: "任務列表",
	taskDetails: "任務細節",
	fullScreen: "全螢幕",
	exitFullScreen: "退出全螢幕",
	defaultDropdown: "下拉式清單",
	status: "狀態",
	language: "語言",
	channel: "頻道",
	header: "標題",
	headerName: "標題名稱",
	sectionCustomLabelLabel: "自訂標籤",
	sectionNamePlaceHolder: "輸入段落標題",
	showRelatedObjectLabel: "顯示相關物件",
	errorBanner: "{0} 錯誤",
	customize: "自訂",
	customized: "已自訂",
	custom: "自訂",
	description: "說明",
	seeDescription: 'See description',
	section: 'Section',
	entities: "個體",
	edit: "編輯",
	delete: "刪除",
	collapse: "收合",
	collapseAll: "全部收合",
	expand: "展開",
	expandAll: "全部展開",
	incompleteResponse: "未完成回應",
	unresolvedComments: "未解決註解",
	saving: "儲存...",
	tasks: "任務",
	requests: 'requests',

	//BodyType Placeholder
	numericValuePlaceholder: "輸入金額",

	//Modal
	addButton: "加入按鈕",
	evidence: "證據",
	temporary: "暫存",
	temporaryFiles: "暫存檔案",
	priorPeriod: "前期",
	externaldocuments: "外部文件",
	eydocuments: 'EY documents',
	clientRequestClientAnalytics: "分析名稱",
	groupdocuments: "集團文件",
	name: "姓名",
	reason: "理由",
	browse: "瀏覽",
	uploadFile: "上傳檔案",
	uploadDocument: "上傳文件",
	duplicateDocumentHeader: "此案件已存在相同名稱之文件(無論於「證據」或「暫存檔案」)。",
	duplicateDocumentInstruction: "選擇「覆蓋」以上傳文件並取代現存檔案或「放棄」以取消。若現存檔案於「證據」，則文件將上傳至「證據」。若現存檔案於「暫存檔案」，則文件將上傳至「暫存檔案」。",
	overwriteLabel: "覆蓋",
	discardLabel: "放棄",
	discardChangesLabel: "捨棄變更",
	note: "註記",
	notes: "註記",
	signOffs: "簽名",
	related: "關聯",
	attributes: "屬性",
	approveChanges: "核准變更",
	nodocumentsAdded: "無文件",
	noEntitiesAvailable: "No entities available",
	noDocumentsUpload: "無文件上傳",
	noSections: "無可用段落",
	noRequestMessage: "此案件無請求或外部任務",
	noResultFound: "找不到結果",
	noRequestsFound: "沒有請求",
	noTimePhasesFound: "無可用之時段",
	noEntitiesFound: "沒有結果",
	relatedEntities: "相關個體",
	noClickableRelatedEntities: "Related entities cannot be edited for this task",
	taskByEntityLabel: "按個體區分的任務",
	relEntityLabel: "個體",
	singleEntity: "{0}個個體",
	multipleEntity: "{0}個個體",
	engagementDeliveryLabel: "按案件區分的任務",
	onlyShowRelEntities: "僅顯示相關個體",
	engDeliveryDescription: "此任務與案件中的所有個體相關聯。",
	relEntitiesDescription: "View entities related to the task. Related entities can only be edited for OSP and OST tasks.",
	relEntitiesPSTorPSPDesc: "View entities related to the task. Related entities cannot be edited for PST and PSP tasks.",
	warningRelMsg: "任務必須與一個或多個個體相關。 若要將任務改為全案件範圍，請切換為「按個體區分的任務」。",
	reldetailDescription: "在預設情況下，OSP 和 OST 任務是案件範圍內的，並且與所有個體相關。 透過按個體區分的任務，可以將任務與一個或多個個體連結。",
	results: "結果",
	searchPlaceholder: "搜尋",
	searchDocPlaceholder: "搜尋文件",
	searchCanvasForms: "搜尋Canvas表單",
	searchControlForms: 'Search SCOTs',
	canvasFormListDescription: 'Select a Canvas Form from the list below to view related Canvas Form reports.',
	controlFormListDescription: 'Select a SCOT to see its related control forms.',
	object: "物件",
	relateCollaboration: "連結合作",
	reviewNote: "複核註記",
	reviewNoteSingle: "複核註記",
	documentReviewNotes: "文件註記",
	noEvidenceFilesAssociated: "無證據檔案連結至此任務",
	taskReviewNoteWithParenthesess: "任務註記",
	taskNotes: "任務註記",
	documentsNotes: "文件註記",
	addNewDocumentNote: "加入文件註記",
	selectDocument: "選擇檔案",
	taskReviewNotes: "任務註記",
	showCleared: "顯示已清除",
	Replied: "已回覆：",
	showClosed: "顯示已解決",
	allNotes: "所有註記",
	myNotes: "我的註記",
	noTasksAvailable: "無可用任務",
	noWCGWAvailableForTask: "無重大不實表達風險(ROMM)",
	noSubstantiveTasksAvailable: "沒有相關證實性任務",
	noNotesAssociatedWithDocument: "本文件無相關註記",
	noNotesAssociatedWithTak: "本任務無相關註記",
	otherEngagementNotes: "其他案件註記",
	to: "to",
	deleteReviewNote: "刪除",
	missingToUserError: "必須",
	missingReviewNoteTextError: "複核註記文字為必須",
	invalidReviewNoteTextError: "所輸入文字超過限制",
	dueDateRequiredTextError: "到期日為必要",
	saveNoteTextError: "儲存或取消以繼續",
	engagementName: "案件名稱:",
	assignmentsCountLabel: 'Assignments',
	AssignmentsDays: "Days",
	closedOnTime: 'Closed on time',
	daysToPrepare: 'Days to prepare',
	daysToReview: 'Days to review',
	totalAssignments: "總<br>指派事項",
	currentlyAssigned: "目前<br>已指派",
	UpcomingAssignments: "即將推出",
	authoredByMe: 'Authored by me',
	commentsLabel: "複核註記",
	clearedOnTime: 'Cleared on time',
	daysToClear: 'Days to clear',
	daysToClose: 'Days to close',
	totalLabel: "註記總數",

	criticalAndHighRn: "重要及高重要性註記",
	criticalAndHighComments: "重要及高重要性註記",
	lowAndMediumComments: "中及低重要性註記",
	metricsInstructionalText: "檢視執行矩陣(performance metrics)下方您的指派事項及註記。 <br>選擇一個團隊成員以查看他們的矩陣或選擇 <b>案件總覽</b> 以查看整體概要。",
	metricsNewInstructionalText: "Select a team member to see their review notes and assignments or choose <b>Engagement view</b> to see an overall summary.",
	switchToViewPlaceholder: 'There is no data to display.<br>Select another team member or switch to the <b>Engagement view.</b>',
	tasksClosedOnTime: 'Tasks closed on time',
	daysDetailReview: 'Days to detail review',
	daysGeneralReview: 'Days to general review',
	totalDaysReview: 'Total days to review',
	metricsInstructionalTextconfiguration: "檢視執行矩陣(performance metrics)之整體概要以下指派事項及註記",

	//document download
	docSizeMB: 'MB',
	docSizeKB: "KB",
	labelForExpiredPackage: 'Package is expired.',
	headerForDocumentDownload: 'Click on the filename to download',
	labelForNoFiles: 'There were no files in the selected categories.',
	labelForProcessing: 'Files are being processed.',

	//create dropdown texts
	create: "建立",
	addRequestText: "請求",
	addExternalTaskText: "外部任務",
	addFindingText: "發現",
	show: "顯示：",
	riskTypeHeader: "風險類型",
	wcgwHeader: "WCGW",
	hasNotes: "未解決註記",
	hasNote: "未解決註記",
	noNotes: "(0 未解決註記)",
	addTemporaryFiles: "加入暫存檔案",
	addPriorPeriodEvidence: 'Add prior period',
	addExternalDocuments: "加入外部文件",
	//Nav
	navHeaderTasks: "任務",
	quickFilterAllCompletedTasks: "所有已完成任務",
	quickFilterMyCompletedAssignmnets: "我已完成的指派事項",
	quickFilterMyUpcomingAssignments: "我即將到期的指派事項",
	navHeaderTaskCategory: "任務類別",
	navFilterBy: "篩選項目",
	navHeaderDocuments: "文件",
	navHeaderCollaboration: "合作中心",
	navHeaderAssignments: "指派事項",
	navHeaderAutomation: "自動化中心",
	navHeaderMore: "更多",
	navDashboard: "儀錶板",
	navReviewnotes: "複核註記",
	navHeaderManageteam: "管理團隊",
	navHeaderMangeteamNew: "管理團隊 - 新",
	mangeteam: "管理團隊",
	postArchive: "歸檔後",
	addmember: "加入成員",
	addnewmember: "加入新成員",
	addPriorPeriodMembers: "新增非使用中成員",
	addPriorPeriodUsers: "Add inactive members",
	createPackage: "建立package",
	engagementrole: "案件角色",
	noPendingPriorPeriodUsers: "No inactive members to invite",
	sendPriorPeriodUserInvitesWithCount: "傳送 ({0}) 邀請",
	sendPriorPeriodUserInvitesWithoutCount: "傳送邀請",
	priorPeriodMembersModalHeaderMessage: "Select the inactive members that you would like to add to your engagement. Members will be granted permissions they previously had within the engagement upon reactivation.",
	priorPeriodIndependenceModalHeaderMessage: "Select the inactive independence only members that you would like to add to your engagement.",
	disabledPriorPeriodMembersButtonToolTip: "無足夠權限加入前期成員。請由有權限之案件團隊成員進行此動作。",
	disabledNewMembersButtonToolTip: "無足夠權限加入新成員。請由有權限之案件團隊成員進行此動作。",
	disabledNewMembersButtonToolTipThirdpartyuser: "權限無法加入第三方成員。請告知有適當權限之案件團隊成員以進行此動作。",
	rbacNoRightsForContentUpdateToolTip: "權限不足以執行內容更新。請聯絡您的案件管理者並請求權限以開始內容更新。",
	deactivateInternalUsersWithCount: "已選擇 {0} 位成員",
	canvasFormSelectionMessageSingular: "已選擇{0} Canvas 表單",
	canvasFormSelectionMessagePlural: "已選擇{0} Canvas 表單",
	pspAccountSelectionMessageSingular: "已選擇{0}個科目",
	pspAccountSelectionMessagePlural: "已選擇{0}個科目",
	manageTeamGroupLabel: "群組",
	manageTeamGroupsLabel: "群組",
	allAccessGroups: "全部登入群組",
	reactivate: "重新啟用",
	deactivate: "停用",
	unselect: "取消全選",
	deactivateInternalModalTitle: "停用內部成員",
	deactivateInternalModalMessage: "請確認是否停用以下團隊成員？",
	deactivateInternalUsersSuccessMessage: "已成功停用 {0} 位成員。",
	deactivateExternalModalTitle: "停用外部成員",
	deactivateExternalModalMessage: "請確認是否要從 {0} 停用以下團隊成員？所指派項目將被重新指派給相應之登入群組。",
	deactivateExternalSuccessMessage: "已成功停用成員。",
	internalMember: "內部成員",
	addinternalmember: "加入內部成員",
	addThirdPartymember: "加入第三方成員",
	missingResponsiblePerson: "負責人員遺失",
	sentRequests: "已傳送",
	receivedRequests: "已接收",
	syncProfileNotAllowed: "不允許同步基本資料",
	allSyncProfileNotAllowedMessage: "不允許同步基本資料。表單不適用於此基本資料。",
	allCanvasFormsContentUpdateMessage: "無法為共享的 EY Canvas FIT enablement活動提供內容。 請取消這些活動的連結以繼續內容更新。",
	someFormContentUpdateMessage: "由於沒有內容，某些表單無法同步到案件基本資料",
	linkedFormContentUpdateMessage: "內容將不會提供給已共享的EY Canvas FIT enablement活動。若要更新這些活動的內容，請取消這些活動的共享連結。",
	leaveUsFeedback: "Leave us feedback",

	notApplicableLabel: "不適用",
	addThirdPartyMemberDescription: "此功能僅用於允許第三方複核人員登入EY Canvas案件。請從Professional Practice取得適當核准及授權。",
	hasOverallResponsibilityDescription: "對查核或案件之指導、監督及執行，以及對所出具之報告及/或會員所間結論於當時情況下係屬適當負有整體責任之案件團隊成員",
	partnerInChargeHeader: "主辦會計師/主辦高階管理人員",
	picFlag: "PIC",
	CannotUpdatePicInArchivedEngagement: "無法處理編輯動作至受限制欄位。請重新整理並重試。",

	noGroupFound: "此案件未建立登入群組。請選擇 \'加入登入群組\' 以建立新外部團隊成員登入群組。",
	addGroup: "加入群組",
	deleteGroup: "刪除登入群組",
	deleteGroupMessage: "請確認是否要刪除 {0} 登入群組？",
	addAccessGroup: "加入登入群組",
	accessGroupCreated: "已成功建立新的登入群組{0}。",
	accessGroupUpdated: "登入群組 {0} 變動已成功儲存。",
	editAccessGroup: "編輯登入群組",
	sharedGroupwarning: "此為共享登入群組且其變更將反映至所有相關案件。",
	groups: "群組",
	addExternalMembers: "所有外部成員",
	members: "成員",
	externalMember: "外部成員",
	member: "成員",
	role: "角色",
	actions: "動作",
	internalUserEdit: "編輯",
	internalUserDeactivate: "停用",
	usersFilter: "篩選",
	externalUserEdit: "編輯",
	externalUserDeactivate: "停用",
	externalUserGroupLabel: "群組",
	externalNoUserInGroup: "無成員加入此登入群組。",
	externalNoUserInAllGroup: "無成員加入此案件。",
	alias: "別名",
	independence: "獨立性",
	navManagegroup: "管理集團",
	navCRAsummary: "CRA彙總",
	navAuditplan: "查核計畫",
	navWorkplan: "工作計畫",
	navSEM: "證實評估矩陣",
	nav440GL: "報告日後的變動",
	navFindings: "發現中心",
	navCanvasformupdates: "Canvas表單更新",
	navPSPContentUpdates: "PSP內容更新",
	navCopyhubNew: "Copy hub - NEW",
	navCopyhub: "複製中心",
	navArchiveChecklist: "歸檔檢查表",
	navExporthub: "匯出中心",
	navReporting: "報表中心",
	navAccountSummary: "Account summary",
	navScotSummary: "SCOT summary",
	navItSummary: "IT summary",
	navGroupInstructionSummary: "Group instructions",
	navGroupInvolvement: "Group involvement",
	navHelixProjects: "EY Helix connections",
	navContentUpdates: "Content update",
	contentUpdateErrorMsg: "您無權限儲存變更。請由其他有權限之團隊成員進行變更。",
	contentUpdateTitleTip: "無足夠權限以執行內容更新。請聯絡您的案件管理者並要求權限以開始內容更新。",
	noPreviousUpdates: "無先前更新",
	noContentUpdateResults: "未找到結果",
	noPSPAccountsToUpdate: "沒有要更新的科目",
	rbcaUnavailableMsg: "EY Canvas目前無法儲存變更。請重試，若問題仍然存在，請聯絡Help Desk",
	showErrInProgressMsg: "29007 - 其他更新進行時無法開始內容更新。請稍待目前內容更新完成，或重新整理頁面並重試。",
	navHelp: 'General help',
	validationNavHelp: 'Validation help',
	searchUserText: "搜尋使用者",
	superModelTitle: 'Engagement objects',
	superModelText: 'Super modal',
	independenceOnlyMembers: "Independence only members",
	noIndependenceOnlyPriorPeriodUsers: "No inactive independence only members to invite",

	//Copyright
	copyRight: "Copyright © <year> all rights reserved",

	//Copyhub List labels
	moreRecipient: 'more',
	copyHubPackageName: "package名稱",
	copyHubSentBy: "傳送者",
	copyHubSentTo: "傳送給",
	copyHubReceivedBy: "接收者",
	copyHubDate: "日期",
	copyHubRemainingTime: "剩餘時間",
	copyHubAvailableFor: "可以用來",
	copyHubStatus: "狀態",
	noCopyHubSentPackages: "尚未建立複製package。請選擇建立package以建立新的資料package。",
	noCopyHubReceivedPackages: "此案件無複製package",
	remainingTimeTooltip: "項目將於歸檔時或建立10天後永久移除",
	copyHubDeleteText: "刪除",
	appendDays: "天",
	generalInformation: "一般資訊",
	copyDocuments: 'Documents',
	copyFiles: 'Files',
	scots: "SCOTs",
	accounts: "Accounts",
	copyHubImport: "Import",
	copyHubPackageType: "Package type:",
	copyHubCreatedModal: "Created:",
	copyHubRemainingTimeModal: "Remaining time:",
	copyHubAvailableForModal: "可以用來：",
	copyHubInstructionModal: "Instructions:",
	copyHubCategories: "Categories",
	copyHubPendingDeletion: "Pending Deletion",
	copyHubVersionMismatchCat: "Cannot show categories due to package version mismatch",
	copyHubVersionMismatchPersonInfo: "Cannot show sender and receiver information due to package version mismatch",
	copyHubViewLegacyPacakgeDetails: "This is legacy copy package for which detailed information is unavailable",
	associateTasks: "關聯任務",
	backToForms: "返回表單",
	noTaskSelected: "至少選擇一項任務",
	taskLabel: "任務：",
	taskMessage: "您必須連結任務與所匯入表單。",
	importSuccessMessage: "Import request queued successfully",
	taskSelectedText: "任務已選擇",
	insufficientPermissionsToImport: "無足夠權限匯入所複製資料。請聯絡您的案件管理員並請求權限以匯入所複製資料。",
	cannotImportExpiredPackage: "無法匯入過期之所複製資料。",
	cannotImportWhileInProgress: "無法匯入進行中所複製資料。",
	deletePackageHeader: 'Delete package',
	copyPackageDeleted: 'The package has been deleted',
	copyPackageDeleteConfirmation: 'Are you sure you want to delete this package?',
	insufficientPermissionsToDelete: 'Insufficient permissions to delete copy package. Contact your engagement administrator and request permission to delete copy package.',
	insufficientPermissions: "權限不足",
	GuidedWorkflowsPackageDisplayText: "Selecting import will update matching Guided workflows from the copy to this engagement. Guided workflows without a match will not be imported.",
	copyRequestStatusInQueue: "在行列中",
	GuidedWorkflowImportError: "Guided workflows import is not available for multi-entity engagements",

	//TopHeaderLayout.js
	topHeaderLayoutMilestoneText: "里程碑核對或調節財務資訊至會計紀錄取得證據期中財務資訊核對或調節至會計紀錄。",
	//TaskLayoutHeader
	taskLayoutHeaderSearchPlaceholder: 'Search tasks',
	taskLayoutHeaderAssignments: "指派任務",
	taskLayoutHeaderAddTask: "New task",
	wcgwSearchPlaceholder: "搜尋WCGW",
	//TaskListHeader
	taskTypeHeader: "類型",
	taskNameHeader: "名稱",
	taskDueDateHeader: "到期日",
	reviewNoteChangeDueDate: "Change due date",
	taskListHeaderSortByDueDate: "到期日",
	taskListHeaderSortByTaskName: "任務名稱",
	sortBy: "排序方式：",
	ascending: "由低至高排序",
	descending: "由高至低排序",
	taskListHeaderSortByKnowledge: "查核規劃",
	taskListHeaderDeleteWarning: "請確認是否欲刪除所選任務。",
	taskListHeaderSortText: "分類",
	taskListHeaderSortOrderText: "排序",
	taskListHeaderTimePhaseText: "設定時段",
	taskListHeaderBookMarkText: "書籤",
	taskListHeaderFavoriteText: "我的最愛",
	taskListHeaderEditText: "編輯任務標題",
	moreMenu: "更多",
	taskListHeaderMoveTaskText: "變更任務群組",
	taskGroupIconHoverText: "變更任務群組",
	taskGroupLabel: "變更群組",
	task: "任務",
	toc: "TOC",
	tenNotes: "10 註記",
	source: "來源",
	nature: "性質",
	assertion: "聲明",
	relatedAccounts: 'Related accounts',
	testOfDetail: "細項測試",
	testOfControl: "控制測試",
	substantiveAnalyticalProcedure: "證實分析性程序",
	tod: "TOD",
	sap: "SAP",
	int: "INT",
	ext: "EXT",
	notSel: "未選擇",
	internal: "內部",
	external: "外部",
	notSelected: "未選擇",
	documentCannotOpen: "無法從「任務詳細內容」開啟此文件。請至「文件清單」以開啟此文件。",
	//TaskPanelLayout
	emptyTaskDetailsMessage: "請選擇任務以檢視詳細內容。",
	multiTaskSelectedMessage: "若啟用批次控制，請使用控制關鍵並選擇多項任務。 \n 若您欲於單獨任務作業，請從任務清單選擇該任務。",
	emptyAndMultiSelectedMessage: "To enable bulk controls, use the checkbox to select one or more tasks. Use the shift key to select several tasks at once. If you would like to work on an individual task, then select that task from the list.",
	//Evidence
	evidenceDragAndDrop: "拖放或",
	//Timephases
	noResultTimePhase: 'No results found.',
	//handoff
	handoff: "移交",
	handoffConfirmButtonText: "移交",
	handoffModalTitle: "移交任務",
	handoffTitle: "移交至下一位團隊成員",
	handoffTextLine2: "欲簽名證據檔案，請從下列選項中選擇。",
	return: "退回",
	returnDisabledMessage: "此任務無法退回因：(1) 您被指派為編製者， (2) 任務狀態不是「複核中」或「完成」，或 (3) 沒有指派編製者。",
	handOffTitleTip: "移交以供複核",
	//Mark Complete
	markCompleteTitleTip: "標示為完成",
	markCompleteTitle: "標示任務完成",
	markCompleteText: "您的簽名將適用到連結至此任務之證據(如以下指示)。此任務將標示為完成。",
	markCompleteTextLine1: "移交此任務至下一個團隊成員",
	markCompleteTextLine2: "要簽核證據檔案，請從以下選項中選擇。若您被指派了此任務並已完成，請選擇<b>是</b> 將其關閉。 若此任務需要 PIC 或 EQR 簽核，請從以下選項中選擇。",
	markCompleteConfirm: "標示完成",
	signOffAs: "全部簽名：",
	additionalSignOff: "其他必要簽名",
	additionalTaskStatus: "關閉我的指派事項",
	markCompleteModalHeaderTextPart1: "此任務將被標記為完成。",
	markCompleteModalHeaderTextPart2: "要簽核證據檔案，請從以下選項中選擇。若您被指派了此任務並已完成，請選擇<b>是</b> 將其關閉。 若此任務需要 PIC 或 EQR 簽核，請從以下選項中選擇。",
	ep: "PIC",
	eqr: "EQR",
	closeMyAssignment: "結束我的指派事項",
	tempMarkCompleteMessage: "無法將任務標記為完成。請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	tempMarkCompleteEnable: "標記完成啟用",
	tempMarkCompleteDisable: "標記完成停用",
	//TaskDetails
	seeTask: "請見任務",
	NoTasksFound: "未找到任務",
	taskDetailsAddRelate: "加入/連結",
	taskDetailsDocument: "文件",
	taskDetailsAutomationRequest: "自動化請求",
	taskDetailsExternalTask: "外部任務",
	taskDetailsFinding: "發現",
	taskDetailsRequest: "請求",
	taskDetailsNotes: "註記",
	taskDetailsRelatedTask: "相關任務",
	epeqr: "PIC/EQR",
	epeqrsignoffheader: "簽名為必須",
	addTaskGroupLabel: "加入任務群組",
	itgcTaskDescription: 'Perform our designed tests of ITGCs to obtain sufficient appropriate audit evidence of their operating effectiveness throughout the period of reliance.',
	//create assignment
	createassignmentheaderLine1: "所選團隊成員無此任務之指派事項。",
	createassignmentheaderLine2: "於此建立指派事項。若其他團隊成員已有相同類型之未完成指派事項，",
	createassignmentheaderLine3: "選擇",
	createassignmentheaderLine4: "以此指派事項取代。",
	overwriteIncompleAssignments: "覆寫未完成指派事項",
	//Create Assignment
	createassignmentheader1: "選擇的團隊成員沒有此任務的指派事項。",
	createassignmentheader2: "在此處建立指派事項。",
	//Guidance
	atlasLink: "Atlas連結",
	automationLink: "Smart Automation連結",
	otherLink: "其他連結",
	helixLink: "Helix連結",
	relatedAutomations: "相關自動化流程",
	noSuggestedAutomationLabel: "此案件無建議之自動化流程。",
	noSuggestedItemLabel: "此任務沒有建議的項目。",
	noAutomationRequestLabel: "此案件無任何相關自動化流程。要開始請建立新自動化流程、或連結現存自動化流程。",
	relateAutomation: "Relate",
	relateAutomationModelHeader: "Relate Smart Automations",
	automationSolution: "Solution",
	automationName: "Automation name",
	relateAutomationTextLine1: "Relate a Smart Automation to this task.",
	relateAutomationTextLine2: "Once related, you can view the automation from task details and click to open it.",
	noSamrtAutomationForEngagement: "No Smart Automations have been created for your engagement.",
	searchAutomationLabel: "Search automations",

	//RelatedItemHeader
	relatedItemsHeader: "相關項目",
	relateButtonText: "連結",
	createButtonText: "建立",
	relatedItemREQ: "請求",
	relatedItemET: "外部任務",
	relatedItemATM: "自動化流程中心",
	relatedItemRelatedTask: "相關任務",
	relateObjectsToTaskTitle: "連結物件到此任務",
	relateObjectsToTaskSubTitle: "連結物件到此任務。該等物件將顯示於任務詳細內容之相關項目區塊。",
	relateObjectOptionsHeaderPSPOSP: "科目，聲明，以及有限風險科目",
	relateObjectOptionsHeaderITWalkthrough: "IT流程",
	relateObjectOptionsHeaderITControl: "IT控制 (ITGC及ITSP)",
	// SDM Nextwave services
	scheduledServicesText: "相關服務",
	suggestedServicesText: "已建議服務",
	suggestedServicesDefaultMessage: "建議為此任務提供NextWave服務。點選",
	suggestedServicesDefaultMessage1: '+',
	suggestedServicesDefaultMessage2: "圖示以開始。",
	suggestedServicesPlaceholderMessage: "此任務無建議之服務。",
	nextWaveServiceOfferingLabel: "服務",
	nextWaveServiceStatusLabel: "狀態",
	nextWaveServiceStartDateLabel: "開始",
	nextWaveServiceDueDateLabel: "到期",
	nextWaveServiceRequestCreate: "建立請求",
	nextWaveServiceRequests: "Centralized service requests",
	nextWaveServiceGatewayRequests: "Service Gateway請求",
	onlyShowSelectedTask: "Only show selected task",
	sdmRestrictAddTaskLabel: "Click continue to proceed to the next step. Task selection can occur after the service offering has been accepted and the GDS process based team manager reaches out to discuss the work to be completed.",
	//Links
	linksText: "連結",
	//Forms
	formsText: "表單",
	/*Accounts*/
	associatedTasks: "任務連結至WCGW項目",
	noAssertionsChecked: "選擇聲明以檢視相關WCGW",
	noAccountsCreated: "沒有建立科目",
	noDesignationSelected: "未選擇指定",
	noRelatedAccounts: "沒有相關科目",
	manageAccount: 'Manage accounts and disclosures',
	/*Risks*/
	risk: "風險",
	risks: "風險",
	wcgw: "WCGW",
	riskWcgw: "風險：WCGW",
	wcgwTasks: "WCGW：任務",
	riskWcgwLabel: 'Relate risks to WCGWs',
	wcgwTasksLabel: "連結WCGW至任務",
	noRiskTypes: "找不到風險類型",
	saveRisk: "儲存",
	noRisksFound: "找不到風險",
	haveBeenIdentified: "已辨認",
	noAssertionFound: 'No related assertions applicable to this engagement',
	noAssertionApplicable: 'No Assertions applicable to this engagement have been associated',
	noWCGWFound: "無WCGW連結到此風險。請點選編輯連結以連結WCGW。",
	noRelatedWCGWs: "無相關WCGWs",
	noRelatedControls: "沒有相關控制",
	noRelatedRisks: "無相關 IT 風險",
	noRelatedITGCs: "無相關的 ITGCs",
	iTriskVal: "IT risk",
	iTrisksVal: "IT risks",
	iTGCVal: "ITGC",
	iTGCsVal: "ITGCs",
	iTSPVal: "ITSP",
	iTSPsVal: "ITSPs",
	iTGCname: "ITGC 名稱",
	iTSPname: "ITSP 名稱",
	noWCGWAvailable: "所選擇聲明無可用重大不實表達風險(ROMM)",
	relevantWcgwCountHint: "科目名稱旁顯示之數目為與控制風險評估係不仰賴聲明、或者相關較高風險估計聲明相關之WCGW數目，其已連結至證實程序之數目，相較於WCGW總數。",
	noAccountsFound: "找不到紀錄",
	selectAssertionToRelateWCGW: "選擇聲明以連結風險至WCGW",
	significantAccounts: "重大科目",
	riskName: "風險：",
	accountName: "科目：",
	noScotsFound: "沒有相關SCOT",
	relatedwcgw: "相關WCGW",
	relatedRisks: 'Related risks',
	noRelatedAssertionsLabel: "沒有為科目選擇聲明",
	boltIconTitle: "相關風險",
	instructions: "指引",
	expandRisk: "1. 展開風險",
	selectAssertion: "2. 選擇聲明",
	identifyRelatedWCGW: '3. Identify WCGWs related to the risk',
	clickAccount: "1. 點選科目",
	selectWCGW: "2. 選擇WCGW",
	identifyRelatedTask: "3. 辨認回應WCGW的任務",
	information: "資訊",
	requiredAssertions: "所須聲明",
	wcgwWithoutTasks: "WCGW無任務",
	found: "found",
	editAssociations: "編輯連結",
	riskWCGW: "風險：WCGW關係",
	wcgwTask: "WCGW：任務關係",
	requireTaskToBeRelated: "需要連結任務",
	expandCollapse: "點選這裡以收合/展開",
	requiredAssertionsInfo: "僅顯示控制風險評估係不仰賴聲明及相關較高風險估計聲明",
	wCGWwithoutTasksInfo: "僅顯示與控制風險評估係不仰賴聲明及相關較高風險估計聲明之相關WCGW，而未連結任何回應證實任務",
	noBuildStepsAvailable: "無建立步驟可顯示。",
	accountRiskAssessmentSummary: "科目和揭露",
	manageRisk: 'Manage risks',
	addResponsivePSPOSP: 'Add responsive PSP/OSP',
	assertionlbl: 'Assertion',
	addResponsiveControl: 'Add responsive control',
	addResponsiveTOC: 'Add responsive TOC',
	showOnlyRelatedItems: 'Show only related',
	relatedControlCounter: '{0} control',
	relatedControlsCounter: '{0} controls',
	noControlsAvailableForRelateItem: 'No controls available',
	relateControlName: 'Controls',
	relateContolsAPIErrorMessage: 'Control cannot be related to the assertion.  Refresh the page and try again. If the issue persists contact the Help Desk.',
	relateTasksAPIErrorMessage: 'Task cannot be related to the assertion.  Refresh the page and try again. If the issue persists contact the Help Desk.',
	toggleFilterWarningMessage: 'Show only accounts and disclosures without any substantive procedures',
	toggleFilterWarningMessageForRisk: 'Show only risks without any responsive substantive procedures or controls/TOCs',
	warningIconHoverText: 'Risk without any responsive substantive procedures or controls/TOCs',
	filterYes: "是",
	filterNo: "否",

	/*OrphanedControls*/
	orphanedControls: 'View unrelated controls',
	unRelatedOrphanControls: 'Unrelated controls',
	noOrphanedControlsDataLabel: "No unrelated controls available",
	noOrphanedControlsResultLabel: "No unrelated controls available",
	noControlSelected: 'At least one control must be selected for deletion.',
	controlsDeleteConformation: 'Are you sure that you want to delete the selected controls?',
	controlDeleteConformation: 'Are you sure that you want to delete the selected control?',
	deleteControlModalHeader: 'Confirm deletion of selected control',
	deleteControlsModalHeader: 'Confirm deletion of selected controls',

	/*SEM*/
	select: "選擇",
	selectAnAccountFromTheDropDown: "1. 從下拉式選單中選擇科目",
	applyAsertionsFilters: "2. 應用聲明篩選",
	reviewTheTasksThatRespondToTheRisks: "3. 複核回應風險的任務",
	riskOfMaterialMisstatement: 'Risks of material misstatement',
	expandScot: "1. 展開SCOT",
	selectWCGWToDisplayTheResponsiveTask: "2. 選擇重大不實表達風險以顯示回應任務",
	tasksWithNoRelatedWCGW: 'Tasks with no related risks of material misstatement',
	selected: "已選擇",
	clearSelections: "取消全選",
	romm: "重大不實表達風險(ROMM)",
	selectAccount: "Account",
	selectHeader: "選擇表頭",
	riskOfMaterialMisstatementsWithoutRelatedTask: 'Risks of material misstatement without related tasks',
	selectOneOrMoreTasksToSeeTheRelatedROMM: "選擇一個以上任務以檢視相關重大不實表達風險(ROMM)",
	invalidRelatedEntity: "找不到相關科目。請重新整理頁面並重試。若問題仍然存在，請聯絡Help Desk。",
	scrollUp: "向上捲動",
	scrollDown: "向下捲動",
	duplicate: "重複",
	showIndex: "顯示index",
	noContentAvailable: "無可用內容",
	navigateTo: "導引至",
	/*validations */
	semValidation: "SEM驗證",
	riskWCGWValidation: "風險WCGW驗證",
	showValidation: "驗證",
	wcgwWithNoRelatedTask: "WCGW沒有相關證實性任務",
	riskWithNoRelatedWCGW: "風險沒有相關WCGW",
	noValidationIdentified: "沒有辨認出驗證",
	onlyShowScotWithNoControlNoWCGW: 'Show only SCOTs without related WCGW or control',
	/*CRA Badge*/
	ir: "IR",
	cr: "CR",
	cra: "CRA",
	selectToEdit: "選擇以編輯",
	both: "兩者",
	prefix: "字首",
	suffix: "字尾",
	optional: "(非必須)",
	title: "標題",
	charLimitExceeded: "超過字元限制",
	requiredField: "必填欄位",
	Lastmodifiedby: "最近一次修改由",
	fileSize: " | {1} KB",
	fileSizeInKB: "{1} KB",
	fileSizeHeader: "檔案大小",
	daysAgo: "天前",
	weekAgo: 'week ago',
	weeksAgo: 'weeks ago',
	monthAgo: 'month ago',
	monthsAgo: 'months ago',
	yearAgo: 'year ago',
	yearsAgo: 'years ago',
	currentlyBeingModifiedBy: "目前修改者為",
	beingEditedInCoeditModeError: 'Being edited in multi-user edit',
	beingEditedInCoeditMode: 'Being edited in multi-user edit. Edit started by {0}',
	beingEditedInCoeditModeOn: 'on {0}.',
	coEditModeAutomaticallyEnds: 'Multi-user editing. {0} days until multi-user editing automatically ends.',
	coEditModeIsEnding: "Multi-user editing is ending",
	coEditMode: "Multi-user editing",
	checkInInProgressMessage: "Check-in in progress. It may take up to 20 minutes for the document to be checked in. Please refresh for updates",
	checkOutInProgressMessage: "Check-out in progress. It may take up to 20 minutes for the document to be checked out. Please refresh for updates",
	daasErrorMessage: "Operation cannot be complete at this time. Refresh the page and try again. If the issue persists contact the Help Desk",
	coEditModeIsStarting: "Multi-user editing is starting",
	daasOpenDocumentWarning: 'Multi-user editing may have been ended by another user. Refresh the page and try again.',
	daasStartCollaborationModeWarning: 'Collaboration mode may have been started by another user. Refresh the page and try again.',
	documentCurrentlyBeingModifiedTitle: 'Document currently being modified',
	documentCurrentlyBeingModifiedHeader: 'This document is currently being modified by {0}. This user opened the document',
	documentCurrentlyBeingModifiedBody: 'Starting multi-user edit mode could cause conflicts, so we recommend discussing with {0} before proceeding. Select {1} to start the multi-user edit mode or {2} to return without starting multi-user edit mode.',
	documentEndMultiUserEditingTitle: 'Confirm you want to end multi-user editing',
	documentEndMultiUserEditingHeader: 'Warning: Other users may be actively editing this document.  This can be checked by opening the document and seeing if other users are currently in the file. Please confirm that all changes are complete before ending multi-user mode. File changes in multi-user mode may take up to 1 minute to be processed. Therefore, please wait at least 1 minute after exiting the file before ending multi-user mode.',
	documentEndMultiUserEditingBody: 'Select {0} to end the multi-user edit mode or {1} to return without ending multi-user edit mode.',
	startMultiuserEditing: 'Start',
	continue: "繼續",
	openReadOnly: "以唯讀方式開啟",
	takeControlFromTeam: "從目前團隊成員取得控制",
	itapplication: "IT應用系統",
	aggregateITevaluation: "綜合IT評估：",
	control: "控制",
	itgcitsp: "ITGC/ITSP",
	limitedRisk: "有限風險科目",
	so: "SO",
	itApp: "IT應用系統",
	itAppType: "IT app",
	deleteTaskModalHeader: "確認刪除所選任務",
	deleteTasksModalHeader: "確認刪除所選任務",
	deleteTaskModalMessage: "請確認是否欲刪除所選任務？",
	deleteTaskModalMessage1: "此案件未與任何其他任務連結之相關證據將被移至暫存檔案。未連結至任何其他證據之發現及回應任務將被刪除。",
	deleteTasksModalMessage: "請確認是否欲刪除所選任務？",
	someTasksCannotBeDeleted: "某些任務無法刪除",
	onlySomeTasksCanBeDeleted: "您所選擇的任務中僅有部分可被刪除",
	tasksThatCanBeDeleted: "若您選擇繼續 <b>下列任務將被移除</b> 自您的案件中。您的案件中未被連結至其他任務之證據將被移至暫存檔案。未連結至其他證據之發現及回覆任務也將被刪除。",
	tasksThatCannnotBeDeleted: "<b>下列任務無法被移除</b>自您的案件中。 但若必要時可自查核計劃中拒絕。",
	accountHeader: "科目",
	noAccountsIdentified: "未辨認科目。",
	noRisksIdentified: "未辨認風險",
	noAssertionsIdentified: "未辨認聲明",
	noWcgwsIdentified: "未辨認WCGW",
	// Tasks/TaskDetails/Evidence
	addEvidence: "加入證據",
	relateEvidence: "連結證據",
	relateTemporary: "連結暫存檔案",
	relatePriorPeriod: "連結前期證據",
	relateExtDoc: "連結外部文件",
	relateFile: "連結檔案",
	relateAnalytics: "相關分析",
	quickAddButton: "快速新增",
	createPaperProfile: "建立紙本檔案",
	paperProfileInformationMessage: "我們以電子格式編製所有底稿文件紀錄，包括編製者及複核者簽名。僅有管理階層或第三方所提供之紙本格式文件且無電子檔副本者(例如：企業與第三方間所簽訂之合約副本)允許為紙本工作底稿。",
	paperProfileName: "紙本檔案名稱",
	paperProfileAdd: "加入",
	paperProfileError: "請輸入有效之紙本檔案名稱",
	otherEngagementsInWorkspace: "此工作區其他案件",
	relateDescription: "於此工作區自此案件、或從其他案件連結文件。",
	onlyShowRelatedDocuments: "僅顯示相關文件",
	relateDescriptionTemp: "自此案件連結文件。",
	added: "已加入",
	documentLocation: "文件地點",
	documentIneligibleForSharingMessage: "機密文件不得共享。",
	confidentialityNotAppropiateForSharing: "You do not have the appropriate confidentiality level to send this document.",
	documentIsCheckedOut: "Document is in co-edit mode and cannot be shared. End co-edit mode to share the document.",
	addCanvasFormNew: "加入 Canvas form NEW",
	documentCount: "{0} 文件",
	documentsCount: "{0} 文件",
	fitDocumentCannotbeSelected: "FIT 文件無法在案件之間共享。",
	// Task/TaskDetail/Description
	noDescriptionAvailable: "No description available.",
	knowledge: "Knowledge",
	knowledgeDescription: "Knowledge說明",
	descriptionInstructions: "指引說明",
	fromInstructions: "From instructions",
	customizeDescription: "自訂說明",
	custimizeTaskDescription: "自訂任務說明",
	editTaskDescription: "編輯任務說明",
	saveLabel: "儲存",
	okLabel: "Ok",
	cancelLabel: "取消",
	leaveCommentLabel: "發表註解",
	addLabel: 'Add',
	closeLabel: "關閉",
	editText: "編輯",
	enterReply: "輸入回應",
	reply: "回應",
	deleteTagDesc: "刪除的標記無法復原，您確定要繼續嗎？",
	requiredText: "文字為必須",
	descriptionEmptyError: "說明為必須",
	descriptionMaxLengthError: "說明長度超過最大允許長度",
	assignmentDueDate: "指派事項到期日",
	navigateToGuidedWorkflow: "導航至 EY Canvas FIT enablement",
	openInTasksPage: "在任務中打開",
	copyTaskLink: "複製任務連結",
	copyReviewNoteLink: "Copy review note link",
	urlCopiedLabel: "連結複製成功",
	//Related Tasks
	showOnlyRelatedTask: 'Show only related',
	noTaskAvailable: 'No tasks available',

	// Client Request / Client Request Detail /  Client Request Drawer
	openInCollaborationPage: "在合作中心開啟",
	copyRequestLink: "複製請求連結",
	requestType2MessageTitleDrawer: "此請求具有附加功能。",
	requestType2MessageSubtitleDrawer1: "請",
	requestType2MessageSubtitleDrawer2: "點選這裡",
	requestType2MessageSubtitleDrawer3: "引導至它。",

	// SeeMore component
	showMore: "顯示更多",
	showLess: "顯示較少",
	showMoreEllipsis: "顯示更多…",
	showLessEllipsis: "顯示較少…",

	// Request Description
	saveAndCloseButtonLabel: 'Save and close',
	saveButtonLabel: 'Save',
	cancelButtonLabel: 'Close',

	// Request Description Modal labels
	discardChangesModalText: 'Discard changes',
	inlineSaveUnsavedChanges: 'There are unsaved changes, do you want to continue?',

	// RelateWCGWModal labels
	wcgwName: 'WCGW name',
	wcgwByScot: 'WCGWs by SCOT',
	unrelatedSCOTsHeader: 'Unrelated SCOTs',
	unrelatedSCOTPlaceholder: 'No unrelated SCOTs',
	noWcgwPlaceholder: 'No WCGWs have been created',
	showOnlyUnrelatedWCGW: 'Show only unrelated',

	// CharCount component.
	of: "of",
	characters: "字元",
	fromUserLabel: "From",
	toUserLabel: "To",
	handoffto: "移交至",
	priorityLabel: "重要性",
	addNoteLabel: "加入",
	replyNoteLabel: "回覆",
	characterCountLabel: "/4000字元",
	taskNotePlacehodler: "輸入任務註記",
	documentNotePlacehodler: "輸入文件註記",
	taskNoteStatusBy: "by:",
	addNewReviewNoteButtonText: "New note",
	fromKnowledge: "從Knowledge",
	/*day labels*/
	mon: "星期一",
	tues: "星期二",
	wed: "星期三",
	thurs: "星期四",
	fri: "星期五",
	sat: "星期六",
	sun: "星期日",
	/*month labels*/
	jan: "一月",
	feb: "二月",
	march: "三月",
	april: "四月",
	may: "五月",
	june: "六月",
	july: "七月",
	august: "八月",
	sept: "九月",
	oct: "十月",
	nov: "十一月",
	dec: "十二月",
	/*Rename*/
	documentDropdown: "文件下拉式清單",
	fileNameRequired: "文件名稱為必須",
	invalidCharacters: '文件名稱不可包括：*/:<>\\?|\"',
	existingFileName: "文件名稱非唯一。請重新整理頁面或重新命名檔案以移除此訊息。",
	unknowError: "發生未預期錯誤。請重新整理頁面並移除此訊息。",
	maxLengthExceeded: "文件名稱不得超過115字元。",
	documentNameSyncErrorMessage: 'Document name could not be synced to the Canvas Client Portal. Refresh the page and try again.',
	/*Delete*/
	deleteFileTitle: "刪除文件",
	deleteFileCloseBtnTitle: "取消",
	deleteFileConfirmBtnTitle: "刪除",
	deleteFileCloseTitle: "關閉",
	deleteFileModalMessage: "請確認是否要刪除所選文件？",
	none: "無",
	/*Unlink*/
	unlinkFileTitle: "解除共享證據連結",
	unlinkSource: "來源",
	unlinkTarget: "目標",
	unlinkFileCloseBtnTitle: "取消",
	unlinkFileConfirmBtnTitle: "確認",
	unlinkFileCloseTitle: "關閉",
	unlinkFileModalMessage: "請確認是否要解除共享證據檔案連結？",
	/*Relate Tasks*/
	relateTasksTitle: "連結任務",
	relateTaskSearchPlaceholder: "輸入以搜尋",
	relateTaskInstructionalText: "加入或移除文件應連結之任務。若文件為證據，從最後任務移除文件將移動到暫存檔案。",
	relatedTaskInstructionalText: "文件連結至此案件以下任務。請點選任務名稱以導引至該任務。",
	relateTaskName: "任務名稱",
	relateTaskType: "類型",
	relatedTaskCounter: "{0}任務",
	relatedTasksCounter: "{0}任務",
	/*Relate Entities*/
	relateEntitiesTitle: "Relate entities",
	relateEntitiesSearchPlaceholder: "Enter to search by name",
	relateEntitiesName: "Entity name",
	relateEntitiesIndex: "Entity standard index",
	relatedEntitiesCounter: "{0} entities",
	relatedEntityCounter: "{0} entities",
	onlyShowRelatedEntities: "Only show related entities",
	unableToRemoveSystemAssociatedRelatedEntity: "Unable to remove system relationships between documents and entities",
	/* Finalize document */
	document: "文件",
	finalize: "完成",
	finalizeDocument: "完成文件",
	finalizeDocumentTitle: "請確認是否要通知主查團隊此文件已完成？",
	finalizeDocumentSubtitle: "完成文件會通知主查團隊您將不再傳送任何其他版本之文件，並變更文件狀態至<b>最終版本已傳送</b>。當您變更了已完成文件，您仍可傳送新版本給主查團隊。",
	/* Remove From Task */
	removeEvidenceModalTitle: "從任務移除",
	remove: "移除",
	removeFromTaskModalContent: "您確定要從任務移除該文件嗎？該文件未與案件其他任務連結，將會被移動到暫存檔案。",
	sharedEvidenceRemoveFromTaskModalContent: "請確認是否要自此任務移除所選文件？此為共享文件且未連結到任何此案件的其他任務。文件移除後將不再於您的案件中。",
	/*AddDocumentToTasksModal*/
	modalCheckboxHeading: "加入證據至一個以上之任務",
	modalRadioHeading: "連結文件至一個以上之任務",
	confirm: "確認",
	proceed: "進行",
	modalCheckboxMessage: "選擇相關任務以加入此文件至",
	selectedDocument: "已選擇文件",
	modalRadioMessage: "此文件先前已被加入證據或暫存檔案。",
	modalRadioMessage1: "再度加入此文件將建立重複副本。選擇是否連結此文件現存副本或建立此文件新副本。",
	option: "選項",
	option1Message: "連結現存文件至此任務",
	option2Message: "建立此文件新副本",
	addToEvidenceSelectAll: "選擇全部",
	currentTask: "目前任務：",
	createNewCopy: "建立新副本",
	fileNameMaxLenError: (maxFileLen) => ` 檔案名稱限制為 ${maxFileLen} 字元。`,
	/* Confidentiality */
	confidentiality: "保密性",
	confidentialityType: "機密(選擇性)",
	confidentialityTitle: "文件機密",
	confidentialityPlaceholder: "選擇保密",
	confidentialityText: "設定開啟此文件所需要之登入層級。登入層級係由案件管理者於「管理團隊」頁面設定。若此文件已設定機密，僅可開啟文件者能夠變更。",
	confidentialityNotOpenable: "無法開啟文件，因您的案件權限不足。 登入層級由案件管理者於「管理團隊」設定。",
	confidentialityTargetNotOpenable: "機密文件僅可從來源案件開啟。",
	/*Sign-off requirements*/
	signOffRequirements: "簽核要求",
	signoffRequirementsModalTitle: "簽核要求",
	signoffRequirementsModalDescription1: "在下方調整檔案的執行簽核要求。",
	signoffRequirementsModalDescription2: "某些簽核要求無法調整，因為它們是 EY Canvas 的要求。",
	signoffRequirementsModalSaveLabel: "儲存",
	signoffRequirementsModalCancelLabel: "取消",
	signoffRequirementsModalCloseLabel: "關閉",
	signoffRequirementsModalPICLabel: "PIC",
	signoffRequirementsModalEQRLabel: "EQR",
	/*SEM summary*/
	nextAccount: '>',
	prevAccount: "<",
	reviewedBy: "複核由",
	displaytoc: "顯示TOC",
	viewBy: "檢視以",
	substantiveEvaluation: "證實評估矩陣",
	reviewed: "已複核",
	estimate: "Estimate",
	/*440GL*/
	FourFortyTitle: "證據於報告日({0})後修改",
	LeftContainerTitle440GL: "變更理由",
	approvals: "核准",
	approveChangesColumnTitle: "核准變更",
	approveChangesButton: "核准變更",
	deleteApproval: "移除核准",
	unauthorizedAction: "動作僅可由案件主管執行",
	reasonColumnTitle: "理由",
	approvedBy: "核准由:",
	approvedByPeople: "人員",
	noChangeReasonCommentAvailable: "從文件齒輪選項點選編輯理由以輸入變更理由。",
	changeReasonModalTitle: "編輯變更理由",
	changeReasonModalText: "選擇於報告日後變更文件之理由。若已進行多項行政變更，請從下方之下拉選單選擇最重要之變更。若所作變更包括行政變更及非行政變更，請於下方選擇非行政。",
	changeReasonUploadModalTitle: "上傳文件理由",
	changeReasonUploadModalText: "選擇於報告日後變更文件之理由。若已進行多項行政變更，請從下方之下拉選單選擇最重要之變更。若所作變更包括行政變更及非行政變更，請於下方選擇非行政。",
	changeReasonModalComboPlaceholder: "選擇",
	changeReasonModalAnnotationText: "記錄所遇到情況及加入資訊之理由；所執行新增或額外查核程序、所取得查核證據及所作結論，以及對會計師報告之影響。",
	changeReasonUploadModalAnnotationText: "記錄所遇到情況及加入資訊之理由；所執行新增或額外查核程序、所取得查核證據及所作結論，以及對會計師報告之影響。",
	changeReasonModalAnnotationPlaceHolder: "輸入變更理由",
	changeReasonModalChangeReasonRequired: "儲存變更理由。",
	noDocumentsModifiedAfterReportDate: "沒有於報告日後修改之文件",
	noReasonSelected: "未選擇變更理由",
	fileSizeColumn: "檔案大小",
	changePercent: "% 變動",
	toolTipChangePercent: "檔案大小變動係以報告日之檔案大小與目前檔案大小來計算",
	/*Account Conclusion*/
	AccountConclusion: "科目結論",
	AccountDetails: "詳細內容",
	Conclusions: "結論",
	accountDetailsTab: "詳細內容",
	conclusionsTab: "結論",
	accountConclusionNoContentText: "內容尚未傳送至此表單。請從Global Navigation More選單至「Canvas表單更新」並手動更新內容。",
	validations: "驗證檢查",
	/*RelatedFindings*/
	deficiency: "{0} 相關缺失",
	misstatement: "{0} 相關不實表達",
	relatedDeficiency: "{0} 相關缺失",
	relatedMisstatement: "{0} 相關不實表達",
	deficiencies: "缺失",
	misstatements: "不實表達",
	pagingShowtext: "顯示",
	documentOpenModelLabel: "文件目前修改中",
	openedLabelText: "已開啟",
	modelDocumentOpenedText: "此文件目前修改者為",
	modelUserOpenedTheDocumentText: "使用者開啟文件",
	modelOpenedDocumentConflictText: "開啟文件可能導致衝突。我們建議以唯讀方式開啟。若您想成為文件編輯者，則",
	clickHereEnabledText: "點選這裡。",
	reviewNotesTemporeryFilesTitle: "暫存檔案複核註記",
	addNewReviewNoteTitle: "任務註記",
	/*Assignments*/
	assignedTo: "指派給",
	createAssignment: "建立指派事項",
	createAssignments: "建立指派事項",
	editAssignments: "編輯指派事項",
	deleteAssignments: "刪除指派事項",
	removeAssignments: "移除指派事項",
	noTimephaseSelected: "未選擇",
	unassigned: "未指派",
	unassignedCapitalized: "未指派",
	dueDateBlank: "到期",
	reviewerAssignment: "複核者指派",
	manageAssignments: "管理任務指派事項",
	manageTaskAssignments: "建立指派事項",
	selectedTasks: "選擇任務",
	someTasksCannotBeMoved: "某些任務無法移動",
	onlySomeTaskCanMoveToOtherGroup: "您所選擇的任務中僅有部分可被移動至其他任務群組。",
	taskThatCanBeMovedToOtherGroup: "若您選擇繼續 <b>下列任務將被移動</b> 至您所選的任務群組中。",
	tasksThatCannotBeMovedToOtherGroup: "<b>下列任務無法被移動</b> 至其他任務群組。",
	taskGroupSectionNotFound: "找不到結果",
	placeholderForSearch: "搜尋",
	taskFilter: "篩選",
	noResultsAvavilable: "找不到結果",
	noTasksAvavilable: "No tasks available",
	clearAll: "清除全部",
	engagementPhase: "查核階段",
	noOptionAvailable: "無可用選項",
	noTimePhase: "未指派時程",
	roles: "角色",
	users: "團隊成員",
	rommAssociatedWNotRelyAssertion: "當科目含有估計，重大不實表達風險(ROMM)係連結至不仰賴控制風險聲明或較高固有風險聲明",
	hasRiskAssociated: "風險連結",
	canvas: "Canvas",
	workingoffline: "離線工作",
	syncinprogress: "同步進行中",
	prepareoffline: "離線編製資料",
	connectionavilable: "有連接",
	createAnAssignment: "建立指派事項",
	createAssignmentEnd: "為此任務以開始。",
	// Manage Assignments
	step01: "步驟一",
	step02: "步驟二",
	step03: "步驟三",
	step04: "步驟四",
	step05: "步驟五",
	manageAssigmentsStep1: "選擇動作.",
	manageAssigmentsStep2: "編輯任務指派",
	editAssignment: "編輯指派事項",
	deleteAssignment: "刪除指派事項",
	manageAssigmentsStep3: "完成指派",
	taskAssigmentStatusHeader: "指派事項狀態",
	taskAssigmentStatusTileHeader: 'Task and assignment status',
	taskAssignmentName: "指派事項",
	dueDateAssigment: "到期",
	editDueDate: "選擇性：編輯早於結束日期的天數",
	teamMemberAssigmentLabel: "團隊成員",
	currentAssigmentLabel: "目前",
	handOffToAssigmentLabel: "移交給：",
	priorToEndDateLabel: "結束日期之前",
	noTimePhaseAssigmentLabel: "未指派時程",
	closedByAssigmentLabel: "關閉由",
	onAssingmentLabel: "在",
	preparerAssigmentOpenTitleTip: "移交此任務以關閉您的任務指派事項",
	reviewerAssigmentOpenTitleTip: "標記任務指派事項為關閉",
	reviewerAssigmentClosedTitleTip: "標記任務指派事項為開啟",
	AssigmentLabel: "移交此任務以關閉您的任務指派事項",
	noEvidenceReviewerAssigmentTitleTip: "加入證據以標記任務指派事項為關閉",
	noTaskEvidencesHandoffModal: "沒有與此任務相關的證據文件。",
	back: "返回",
	savecontinue: "儲存並繼續",
	finish: "完成",
	save: "儲存",
	emptyManageAssignmentStep: "...",
	selectAssignmentActionToContinue: "選擇動作以繼續",
	createNewTaskAssingment: "建立新任務指派事項",
	deleteTaskAssingment: "刪除任務指派事項",
	createTaskAssingment: "建立任務指派事項",
	editExistingTaskAssingment: "編輯已存在任務指派事項",
	editTaskAssingment: "編輯任務指派事項",
	removeExistingTaskAssingment: "移除已存在任務指派事項",
	warningPopUpPreparerAssignmentTitle: "覆寫現有編製者指派事項",
	warningPopUpPreparerAssignmentText: "此任務已有編製者指派事項。請確認是否覆寫此指派事項？",
	warningPopUpPreparerAssignmentConfirm: "確認",
	warningPopUpPreparerAssignmentCancel: "取消",
	selectTaskAssingment: "選擇任務指派事項",
	viewHistoryAndConflicts: "檢視歷史",
	noHistoryAvailable: "無歷史記錄",
	teamMember: "團隊成員",
	dateEdited: "最近修改",
	viewHistoryHeader: "此文件版本歷史顯示如下。",
	viewHistorySubHeader: "請點選團隊成員名稱以唯讀模式開啟此文件之以前版本。於此以前版本所作之任何變更將不會儲存到EY Canvas。",
	docConflictedMessage: "與文件有關的衝突。請至文件清單中的衝突頁解決",
	removeTaskAssingment: "移除任務指派事項",
	addAssignmentInstructionalText: "輸入新任務指派事項名稱(例如：詳細複核者，一般複核者)",
	addNewAssingmentName: "加入新指派事項名稱",
	addTaskAssignmentName: "加入任務指派事項名稱",
	assignmentName: "指派事項名稱",
	selectedTask: "選擇任務",
	createTaskAssignmentHeading: "於此建立新指派事項。",
	createTaskAssignmentHeading1: "Enter the assignment details below and select <b>Save and close</b> to finish. To create another assignment, select <b>Save and add another</b>.",
	saveDelete: "儲存並刪除",
	createTaskAssignmentFinishLabel: "儲存並關閉",
	createTaskAssignment: "儲存並加入",
	editTaskAssignment: "儲存並管理其他",
	createTaskAssignmentSaveAndContinueLabel: "儲存並管理其他",
	daysPriorToEndDate: "天早於結束日",
	daysdue: "到期天數",
	daysPriorToEndDateOptional: "早於結束日期的天數(選擇性)",
	timephase: "時程",
	timephasesLabel: 'Time phases',
	manageTimePhase: "Manage time phases",
	removeTaskAssingmentSingleTaskHeading: "請選擇您欲刪除之指派事項。",
	removeTaskAssingmentSingleTaskHeading2: "若已完成請點選「儲存並關閉」或點選「儲存並管理其他」若欲管理其他任務指派事項。",
	removeTaskAssingmentMultipleTaskHeading: "If the assignment and team member combination exists for a selected task, then the assignment will be deleted. Make your selections and select <b>Save & close</b> to finish. To delete another assignment, select <b>Save & delete</b>.",
	editTaskAssingnmentStep2Heading: "請選擇您欲編輯之任務指派事項。",
	selectedAssignment: "選擇指派事項：",
	editTaskAssingmentBulkHeading: "請選擇您要編輯之指派事項。",
	editTaskAssingmentBulkSubHeading1: "若所選任務存在指派事項和團隊成員組合，則將重新指派該任務。您可以選擇編輯<b>結束日期之前的天數</b>。若您編輯此數值，則將更新所有重新指派的任務。進行編輯並選擇<b>儲存並關閉</b>以完成。若要編輯其他指派事項，請選擇<b>儲存並管理另一個</b>。",
	noResultInCategory: "任務類別中找不到結果",
	searchTaskList: "搜尋任務清單",
	searchCanvasFormList: "搜尋",
	clearHoverText: "清除",
	filtersWarningMessage: "超過篩選限制。一次僅可使用25個篩選。",
	reviewNotesWarningMessage: "檢索數據時發生錯誤。請重試，若錯誤仍然存在，請聯絡Help Desk。",
	editTaskAssingmentSept3Header: "編輯所選擇的指派事項。",
	editTaskAssingmentSept3Header2: "若已完成請點選「儲存並關閉」或點選「儲存並管理其他」若欲管理其他任務指派事項。",
	editTaskAssignmentHeaderPart1: "編輯下方的指派事項詳情，然後選擇<b>儲存變更</b>。",
	calculatedDate: "計算日期",
	saveAndAddbtn: "Save and add another",

	//Calendar Toggle Labels
	daysPriorToEndDateRequired: "結束日期前的天數（必填）",
	dueDateRequired: "到期日（必填）",
	selectDate: "選擇日期",
	calculateDate: "計算日期",

	/* Bulk TimePhase*/
	taskText: "任務",
	timephasesetsuccess: "{0} 時段設定成功。",
	timephasessetsuccess: "{0} 時段設定成功。",
	addTimephaseLabel: "新增時段",
	infoSetTimePhase: "<h3>設定時段</h3><p>請拖放一個時段以為所選項目設定該時段</p>",
	infoEditTimePhase: "<h3>編輯時段</h3><p>請點選更多選項(三個點)並選擇編輯以編輯時段之性質。</p>",
	infoAddTimePhase: "<h3>新增時段</h3><p>請點選新增時段以建立一個新的時段。</p>",
	infoDeleteTimePhase: "<h3>刪除時段</h3><p>請點選更多選項(三個點)並選擇「刪除」以刪除該時段。</p>",
	deletedTimePhaseFilterWarningMessage: "時間階段已被其他使用者刪除。",

	//Set assignment dates modal labels
	setAssignmentTitle: "設定指派事項到期日",
	setAssignmentDesc: "您尚未定義指派事項的到期日。 選擇以下指派事項的到期日以繼續。",
	setAssignmentDesc2: "一項或多項任務的時間階段日期早於您選擇的截止日期 {0}。 調整任務的截止日期或時間階段截止日期以繼續。",
	timePhaseNameLabel: "時間階段",
	timephaseEndDate: "時間階段結束日期",
	tasksLabel: "任務數",
	assignmentDateLabel: "指派事項",
	noAssignedTimePhase: "沒有指派的時間階段",
	endDate: "結束日",
	calendarDateError: "到期日應早於時間階段結束日期",

	/* Events*/
	addEventLabel: "新增事件",
	sharedWithClient: "分享",
	noEventsMessage: "沒有辨認出任何事件。",
	naLabel: "不適用",
	deleteEventModalTitle: "刪除事件",
	deleteEventDescription: "您確定要刪除此事件嗎？",
	showEventeName: "事件",
	eventDateLabel: "日期",
	eventDatesLabel: "日期",
	showEventStartDate: "開始日期",
	showEventEndDate: "結束日期",
	deleteEventSuccessMessage: "事件刪除成功",
	eventTypeLabel: "事件類型",
	singleDayEventLabel: "單日",
	multiDayEventLabel: "多日",
	dateRangeEventLabel: "日期範圍",
	eventSharedWithClientLabel: "與客戶共享",
	editEventLabel: "編輯事件",
	eventUpdateSuccessMessage: "事件更新成功",
	noTimephasesMessage: "沒有已被確認的時間階段。",

	/* Review Notes */
	showAll: "All",
	reviewNotesLabel: "複核註記",
	athoredByMeLabel: "由我撰寫",
	assignedToMe: 'Assigned to me',
	assignedToOpen: "指派給（開放）",
	authoredByCleared: "作者：（已清除）",
	totalOpenReviewLabel: "開放的複核註記總計",
	totalClearedReviewLabel: "已清除的複核註記總計",
	agingLabel: "帳齡",
	openLabel: "開啟",
	clearedLabel: "清除",
	noUsersFoundLabel: "未找到結果",
	chartDataLabel: "無可用資料",
	noClientDataAvailable: "無可用資料",
	DaysLessThan10: "<10天",
	Days11To30: "<30天",
	Days31To60: "<60天",
	Days61To90: "<90天",
	DaysMoreThan90: "> 90 天",
	noReviewNotesFound: "沒有找到複核註記",

	formMaxLength: "文字不能超過 {number} 個字符。",
	voiceNote: "語音留言",
	microphoneBlockedMessage: "允許瀏覽器訪問您的麥克風以使用語音註記。若已允許，請重新整理頁面並重試。",
	microphoneBlockedOnVideoMessage: "允許瀏覽器存取您的麥克風以在螢幕錄製中使用語音。 若已允許，請重新整理頁面並重試。",
	notInMainWindowVoice: "側邊欄內不允許進行語音錄製，請在新分頁中開啟文件進行此操作。",
	notInMainWindowScreen: "側邊欄內不允許進行螢幕錄製，請在新分頁中開啟文件進行此操作。",
	screenRecord: "螢幕錄製",
	playbackReview: "回放回顧",
	recording: "錄製",

	/* Sign Offs */
	preparerHoverText: "以編製者身分簽名",
	reviewerHoverText: "以複核者身分簽名",
	preparerTitle: "編製者簽名",
	reviewerTitle: "複核者簽名",
	preparerLetter: "P",
	reviewerLetter: "R",
	deleteHoverText: "移除簽名",
	signoffsrequired: "必須簽名",
	signoffsOptional: "PIC/EQR 選擇性的",
	eqrLabel: "EQR",
	partnerInChargeLabel: "PIC",

	landingPage: "登入頁面",
	dashboardPage: "儀錶板",
	tasksPage: "任務",
	documentsPage: "文件",
	collaborationPage: "合作中心",
	automationPage: "自動化中心",
	newContentUpdate: "內容更新",
	contentUpdatesHistory: "歷程紀錄",
	history: "歷程紀錄",
	contentUpdateType: "內容更新類型",
	iniciatedBy: "發起由",
	date: "日期",
	clickForOptions: "點選更多選項",
	offline: "離線",
	eyServiceGateway: 'EY Service Gateway',
	eyAutomation: 'EY Automation',
	eyserviceGatewayAutomation: 'EY Service Gateway & Automation',

	// ContentUpdates
	contentUpdate: "內容更新",
	canvasFormUpdates: "Canvas form更新",
	syncFormProfile: 'Sync form profile',
	documentName: "文件名稱",
	analyticName: "分析名稱",
	formType: "表單類型",
	dateOfContent: "內容日期",
	formStatus: "狀態",
	formsWarningMessage: "One or more EY Canvas forms must be selected for update",
	formsUpdateSuccessMessage: "EY Canvas form update submitted",
	filterTypeOfFormLabel: "表單類型",
	filterSourceOfFormLabel: "表單來源",
	documentSelectionRequired: "選擇覆寫之文件",
	overwriteForm: "覆寫表單",
	overwriteFormInstructionalText: "請選擇表單以從目前Canvas form之資料覆寫回應。請注意目前Canvas form將移到暫存檔案。",
	confirmOverwrite: "確認覆寫",
	confirmOverwriteAreYouSure: "請確認是否要複製 \'{0}\' 表單內容至\'{1}\'表單？",
	confirmOverwriteDesc: "\'{1}\'表單回應將被覆寫，但相關證據及物件則否。適用之相關證據及物件於完成覆寫後應重新連結到\'{1}\'表單。\'{0}\'表單將維持目前基本資料/GAM layers，因此若基本資料與\'{1}\'表單不同，請複核並清除所複製內容。",
	confirmOverwriteDoNotClose: "當覆寫流程進行時請勿關閉瀏覽器或離開。覆寫流程完成後，\'{0}\'表單將移到暫存檔案。此動作無法復原。",
	sourceDocument: "來源文件",
	targetDocument: "目標文件",
	profileLayers: 'GAM layers',
	pspAccountWarningMessage: "必須選擇一個或多個科目進行更新",
	pspAccountUpdateSuccessMessage: "已提交 PSP 內容更新",
	pspAccountconfirmUpdateMessage: "更新這些科目可能會對內容產生重大影響。 一旦開始，在這些完成之前不能執行額外的內容更新。",
	est: "有估計",
	bookmarkTaskModalHeader: "無法下載所選任務",
	bookmarkTaskModalMessage: "所選任務無法下載離線工作。",
	noGuidanceAvailable: "無指引",
	next: "後",
	previous: "前",
	guidanceLink: "連結",
	addToEvidenceLabel: "加入證據",
	otherEngagements: "其他案件",
	navigationView: "瀏覽檢視",
	listView: "列表檢視",
	detailsView: "詳細內容檢視",
	closeguidance: "關閉指引",
	reviewNotesModalClose: "關閉",
	gamGuidanceLinkLabel: "GAM指引",
	inProgess: "進行中",
	upcomingReview: "待複核",
	teamSummaryEmptyTaskDetailsMesage1: "使用Team Summary依狀態檢視各團隊成員之編製者及複核者指派事項。要管理您案件的全部指派事項，請選擇",
	teamSummaryEmptyTaskDetailsMesage2: "管理指派事項。",
	teamSummaryEmptyTaskDetailsMesage3: "To enable bulk controls, use the checkbox to select one or more tasks. Use the shift key to select several tasks at once. If you would like to work on an individual task, then select that task from the list.",
	taskSummaryPoint1: "選擇「待編製」以檢視每位團隊成員之編製者指派事項清單。",
	taskSummaryPoint2: "選擇「待複核」以檢視每位團隊成員之複核者指派事項清單。",
	taskSummaryPoint3: "指派事項依照指派事項狀態排序（尚未開始、進行中、以及完成）",
	noLinksfound: "此任務無可用連結",
	noFormsfound: "此任務無可用表單",
	workofflinemsg: "您所選擇的任務將下載最新版本，並允許您繼續離線編輯。重新連線後您將可同步您的變更。",
	workonlinemsg: "恢復上線後將自動同步您的變更。重新連線前請確認有網路連線。",
	workoffline: "離線工作",
	workonline: "離線工作",
	duplicateFileNames: "重複檔案名稱",
	training: "訓練",
	duplicateFileNameValidationMessage: "您欲加入至此案件之檔案於此案件有相同名稱之現存檔案。請重新命名其中一個檔案以繼續。",
	documentHelperConnectionIssue: '檢測到 EY Canvas Document Helper 存在問題。 點擊<a style="color: #467cbe" href="https://eyt.service-now.com/kb_view.do?sysparm_article=KB0486774" target="_blank">此處</a>取得如何操作的說明以解決此問題。',
	incompleteCra: "CRA不完整",
	noteItemCreated: "已建立：",
	NetworkErrorMessage: "程式網路出現錯誤。請重新整理頁面並稍後重試。若錯誤仍然存在，請聯絡Help Desk。",
	saveClose: "Save and close",
	contentupdatePSPs: "內容更新 - PSPs",
	/* PAANS */
	paansIsNotReachable: "安永政策編輯、核准及通知服務目前不可用。我們無法確認相關政策是否已完成。若尚未複核相關政策，請重新整理頁面並重試。若問題仍然存在，請聯絡Help Desk。",

	/* Add New Task */
	standardtask: "標準任務 – OST",
	substantivetask: "證實任務 – OSP",
	walkthroughtask: "簡易測試任務 – WT",
	controltask: "控制任務 – TOC",
	addnewTask: "加入新任務",
	taskType: "任務類型",
	taskTypeError: "請選擇任務類型",
	selectTaskTypeHeader: "請選擇任務類型以繼續。",
	selectTaskType: "選擇任務類型",
	enterTaskDetails: "輸入任務詳細內容",
	assignTask: "指派任務",
	taskGroup: "任務群組",
	finishLabel: "儲存並關閉",
	addTaskContinueLabel: "Save and assign",
	AssignTaskStepSaveandContinueLabel: "儲存並加入其他",
	addTaskDetailsHeader: "輸入任務詳細內容以繼續",
	addTaskAssignmentHeader: "選擇性：為此任務建立指派事項。",
	addTaskDetailsSubHeader: "Click <b>Save and assign</b> if you wish to assign this task now or click <b>Save and close</b> if you wish to assign this task later.",
	addTaskAssignmentSubHeader: "輸入以下指派事項詳細內容並選擇「儲存並關閉」以完成。要建立其他指派事項，請選擇「儲存並加入」。",
	addTaskAssignmentSubHeader1: "Enter the assignment details below and select <b>Save & close</b> to finish. To create another assignment, select <b>Save & add.</b>",
	addTaskGroup: "於此加入新任務群組。一旦加入，當建立新任務時您可選擇此任務群組，以及移動現存OST任務至此任務群組。",
	relateObjectHeaderAccount: "Select one or more assertions for a significant account or disclosure, or select a limited risk account.",
	relateObjectSubHeaderAccount: "Tasks can only be related to one account or disclosure.",
	relateObjectHeader: "連結物件以繼續",
	limitedRiskAccount: "有限風險科目",
	onlyShowAddedObject: "僅顯示已加入物件",
	relateObjectRequiredError: "必須選擇物件以繼續。",
	invalidSelectionWarning: "Tasks can only be related to one account or disclosure. Remove the selected assertions or limited risk account to relate the task to assertions for a different account or disclosure or a different limited risk account.",
	invalidSelctionCRA: "請選擇單一物件類型",
	relateObjectOptionsHeaderAccountTask: "聲明及有限風險科目",
	relateObjectOptionsHeaderITWalkthroughTask: "IT/SO processes",
	relateObjectOptionsHeaderITControlTask: "IT 一般控制",
	relateObjectOptionsHeaderITSubstantiveTask: "IT 證實程序",
	relateObjectOptionsHeaderSCOTControlTask: "控制",
	relateObjectOptionsHeaderSCOTWalkthroughTask: "SCOTs",
	StrategyTypeControls: "控制",
	StrategyTypeSubstantive: "證實性",

	//Manage quick filters labels
	manageQuickFilterHeader: "Select a saved or suggested filter as a default.",
	manageQuickFilterText: "If you select a default, then this filter will be applied when you navigate to the task list.",
	noDefaultFilter: "無預設篩選",
	suggestedFiltersHeading: "所建議之篩選",
	savedFiltersHeading: "已儲存之篩選",
	manageQuickFilters: "管理快速篩選",
	manageLabel: "管理",


	/* RNH Labels */
	emptyNoteDetailsMessage: "選擇註記以檢視詳細內容。如要啟動批次控制，請使用control或shift鍵並選擇多個複核註記。若您欲操作個別註記，則從列表中選擇該註記。",
	emptyRepliesMessage: "尚未回覆",
	emptyRepliesMessageAlt: "沒有回覆",
	reviewNotes: "複核註記",
	reviewNotesStatus: "Review note status",
	reviewNotesStatusAssignedToMe: "Status of review notes assigned to me",
	reviewNotesStatusAuthoredByMe: "Status of review notes authored by me",
	comments: "複核註記",
	showHideNotes: "顯示/隱藏註記",
	fileType: "檔案類型",
	noteType: "類型",
	statusId: "狀態",
	rnhPriority: "優先事項",
	rnhDueDate: "到期：",
	rnhModifiedDate: "已修改",
	textAreaPlaceholder: "輸入註記",
	requiredFieldErrorMessage: "此為必要之欄位。",
	meLabel: "我",
	editIconHoverText: "編輯",
	deleteIconHoverText: "刪除",
	deleteIconModalTitle: "刪除註記",
	deleteIconCommentModalTitle: "刪除註記",
	deleteReplyIconModalTitle: "刪除回覆",
	deleteIconModalConfirmMessage: "請確認是否要刪除此註記的回應？",
	deleteIconModalConfirmMessageParent: "請確認是否要刪除所選註記？",
	deleteIconModalCommentConfirmMessage: 'Are you sure that you want to delete this reply?',
	deleteIconModalCommentConfirmMessageParent: "請確認您是否要刪除本註記？本註記之所有回覆亦將被刪除。",
	deleteIconModalAcceptText: "刪除",
	replyInputPlaceholder: "回覆本註記",
	changeStatus: "變更狀態",
	emptyReplyErrorMsg: "新增文字或語音註記以繼續",
	lengthReplyErrorMsg: "回覆不能超過4,000字元",
	closeTitle: "關閉",
	closedBy: "關閉由",
	ClearedBy: "清除由",
	ReopenedBy: "重新開啟由",
	commentTitle: "註記",
	noteDueDateLabel: 'Due',
	reopen: "重新開啟",
	noNotesAssociatedWithDocumentLabel: "使用下面的輸入留下註記。 將註記指派給使用者並指定優先層級和截止日期。",
	noNotesFound: "沒有找到註記",

	/* Add new review note RNH */
	addNewNoteButtonTitle: "New note",
	addNewNoteModalTitle: "加入新註記",
	addNewNoteModalClose: "關閉",
	backButtonLabel: "返回",
	cancelButtonLabel: 'Cancel',
	addNewNoteStep1Title: "選擇註記類型",
	addNewNoteStep2Title: "選擇文件或任務",
	addNewNoteStep3Title: "輸入註記詳細內容",
	editNoteModalTitle: "編輯註記",
	editReplyModelTitle: "編輯回覆",
	voiceNoteButtonLabel: "語音訊息",
	stopRecordingButtonLabel: "停止",
	enterText: "輸入文字",

	/* RNH Review note hub Step 1 */
	step1Title: "選擇註記類型以繼續。",
	step1Subtitle: "您僅可於此處加入文件及任務註記。Canvas表單註解必須於各Canvas表單加入。",
	step1NoTypeSelectedError: "選擇複核註記類型以繼續。",

	/* RNH Review note hub Step 2 */
	step2DocumentTitle: "選擇您欲加入註記之文件。",
	step2TaskTitle: "選擇您欲加入註記之任務。",
	step2SearchTitle: "搜尋",
	step2SearchClearTitleTip: "清除",
	step2ErrorMessageTop: "選擇項目以進行。",
	step2ErrorMessageBottom: "完成以上辨認之必要欄位以進行。",
	step2EmptySearch: "找不到結果",

	/* RNH Review note hub Step 3 */
	step3InstructionalText: "為所選文件或任務輸入註記詳細內容。",
	step3InstructionalSubTitle: "請點選<b>儲存並關閉</b> 當您完成後，或點選<b>儲存並加入其他，</b>若您預計加入其他註記至所選文件或任務。",
	step3SelectedDocument: "所選文件:",
	step3SelectedTask: "所選任務:",
	step3SaveAndContinue: "儲存並加入其他",
	step3SaveAndClose: "儲存並關閉",

	/* RNH List Layout Labels*/
	searchReviewNotes: "搜尋註記",
	searchReviewNotesResultsNotFound: "在本註記類別中找不到結果",
	searchReviewNotesNotAvailable: "無可用註記",
	notesRepliesNotFound: "找不到所選註記之回覆。",

	selectValueToContinue: "請選擇值以繼續",
	required: "必要",
	invalidEngagementId: "案件ID無效。請重新整理頁面並重試。若錯誤仍然存在，請聯絡Help Desk。",
	accessDenied: "拒絕登入",
	annotationDeletedError: "所選註記已刪除。請重新整理謁見並重試。",

	/* RNH Filters */
	rnhClearAll: "清除全部",
	rnhShowMore: "更多",
	rnhFilter: "篩選",
	hideFiltersLabel: "隱藏",
	noDocumentChangeTypes: "找不到結果",
	selectatasktype: "選擇任務類型",
	importfromknowledge: "自Knowledge匯入",
	assigntaskoptional: "指派任務 (選擇性)",
	relateanobject: "連結物件",
	account: "科目",
	userOrRole: "使用者或角色",
	userSummary: "使用者概要",
	other: "其他",
	userNotFound: "找不到使用者",
	dueOnOrBefore: "Due on or before",
	dueOnOrAfter: "Due on or after",

	/*Dashboard - Milestone tile*/
	milestonesLabel: "里程碑",
	scopeAndStrategy: 'Scope & strategy',
	scopeAndStrategyTabLabel: "範圍與策略",
	executionTabLabel: "執行",
	conclusionTabLabel: "結論",
	viewAllTabLabel: "檢視全部",
	noTaskAssociatedToMilestoneMsg: "無任務連結至此查核階段之里程碑。",
	overdueLabel: "逾期",
	upcomingLabel: "截止日期即將到來",
	quickLinkText: "快速連結",
	inreviewLabel: "複核中",
	CompleteLabel: "完成",
	completeLabel: "完成",
	startLabel: "開始",
	endLabel: "結束",
	auditPhaseSummary: "Audit phase summary",
	milestoneView: 'Milestone view',
	timePhaseView: 'Time phase view',
	localLandingPageHeader: 'This page displays only EY Canvas Engagements which are available in this data center.',
	localLandingPage: 'LOCAL LANDING PAGE',
	noEngagementsAvailable: 'No engagements available in this data center',
	engagements: 'Engagements',
	/* Document List */
	docListRelatedTasks: "相關任務",
	temporaryFilesTab: "暫存檔案",
	priorPeriodEvidenceTab: "前期證據",
	conflictsTab: "衝突",
	recentlyDeletedTab: "最近刪除",
	docListSelectedDocument: "{0} 文件已選取",
	docListSelectedDocuments: "{0} 文件已選取",
	shared: "共享",
	shareStatusOwned: "由此案件所有。",
	shareStatusShared: "共享至此案件。",
	unlinkInprogress: "取消連結中",
	unlinkError: "取消連結錯誤",
	documentList: 'Documents',
	restoreModalTitle: "還原至暫存檔案",
	restoreModalText: "還原以退回此文件至暫存檔案。",
	permanentlyDeleteModalTitle: "永久刪除",
	permanentlyDeleteModalText: "永久刪除文件將從EY Canvas移除且無法復原。請點選永久刪除以繼續。",
	misstatementsInstructionalText: "文件連結至此案件以下「不實表達」。請點選以導引至「不實表達」。",
	deficienciesInstructionalText: "文件連結至此案件以下「缺失」。請點選以導引至「缺失」。",
	referenceId: "ID",
	findingDescription: "說明",
	deficienciesModalTitle: "相關缺失",
	misstatementsModalTitle: "相關不實表達",
	startsWith: "開頭以",
	contains: "包含",
	documentsWherePICEQRSignOffIsRequired: "必須由PIC/EQR簽核的文件",
	otherDocuments: "其他文件",
	documentsWherePICSignOffIsRequired: "此文件 PIC 簽名是必須的",
	documentSignoffRequiredLabel: "簽核要求：",
	timePhaseFilterLabel: "時間段",
	drillDownTimePhaseFilterLabel: "按時間階段檢視",
	auditPhasesLabel: "查核階段",
	openedLabel: "Opened",

	clientApprovals: 'External sign-offs',
	noTeamsAvailable: 'No teams have been created yet.  Create a team and send a link request to get started.',
	noDocumentRecieved: 'No documents received yet.',
	team: "團隊",
	pendingEvidence: "待處理證據",
	noTimePhasePlaceHolder: "無時間段",

	regionComponentEvidence: "地區及組成個體證據",
	preparersignoffs: "編製者簽名",
	reviewersignoffs: "複核者簽名",
	receivedon: "接收於：",
	nosignoffsyet: "尚未簽名。",
	noRegionComponentEvidence: 'No documents have been received yet. To see a list of regions and components that have not sent documents yet, select <b>Documentation pending</b>.',
	noComponentEvidence: 'No documents have been received yet.',
	assignToRegionOrComponent: "指派給區域及組成個體",
	assignRegionComponentModalText: "選擇您欲指派此文件之區域及組成個體。",
	documentAssignedToPGT: "This document has already been assigned to another region or component. Therefore, it is not available for assignment.",
	assignedToRegionComponent: "Assigned region or component:",
	noRegionComponentsAvailable: "無區域及組成個體",
	documentUnassignedFromComponent: "已從{1}取消連結{0}。",
	documentUnassigned: "{0}已取消指派。",
	documentReturnedToComponent: "{0}已退回給{1}。",
	documentReturned: "{0}已退回。",
	regionComponentName: "區域或組成個體名稱",
	relatedReviewNoteCount: "來自其他案件之 1 項未解決註記",
	relatedReviewNotesCount: "來自其他案件之{0}項未解決註記",

	deleteVersion: 'Delete version',
	deleteVersionMessage: "Select a version in order to proceed.",
	deleteVersionDisabledMessage: 'History versions can only be deleted from the source engagement of the document by engagement administrators.',
	deleteVersionTitle: 'Delete document version',
	deleteVersionPlaceholder: 'Are you sure you want to delete this history version? This action cannot be undone',

	childDocumentsCountLabel: "存在的副本",
	childDocumentsModalTitle: "存在的副本",
	childDocumentsModalDescription: "以下文件自原始文件建立",
	childDocumentsModalColumnDocumentName: "文件名稱",
	childDocumentsModalColumnDocumentType: "文件類型",
	childDocumentsModalColumnRelatedTasks: "相關任務",
	childDocumentsModalColumnSignoffs: "簽名",

	bulkAddToEvidenceDescription1: "請將顯示為證據的文件建立一個新副本，或選擇一個存在的副本(如可用時)",
	bulkAddToEvidenceDescription2: "新建立之文件將加入至所有與舊文件所連結之任務及Canvas表單。使用進階選項以使用人工選擇新文件所欲連結之任務及Canvas表單。利用搜尋及取代功能以取代新文件名稱中之某些部分(例如：年度)；此功能可被多次使用。",
	bulkAddToEvidenceDescription3: "當一個存在的文件被選擇，它僅能加入至當前之任務。若僅有一個已存在的文件可用時，它將被預選，或選擇一個已存在的副本來加入。",
	bulkAddToEvidenceAdvancedOn: "進階選項",
	bulkAddToEvidenceAdvancedOff: "關閉",
	bulkAddToEvidenceFindText: "尋找文字",
	bulkAddToEvidenceFindTextRequired: "請輸入一個有效尋找文字",
	bulkAddToEvidenceReplaceWith: "取代以",
	bulkAddToEvidenceReplaceSuccess: "取代{0} 以 {1}。",
	bulkAddToEvidenceUseExisting: "使用存在的",
	bulkAddToEvidenceCreateNew: "建立新的",
	bulkAddToEvidenceDocumentName: "文件名稱",
	bulkAddToEvidenceExistingDocument: "已存在的文件",
	bulkAddToEvidenceSelectANewOrExistingCopy: "選擇一個新的或已存在的副本",
	bulkAddToEvidenceAssociateToTasks: "連結至任務",
	bulkAddToEvidenceAssociateToCanvasForms: "連結至Canvas表單",
	bulkAddToEvidenceOtherRelatedTasks: "其他相關任務",
	bulkAddToEvidenceAssociateToTasksPlaceholder: "僅有新建立之文件可以被連結至任務。已存在之文件將被自動連結至目前之任務。",
	bulkAddToEvidenceSelectedTask: "{0} 相關任務",
	bulkAddToEvidenceSelectedTasks: "{0} 相關任務",
	bulkAddToEvidenceSelectedTasksPlaceholder: "無可用的相關任務",
	bulkAddToEvidenceAssociateToCanvasFormsPlaceholder: "僅有新建立之文件可以被連結至Canvas表單。",
	bulkAddToEvidenceRelatedCanvasForms: "相關Canvas表單",
	bulkAddToEvidenceSelectedForm: "{0} 相關Canvas表單",
	bulkAddToEvidenceSelectedForms: "{0} 相關Canvas表單",
	bulkAddToEvidenceSelectedFormsPlaceholder: "無相關Canvas表單",
	picRequiredValidation: "PIC 必須簽名之文件未連結至 PIC 任務",
	eqrRequiredValidation: "EQR 必須簽名之文件未連結至 EQR 任務",
	picEqrRequiredValidation: "PIC/EQR 必須簽名之文件未連結至 PIC/EQR 任務",

	viewSwitcherDefault: "Default view",
	viewSwitcherEntity: "Entity view",
	viewSwitcherAllEntities: "All Entities",
	viewByEntities: "View by entities",

	/* bulk delete modal */
	bulkDeleteFilesModalMessage: "您確定要刪除所選擇的文件嗎?",
	bulkDeleteFIlesModalMessageSub: "無法被刪除的文件列示如下，且將不會被刪除",
	bulkDeleteModalLabel: "刪除文件",
	bulkDeleteSuccessMessage: "文件刪除成功",
	bulkDeleteValidDocumentsHeader: "下列文件將會被刪除",
	bulkDeleteInvalidDocumentsHeader: "下列文件無法被刪除",

	/* Bulk sign-off requirements modal */
	bulkSignOffRequirementsModalMessage: "在下方調整所選文件的執行簽核要求。 某些簽核要求無法被調整，因為這些為 EY Canvas 的要求。",
	bulkSignOffRequirementsResultMessage: "{0} 文件簽核要求已成功更新",


	bulkOpenCountWarning: "所選文件數量超過所允許上限。僅有前面{0} 個將會被開啟",

	/* Pending evidence modal */
	pendingEvidenceInstructionalText: "下列團隊尚未傳送任何集團文件。",
	pendingEvidenceDueDate: "到期日",
	searchRegionComponentLabel: "搜尋區域或組成個體",

	/* Review Notes Count */
	noReviewNotesAssignedOrAuthored: "所選團隊成員沒有註記。",
	noUserSelected: "選擇使用者以檢視詳細內容。您無法指派註記至EY Canvas角色中。",
	reviewNotesText: "複核註記",
	assigned: "已指派",
	authored: "已編輯",
	overdue: "逾期",
	comingDue: 'Coming due',
	cleared: "已清除",
	open: "Open",
	closed: "已關閉",
	noTaskAssignedToUser: "沒有任務被指派給所選的團隊成員或角色。",
	preparer: "編製者",
	reviewer: "複核者",
	assignments: "指派事項",
	notStarted: "尚未開始",
	inProgress: "處理中",
	done: "完成",
	forUpcomingReview: "即將到來",
	noTaskOrNotesAssigned: "所選團隊成員或角色無任務或註記。",
	fromTo: "從/到",

	/* Collaboration grid */
	overdueCollaboration: 'Overdue',
	comingDueCollaboration: 'Coming due',

	/*Document Conflict*/
	documentConflict: "文件衝突",
	documentConflictModalConfirm: "保留此版本",
	documentConflictModalClose: "取消",
	documentConflictInstruction: "為解決衝突，請選擇應保留之文件版本。",
	documentConflictMessage: "點選團隊成員名字以唯讀模式開啟此文件先前版本。對該先前版本所做的任何變更將不會被儲存在EY Canvas。",
	lastmodifiedDate: "最近修改日期",
	modifiedBy: "修改由",
	documentConflictErrorMessage: "選擇版本以繼續",
	currentVersion: "目前版本",
	documentConflictError: "文件衝突錯誤訊息",
	documentConflictHeader: "此文件有衝突",
	viewHistory: "檢視歷程紀錄",
	confirmButtonToolTip: "You must have permission to resolve conflicts for group documents. Contact an engagement administrator and request permission to take this action.",
	documentHistoryHeader: "此文件版本歷程紀錄顯示如下。",
	documentHistoryMessage: "點選團隊成員名稱以唯讀模式開啟此文件先前版本。任何先前版本所作之變更將不會儲存至EY Canvas。",

	documentHistoryInstruction: '若先前版本應是目前版本，請選擇該版本並點選"更新版本"',
	documentHistoryAdminInstruction: '若該版本不是必要的，請選擇版本並點選"刪除版本"。',

	documentHistoryModalConfirm: 'Update version',
	documentHistoryModalClose: "關閉",
	documentHistoryErrorMessage: "文件有衝突，請解決以繼續。",

	/* Dashboard  - Collaboration Tile*/
	clientCollboration: "Client Collaboration",
	nextwaveServices: "集中服務",
	receivedStatusLabel: "已接收",
	acceptedStatusLabel: "已接受",
	outstandingStatusLabel: "未完成",
	collaborationNonUsageMessage1: "使用「合作中心」以直接於EY Canvas傳送請求及外部任務給外部團隊成員。為啟用「合作中心」，請先於EY Canvas Client Portal為您的客戶註冊。下一步請設定登入群組。接下來請建立請求及/或指派外部任務。點選",
	collaborationNonUsageMessage2: "如何開始內容。",
	collaborationNonUsageMessageHyperlinkText: "這裡",
	collaborationNonSentMessage1: "導引至",
	collaborationNonSentMessage2: "並傳送草稿以開始。",
	collaborationNonSentMessageHyperlinkText: "合作中心",
	noBodies: "無內文",
	editResponse: "編輯回應",
	unsentDrafts: "未傳送草稿",
	unsentDraft: "未發送的草稿",
	noUnsentDrafts: "無未傳送草稿",
	requestsSent: 'Requests sent',
	nextWavetotalTasks: "任務合計",
	comingDueTimeframe: 'Time frame',
	otherTimeframeDataAvailableMessage: "請選擇其他時間範圍以檢視資料",

	/* Dashboard Engagement Metrics */
	engagementMetricsTileHeader: "Engagement metrics",
	overdueColumnHeader: "逾期",
	comingDueColumnHeader: "即將到期",
	whatsNewColumnHeader: "What's new",
	placeholderMessageNoContentInSpecifiedTimeframe: "請選擇其他時段以檢視資料",
	placeholderMessageNoEngagementMetrics: "無案件指標。",
	performanceMetrics: 'Performance metrics',
	reviewNotesAndAssignments: "複核註記和指派事項",
	/*Dashboard Engagement overview*/
	engagementOverview: "案件總覽",
	engagementOverviewInstructionalText: "透過以下審計階段複核您的案件進度。",

	/*Dashboard Milestone tile*/
	milestoneprogressTileHeader: "里程碑",
	milestoneprogressSubHeader: "選擇下方的查核階段以按里程碑檢視任務完成情況。 若要按時間階段檢視任務完成情況，請選擇<b>按時間階段檢視</b>。 若要檢視每個里程碑或時間階段的詳細進度，請選擇<b>顯示詳細資訊</b>。",
	tasksStatus: 'Tasks status',
	preparerAssignments: 'Preparer assignments',
	reviewerAssignments: 'Reviewer assignments',
	openComments: "未解決註記",
	/* Dashboard Profile Page */
	groupAudit: "集團查核",
	groupStatus: 'Group status',
	viewInstructions: "檢視指示函",
	instructionsInstructionalText: "請見下方從主查團隊接收之指示函。請選擇連結以檢視指示函。",
	noInstructionsAccepted: "尚無已接受之指示函。",

	/* Dashboard SDM Summary */
	nextWaveservices: "集中服務",
	totalTasksLabel: "任務合計",
	tasksUsingNextWaveservices: ' tasks using Centralized Services',
	tasksSuggestedForNextwaveUse: ' tasks suggested for Centralized Services',
	outOf: "out of",
	tasksUsing: "任務使用",
	suggestedFor: "建議供",
	nextwaveUse: "集中服務",
	draftRequests: "草稿請求",
	draftRequest: "draft request",
	createRequests: "建立請求",
	noRequestCreated: "尚未建立請求。請建立並傳送請求以開始。",

	/* RNH Bulk Controls */
	rnhBulkAssignPriorityTitle: "變更優先順序",
	rnhBulkAssignPriorityTooltip: "優先順序",
	rnhBulkDueDateTooltip: "到期日",
	rnhBulkAssignPriorityModalHeader: "無法編輯所選註記",
	rnhBulkAssignPriorityModalContent: "您僅可變更「未解決」狀態註記之重要性。請重新開啟「已清除」或「已解決」狀態註記以變更重要性。",
	rnhBulkAssignDueDateModalContent: "您僅可變更「未解決」狀態註記之到期日。請重新開啟「已清除」或「已解決」狀態註記以變更到期日。",
	rnhBulkAssignUserTooltip: "重新指派",
	rnhBulkAssignUserSearch: "搜尋",
	rnhBulkAssignUserTitle: "無法編輯所選複核註記",
	rnhBulkAssignUserText: "您僅可重新指派「未解決」狀態之複核註記。請重新開啟「已清除」或「已解決」狀態之複核註記以重新指派。",
	rnhBulkAssignStatusTooltip: "狀態",
	rnhBulkAssignUserNoFound: "找不到結果",
	rnhBulkDueDatePlaceholder: "選擇日期",
	rnhBulkDeleteTextCorrect: "請確認您是否要刪除所選註記？一旦刪除複核註記，您將再也無法存取它。",
	rnhBulkDeleteTextIncorrect: "您僅可刪除「已解決」狀態之註記。若要刪除，請關閉「未解決」或「已清除」狀態註記。",
	rhnBulkDeleteTitleCorrect: "刪除所選註記",
	rhnBulkDeleteTitleIncorrect: "無法刪除所選註記",
	rnhBulkDeleteTextIncorrectComment: "您僅可刪除「已解決」狀態之複核註記。若要刪除，請關閉「未解決」或「已清除」狀態之複核註記。",
	rhnBulkDeleteDescriptionAuthorComment: "您僅可刪除您所編輯的註記。",
	rnhBulkDeleteEngagementComment: "請確認是否刪除所選複核註記？一旦刪除複核註記，您將再也無法存取它。",
	rhnBulkDeleteTitleCorrectEngagementComment: "刪除所選註記",
	rhnBulkDeleteTitleCommentCloseStatus: "無法刪除所選註記",


	fourFortyFilters: "篩選",
	fourFortySearch: "搜尋",

	/* Add External Member Start*/
	addExternalModalTitle: "加入外部成員",
	accessGroupSelection: "登入群組選擇",
	noRecordinGroups: "找不到結果",
	permission: "許可",
	permissionProjectManagement: "案件管理",
	permissionProjectManagementDesc: "可以在EY Canvas Client Portal檢視客戶請求及外部任務狀態。該外部成員將無法登入客戶請求及外部任務細節。",
	permissionInfoTooltip: "所有許可清單",
	groupInfoTooltip: "集團清單",
	groupRequired: "請選擇群組",
	firstnameRequired: "名字為必須",
	lastnameRequired: "姓氏為必須",
	initialsRequired: "縮寫為必須",
	roleRequired: "案件角色為必須",
	confidentialityRequired: "機密程度為必須",
	groupLabel: "登入群組",
	firstnameLabel: "名字",
	lastnameLabel: "姓氏",
	initialsLabel: "縮寫",
	userinfo: "使用者資訊",
	userinfoDescription: "請輸入您欲邀請之團隊成員名字、姓氏或電子郵件地址並按enter.",
	inviteAndClose: "邀請&關閉",
	inviteAndAddOther: "邀請&加入其他",
	addAndClose: "邀請並關閉",
	addAndAddOther: "邀請並加入其他",
	externalUserCreatedSuccessMessage: "您已加入成功",
	accessGroupSelectionMessage: "「存取群組」允許團隊管理外部團隊中誰可以看見寄送至EY Canvas Client Portal的請求」。請與您的客戶商議「存取群組」的清單以及可以存取EY Canvas Client Portal的使用者。當一個請求被指派至一個群組的外部使用者時，它將被該群組中的所有成員看見。",
	accessGroupSectionMessage1: "在新增外部團隊成員進入EY Canvas前，必須先使用My EY Admin Portal註冊外部團隊成員。請點選",
	accessGroupSectionMessage2: "以進入My EY Admin Portal 並開始使用。",
	accessGroupMessageHyperlinkText: "此處",
	accessGroupUserMessage1: "有關使用者引導之更多資訊請點選",
	accessGroupUserMessage2: "以進入EY Atlas。",
	noRecordForExternalMember1: "電子郵件地址無法被找到。",
	noRecordForExternalMember2: "請確認該外部團隊成員已於My EY註冊。",

	/* Add External Member End*/

	/* Edit External Member Start*/

	editExternalModalTitle: "編輯外部成員",
	editExternalaccessGroupSelection: "登入群組選項",
	editExternalGroupInfoTooltip: "集團清單",
	editExternalGroupLabel: "登入群組",
	editExternalGroupRequired: "請選擇群組",
	editExternalNoRecordinGroups: "找不到結果",
	editExternalUserinfo: "使用者資訊",
	editExternalUserinfoDescription: "編輯名字、姓氏、或縮寫。",
	editExternalEmailLabel: "電子郵件",
	editExternalFirstnameLabel: "名字",
	editExternalLastnameLabel: "姓氏",
	editExternalInitialsLabel: "縮寫",
	editExternalSaveLabel: "儲存",
	editExternalUsersSuccessMessage: "變動{0} {1}已成功儲存。",
	editExternalUsersCloseLabel: "關閉",

	/* Edit External Member End*/



	/*access group*/
	groupName: "群組名稱",
	groupNameHelp: "名稱為必要以建立登入群組",
	groupNameHelpOnEdit: "名稱為必要",
	groupNameReq: "群組名稱為必要",
	groupNameInvalidCharacter: "無效字元",
	grpDomainManage: "管理網域",
	grpDomainHelp: "網域限制可加入此登入群組的使用者。至少需要一個網域以建立登入群組。網域請參照@符號後之字元。Use * for wildcard (e.g., *.ey.com).",
	btnAddNewDomain: "加入新網域",
	btnAddExistingDomain: "加入已存在網域",
	domainValidation01: "至少需要一個有效網域",
	domainValidation02: "選擇一個網域",
	domainValidation03: "重複輸入",
	domainValidation04: "無效網域名稱",
	domainValidation05: "網域名稱為必要",
	domainName: "網域名稱",
	emailDomain: "郵件網域",
	groupDeletionErrorPendingReqMsg: "刪除登入群組時發生錯誤。請確認無請求/外部任務指派給此群組或此群組成員並重試",
	groupDeletionSuccessMsg: "{0} 已刪除成功。全部使用中成員已被停用。",

	/* uncommon values for internal mem */
	editInternalMember: "編輯內部成員",
	editThirdPartyMember: "編輯第三方成員",
	listOfAllPerm: "所有許可清單",
	internalPermiInviteExt: "邀請內部成員",
	internalPermiInviteInt: "邀請外部成員",
	internalPermiAssignPer: "指派許可",
	internalPermiDeleteEng: "刪除案件",
	internalPermiArchEng: "歸檔案件",
	internalPermiUpdateContet: "更新內容",

	internalPermiInviteExtToolTp: "可邀請內部團隊成員至案件",
	internalPermiInviteIntToolTp: "可邀請外部團隊成員至案件",
	internalPermiAssignPerToolTp: "可於案件指派該等許可給內部及外部團隊成員",
	internalPermiDeleteEngToolTp: "可刪除案件",
	internalPermiArchEngToolTp: "可歸檔案件",
	internalPermiUpdateContetToolTp: "能夠編輯基本資料及接收內容更新",
	internalMemberInviteSuccessMessage: "您已成功寄送邀請至 {0} {1}",
	internalMemberPostArchivalAdditionSuccessMessage: "您已成功加入{0} {1}",
	invitePriorPeriodUsersSuccessMessage: "您已成功寄送邀請給非使用中之使用者",
	editInternalUsersSuccessMessage: "您的變更 {0} {1} 已儲存成功",
	rbacErrorEditUser: "目前無法儲存變更。請重試，若問題仍然存在，請聯絡Help Desk。",
	universalQueueErrorEditUser: "EY Canvas Landing Page目前無法登入且需要進行編輯。請重試，若問題仍然存在，請聯絡Help Desk",
	removeExternalUsersSuccessMessage: "{0} {1}已成功移除。",
	reActivateExternalUsersSuccessMessage: "{0} {1}已重新啟用以下登入群組：{2}",

	/*user search component*/
	seachInputRequired: "需要搜尋輸入值",
	nameOrEmail: "名稱或電子郵件",
	emailForExternal: "郵件",
	noRecord: "找不到結果",
	userSearchPlaceholder: "輸入名稱或電子郵件並按enter以檢視結果。",
	userSearchPlaceholderForExternal: "輸入郵件及按Eenter鍵以查看結果",
	clearAllValues: "清除全部值",
	inValidEmail: "請輸入有效郵件",

	maxLengthForEditResponse: "最多(包括RTF格式)為30,000字元。請刪除不必要之格式並重試。",
	clickEditResponseToContinue: "請點選編輯回應以繼續",
	bodyDescriptionFromKnowledge: "內文說明來自knowledge",
	execution: "執行",
	cannotpasteimages: "無法貼上圖片",
	pastingImagesNotAllowed: "不允許貼上圖片。若需要圖片請將其上傳作為證據並索引。",
	saveResponse: "有未儲存變更，請問是否繼續",
	conclusion: "結論",
	referenceDocsPlaceHolder: "透過加入經常存取檔案至此以快速開啟。",
	referenceDocsTeamPlaceHolder: "此案件未加入團隊參照文件。請點選「加入文件」以開始。",
	referenceDocsMyPlaceHolder: "您尚未加入任何參照文件。請點選「加入文件」以開始。",
	teamDocuments: 'Team pinned',
	myDocuments: 'My pinned',
	teamDocumentsModalTitle: "Team documents",
	myDocumentsModalTitle: "My documents",
	referenceDocuments: 'Team pinned',

	/* PinnedDocument  */
	PinnedDocument: 'Pinned documents',
	PinnedDocumentSubTite: "Create a list of frequently accessed documents by pinning items to either your own list or your team's list below. To modify the list, select <b>Add document</b>.",
	PinnedDocPaceholder: 'You have not pinned any documents. <br> Select <b>Add document</b> to pin documents here.',
	PinnedTeamDocPlaceholder: "Your team has not pinned any documents. <br> Select <b>Add document</b> to pin documents here.",
	PinnedDocAddDocHeaderText: 'Select evidence and temporary files to customize the list of pinned documents.',
	onlyShowPinnedDocuments: 'Only show pinned documents',
	pinned: 'Pinned',
	/* Arc Timeline */
	arcTitle: "歸檔檢查表",
	arcCompleted: "已完成",
	arcSubmit: "提交歸檔",
	arcDescription: "完成檢查表所有項目以歸檔此案件",
	invalidEngagementCode: "無效的案件編號",
	invalidClientCode: "無效的客戶編號",
	arcCheckBox: "覆蓋歸檔",
	arcUnlinkEvidenceButtonText: "取消連結全部",
	arcUnlinkEvidenceModalTitle: "取消連結全部共享證據",
	arcUnlinkEvidenceModalText: "請確認是否欲於本工作區取消連結此案件來自其他案件之全部共享證據？一旦完成此動作無法復原。",
	arcUnlinkEvidenceModalConfirmButton: "取消連結全部",
	arcUnlinkEvidenceModalCancelButton: "取消",
	arcUnlinkEvidenceButtonUnlinkInProgress: "取消連結中",
	arcUnlinkEvidenceButtonUnlinkError: "取消連結錯誤",
	arcUnlinkGroupEngagementButtonText: "從集團取消連結",
	arcUnlinkGroupEngagementModalTitle: "從集團取消連結此案件",
	arcUnlinkGroupEngagementModalText: "請確認是否欲於此工作區將此案件取消連結其他案件？一旦完成此動作將無法復原。",
	arcUnlinkGroupEngagementModalConfirmButton: "取消連結",
	arcUnlinkGroupEngagementModalCancelButton: "取消",
	arcUnlinkGroupEngagementButtonUnlinkInProcess: "取消連結中",
	arcModalTitle: "現存ARC紀錄",
	arcProceedWithArchive: "進行歸檔",
	arcModalBodyText: "您欲歸檔一還原歸檔案件之檔案。該檔案已存在於Archive Records Center (ARC)。請確認是否要繼續？",
	noDataAvailabel: "目前無資料。請重新整理頁面並重試。若錯誤仍然存在，請聯絡Help Desk。",
	reportDateBeforeCurrentDate: 'The engagement report date must be on or before the current date. Update the report date in order to proceed. To update the report date, click on the "Confirm the accuracy of key engagement dates" link.',

	/*Helix Projects*/
	linkedProjects: "Linked projects",
	suggestedAnalyzers: 'Suggested analyzers',
	linkSelected: "連結已選擇",
	noLinkedProjectsAvailable: "There are no linked projects",
	helixProjectTitle: "EY Helix Projects",
	findProjects: "Find projects",
	findProjectsModalTitle: "尋找 EY Helix 項目",
	selectProjectsToLink: "選擇下方的一個或多個 EY Helix 項目以建立與您的 Canvas 案件連結。 您可以透過客戶編號搜尋以尋找其他 EY Helix 項目。",
	newSearch: "新搜尋",
	noResultsFound: "No results found",
	enterClientCode: "輸入客戶編號再次搜尋",
	enterClientCodeToDisplayAnalizers: 'Enter a client code to display a list of available analyzers.',
	defaultClientCodeIsInvalid: 'The default client code {0} for this engagement is invalid. Enter a valid client code to display a list of available analyzers.',
	mirrorCodesNotAccepted: "Note that mirror codes are not accepted.",
	helixProjectSearch: "搜尋",
	helixProjectsSearchPlaceholderText: "輸入客戶編號以搜尋",
	helixWizardProjectsSearchPlaceholderText: 'Search analyzer by client code',
	selectOneOrMoreProjects: "請從此清單選擇連結Helix projects",
	noPermissionLabel: "您必須有歸檔許可以提交此案件歸檔",
	linkProject: "連結項目",
	oneAnalyzerMustBeSelected: 'One analyzer must be selected.',
	selectAnAnalyzer: 'Select an analyzer',
	selectOneAnalyzer: 'Select an EY Helix analyzer below to create a link with your EY Canvas engagement. You can manually search by client code to find EY Helix projects and the related analyzer(s).',
	selectAnalyzerModalTitle: "選擇Analyzer",
	selectAnalyzerModalBodyText: "選擇一個 EY Helix analyzer與您的 EY Canvas 案件相連結",
	selectAnalyzerModalSubmitButtonLabel: "連結項目",
	projectCanNotBeLikedTootip: "此 EY Helix 計畫不可用，因為它的位置與 EY Canvas 案件的位置不相配。",
	unlinkProjectConfirmationModalTitle: 'Warning - unlink project',
	unlinkProjectConfirmationModalBodyText: 'The EY Helix analyzer being unlinked has client bookmarks associated to this engagement. Unlinking this analyzer will result in those bookmarks no longer being available.  This action cannot be undone. Do you want to continue?',
	defineConnectionSettings: "Define connection settings",

	helixConnectionPageTitle: "EY Helix connections",
	helixConnectionPageSubtitle: "Connected EY Helix analyzers, their imported data, and the percent of GL accounts that have been mapped to EY accounts. Click on the percentage mapped to adjust mapping. The mapped percentage can be different between the connection and the imported data. For instance, if mapping occurred after the imported date. Re-import the data to get the latest mapping.",
	helixIntegrationPageNoConnectedAnalyzerLabel: "No connected analyzers",
	helixIntegrationPageTitle: 'EY Helix integration',
	helixIntegrationPageSubtitle: 'Relate one or more EY Helix analyzers to your EY Canvas engagement.',
	helixIntegrationPageNoHelixProjectLinkedLabel1: 'No related analyzers. To relate a new analyzer,',
	helixIntegrationPageNoHelixProjectLinkedLabel2: '  click here.',
	helixIntegrationPageColumnConnectionName: 'Connection name',
	helixIntegrationPageColumnConnectionType: 'Connection type',
	helixIntegrationPageColumnAnalysisPeriod: "Analysis date",
	helixIntegrationPageColumnAnalyzerName: 'EY Helix analyzer name',
	helixIntegrationPageColumnLastConnectedBy: 'Last connected by',
	connectAnalyzer: "Connect analyzer",
	dataImportModalTitle: "Import confirmation",
	dataImportModalBodyLabel: "A 'Scope & strategy' import already exists in this engagement. Only a single 'Scope & strategy' import is allowed per engagement. Importing this data will replace the existing 'Scope & strategy' import. Do you want to continue? This action cannot be undone.",
	dataImportModalBodyLabelMest: "A 'Scope & strategy' import already exists for this entity. Only a single 'Scope & strategy' import is allowed per entity. Importing this data will replace the existing 'Scope & strategy' import. Do you want to continue? This action cannot be undone.",
	dataImportModalCancelButtonLabel: "Cancel",
	dataImportModalCloseButtonLabel: "Close",
	dataImportModalConfirmButtonLabel: "Import",
	dataImportModalImportError: "An error occurred related to the connected EY Helix analyzer. Data cannot be imported. Refresh the page and try again. If the issue persists, contact the Help Desk.",

	//Entites to Business Mapping Modal
	entityMappingModalTitle: 'Entity mapping',
	entityMappingModalCancelLabel: 'Cancel',
	entityMappingModalSaveLabel: 'Save',
	entityMappingModalDescription: 'Manage the mapping between entities and business units for this connection. Each business unit can be mapped to a single entity only.',
	entityMappingModalBusinessUnitsPlaceholder: 'Business unit(s)',
	entityMappingModalAllBusinessUnitsLabel: 'All business units',
	entityMappingModalBusinessUnitSelectedCount: '{0} business unit',
	entityMappingModalBusinessUnitsSelectedCount: '{0} business units',
	entityMappingModalNoResultsFound: 'No results found',
	entityMappingModalNoEntitiesLabel1: 'No entities exists in the engagement.',
	entityMappingModalNoEntitiesLabel2: 'Create an entity to get started.',
	entityMappingModalBusinessUnitAlreadyMapped: 'A business unit can be related to only one entity. Unrelate from other entities to enable.',
	/*Entites to Business Table*/
	entityMappingTableEntityColumnLabel: 'Entity',
	entityMappingTableBusinessUnitsColumnLabel: 'Business unit(s)',

	helixProjectPageTitle: "EY Helix projects",
	helixProjectPageSubtitle: "Link the EY Helix project(s) relevant to this EY Canvas engagement. When more than one EY Helix project is linked, select one as the primary project to enable data integration into EY Canvas. Only the primary project can be integrated into EY Canvas, so it must contain all journal entry activity for the date that is relevant to the engagement.",
	helixProjectPageNoHelixProjectLinkedLabel1: "目前沒有任何 EY Helix projects與此案件連結。",
	helixProjectPageNoHelixProjectLinkedLabel2: "新增新的 EY Helix project",
	helixProjectPageNoHelixProjectLinkedLabel3: "  開始。",
	helixProjectPageNoHelixProjectLinkedLabel4: "點選",
	linkToHelixProject: "在 EY Helix 中開啟",
	addNewEYHelixProject: "新增新的 EY Helix project",
	eyHelixSetup: "整合 EY Helix 資料",
	existingConnectionDetectedModalTitle: "Existing connection(s) detected",
	existingConnectionDetectedDescription: "The selected analyzer has previously been connected to this EY Canvas engagement. You can either create a new connection or select an existing connection below.",
	selectExistingConnection: "Select an existing connection",
	selectCreateNewConnection: "Create a new connection",
	connectionNoRecords: "No connections found",
	selectOneOfTheOptionsToProceed: "Select one of the options to proceed.",
	saveHelixProjectErrorMessage: "Could not save the selected analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	noResultFoundForAnalyzerSelection: "Ensure that the analyzer you are searching for is in a valid state and that you have been granted access to the analyzer. Contact an EY Helix administrator for more details. Enter a client code to search again.",

	/*Helix Analyzer Details Drawer*/
	connectButtonLabel: "Connect",
	reConnectButtonLabel: "Re-connect",
	demoteFromFinancialStatementsOptionLabel: "Demote from financial statements",
	promoteToFinancialStatementsOptionLabel: "Promote to financial statements",
	deleteOptionLabel: "Delete",
	projectAndAnalyzerDetailsSectionTitle: "Project and analyzer details",
	projectNameLabel: "Project name",
	clientCodeLabel: "Client code",
	analyzerNameLabel: "Analyzer name",
	periodEndDateLabel: "Date end date",
	analysisDateLabel: "Analysis date",
	lastConnectedByLabel: "Last connected by",
	connectionSettingsSectionTitle: "Connection settings",
	connectionTypesLabel: "Connection type(s)",
	currencyTypeLabel: "Currency type",
	currencyLabel: "Currency",
	currencyCodeLabel: "Currency code",
	businessUnitsLabel: "Business unit(s)",
	entitiesLabel: "Entities",
	analysisPeriodLabel: "Analysis date",
	comparativePeriod1Label: "Comparative date 1",
	comparativePeriod2Label: "Comparative date 2",
	manageAccountMappingSectionTitle: "Manage account mapping",
	manageAccountMappingButtonLabel: "Manage account mapping",
	mappedGLAccountsLabel: "% mapped GL accounts:",
	updateSettingsButtonLabel: "Update settings",
	deleteConnection: "Delete connection",
	deleteConnectionQuestion: "Are you sure that you want to delete the selected connection? All previously integrated data related to this connection will be deleted. This action cannot be undone.",
	deleteConnectionWithAnalyticsQuestion: "Are you sure that you want to delete the selected connection? All previously integrated data related to this connection will be deleted. Additionally, the selected connection has client bookmarks associated to this engagement. Deleting the connection will result in those bookmarks no longer being available. This action cannot be undone.",

	/*Helix Projects Table*/
	tableShowing: "顯示結果：",
	tableClientCode: " - 客戶編號：",
	tableEngagementCode: "案件編號",
	tableEngagementCodeName: "案件名稱",
	tableProjectID: "Project ID",
	tableProjectName: "Project名稱",
	tableAnalyzerName: 'Analyzer name',
	tablePeriodEndDate: 'Period end date',
	tableEYHelixPeriodEndDate: "End date",
	tableAnalysisDate: "分析日期",
	tableEYHelixAnalysisDate: 'Analysis date',
	tableAssignedPartner: "指派會計師",
	tableProjectLinked: "項目連結",
	tableTooltipAnalizerIsDeleted: "Analyzer has been deleted within EY Helix. To permanently delete the connection, click to open the details drawer. Please consider if another analyzer should be connected.",
	tableTooltipAnalizerIsUnavailable: "Analyzer is unavailable within EY Helix. Contact an EY Helix administrator for more details. To permanently delete the connection, click to open the details drawer. Please consider if another analyzer should be connected.",
	tableTooltipNotValidUser: "You are not an authorized team member of the selected analyzer. Contact the EY Helix project administrator to gain access and try again.",

	/*Helix Project Cards*/
	cardAnalyzerConnectionLabel: "Connections",
	cardAnalyzerHelixLabel: "EY Helix analyzers",
	cardAnalyzerMappedGLAccountsLabel: "Mapped GL accounts",
	cardAnalyzerEntityMappingLabel: 'Entity mapping',
	cardAnalyzerManageGLAccountsLink: "Manage account mapping",
	cardAnalyzerSectionScopeAndStrategy: "Scope & strategy",
	cardAnalyzerSectionFinancialStatements: "Financial statements",
	cardAnalyzerSectionButtonLink: "here",
	cardAnalyzerSectionButtonDisconnect: "Disconnect analyzer",
	cardAnalyzerSectionScopeAndStrategyNoBalance: "Scope & strategy data is used to present balances in Scope & strategy activities such as materiality. Click {0} to import Scope & strategy data.",
	cardAnalyzerSectionFinancialStatementsNoBalance: "Financial statements can be imported to EY Canvas to provide drill-down from the financial statements to where the work has been performed in the EY Canvas engagement. Click {0} to import financial statements.",
	cardAnalyzerSectionAnotherAnalyzerType: "This analyzer has been connected to facilitate integration between EY Canvas, EY Helix, and/or EY Smart Sampling. Click {0} to disconnect this analyzer.",
	cardAnalyzerSectionButtonLinkDisableTooltip: "You are not an authorized team member of the linked analyzer. Contact the EY Helix project administrator to get access.",
	cardAnalyzerSectionButtonLinkDisableTooltipPermission: 'You do not have the necessary permissions to import this data. Ensure you have the "Import EY Helix data" permission within this Canvas engagement and try again.',
	cardAnalyzerTrialBalanceAnalisysPeriod: "Analysis date",
	cardAnalyzerTrialBalanceComparativePeriod: "Comparative date",
	cardAnalyzerTrialBalanceSecondComparativePeriod: "Second comparative date",
	cardAnalyzerTrialBalanceLastImportDate: "Last imported date",
	cardAnalyzerTrialBalanceCurrency: "Currency",
	cardAnalyzerTrialBalanceBusinessUnits: "Business unit(s)",
	cardAnalyzerTrialBalanceMapedGLAccounts: "Mapped GL accounts",
	cardAnalyzerTrialBalanceImportStatus: "Import status",
	cardAnalyzerTrialBalanceCurrencyTypeFunctional: "Functional",
	cardAnalyzerTrialBalanceCurrencyTypeReporting: "Reporting",
	cardAnalyzerTrialBalanceImportData: "Import data",
	cardAnalyzerTrialBalanceAdjustmentModule: "Adjustment module",
	cardAnalyzerTrialBalanceReImport: "Re-import",
	cardAnalyzerTrialBalanceRemove: "Remove",
	cardAnalyzerTrialBalanceImportStatusInProgress: "In-progress",
	cardAnalyzerTrialBalanceImportStatusImported: "Imported",
	cardAnalyzerTrialBalanceImportStatusError: "Error",
	cardAnalyzerTrialBalanceImportStatusDisconnected: "Disconnected",
	cardAnalyzerTrialBalanceImportModalTitle: "Import data",
	cardAnalyzerTrialBalanceImportModalDescription: "Select the attributes of the import and click 'import' to import",
	cardAnalyzerTrialBalanceImportModalButton: "Import",
	cardAnalyzerTrialBalanceReImportModalTitle: "Re-import data",
	cardAnalyzerTrialBalanceReImportModalDescription: "Select the attributes of the import and click 're-import' to re-import.",
	cardAnalyzerTrialBalanceReImportModalButton: "Re-import",
	cardAnalyzerTrialBalanceImportInProgressTooltip: "Import is in progress. This could take several minutes.",
	cardAnalyzerTrialBalanceImportEntityTooltip: "Entity cannot be changed during a re-import. Create a new import to select a different entity.",
	cardAnalyzerTrialBalanceImportMestEntity: "This selection was made in the previous step. To edit, you must return there.",
	cardAnalyzerTrialBalanceMestBusinessUnit: "This selection is based on the above entity. To edit the entity to business unit(s) relationship, access the 'Entity mapping' on the underlying summary page.",
	cardAnalyzerTrialBalanceFirstSelectCurrencyTypeTooltip: "First select a 'Currency type' to enable this field.",
	cardAnalyzerTrialBalanceFirstSelectCurrencyTooltip: "First select a 'Currency' to enable this field.",

	/*Helis Linked Projects Cards*/
	analysisDate: "分析日期：",
	unlinkProject: "取消連結project",
	editAnalyzer: "編輯analyzer",
	deleteProject: "刪除project",
	projectDeleted: "Project已被刪除。",
	loadingProjectDataLinked: "從 EY Helix 載入資料",
	projectMarkPrimaryConfirmationHeader: 'Change primary EY Helix project',
	projectMarkPrimaryConfirmationMsg: 'Are you sure that you want to change the Primary EY Helix project?',
	projectPrimaryEYHexliProject: 'Primary EY Helix project',
	helixProjectUnlink: 'Unlink',
	helixProjectDelete: 'Delete',
	analyzersLabel: "Analyzers：",


	/*Helix Import List*/
	importHelixList: "EY Helix 匯入清單",
	importDocumentName: "文件名稱",
	importDocumentID: "文件 ID",
	importFileSize: "檔案大小（in KB）",
	importDownload: "下載",
	importNoRecords: "沒有找到文件",
	importInvalidDocumentID: "文件 ID 需要完全相應才能搜尋。 請確保您已提供完整的文件 ID",

	/*Helix Connect analyzer modal*/
	connectAnalyzerClientLabel: "Client:",
	addConnectionNameLabel: "Add connection name",
	connectionNamePlaceholder: "Connection name",
	connectionNameRequired: "Required",
	connectAnalyzerModalTitle: "Connect analyzer",
	connectAnalyzerDescription: "Select an analyzer below to create a link with this EY Canvas engagement. Search by client code to find EY Helix projects and the related analyzers.",
	analyzerLocationIncompatibleErrorMessage: "Analyzer cannot be connected because its data is stored in a location incompatible with the location of the EY Canvas engagement.",
	analyzerMaxConnectionReachedErrorMessage: "Maximum number of allowed connections have been reached for the selected analyzer. Please select another analyzer to proceed.",
	helixAnalyzerErrorMessage: "There was an error connecting to the EY Helix analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	helixAnalyzerGLAConnectionErrorMessage: "There are one or more error(s) connecting to the EY Helix analyzer to get mapped account count. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	helixReImportErrorMessage: "An error occurred importing data from EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.",

	/*Helix Select Entity Modal*/
	selectEntityModalTitle: "Select entity",
	noEntitiesMappedToBusiness: "No entities have been mapped to business unit(s).",
	noEntitiesMappedToBusinessFirst: "Click",
	noEntitiesMappedToBusinessLink: "here",
	noEntitiesMappedToBusinessLinkText: " to get started.",
	searchEntityPlaceholder: "Search entity",
	entityListHeader: "Entity",
	selectEntityErrorMessage: "Select an entity to continue.",
	entityAlreadyConnectedToScopeAndStrategy: "A 'Scope & strategy' import already exists for this entity. Only a single 'Scope & strategy' import is allowed per entity. Remove the existing import to enable this selection.",
	selectEntityNoEntitiesFound: "No results found",
	selectEntityModalDescription: "Select an entity for which you want to import data.",

	/*Manage Account Mapping*/
	manageAccountMapping: "Manage account mapping",
	manageAccountMappingErrorMessage: "Could not connect to EY Helix. Refresh the page and try again. If the issue persists, contact the Help desk.",
	helixViewerLoader: "Loading Helix Viewer...",

	/*Helix Remove Import Modal*/
	removeImportModalTitle: "Remove import",
	removeImportRemoveButtonLabel: "Remove",
	removeImportDescription: "Are you sure you want to remove the following import?",
	removeImportActionUndoneDescription1: "Are you sure you want to remove the following import?",
	removeImportActionUndoneDescription2: "This action cannot be undone.",
	removeImportErrorMessage: "The imported data has been changed since you opened this screen. To continue with the removal, refresh the page and try again.",

	/*Disconnect analyzer modal*/
	disconnectAnalyzerModalTitle: "Disconnect analyzer",
	disconnectAnalyzerDisconnectButtonLabel: "Disconnect",
	disconnectAnalyzerDescription: "Are you sure you want to disconnect the selected analyzer?",
	disconnectAnalyzerImportsExistErrorMessage: "An import was added to this connection since you opened this screen. A connection can only be disconnected if all associated imports are first removed. Refresh the page and try again.",

	/*Content Update */
	quote: '"',
	performContentUpdate: "執行內容更新",
	contentupdate: "內容更新",
	btnContentUpdate: "更新",
	btnContentUpdateSelected: "更新",
	updateSuccessMessage: "內容更新已提交",
	msgContentUpdate: "選擇下方類別以更新內容。若多數工作已完成，請與案件主管討論內容更新是否適當。 內容更新無法復原。",
	msgIndependance: "更新獨立性可能導致需要再次完成獨立性確認。",
	msgProfile: "更新基本資料可能重大影響案件內容。在提交新基本資料前，使用者可能無法登入案件。此動作無法復原。",
	msgHistoryContentUpdate: "先前所進行之內容更新以及其狀態。",
	msgWarningTitle: "警告",
	btnProceedContentUpdate: "處理中",
	btnCancelContentUpdate: "取消",
	confirmationMessageP1: "您將要完成所選內容類別的內容更新。選擇",
	confirmationMessageP2: "繼續或選擇",
	confirmationMessageP3: "若您不希望此時完成內容更新",
	warningMessage: "必須選擇內容類型進行更新",
	groupReportingFormsSent: "group reporting <b>forms sent</b>",
	groupReportingFromStatus: "集團報告表單狀態",
	primaryTeamReviewStatus: "主查團隊複核狀態",
	reportingStatus: "報表狀態",
	taskStatusLabel: "任務狀態",
	primaryTeam: "主查團隊",
	componentTeam: "組成個體團隊",
	groupTasksReceived: 'group audit <b>tasks received</b>',
	group: "集團",
	regionalTeam: "區域團隊",
	unlinkedLabel: "已取消連結",
	linkedLabel: "已連結",
	unlinkedTasks: "<b>unlinked tasks</b>",
	unlinkedTask: "<b>unlinked task</b>",
	primaryTeamGroupTaskPlaceholder: "建立組成個體並傳送集團指示函以於此監督進度。",
	componentTeamGroupTaskPlaceholder: "接受來自主查團隊之組成個體集團任務以於此檢視進度概要。",
	confirmUpdateMessage1: "Updating these forms may have a significant impact on the content. Once started, no additional content update can be performed until these complete.",
	confirmUpdateMessage2: 'Select "Proceed" to continue or select "Cancel" if you do not wish to complete the content update at this time.',
	updateSelectedTitle: 'Update selected',
	statusCodeForbidden: 403,
	pspAccountHeader: "科目",
	pspAccountDateHeader: "內容日期",
	pspAccountStatus: "狀態",
	pspAccountSelected: "已選擇",

	/*Preapre for Arc*/
	YearEndDate: "年度結束日:",
	PeriodEndDate: "涵蓋期間結束日:",
	ReportDate: "報告日:",
	ArcDeadlineDate: "歸檔截止日:",
	ClientCode: "客戶編號：",
	PrimaryEngCode: "主要案件編號:",
	SecondaryEngCode: "次要案件編號:",
	ReportType: "是否為修正式意見及/或有強調事項?:",
	ProtectedDocuments: "注意：除非必要，受保護的文件不應保留在案件文件中",
	noObjectsAvailable: "無可用物件",
	CurrentlyUnavailable: "目前不可用",
	showMoreToggle: "顯示更多",
	showLessToggle: "顯示較少",

	//#region Document upload status

	docListUploadTemporaryPlaceholder: '<center>No documents available<br />―<br />You can drag and drop one or more documents or click <button class="motif-button motif-text-alt-button motif-button-small">Add temporary files</button></center>',
	uploadEvidencePlaceholder: 'Drag and drop one or more documents or click <a>Add evidence</a>',
	uploadTemporaryPlaceholder: 'Drag and drop one or more documents or click <a>Add temporary files</a>',

	processing: "處理中",
	uploading: "上傳中",
	uploadComplete: "進行中",
	downloading: "下載中",
	downloadComplete: "下載完成",
	loading: "載入",

	//#region Filter

	filter: "篩選",
	noFiltersAvailable: "無篩選",
	pickADate: "選擇日期",
	filterYes: "是",
	filterNo: "否",

	//#region Document list filters
	filterGroupDocumentsLabel: "文件",
	filterDocumentContentLabel: "檔案內容",
	filterSharedEvidenceLabel: "共享證據",
	filterFileExtensionLabel: "副檔名",
	filterDocumentConflictLabel: "衝突",
	filterDuplicateFileNameLabel: "重複檔案名稱",
	filterCanvasFormsLabel: "Canvas表單",

	filterGroupModificationsLabel: "修改",
	filterLastModifyUserLabel: "最近修改由",
	filterModifyAfterReviwerSignoffLabel: "複核者簽名後修改",
	filterModifiedAfterLabel: "在所示時點之後才修改",

	filterGroupReviewNotesLabel: "複核註記",
	filterReviewNoteStatusLabel: "狀態",
	filterReviewNoteAssignedToLabel: "指派給",
	filterReviewNoteAuthoredByLabel: "編輯由",
	filterReviewNoteOtherEngagementLabel: "從其他案件",

	filterGroupSignOffsLabel: "簽名",
	filterSignOffMissingLabel: "缺少簽名",
	filterSignedOffByUserLabel: "簽名由",
	filterNotSignedOffByUserLabel: "未經簽名",
	filterSignOffRequirementsLabel: "簽核要求",

	filterGroupOtherLabel: "其他",
	documentLink: "Document link",
	filterByCopyLinkDocument: "Filtered by copy link document",
	filterGroupAuditComponentLabel: "區域/組成個體查核團隊",
	noGroupAuditComponents: "未建立組成個體",
	filterFindingsLabel: "發現",
	filterGroupInstruction: "集團指示函",
	noGroupInstruction: "無指示函被建立",

	documentSearchPlaceholderLabel: "搜尋文件",
	analyticSearchPlaceholderLabel: "搜尋分析",
	//#endregion

	//#endregion

	pendingResponseLabel: "尚未回應",
	receivedLabel: "已接收",
	dueToPrimaryTeam: "Due to primary team",
	sentToPrimaryTeam: "Sent to primary team",
	documentationPending: "Documentation pending",
	documentationComplete: "Documentation complete",
	viewBytimephaseTextLabel: "透過時段檢視",
	showDetails: 'Show details',
	referenceDocAddDocHeaderText: "從本案件連結證據或暫存檔案以從儀錶板存取。",
	addDocsToTeam: "加入文件至團隊文件",
	addDocsToMy: "加入文件至我的文件",
	addDocument: "加入文件",
	externalUserRemove: "移除",

	// Internal user roles abbr
	adminRole: "管理者",
	readOnlyRoleForThirdPartyUser: "唯讀",
	legacy: "未限制",
	permissionLabel: "許可",
	displayPermissionErrorText: "目前無法顯示許可。請重試，若問題仍然存在，請聯絡Help Desk。",
	onlyShowRelatedTasks: "僅顯示相關任務",

	softwareUpdate: "軟體更新",
	updateNow: "現在更新",
	updateMsg: "Software updates are available for EY Canvas. Select Update Now to download and install the updates. The page will be refreshed.",

	processingError: "處理錯誤",

	//Create tag modal labels
	createtags: "建立標記",
	reportDate: "報告日期：",
	managetags: "管理標記",
	savechanges: "儲存變更",
	manageTagGroupCreate: "建立",
	manageTagGroupDiscard: "放棄",
	manageTagGroupCreateTooltip: "標記群組",
	deletetag: "刪除標註",
	deletetaggroup: "刪除標記群組",
	createTagGroup: "建立標記群組",
	manageTagGroupName: "標記群組",
	countOftasksAssigned: "指派的任務數",
	createTagGroupMessage: 'Create tag groups and tags to get started. Click {0} to create a tag group.',
	tagsContnetSearchPlaceholder: "搜尋標記",
	deleteTagHoverText: "一旦儲存，無法復原任何已刪除標註或標註群組。",
	deleteTagGroupHoverText: "將從您案件的所有任務移除此標註。",
	tagSaveChangesInfoText: "將刪除此群組的所有標註並從您案件的所有任務移除。",
	tagConfirmModalTitleText: "一旦儲存將套用變更。",
	tagConfirmModalPrimaryMessage: "請確認是否要儲存變更？",
	tagConfirmModalSecondaryMessage: "請確認是否要儲存該等變更？",
	tagDeleteModalSecondaryMessage: 'Once saved, any deleted tags cannot be recovered.',
	createNewTag: 'Create new tag',
	tagWillBeRemovedFromRequests: 'This tag will be removed from all requests in your engagement.',
	eyTags: 'EY tags',
	clientTags: 'Client tags',
	allTags: 'All tags',
	// Add canvas form
	addCanvasForm: "加入canvas表單",
	addCanvasFormName: "文件名稱",
	addCanvasFormNameBlankMessage: "文件名稱為必填欄位",
	addCanvasFormNameInvalidCharacterMessage: 'Name cannot contain any of the following characters: */:<br>\\?|"',
	addCanvasFormDigital: "數位",
	addCanvasFormCore: "核心",
	addCanvasFormNonComplex: "非複雜",
	addCanvasFormComplex: "複雜",
	addCanvasFormListed: "上市櫃",
	addCanvasFormGroupAudit: "集團審計",
	addCanvasFormPCAOBFS: "PCAOB-FS",
	addCanvasFormPCAOBIA: "PCAOB-IA",
	addCanvasFormStandards: "準則",
	addCanvasFormStandardsNotSelectedMessage: "準則為必要",
	addCanvasFormLanguage: "語言",
	addCanvasFormLanguageNotSelectedMessage: "語言為必要",
	addCanvasFormNoResultFound: "找不到結果",
	addCanvasFormManageTasks: "管理任務",
	addCanvasFormAvailableTasks: "任務名稱",
	addCanvasFormAvailableTaskType: "類型",
	addCanvasFormTypeOfForm: "表單類型",
	addCanvasFormSubServiceLine: 'Sub service line',
	addCanvasFormTypeOfFormNotSelectedMessage: "表單類型為必要",
	addCanvasFormSelectedTasks: "所選任務",
	addCanvasFormNoTaskDataAvailable: "未選擇任務。請選擇至少一項任務以建立表單.",
	addCanvasFormCreateForm: "建立表單",
	addCanvasFormCancel: "取消",
	addCanvasFormSuccessMessage: "已成功建立{0}。傳送內容可能需要十分鐘。",
	// Add Canvas form manage Objects
	addCanvasFormManageObjects: "管理{0}",
	addCanvasFormAvailableObjects: "{0} 名稱 //",
	addCanvasFormSelectedObjects: "已選擇 {0}",
	addCanvasFormClickHereToOpenManageTab: 'Click here to open "Manage {0} tab',
	addCanvasFormNoObjectsDataAvailableRequired: "未選擇{0}。請選擇至少一個以建立表單",
	addCanvasFormNoObjectsDataAvailableOptional: "未選擇{0}.",
	addCanvasFormObjectNotDefinedMessage: "此表單無物件",
	addCanvasFormOptional: "(選擇性)",
	addCanvasFormObjects: "物件",
	addCanvasFormObject: "物件",
	addCanvasFormSCOT: "SCOT",
	addCanvasFormSCOTs: "SCOTs",
	addCanvasFormITProcess: "IT流程",
	addCanvasFormITProcesses: "IT流程",
	addCanvasFormControl: "控制",
	addCanvasFormControls: "控制",
	addCanvasFormITControl: "IT 控制",
	addCanvasFormITControls: "IT 控制",
	addCanvasFormITApplication: "IT 應用系統",
	addCanvasFormITApplications: "IT 應用系統",
	addCanvasFormSignoffRequirements: "需要簽核：",
	addCanvasFormPICCheckBox: "PIC",
	addCanvasFormEQRCheckBox: "EQR",
	itProcessRelatedITGCITSP: 'IT process and related ITGCs/ITSPs',
	taskTitle: 'Understand and document the IT Process: {0}',
	taskDescription: 'Document our understanding of the IT process. Attach the relevant form as evidence to support our understanding of the IT process.<br>When ITGCs appear in the Task Attributes section, perform walkthrough procedures to confirm our understanding of the ITGCs and evaluate their design and implementation. Attach evidence of our procedures.',
	addCanvasFormAccounts: "科目",
	addCanvasFormAccount: "科目",
	addCanvasFormErrorMessage: "此表單只能與一個科目相關",
	addCanvasFormValidationMessage: "需要進行選擇",
	addCanvasFormEstimates: 'estimates',
	addCanvasFormEstimate: 'estimate',
	addEstimateCanvasFormErrorMessage: 'This form can only be related to one estimate',
	addControlCanvasFormErrorMessage: "This form can only be related to one control",
	addScotCanvasFormErrorMessage: "This form can only be related to one SCOT",

	//Independence Confirmation
	sortOrderIndependence: "排序",
	confirmationStatus: "確認狀態",
	confirmationDate: "確認日期",
	independenceConfirmationSearch: "搜尋團隊成員",
	editTemplate: 'Edit template',
	viewTemplate: "檢視表單",
	confirmedBy: "確認由",
	overriddenBy: "覆蓋由",
	grantedBy: "允許登入",
	deniedBy: "拒絕登入",
	list: "清單",
	paginationShow: "顯示",
	options: "選項",
	removeTeamMemberModalText: "請確認是否要從您的案件移除此團隊成員？",
	removeTeamMemberModalTitle: "移除團隊成員",
	overrideRemovedBy: "Override removed by",

	// Custom instructions
	addCustomInstruction: "加入自訂指示函",
	editCustomInstruction: "編輯自訂指示函",
	customInstructionInstructionalText: "於此加入或編輯自訂之指示函。該等指示函將顯示於每位團隊成員之個人獨立性確認，以對如何回應客戶特定問題提供指引。",
	customInstructionPermissionTooltip: "您必須有<b>管理案件</b>權限以執行此動作。請向<b>案件管理者</b>請求權限。",
	customInstructionMaxLengthExceeded: "文字超過最大允許長度",

	//Independence Confirmation Details
	details: "詳細內容",
	question: "問題",
	answer: "回答",
	countTeamMembers: "團隊成員數目",
	executiveApproval: "主管核准",
	yes: "是",
	no: "No",
	independenceModalText: "您可於此檢視「個人獨立性確認」選擇此回答之團隊成員。",
	notApplicable: "不適用",
	readMore: "查看較多",
	readLess: "查看較少",
	teamMembsersTitle: "團隊成員詳細內容",

	tasksSelected: "所選任務",
	taskSelected: "所選任務",
	unselectAll: "取消全選",
	addForm: "加入表單",
	addFormName: "名稱",
	addFormDigital: "數位",
	addFormCore: "核心",
	addFormNonComplex: "非複雜",
	addFormComplex: "複雜",
	addFormListed: "上市櫃",
	addFormGroupAudit: "集團審計",
	addFormPCAOBFS: "PCAOB-FS",
	addFormPCAOBIA: "PCAOB-IA",
	addFormStandards: "準則",
	addFormLanguage: "語言",
	addFormManageTasks: "管理任務",
	addFormManageObjects: "管理物件",
	addFormAvailableTasks: "可用任務",
	addFormAvailableObjects: "可用物件",
	addFormTypeOfForm: "表單類型",
	addFormSelectedTasks: "所選任務",
	addFormSelectedObjects: "所選物件",
	addFormCreateForm: "建立表單",
	addFormCancel: "取消",
	createtag: "建立標記",
	tagsLabel: "標記",

	//Group instruction summary
	sInstruction: "範圍",
	iInstruction: "單獨",

	//CGT and CGT Unlinked related labels
	cgtSend: "傳送",
	cgtDueDate: "到期日",
	cgtFrom: "從",

	notesSelected: "已選註記",
	noteSelected: "已選註記",
	cgtUnlinkedLabel: "已取消連結",
	cgtUnlinkedInformationMessage: "此任務不再連結到其他集團案件，且若不再為必要則可刪除。",
	sendtoPrimaryTeam: "傳送給主查團隊",
	sendtoPrimaryTeamdisableBtn: "此任務必須包括至少一位編製者及複核者簽名的證據以傳送給主查團隊",
	cgtSendModalHeader: 'Select one or more documents to send to the primary team. <span class="modal-instruction-text">Canvas forms will be sent in PDF format.  A record of PDF Canvas forms sent to the primary team is available in Temporary files.</span>',
	cgtNotifyCheck: "通知主查團隊預計將不再傳送其他文件。",
	cgtCanvasFormValidation: 'There are unresolved validations in this Canvas form. Consider whether the validations should be resolved before sending it to the primary team.',
	finalVersionLabel: 'Final version',
	draftVersionLabel: 'Draft version',
	otherEvidence: 'Other evidence',
	selectAtLeastOneDocument: 'Select at least one document to continue.',
	cgtsendmodelinstructionheader: 'Select one or more documents to send to the primary team. <span class="modal-instruction-text">Marking a document as <b>Draft version</b> informs the primary team that you are still working on the document and may send additional versions. Marking a document as <b>Final version</b> informs the primary team that your work is complete and that you do not expect to send any additional versions of the document.</span>',
	//Independence confirmation
	undefined: "未定義",
	incomplete: "未完成",
	nomattersidentified: "未辨認出事項",
	matteridentifiedpendingaction: "已辨認出事項-待處理",
	matterresolveddeniedaccess: "事項已處理 - 拒絕登入",
	matterresolvedgrantedaccess: "事項已處理 - 允許登入",
	notapplicable: "不適用",
	restored: "已還原",
	overriden: "已覆蓋",
	override: "覆蓋",
	priornomattersidentified: "Prior - No Matters Identified",
	priormatteridentifiedpendingaction: "Prior - Matter identified - Pending action",
	priormatterresolvedgrantedaccess: "Prior - Matter Resolved - Granted Access",
	priormatterresolveddeniedaccess: "Prior - Matter Resolved - Denied Access",
	addTagsLabelForTaskList: "加入標記",
	addTagLabelForTaskDetails: "+ 加入標記",
	manageTagsColorInputLabel: "顏色",
	manageTagsTagNameInputLabel: "標記名稱",
	addTagRequiredMessage: "必要",
	addNewTagLinkText: "加入新標記",
	manageTagsLabel: "管理標記",
	manageTagGroupHeader: "於此建立新的標註及群組。您亦可編輯並刪除現存標註及群組。標註任務可提升您的案件管理。",
	//add tag color dropdown
	addTagRedColorText: "紅色",
	addTagOrangeColorText: "橘色",
	addTagTealColorText: "藍綠色",
	addTagBlueColorText: "藍色",
	addTagPurpleColorText: "紫色",
	addTagGreenColorText: "綠色",
	deleteAssignmentConfirmationMessage: "請確認是否要刪除此指派事項？",

	// Return label for Returned document
	recieved: "Recieved",

	selectServiceOffering: "請選擇service offering",
	selectTasks: "選擇任務",
	reviewSuggestedTasks: "Review suggested tasks",
	reviewAvailableTasks: "Review available tasks",
	setDueDate: "設定到期日",
	schedulerCreateRequestStep4TabText: "Operating and communication protocols",
	createWorkRequestHeadingpart1: "命名您的服務請求並選擇service offering以開始。",
	createWorkRequestHeadingpart2: "The service offerings listed below are based on your engagement's profile and the services available in your region. Costs vary by the rank of assigned resources and complexity.",
	createWorkRequestHeadingpart3: "If your engagement has been rolled forward, any service offerings used by your engagement in the prior period are labeled with a",
	createWorkRequestHeadingpart4: "Prior period",
	createWorkRequestHeadingpart5: "badge.",
	createWorkRequestStep2Headingpart1: "Review tasks that are available for the",
	createWorkRequestStep2Headingpart2: "service offering.",
	createWorkRequestStep2Headingpart3: '<u>For team’s participating in the Wave 2 centralization pilot</u>, select the relevant tasks based on the following criteria, which centralized team members may perform: (1) Objective audit procedures (i.e. those procedures that require little or no judgement), (2) Subjective procedures (i.e. those procedures that require judgment) only for either lower risk estimates or when inherent risk is lower for the relevant assertion(s).Tasks that are already included in another centralized service request are labeled as',
	createWorkRequestStep2Headingpart4: '. If you used this service before, tasks that were included in your prior period request are labeled as',
	createWorkRequestStep2Headingpart5: "Prior period.",
	requestName: "請求名稱",
	submittedBy: "提交由",

	// Next wave labels
	totalTasks: "任務",
	noServiceRequest: "尚未建立服務請求。請建立並提交服務請求以開始。",
	eyContact: "EY聯絡人",
	requestStatusText: "請求狀態",
	requestsByStatusText: 'Requests by status',
	serviceRequest: "Service Requests",
	serviceGateway: "Service Gateway",
	centralizedServices: "Request services",
	serviceRequestDueDate: "到期",
	NA: "不適用",
	more: "更多",
	eycontacts: "EY聯絡人",
	addEYContact: 'Add EY contact',
	editEYContacts: 'Edit EY contacts',
	addEYContactInstructions: 'Add or remove EY contacts for this request.  The updated EY contacts will be sent to the resource managers and assigned resources.',
	editEYContactDisabledInstructions: 'You must have the <b>Request services</b> permission to take this action. Speak with an engagement administrator to gain access.',
	emptyEYContactsPlaceholder: 'Add at least one EY contact to continue.',
	estimatedHours: "Time to complete (hours)",
	resourceManagers: "Resource managers",
	nextWaveServices: "Centralized Services",
	centralizedservices: "集中服務",
	onlyShowAccepetedRequests: "僅顯示已接受之請求",
	showSelectedOnly: "Only show selected",
	emptyEngCodeMessage: "您的案件無有效編號。",
	primary: "主要",
	estimatedCosts: "估計成本",
	assignedResources: "已指派資源",
	generalAuditTasks: "一般審計任務",
	generalInfo: "一般資訊",
	requestID: "請求ID",
	createdDate: "已建立",
	startDate: "開始",
	serviceRequestDue: "到期",
	comingDueIn: "即將到期於",
	comingDueTodayLabel: "今天即將到期",
	daysLabel: "日",
	dayLabel: "日",
	createByLabel: "建立者",
	notProvidedLabel: "未提供",
	editLabel: "編輯",
	serviceRequestNoHistoryLabel: "此請求無歷史紀錄。",
	serviceRequestHistoryLabel: "歷史紀錄",
	serviceRequestTasks: "服務請求任務",
	suggestedRequestTasks: "建議請求任務",
	estimatedCost: "估計成本",
	addinstructionsAndRelatedFiles: "Add other operating and communication protocols for this request.",
	instructionText: "若您於次年度後推您的案件，此請求相關證據將被歸檔並包含於此請求。若您後推您的案件，暫存檔案將不會被歸檔且不會包含於此請求。",
	instructionPlaceHolder: "Other operating and communication protocols",
	warningText: "證據將歸檔於請求但暫存檔案則否。",
	availableDocuments: "可用文件",
	noDocumentsAvailable: "無可用文件。",
	selectAll: "選擇全部",
	deselectAll: "取消全選",
	documentsSelected: "文件已選擇",
	selectedDocuments: "已選擇文件",
	noDocumentSelected: "尚未選擇文件。請選擇文件以開始(選擇性)。",
	TaskName: "任務名稱",
	AssignmentsLabel: "指派事項",
	noTaskAssociatedToServiceRequest: "此請求沒有相關任務",
	requestServices: "Request services",

	serviceNotEditable1: "To modify the tasks included in this request, select",
	serviceNotEditable2: "Edit",
	serviceNotEditable3: "on the",
	serviceNotEditable4: "Tasks",
	serviceNotEditable5: "tab. To make additional changes or cancel this service request, then",
	serviceNotEditable6: "contact one of the resource managers",
	serviceNotEditable7: "(if assigned).",

	serviceReqMarkComplete: "Marking a centralized service request as complete will inform the service provider that no additional work is required and that you have finished your review. Once the service request is marked complete, it cannot be undone.",
	serviceReqMarkCompleted: "已完成",
	editServiceRequestTasks1: "Review tasks that are selected for this service request.",
	editServiceRequestTasks2: "All tasks that are suggested for the",
	editServiceRequestTasks3: "service offering are presented here. To add a task, select it from the list below. To remove a task, unselect it.",

	submitServiceRequestConfirmation1: "Are you sure that you want to submit this service request?",
	submitServiceRequestConfirmation2: "You selected a service offering that has already been submitted for your engagement.",
	alreadyScheduledHeader: "Service offering already scheduled",

	createServiceRequestPermission1: "You must have Create service request permissions to continue.",
	createServiceRequestPermission: 'You must have the <b>Manage service requests</b> permission to take this action. Speak with an Engagement Administrator to gain access.',
	schedulerRequestSubmissionError: "An error occurred that prevented this request from being submitted to the scheduler. Select <b>Resubmit</b> to try again. Contact the Help Desk if the error persists.",
	resubmit: "重新提交",
	noServiceManager: "A resource manager has not been assigned to this request yet.",
	noAssignedResource: "No resources have been assigned to this request yet.",
	noMileStoneSetForService: "Milestone start and due dates have not been set for this request yet.",
	isEngagementNominnatedForCentralizeService: 'Has your engagement been selected or confirmed by your Region to participate in the GDS Centralization pilot?',
	needApprovalForSericeRequestCreation: "Please contact your Regional Assurance Managing Partner to obtain the appropriate approval to continue with this service request.",

	//TaskList Filters
	filterMissingRelatedTaskLabel: " PIC/EQR 文件未有相關任務",
	filterRelatedToRisksLabel: "風險相關",
	filterGroupTasksLabel: "任務",
	filterGroupAssignmentsLabel: "指派事項",
	filterGroupDocumentsignoffsLabel: 'Document sign-offs',
	filterGroupProjectManagementLabel: "案件管理",
	filterAssignmentTypeLabel: "指派事項類型",
	filterTaskStatusLabel: "任務狀態",
	filterTaskTypeLabel: "任務類型",
	filterAssignedToLabel: "指派給",
	filterAssignmentStatusLabel: 'Assignment status',
	filterTaskReviewNoteStatusLabel: "註記狀態",
	filterTaskCommentStatusLabel: "註記狀態",
	filterTaskReviewNoteAssignedToLabel: "指派給",
	filterTaskReviewNoteAuthoredByLabel: "建立者",
	filterPICDocumentsAssociated: "關聯的 PIC 文件",
	filterEQRDocumentsAssociated: "關聯的 EQR 文件",
	missingSignOffs: 'Missing sign-offs',
	signedOffBy: 'Signed off by',
	notSignedOffBy: 'Not signed off by',
	filterTimePhaseLabel: "時段",
	filterMilestoneLabel: "里程碑",
	filterAuditPhaseLabel: "審計階段",
	filterEngagementPhaseLabel: "案件階段",
	filterDocumentConflictsLabel: "文件衝突",
	filterEntitiesLabel: "企業",
	missingEntityDocuments: "Missing entity documents",
	filterDownloadedForOfflineLabel: "已下載供離線使用",
	filterNextwaveServicesLabel: "Centralized services",
	filterServiceGateway: "Service gateway",
	filterScheduledServicesLabel: "相關服務",
	filterSuggestedServicesLabel: "建議之服務",
	NoDocumentSignedOffLabel: "No documents signed off by",
	SomeDocumentSignedOffLabel: "Some documents signed off by",
	AllDocumentSignedOffLabel: "All documents signed off by",
	usersLabel: "團隊成員",
	serviceRequests: "Centralized services",
	backToMainPage: "回到主畫面",
	suggestedNextwaveRequests: "Suggested centralized requests",
	/* Component Send Status */
	deliveredDate: "已遞交: {0}",
	sentDate: "已傳送: {0}",
	sentFailure: "遞交發生錯誤，請重試且若問題仍然存在，請聯絡Help Desk。",
	chooseTaskInstructionLabel: "選取任務以包含在此請求",
	createSRstep2InstructionalTextPart1: "其他請求中已包含的任務被標記為",
	createSRstep2InstructionalTextPart2: ". If you used this service offering before, tasks that were included in your prior period request are labeled as",
	createSRstep2InstructionalTextPart3: "使用下列切換按鈕僅顯示建議的任務。",
	availableTasksLabel: "可用任務",
	guidance: "Atlas Guidance",
	helixAnalyzers: "Helix analyzers",
	eyHelix: "EY Helix",
	smartAutomationLinks: "Smart Automation",
	createAutomation: "建立自動化流程",
	noProjectTitle: "連結Helix project",
	multipleProjectsTitle: "選擇已連結Helix project",
	noProjectMessage: "連結Helix project至此案件以開始此Helix analyzer",
	multipleProjectsMessage: "此案件連結多個Helix project。至下列清單選擇一個Helix project以繼續。",

	automationGuidanceHeader: "已建議自動化",
	helixAnalyzersHeader: "已建議analyzers",
	linkToHelixLabel: "連結至 EY Helix",
	noSelectedTasksText: "沒有選擇任務。請選擇任務以開始。",
	selectedTasksLabel: "選擇任務",
	serviceOffering: "Service offering",
	submitRequest: "提交請求",
	scheduleYourRequest: "安排您的請求。",
	serviceRequestStep3HeaderText: "選擇您要指派的來源開始執行這些任務的開始日。然後選擇完成這些任務的日期。",
	serviceRequestMilestoneDueDateHeaderText1: "Select the",
	startanddue: "start and due date",
	eachmilestone: "for each milestone.",
	serviceRequestMilestoneDueDateHeaderText2: " Your team is ultimately responsible for all work delivered. Therefore, the due date selected should allow sufficient time for your team to review the work delivered.",
	serviceRequestMilestoneDueDateHeaderText3: "Estimated time to complete should only include time you expect the service provider to incur.",
	schedulerBudgetMainQuestion: "Has your engagement team:",
	schedulerBudgetFirstQuestion: "Included all work for this request in your financial, pricing, and planning processes?",
	schedulerBudgetSecondQuestion: "Notified your onshore Experience Manager about this request?",
	schedulerBudgetThirdQuestion: "Adjusted hours for onshore team members appropriately?",
	timetocompleteinfo1: "Estimated time to complete should only include",
	timetocompleteinfo2: "time you expect the service provider to incur.",
	serviceRequestStartDate: "開始",
	saveDraft: "儲存草稿",
	step3ValidationError: "到期日必須晚於開始日",
	scheduledLabel: "已安排",
	suggestedLabel: "已建議",
	searchTasksLabel: "搜尋任務",
	submit: "提交",
	selectTaskRequiredErrorMessage: "您必須至少選擇一個任務以繼續",
	moveToCompleted: "移至已完成",
	requestResubmitMessagePart1: "重新提交此請求將重設狀態為",
	requestResubmitMessagePart2: "待處理。",
	requestResubmitMessagePart3: "任何所作變更將被排程者複核。",
	showSuggestedTaskToggle: "僅顯示建議任務",

	// Assignments
	addAssignmentName: "加入指派事項名稱",
	editAssignmentName: "編輯指派事項名稱",
	deleteAssignmentName: "刪除指派事項名稱",
	deleteAssignmentNameInstructionalTextHeader: "請確認是否要刪除指派事項名稱？",
	deleteAssignmentNameInstructionalText: "一旦刪除，指派事項將從您案件中的全部團隊成員及角色移除。",
	assignmentType: "指派事項類別",
	assignmentTypeInstructionalText: "選擇指派事項類型並於下方輸入名稱。請點選<b>加入</b>當您已完成。",
	assignmentEditInstructionalText: "編輯以下指派事項類型及名稱。完成請點選<b>儲存變更</b>。",
	noSuggestedTaskLabel: "此類別無建議任務。",
	manageAssignmentsLabel: "管理指派事項",
	myAssignmentsLabel: 'My assignments',
	myAssignedTasks: 'My assigned tasks',
	currentlyAssignedTasks: 'Currently assigned',
	assignmentModalInstructionalText1: "To reassign or remove tasks assigned to a team member or role, select their name below. You may also use the <b>Delete</b> icon to delete all assignments for a team member or role. To edit or delete the name of an assignment, select the <b>More</b> menu.",
	unassignedTasks: "未指派任務",
	assignedTasks: "已指派任務",
	type: "類型",
	priorperiodservicerequests: "前期服務請求",
	unmarkcomplete: "取消標示完成",
	taskAttributes: "Task attributes",
	engagementTeam: "案件團隊",
	assignTo: "指派給",
	reAssignTo: "重新指派給",
	assign: "指派",
	reAssign: "重新指派",
	reAssignWarningLabel: "選擇任務以重新指派。",
	assignWarningLabel: "選擇任務進行指派。",
	searchByTaskName: "依照任務名稱搜尋",
	searchByTimePhaseName: "以時段名稱搜尋",
	assignment: "指派事項",
	noMembersWithThisAssignment: "此指派事項無團隊成員或角色。",
	deleteTaskAssingmentByMemberAndAssignmentIntructionalText: "指派事項將從您的案件所有任務中移除。",
	noTaskAttributes: "There are no attributes for this task. Select Create or Relate to get started.",
	assignmentWithoutAssignedUser: "此指派事項名稱目前未被使用",

	// v2 profile navigation Zeus to Hercules to Kronos message
	v2ProfileDocumentIdAvailableMessage: "Collecting profile information, please wait",
	v2ProfileDocumentIdDeletedMessage: "No profile information found. Refresh the page and try again. if the error persists contact the Help Desk.",
	accountAndRelatedAssertions: "科目及相關聲明",
	risks: "風險",
	scotName: "SCOT名稱",
	strategy: "策略",
	transactionType: "交易類型",
	notSelectedText: "未選擇",
	relatedBy: "Related by",
	collaboration: "合作",
	controlsLabel: "控制",
	scotAndRelatedControls: "SCOT及相關控制",
	scotAndRelatedRisks: "SCOT and related risks of material misstatement",
	frequencyLabel: "頻率",
	operatingEffectively: 'Operating effectively',
	designedEffectively: 'Designed effectively',
	timeToCompleteHours: "完成時間(小時)",
	completeRequiredFieldValidationError: "請完成全部必要欄位以繼續。",
	itgcsAndItsps: "ITGCs及ITSPs",
	itprocessItgcsAndItsps: "IT流程及ITGC/ITSPs",
	approachLabel: "方法",
	typeLabel: 'Type',
	itProcessName: "IT流程名稱",
	processEvaluation: "流程評估",
	unrelatedControls: "Unrelated controls",
	disableNextwavePlaceholder: "Centralized services are not currently available for your country. Refresh the page and try again. Contact the Help Desk if the error persists.",
	disableNextwavePlaceholderDataCenter: "Centralized services are not currently available for your local data center. Refresh the page and try again. Contact the Help Desk if the error persists.",
	dataPrivacyInviteMessage: "邀請前，您是否已適當考量工作底稿可能由於資料隱私規則而適用登入限制？",
	//Session Timeout
	sessionTimerMsg: "Due to inactivity, your current work session is about to expire. For your security, EY Canvas sessions end automatically after 30 minutes of inactivity. Your current session will expire in {0} minutes. If you wish to remain logged in, please click Continue.",
	logout: "登出",
	sessionPopupTitle: "Automatic logout for your protection",
	allSuggestedTasks: 'Tasks',
	viewByAccount: "View by Account",
	viewBySCOT: "View by SCOT",
	noServiceOfferingsAvailable: "There are no service offerings available for your engagement at this time. Refresh the page and try again. Contact the Help Desk if the issue persists.",

	//Collaboration
	myRequests: 'My requests',
	allRequests: 'All requests',
	calendar: "行事曆",
	calendarTodayButton: "今天",
	requestsListButton: "請求清單",
	eventsButton: "活動",
	analyticsButton: "分析",
	showAssignedToMe: "顯示我的要求",
	selectRequestsTitle: 'Select requests to view details',
	selectRequestsSub1: 'To enable bulk controls, use the check boxes or hold the',
	selectRequestsSub2: 'shift or control keys while selecting multiple requests.',
	noTagMessage: 'No tags created yet. Click <b>here<b> to get started.',
	tagAs: 'Tag as:',
	addTag: 'Add tag',
	searchTag: 'Search tags',
	documentsAttached: 'Documents attached',
	editDraftRequest: 'Edit draft request',
	deleteRequest: 'Delete request',
	deleteLabel: 'Delete',
	deleteLabelDisabled: "權限不足，無法批次刪除。 請聯繫您的案件管理者並請求批次刪除權限。",
	DeleteRequestConfirmMsg1: 'Are you sure that you want to delete this request?',
	DeleteRequestConfirmMsg2: 'This action cannot be undone.',
	deleteRequestSuccess: 'Request has been deleted',
	DeleteRequestsConfirmMsg1: 'Are you sure that you want to delete these {0} requests?',
	dueDateCollabLabel: 'Due date',
	requestLabel: "請求",
	statusLabel: "狀態",
	inValidRequestTitleLabel: "以下請求於目前狀態無法刪除",
	bulkSendButton: "傳送",
	bulkDeleteButton: "刪除",
	commentSyncFailedRetry: "註解無法傳遞至EY Canvas Client Portal。",
	commentSyncFailedRetrySendAgain: "再次傳送。",
	commentDeleted: "此訊息已經被刪除",
	CommmentDeletionSyncFailed: "註解無法從EY Canvas Client Portal被刪除",
	clickLabel: "點擊",
	toRetry: "重新嘗試",
	replySyncFailedRetry: "回覆無法傳遞至EY Canvas Client Portal。",
	quickFilterPriority: "優先事項",
	quickFilterErrorCounterTooltip: "一個或多個請求出現錯誤，需要注意。",

	eyContactNoResultsFound: 'User not found',
	eyContactClear: 'Clear',
	eyContactSearch: 'Search',
	eyContactCollaboration: 'EY contact',
	eyParticipantsCollaboration: "安永參與者",
	externalParticipantsCollaboration: "外部參與者",
	syncInProgressEYContact: "Sync in progress",
	syncErrorEyContact: "Sync error. Please try again.",
	noAssignedContact: "No assigned contact",
	noAssignedParticipant: "未添加參與者",

	commentsTooltipLabel: "註解",
	recordingVirusScanInProgress1: "病毒掃描正在進行中。 完成後即可使用語音註記。",
	screenrecordVirusScanInProgress1: "病毒掃描正在進行中。 螢幕錄製完成後即可使用。",
	recordingVirusScanInProgress2: "請重新整理頁面並重試。",
	confidentialDocumentsModalTitle: "機密文件",
	confidentialDocumentsModalMsg1: "以下機密文件已新增至請求中。",
	confidentialDocumentsModalMsg2: "點選繼續，即表示您確認您具有適當的保密層級，可將文件發送至EY Canvas客戶端，並且您已復核請求的指派事項。",
	confidentialDocumentsModalMsg3: "您沒有適當的保密層級，無法將這些一份或多份文件發送至 EY Canvas客戶端。請刪除您無權訪問的任何機密文件以便繼續。",
	confidentialityLevel: "保密層級",
	voiceNoteUploadError: "取得文件詳細資訊時發生錯誤。請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	requestEventTitle: "事件",
	noTaskDescription: 'No task description',

	newRequestLabel: "新請求",
	newEventLabel: "新事件",

	//Analytics Tab
	analyticsCreateDateLabel: "建立日期：",
	createdByLabel: "建立由：",
	expirationDateLabel: "截止日期：",
	sharedWithLabel1: "共享給",
	sharedWithLabel2: "請求",
	sharedWithLabel3: "請求",
	analyticsTabTitle: "分析",
	analyticsTabSubtitle: "從連接的 EY Helix 項目中與客戶共享分析結果。 請從書籤窗格中開始建立客戶查詢",
	analyticsTabSubtitle2: "EY Helix",
	analyticsTabSubtitle3: '.',
	noActiveAnalyticsLabel: "未選擇分析",
	noActiveAnalyticsSubtitleLabel1: "尚未建立任何分析。 點選",
	noActiveAnalyticsSubtitleLabel2: "這裡",
	noActiveAnalyticsSubtitleLabel3: "  開始。",
	noActiveAnalyticsSubtitleLabel4: "在 EY Helix 中連結一個項目並儲存書籤後，返回此頁面以預覽可共享至EY Canvas Client Portal的分析。",
	selectAnalyticsLabel: "選擇分析",
	analyticsNoPrimaryHelixProjectsMessage: "此案件與 Primary EY Helix project無關",
	selectAnalyticsModal: {
		closeTitleTip: "Close",
		modalTitle: "選擇分析",
		modalHeader: "選擇一個分析與外部團隊成員分享",
		selectAnalyticPlaceholder: "選擇分析",
		selectAnalyticError: "分析為必須的",
		analyticNamePlaceholder: "輸入分析名稱（必填）",
		analyticNameError: "分析名稱為必須的",
		cancel: 'Cancel',
		viewPreview: "查看分析",
		noPreviewAvailable: "預覽不可使用",
		noPreviewDescription: "選擇分析器以啟用預覽",
		clickPreviewAnalytic: "點選以預覽所選分析",
		documentObservation: {
			label: "記錄任何有關所選分析的觀察結果或詢問",
			placeHolderLabel: "輸入觀察結果或詢問（可選擇性的）"
		}
	},
	viewAnalyticsModal: {
		closeTitleTip: "Close",
		observationFieldPlaceholder: 'Observations or queries about the selected analytic',
		noObservationField: 'No observations or queries exist for this analytic.',
		appliedFiltersLabel: 'Applied filters',
		appliedFilters: [{
			id: '1',
			label: 'Analysis currency'
		},
		{
			id: '2',
			label: 'Currency code'
		},
		{
			id: '3',
			label: 'Display rounding'
		},
		{
			id: '4',
			label: 'Business unit group'
		},
		{
			id: '5',
			label: 'Business unit'
		},
		{
			id: '6',
			label: 'Primary account type'
		},
		{
			id: '7',
			label: 'Primary account sub-type'
		},
		{
			id: '8',
			label: 'Primary account class'
		},
		{
			id: '9',
			label: 'Primary account sub-class'
		},
		{
			id: '10',
			label: 'Primary account name'
		},
		{
			id: '11',
			label: 'Primary EY account designation'
		},
		{
			id: '12',
			label: 'Primary EY account'
		},
		{
			id: '13',
			label: 'Business unit'
		},
		{
			id: '14',
			label: "Analysis date"
		},
		{
			id: '15',
			label: "Comparative date"
		},
		{
			id: '16',
			label: 'Segment 01 group'
		},
		{
			id: '17',
			label: 'Segment 02 group'
		},
		{
			id: '18',
			label: 'Segment 03 group'
		},
		{
			id: '19',
			label: 'Segment 04 group'
		},
		{
			id: '20',
			label: 'Segment 05 group'
		}
		],
		save: 'Save',
		cancel: 'Cancel',
		disabledEdit: "Observation cannot be edited because the request has already been sent to EY Canvas Client Portal. Please withdraw the request to enable this action.",
		errors: {
			unautorizedUser: 'You are not an authorized team member of the related EY Helix project. Contact the EY Helix project administrator to get access and try again.',
			bookmarkNotFound: 'The selected analytic has been deleted. Go to EY Helix to manage deleted analytics or to create a new analytic.',
			unautorizedAccessToBookmark: 'You do not have access to the requested EY Helix bookmark. Contact the EY Helix project administrator to get access and try again.',
			authenticationError: "Authentication error. Refresh the page and try again. If the issue persists, contact the Help Desk.",
			genericError: 'Refresh the page and try again. Contact the Help Desk if the error persists.',
			defaultError: '{0} Refresh the page and try again. Contact the Help Desk if the error persists.'
		}
	},
	deleteAnalyticModal: {
		modalTitle: 'Delete analytic',
		modalHeader: 'Are you sure that you want to delete this analytic? The analytic will no longer be available within EY Canvas.'
	},
	// activity feed
	search: "搜尋",
	searchTeams: "搜尋團隊",
	clear: "清除",
	groupActivityLabel: "Group activity",
	documents: "文件",
	documentLabel: 'Document',
	linkRequests: "Link requests",
	received: "已接收",
	returned: "已退回",
	rejected: "Rejected",
	accepted: "Accepted",
	sent: "已傳送",
	unlinked: "未連結",
	finalized: "Finalized",
	groupActivityFeed: "Group activity feed",
	component: "Component",
	noExternalApprovalsMessage: "There are no external approvals",
	noFileSelectedMessage: "Select a document to view details",
	noInstructionSelectedMessage: "請選擇一個項目以檢視詳細內容",
	noLinkRequestSelectedMessage: "請選擇一個項目以檢視詳細內容",
	noItemSelectedMessage: "Select an item to view details",
	viewGroupActivity: "View group activity",
	pointOfContact: "Point of contact",
	currentStatus: "Current status",
	resolved: "Resolved",
	viewVersion: "View version",

	// activity feed right pane headings
	scope: "Scope",
	groupRole: "Group role",
	linkRequestStatus: "Link request status",
	instructionStatus: "Instruction status",
	linkStatus: "Link status",
	today: "Today",
	yesterday: "Yesterday",
	thisWeek: "This week",
	lastWeek: "Last week",
	twoWeeksAgo: "Two weeks ago",
	threeWeeksAgo: "Three weeks ago",
	lastMonth: "Last month",
	older: "Older",
	actionsDateNote: "All dates and times are reported in GMT time.",
	noActionsMessage: "There is no data to display.",
	noManageRequestPermissionMessagePart1: "You must have <b>Manage service request</b> permissions to take this action.",
	guidedWorkflow: "EY Canvas FIT enablement",
	navExecution: "執行",
	navCanvasEconomics: "EY Canvas Economics",
	navOversight: "EY Canvas Oversight",
	navConclusion: "結論",
	navTeamMemberIndependence: "團隊成員獨立性",
	navGroupAudit: "集團管理",
	navGroupActivityFeed: "集團活動消息",
	navPrimaryStatus: "Primary status",
	navComponentStatus: "Component status",
	navGroupStatus: "集團狀態",
	navEngagementManagement: "案件管理",
	navProfile: "基本資料",
	navGroupStructureSummary: "Group structure",
	OpenGuidedWorkflowDocument: "透過 EY Canvas FIT enablement打開此文件",
	navNotApplicable: "不適用",
	canvasForms: "Canvas forms",
	eYCanvasEconomics: 'EY Canvas Economics',
	overDueAssignments: 'Overdue assignments',
	comingDueAssignments: 'Coming due assignments',
	overDueReviewNotes: 'Overdue review notes',
	comingDueReviewNotes: 'Coming due review notes',

	//Group Audit/Status  for DashboardV2

	Reportingformsbystatus: 'Reporting forms by status',
	ReportingStatusSubTitle: "檢視以下指派給組成個體查核團隊之集團任務，以及依照狀態彙總之已接收集團文件。<br/>您可選擇依照團隊或依照集團任務複核詳細進度。",

	Total: 'Total',
	Returned: 'Returned',
	Overdue: 'Overdue',
	PendingResponse: 'Pending response',
	Received: 'Received',
	ReadyForReview: 'Ready for review',
	messageNoDocument: 'No documents received yet.',
	byTeam: 'By team',
	byGroupTask: 'By group task',
	groupStructureLabel: 'Group structure',
	instructionPending: 'Instructions pending acceptance',
	linkRequestPending: 'Link request pending',
	notusingeycanvas: 'Not using EY Canvas',
	pendingLabel: 'Pending',
	teams: 'Teams',
	NoDocumentReceiced: 'No documents received yet.',
	selectTeamToSeeData: 'There is no data available. Select a team to see data here.',
	noDataAvailable: 'There is no data available.',
	prepared: 'Prepared',
	tasksAssigned: 'Tasks assigned',
	taskAssigned: 'Task assigned',
	instructionNotSent: 'Instructions not sent',
	assignedTeamNotProvidedDocForTasks: "\{0}\ teams have not sent documents for these tasks | \{1}\ documents expected",
	documentRecievedOutOfAssignedTasks: 'Documents received <br><b>\{0}\</b> out of \{1}\ Assigned tasks',
	documentRecievedOutOfAssignedTeams: 'Documents received <br><b>\{0}\</b> out of \{1}\ Assigned teams',

	groupStatusSubTitle: "檢視以下主查團隊所指派之集團任務，以及依照狀態彙總之集團文件。<br/>您可選擇依照任務或文件狀態篩選集團任務。",
	notSent: 'Not sent',
	draftsent: 'Draft sent',
	finalsent: 'Final sent',
	noTaskForComponent: 'There is no data available.  <p> Group tasks sent from the primary team will be displayed here after they have been accepted.</p>',
	noTaskForComponentWithStatus: 'There is no data available. <p> Select one or more status options to see data here.</p>',

	//Dashboard V2 - activity feed
	activityFeedSubHeadingText: "請選擇活動類型以複核最近10天之相關案件活動。<br/>點選特定項目之<b>活動</b>按鈕以檢視該等項目之全部活動。<br/>You can also use the toggle to refine your view.",
	activityFeedSubHeadingGroupAudit: "請選擇活動類型以複核最近10天之相關案件活動。<br/>點選特定項目之<b>活動</b>按鈕以檢視該等項目之全部活動。<br/>You can also use the toggle to refine your view.",
	teamHistoryInstructionalText: "複核此團隊過去10天之活動。",
	teamHistory: "團隊歷史紀錄",
	onlySeeMyActivity: "See only my activity",

	taskAddedBy: 'Task added by',
	taskMarkedCompleteBy: 'Task marked complete by',
	taskUnmarkedCompleteBy: 'Task unmarked complete by',
	taskHandedOffBy: 'Task handed off by',
	assignmentAddedBy: 'Assignment added by',
	assignmentEditedBy: 'Assignment edited by',
	assignmentClosedBy: 'Assignment closed by',
	assignmentReOpenedBy: 'Assignment reopened by',
	assignmentDeletedBy: 'Assignment deleted by',
	noteAddedBy: "註記加入者為",
	noteClearedBy: "註記清除者為",
	noteClosedBy: "註記解決者為",
	noteReopenedBy: "註記重新開啟者為",

	linkRequestSent: 'Link request sent by',
	instructionSentBy: 'Instructions sent by',
	linkRequestAcceptedBy: 'Link request accepted by',
	engagementUnlinkedBy: 'Engagement unlinked by',
	instructionAcceptedBy: 'Instructions accepted by',
	instructionReturnedBy: 'Instructions returned by',
	labelTo: 'to',
	instructionReceivedFrom: 'Instructions received from',
	filtersLabel: 'Filters',
	advanceOptions: "批量操作",
	advanceOptionsLabel: "批量操作",
	relatedScots: "相關 SCOT",
	noRelatedScots: "沒有相關的 SCOT",
	materialityLabel: "重大性",
	currentPeriod: "Current date",
	previousPeriod: "Prior date",
	showCurrentPeriod: "Show current date",
	showPriorPeriod: "Show prior date",
	planningMateriality: "規劃重大性",
	tolerableError: "可容忍誤差",
	sadNominalAmount: "SAD 名目金額",
	pmLabel: "PM",
	teLabel: "TE",
	sadLabel: "SAD",
	accountBalance: "科目餘額",
	mapAccountBalances: "對應科目餘額",
	connectToHelixProject: "連接到 Helix 項目",
	connectToImportBalances: "  匯入餘額",
	helixMultiple: "多種的",
	selectMESTentity: "選擇一個個體以檢視詳細資訊",
	relatedWCGWAndControls: "相關 WCGW 和控制",
	relateAtLeastOneWCGW: 'Each assertion with a control risk of Rely must have at least one related WCGW.',
	notRelyRelateWCGW: 'Assertions with a control risk of Not Rely do not have a requirement to identify a WCGW.',
	relatedITProcesses: "相關 IT流程",
	noRelatedITProcesses: "沒有相關 IT 流程",
	relatedITRiskITGCs: "相關 IT 風險、ITGCs 與 ITSPs",
	relatedITRisks: "相關 IT 風險",
	ALRAHigherRiskCode: "H",
	materialityMestSelectEntity: "選擇一個個體以檢視詳細資訊",
	OARCurrentPeriod: "Analysis date",
	OARComparative1Period: "Comparative date 1",
	xTELabel: "xTE",
	priorPeriodDesignation: "前期名稱：",
	priorPeriodEstimate: "前期估計：",
	notApplicableAbbreviation: "不適用",
	accountDetails: "科目詳細資料",
	launchGuidedWorkflow: "啟動引導式工作流程",
	guidedWorkflowTitle: 'Guided workflow',
	viewAccountBalace: 'View account balances',
	viewAccountBalaceForEntity: "Select an entity to view account balances",
	mainActivities: "主要活動",
	oversightProjectTile: {
		typeOversight: 'oversight',
		createProject: 'Create project',
		oversightProjectengagementNotConnectedMessage1: 'The EY Canvas Oversight application summarizes milestone, project management, and group audit progress for connected engagements. Use it to ensure your group audit or portfolio of engagements is on track.',
		oversightProjectengagementNotConnectedMessage2: 'Your engagement is not connected to any EY Canvas Oversight projects.',
		click: 'Click',
		togetstarted: ' to get started',
		clickProjectmessage: 'Click <b> + Create project </b> to get started.',
		lblclient: 'Clients:',
		lblEngagementCount: 'Engagements:',
		lblTaskscompleted: "Tasks completed:",
		lblMore: "more",
		myProject: "My projects",
		OtherProject: "Other projects",
		oversightNoProjectConnectedMessage: "You are not a member of any of the EY Canvas Oversight projects that your engagement is connected to.",
		oversightOtherProjectNotConnectedMessage: "You are a member of all of the EY Canvas Oversight projects that your engagement is connected to.",
		draft: 'Draft',
		allTask: 'All Task',
		totalTask: 'Total Task'
	},

	economicsProjectTile: {
		typeEconomics: 'economics',
		economicsProjectengagementNotConnectedMessage1: 'The EY Canvas Economics application summarizes financial and EY Canvas progress.  Use it to manage the economics for your portfolio of engagements.',
		economicsProjectengagementNotConnectedMessage2: 'Your engagement is not connected to any EY Canvas Economics projects.',
		clickProjectmessage: 'Click <b> + Create project </b> to get started.',
		economicsNoProjectConnectedMessage: "You are not a member of any of the EY Canvas Economics projects that your engagement is connected to.",
		lblForecasted: "Forecasted:",
		lblActual: 'Actual:',
		lblETC: 'ETC:',
		lblVariance: 'Variance'
	},
	leftNavigation: {

		engagementOverview: "案件總覽",
		myProgress: 'My progress',
		executiveTasks: "Focus areas",
		integration: "Integration",
		groupAudit: "Group status",
		pinnedDocuments: "Pinned documents",
		Validations: "Validations",
		activityFeed: "Activity feed",
		primaryStatus: "Primary status",
		componentStatus: "Component status",
		picProgress: "PIC進展",
		picEQRProgress: "PIC/EQR 進展",
		drillDown: "向下鑽研",
		maps: "Maps",
		financialStatement: "Financial statements"
	},
	nowRowOverlayClientRequest: {
		createNew: 'Click Add request to create a new request',
		all: 'No requests have been created',
		draft: 'No requests are in Draft status',
		pending: 'No requests are in Pending response status',
		received: 'No requests have been received',
		accepted: 'No requests have been accepted',
		customFilter: "No matches found. Please try again."
	},

	clientRequestPrefixes: {
		draft: 'Draft',
		returned: 'Returned',
		recalled: 'Recalled',
		withdrawn: 'Withdrawn '
	},

	clientRequestsTabHeader: {
		all: 'All',
		draft: 'Draft',
		pending: 'Pending',
		received: 'Received',
		accepted: 'Accepted'
	},

	clientRequestsPriorityFilters: {
		all: 'All',
		normal: "普通的",
		high: "高度的",
		critical: "重要的",
		highAndCritical: "高度+重要的"
	},

	requestTableHeader: {
		requestId: 'Request Id',
		title: 'Title',
		receivedDate: 'Received date',
		dueDate: "到期日",
		sentDate: 'Sent date',
		acceptedDate: 'Accepted date',
		assignedTo: 'Assigned to',
		group: 'Group',
		status: "狀態",
		priorityType: "優先事項",
		tags: "標記"
	},

	dropdownColumnsFilter: {
		1: 'Assigned to',
		2: 'Group',
		3: "Due date",
		4: 'Sent date',
		5: 'Received date',
		6: 'Accepted date',
		7: 'Status',
		8: "優先事項",
		9: "標記"
	},

	requestTableDropdownFilter: {
		customizeTable: 'Customize table',
		selectInfo: 'Select up to 4 options',
		selectInfoTooltip: 'Select up to four columns. Deselect one or more options to continue.'
	},

	ClientStatus: {
		1: "Draft",
		2: "Draft - No contact",
		3: "Sent",
		4: "系統錯誤",
		5: "無效的客戶聯絡方式",
		6: "待回覆",
		7: "Received",
		8: "Accepted",
		9: "Returned",
		10: "Withdrawn",
		11: "發送正在進行中",
		12: "接受正在進行中",
		13: "收回正在進行中",
		14: "刪除正在進行中",
		15: "退回正在進行中",
		16: "回覆正在進行中",
		17: "Deleted",
		18: "無效的客戶聯絡方式",
		19: "撤回途中",
		20: "Recalled",
		21: "完成正在進行中",
		22: "撤回正在進行中"
	},

	analyticStatus: {
		1: "草稿",
		2: "待核准",
		3: "已核准",
		4: "已到期"
	},

	paginationControl: {
		firstPage: 'First Page',
		lastPage: 'Last Page',
		previousPage: 'Previous Page',
		nextPage: 'Next Page',
		show: 'Show'
	},

	auditPlanFilterLabels: {
		showMore: 'more',
		filterTypeOfScots: "SCOT",
		noScotsAvailable: 'No SCOTs available',
		filterTypeOfITProcess: "IT process",
		noITProcessAvailable: "No IT ​processes available"
	},

	controlListBuildStep4FilterLabels: {
		scots: {
			filterTypeOfScots: "SCOTs",
			noScotsAvailable: 'No SCOTs available'
		},
		testing: {
			filterTypeOfTesting: "Testing",
			noTestingAvailable: 'No Testing available'
		},
		designEffectiveness: {
			filterTypeOfDesignEffectiveness: "Design Effectiveness",
			noDesignEffectivenessAvailable: 'No Design Effectiveness available'
		},
	},

	clientRequestsFilterLabels: {
		filterAssignedTo: 'Assigned to',
		filterAttachmentsLabel: 'Attachment type',
		filterCreatedByLabel: 'Created by',
		filterStatusLabel: 'Status',
		filterDueAfterLabel: 'Due after',
		filterDueBeforeLabel: 'Due before',
		filterErrorsLabel: 'Errors',
		filterOverdueLabel: 'Overdue',
		filterTagLabel: 'Tag',
		filterTimePhaseLabel: 'Time Phase',
		filterTypeLabel: 'Type',
		filterPriorityLabel: "優先事項",
		searchMembers: 'Search members',
		noTags: 'No Tags have been created',
		noTimephase: 'No Time Phase',
		clearAll: 'Clear all',
		clearHoverText: 'Clear',
		noResultsFound: 'No results found',
		yes: 'Yes',
		no: 'No',
		showMore: 'Show more',
		// Check this
		filterNoMatchesFound: 'No matches found. Please try again.',
		filter: 'Filter',
		title: "篩選",
		noRelatedTask: 'No related task'
	},
	//Dashboard - integration

	collaborationInstruction: "檢視下方依照狀態之您的Collaboration請求。<br/> Click on a count to navigate to the request list with filters applied.",
	noValidationsAvailable: 'There are no validations for this audit phase.',
	individualView: 'Individual view',
	engagementView: 'Engagement view',
	centralizedServiceInstruction: 'View the percentage of tasks that are leveraging Centralized Services as well as requests by status below. <section >To create a new request, select <b>Request services.</b></section>',
	// Dashboard - todo list
	todoList: 'To-do list',
	todoListInProgress: "目前的",
	todoListOpen: "即將推出",
	todoListClosed: "已完成",
	todoListInstruction: "View assignments and review notes coming due by status. <br /> Select a time frame or category to refine your view. <br /> To open an item, click on the task or review note name.",
	noOpenAssignments: 'You do not have any open assignments.',
	noInProgressAssignments: 'You do not have any in progress assignments.',
	noClosedAssignments: 'You do not have any closed assignments.',
	allLabel: 'All',
	dueLabel: 'Due',
	noAssignments: 'You do not have any assignments.',
	executiveReview: 'Executive review',
	epTasksStatusSignOffWithoutDetails: "查看下方 PIC 狀態彙總。",
	epTasksStatusSignOff: "查看下方 PIC 狀態彙總。若要查看詳細內容，請選擇<b>查看詳情</b>。",
	epeqrTasksStatusSignOffWithoutDetails: "查看下方 PIC 和 EQR 狀態的彙總。",
	epeqrTasksStatusSignOff: "檢視下方 PIC 和 EQR 狀態的摘要。 如須詳細查看，請選擇<b>檢視詳細資料</b>。",
	eqrDefaultMessage: "此案件無須 EQR。",
	selectPartners: 'Select a partner',
	noPartnersInEng: 'There are no partners in your engagement.',
	epTasks: "PIC任務",
	eqrTasks: 'EQR tasks',
	viewDetails: "檢視詳細資料",
	picReview: "PIC 複核",
	eqrReview: "EQR 複核",
	eqrtasksWithSignOff: "EQR <br/> 任務簽名未完成",
	eqrdocumentsWithSignOff: "EQR <br/> 文件簽名未完成",
	pictasksWithSignOff: "PIC <br/> 任務簽名未完成",
	picdocumentsWithSignOff: "PIC <br/> 文件簽名未完成",
	partnerSignoffs: 'Partner sign-offs',
	epTaskswithpartnersignoffs: "Click on a count to navigate to the task list with filters applied.",
	allDocssignedoff: 'All documents <br/>signed-off',
	someDocssignedoff: 'Some documents <br/>signed-off',
	noDocssignedoff: 'No documents <br/>signed-off',
	partnernotinvited: 'Partner not invited',
	noEQRsinyourengagement: 'There are no EQRs in your engagement.',
	selectEQRs: 'Select an EQR',
	eqrNotinvited: 'EQR not invited',
	eqrsignoffs: 'EQR sign-offs',
	eqrtaskswithpartnersignoffs: "Click on a count to navigate to the task list with filters applied.",
	allpartners: 'All partners',
	allEQRs: 'All EQRs',
	reviewComments: "複核註記",
	noOpenReviewComments: "您無任何未解決之複核註記。",
	noClearedReviewComments: "您無任何已清除之複核註記。",
	noClosedReviewComments: "您無任何已解決之複核註記。",
	noReviewCommentsForSelectedTime: "該所選時段，您並無任何複核註記。請選擇其他時段以繼續。",
	picTasksSomeDocSignOff: "PIC 已簽核一些文件的任務",
	picTasksNoDocSignOff: "沒有 PIC 簽核文件的任務",
	eqrTasksSomeDocSignOff: "EQR 已簽核一些文件的任務",
	eqrTasksNoDocSignOff: "沒有 EQR 簽核文件的任務",
	picNotIdentified: "沒有辨認 PIC",
	eqrNotIndentified: "沒有辨認 EQR",
	todoReviewNote: "複核註記",

	// Dashboard - Executive Tasks
	executiveTasks: 'Focus areas',
	executiveTasksInstruction: "Select to view tasks by risk or by account below. <br/> Once you have made your selection, hover over a count to see more details or select a task to navigate to its specific details page.",
	byRisk: 'By risk',
	byAccount: 'By account',
	responsiveTasks: 'Related tasks',
	openNotes: "未解決註記",
	lowLabel: 'Low',
	mediumLabel: 'Medium',
	highLabel: 'High',
	criticalLabel: 'Critical',
	epRequired: "PIC必須的",
	eqrRequired: 'EQR required',
	noDocumentsSignedOff: 'No documents signed off',
	someDocumentsSignedOff: 'Some documents signed off',
	allDocumentsSignedOff: 'All documents signed off',
	completedAssignments: 'Completed assignments',
	designation: 'Designation',
	significantAccount: 'Significant account',
	epSignOff: "PIC 簽核",
	eqrSignOff: 'EQR sign-off',
	someLabel: 'Some',
	riskNoDataLabel: 'This risk has not been related to any tasks.',
	accountNoDataLabel: 'This account and its assertions have not been related to any tasks.',
	NoDataLabel: 'No data available for selected Accordion',
	// Manage tags
	manageTagsInstructionalText: `Create new tags here. You can also edit and delete existing tags. Tagging requests can improve your engagement's organization and project management.`,
	noTagsAdded: 'No tags added. Create a tag to get started.',

	// Client Request Comments
	noCommentsCreatedYet: 'No comments have been created yet.',
	addCommentTitleTip: "新增註解",
	addReplyTitleTip: "新增回覆",
	addAComment: "發表註解...",
	addAReply: 'Add a reply',
	deleteCommentConfirmationModalTitle: "刪除註解",
	deleteCommentConfirmationModalMessage: "您確定要刪除此註解嗎？ 對此註解的所有回覆也將被刪除。",

	// Client Request Voice Note Comment Labels
	voiceNoteCommentRecordLabel: "語音註記",
	voiceNoteCommentStopLabel: "停止",
	voiceNoteCommentPlayLabel: "開始",
	voiceNoteCommentDeleteLabel: "刪除",

	//Client Request Status/Tooltip messages
	SendRequestSuccess: 'Request has been submitted successfully',
	BulkSendRequestSuccess: '{0} requests have been sent successfully',
	BulkSendOneRequestSuccess: "1 request has been sent successfully",
	SendInProgress: 'Send in progress',
	AcceptInProgress: 'Accept in progress',
	CompleteInProgress: 'Complete in progress',
	HasErrorState: 'Request could not be sent. Please try again.',
	WithdrawRequestSuccess: 'Request has been withdrawn',
	WithdrawInProgress: 'Withdraw in progress',
	WithdrawRequestError: 'Request could not be withdrawn, please try again.',
	DeleteRequestError: 'Request could not be deleted. Refresh the page and try again.',
	AcceptRequestError: 'Request could not be accepted, please try again.',
	CompleteRequestError: 'Request could not be completed, please try again.',
	InvalidClientContact: 'Invalid client contact.',
	BulkSendInvalid: 'One or more selected requests cannot be sent without taking further action. Please review and try again.',
	returnInProgress: 'Return in progress',
	returnRequestError: 'Request could not be returned, please try again',

	//Client Withdraw Request
	WithdrawRequest: 'Withdraw request',
	WithdrawReuestConfirmMsg: 'Are you sure that you want to withdraw this request? Once withdrawn, the client can no longer view it. The request will move to the Draft list once complete',
	WithdrawMenuOption: 'Withdraw',
	MoreOptions: 'More options',
	Complete: 'Complete',
	WithdrawLabel: 'Withdrawn',
	CompleteInstructionalText: 'Use Complete when information has already been provided by the client',

	//Client Complete Request
	CompleteRequestConfirmMsg: "完成請求後會將該請求從客戶的待辦事項清單中移除，並將狀態更新為已傳送。該請求將移至 EY Canvas 中的已接收清單。例如，當已透過替代方式接收所要求的資訊時，可以使用它。",
	CompleteRequest: 'Complete request',
	CompleteRequestSuccess: 'Request has been completed',

	//Client Accept Return Request
	AcceptLabel: 'Accept',
	ReturnLabel: 'Return',
	ReturnRequest: 'Return request',
	acceptRequest: 'Accept request',
	acceptRequestWithoutTask: 'Are you sure that you want to accept the selected request?',
	acceptRequestWithTask: '<b>Are you sure that you want to accept the selected request?</b> The attached documents will be available from the external documents tab of the {0} related task(s).',
	acceptRequestSuccess: 'Request has been accepted',
	returnedRequestSuccess: 'Request has been returned -',

	// Client Request Relate Files modal
	noRecordsFound: 'No records found',
	relateSelected: 'Relate selected',
	relateFilesModalHeader: 'To relate existing documents to this request, select the documents and click on Relate selected.',
	relateAnalyticModalHeader: "若要將現有分析與此請求相關聯，請勾選所選分析的方框。若要預覽其他可用的分析，請點選。",
	relateAnalyticHereModalHeader: "這裡",
	noAnalyticsRecordsFound: "沒有可供分享的分析。 請點選",
	noAnalyticsRecordsFoundGetStarted: "開始。",
	associateExistingDocumentsSelected: 'documents added',
	associateExistingDocumentSelected: 'document added',

	// Client Request Details Header
	timePhaseLabel: 'Time phase:',
	receivedDateLabel: 'Received:',
	dueDateLabel: 'Due:',
	sentDateLabel: 'Sent:',
	acceptedDateLabel: 'Accepted:',
	clientRequestSyncLabel: 'Updates are being sent to EY Canvas Client Portal',
	editDescriptionLabel: 'Edit Description',
	createdDateLabel: "建立日期：",

	//Client Advance Search
	advancedSearch: 'Advanced search',
	advancedSearchRefereceNumberCheck: 'Reference #',
	advancedSearchTitleCheck: 'Title',
	advancedSearchDocumentsCheck: 'Documents',
	advancedSearchCommentsCheck: "註解",
	advancedSearchApplyButton: 'Apply',
	searchRequest: "搜尋",
	clearSearch: 'Clear search',

	//Adjustment Topup module
	adjustmentModule: {
		currencyType: 'Currency type',
		currencyCode: 'Currency code',
		businessUnit: 'Business unit',
		all: 'All',
		moduleName: "Adjustment module",
		financialStatement: "Financial statements",
		viewByTrialBalanceType: "View by trial balance type",
		multiEntry: "Multi-entity",
		balanceSheet: "Balance sheet",
		incomeStatement: "Income statement",
		currentperiodUnadjusted: "Analysis date",
		unadjusted: "(unadjusted)",
		currentperiodAdjusted: "Analysis date",
		adjusted: "(adjusted)",
		adjustment: "Adjustment",
		newAdjustment: "New adjustment",
		noRecordsFound: "No records found",
		periodEnded: " date ended",
		periodsEnded: " dates ended",
		noResultsFound: "No results found",
		notApplicableAbbreviation: "N/A",
		noAdjustmentCreated: "No adjustment created.",
		createAdjustment: "Create a {0}.",
		next: "Next page",
		previous: "Previous page",
		reclassification: "Reclassification",
		manageAdjustment: "Manage adjustments",
		lastPage: "Last page",
		firstPage: "First page",
		filterYes: "Yes",
		filterNo: "No",
		showOnlyAdjustedAccountClasses: "Show only adjusted account classes",
		noneAvailable: "None available",
		noImportedTrialbalanceAvailable: "No imported trial balance.",
		trialBalanceRequired: "Trial balance",
		comparativeperiodUnadjusted: "Comparative date",
		comparativeperiodAdjusted: "Comparative date",
		multityEntityRequired: "Multi-entity",
		placeHolderMessageWhenHelixMappingIsTrue: "No imported trial balance. Click {0} to relate a new analyzer.",
		placeHolderMessageWhenHelixMappingIsFalse: "Integration with EY Helix is not available. Refresh the page and try again. If the issue persists, contact the Help Desk.",
		eyHelixIntegrationLinkText: "EY Helix connections",
		noEntitiesAvailablePlaceholder: "No entities created. Create entities to get started.",
		search: "Search",
		viewAdjustmentWithValidations: "View adjustments with validations ({0})",
	},

	misstatementLabels: {
		name: 'Name',
		notes: 'Notes',
		signOffs: 'Sign-offs',
		open: 'Open',
		openReadOnly: 'Open read-only',
		delete: 'Delete',
		rename: 'Rename',
		signOffRequirements: 'Sign-off requirements',
		confidentiality: 'Confidentiality',
		unlink: 'Unlink',
		removeFromAdjustment: 'Remove from adjustment'
	},

	allControls: "所有控制",
	//Client Request Document labels
	clientRequestDocuments: {
		externalDocuments: 'External',
		taskDocuments: 'Documents',
		deletedDocuments: 'Deleted',
		priorPeriodDocuments: 'Prior year',
		priorPeriodInfoMessage: 'These documents cannot be downloaded',
		uploadedBy: 'Uploaded by',
		deletedBy: 'Deleted by',
		lastModifiedBy: 'Last modified by',
		eyBadge: 'Deleted from Documents',
		externalBadge: 'Deleted from External',
		uploadInProgress: "上傳中",
		refreshdocuments: "重新整理文件",
		disabledDocument: 'Bulk operations are not allowed for this type of document.',
		menuOptions: {
			delete: 'Delete',
			open: 'Open',
			openr: 'Open read-only',
			restore: 'Restore',
			remove: 'Remove',
			rename: 'Rename',
			editInHelix: 'Edit in EY Helix'
		},
		externalPriorPeriod: 'Client',
		eyPriorPeriod: 'EY',
		uploadedByEY: 'EY'
	},

	//Client Request Assigned To Errors
	clientRequestAssignedToErrorLabel: "所指派的使用者或群組並非有效。請更新指派事項以繼續。請點擊",
	clientRequestAssignedToErrorLabelEnd: "編輯外部團隊成員",
	clickHereLabel: "這裡",
	clientRequestAssignedToIconErrorLabel: "所指派的群組無使用中成員。請指派該請求至一個使用中的使用者/群組或新增成員至該群組以繼續。",
	clientRequestDueDateErrorLabel: "Due date is required. Update the due date to continue.",

	clientRequestDocumentsNoDocsFound: [{
		id: 'externalDocuments',
		label: 'No external documents added'
	},
	{
		id: 'taskDocuments',
		label: 'Drag and drop one or more documents or click Add document'
	},
	{
		id: 'deletedDocuments',
		label: 'No documents have been deleted'
	},
	{
		id: 'searchRequestDocuments',
		label: "未找到匹配項目，請重試"
	},
	{
		id: 'priorPeriodDocuments',
		label: 'No prior year documents available'
	}
	],

	liveNotifications: {
		"ey.at.hercules.annotation.created": "Annotation created",
		"ey.at.hercules.annotation.edited": "Annotation edited",
		"ey.at.hercules.annotation.replied": "Annotation replied",
		"ey.at.hercules.contentupdate.updated": "內容已更新",
		"ey.at.hercules.contentupdate.failed": "內容更新失敗"
	},

	//Assign to
	usersOption: 'Users',
	externalUsersOption: 'External users',
	groupsOption: 'Groups',
	lblassignedto: 'Assigned to',
	searchGroup: 'Search group',
	requiredAssignedTo: 'Assigned to is required',
	rdSubmitRequest: 'Submit request',

	closeDrawer: 'Close and deselect all',
	requestSelected: 'request selected',
	requestsSelected: 'requests selected',
	//GA Scopes labels
	engagementScopesAndCustomSubScopes: 'Engagement scopes and custom sub-scopes',
	defineGroupScopes: 'Define group scopes',
	gaScopeIntro: "預設包含每個EY GAM案件範圍。若您欲客製集團任務和指示給同一範圍的團隊，可考慮建立一個次範圍。在發送指令時，您將能夠向每個次範圍發送不同的版本。",
	addSubScope: "Add sub-scope",
	customSubScope: "Custom sub-scope",
	noCustomSubscopes1: "There are no custom sub-scopes for this engagement scope.",
	noCustomSubscopes2: "Select <b>Add sub-scope<b> to get started.",
	subScopeName: 'Sub-scope name',
	addDescription: 'Add description',
	textExceedsLength500: 'Text cannot exceed 500 characters.',
	manageGroupPermission: 'You must have the <b>Manage group</b> permission to take this action. Speak with an Engagement Administrator to request permission.',
	deleteCustomSubScope: 'Delete custom sub-scope',
	areYouSureDeleteCustomSubScope: 'Are you sure that you want to delete this custom sub-scope?',

	//GA Component labels
	newTeam: 'New team',
	teamName: 'Team name',
	legalEntityName: 'Legal entity name',
	parentTeam: 'Parent team',
	isReferenceOnly: 'Reference only',
	isNotUsingCanvas: 'Team not using EY Canvas',

	referenceOnlyTooltip: 'Teams designated as <b>Reference only</b> will not receive link requests, instructions or tasks. They are used for organizational purposes only.',

	canvasFormNotOwnedByEng: 'Shared Canvas forms that are not owned by this engagement cannot be sent to EY Canvas Client Portal. Make a copy of the form in this engagement if you need to send it, or send it from the source engagement.',
	canvasFormNotAllowedInCtry: 'Sharing Canvas forms with clients is not available in your country.',
	on: 'on',
	sendRequest: 'Send request',
	selectUserOrGroup: 'Select user or group',
	canvasFormShowAttachments: "顯示{0} 附加檔案",
	canvasFormShowOneAttachment: "顯示一個附加檔案",
	canvasFormHideAttachments: "隱藏{0} 附加檔案",
	canvasFormHideOneAttachment: "隱藏一個附加檔案",

	//GA Components
	createGroupStructure: 'Create group structure',
	componentText: "為每個將透過EY Canvas發送交付成果的案件團隊建立區域和組成個體。若團隊將不透過EY Canvas發送交付成果，您可以選擇將團隊指定為<b>不使用EY Canvas</b>。您還可以出於組織目的建立團隊並將其指定為<b>僅供參考</b>。這些團隊將不會收到連結請求、說明或任務。完成後，選擇<b>發送連結請求</b>。",
	addTeam: 'Add team',
	sendLinkRequests: 'Send link requests',
	noComponents: 'No teams have been created yet.  Select <b> Add team <b> to get started.',
	editTeam: 'Edit team',
	deleteTeam: 'Delete team',
	deleteInstructional: 'Are you sure that you want to delete this team? <br/><br/> The link to this team will be broken and your engagements will no longer be able to exchange documentation. Additionally, all custom instructions and tasks assigned to this team will be deleted.',
	linkRequestHasBeenSent: 'You cannot edit the scope or designation for this team because a link request has already been sent or the designation is already set.',
	selectScopes: 'Select scope(s)',
	searchScopes: 'Search scopes',
	selectTeams: 'Select team(s)',
	sendLinkRequestsDescription: "選擇您欲連結您案件的範圍或團隊。<br> 一個連結請求將會寄送至每一個團隊之聯絡窗口。待聯絡窗口接受該連結請求後，他們將透過EY Canvas收到集團指示函以及任務。",
	sendVersionsDescription: "選擇您欲傳送最新版本集團指示函及任務的範圍或團隊。<br> 一個團隊必須連結至您的案件以接收集團指示函及任務，待團隊接受最新版本後，它將可供該案件使用。",
	notSentYet: "尚未發送版本",
	notLinkedYet: "未發送連結請求",
	cardView: "卡片式版面",
	noItemsPlaceholder: "版本還沒有發布。 在此查看發布集團指示函版本和任務資料。",

	//GA Instructions
	customizeGroupInstructions: 'Customize group instructions',
	gaInstructionsIntro: "預設包含每個EY GAM集團指示函，其性質是資訊性的。它們的目的是通知區域和組成團隊的關鍵資訊、工作範圍和集中執行的程序。從EY GAM中客製指示及添加額外的指令(若須)，並指定每個指示是否應指派給一個範圍或一個團隊。當您完成，請發布您的指示，這樣它們就可被發送至指定的範圍或團隊。",
	addInstruction: 'Add instruction',
	instruction: 'Instruction',
	groupTaskSelected: 'Group task',
	assignScopes: 'Assign to scopes',
	assignTeams: 'Assign to teams',
	maxLengthMessage: 'Text cannot exceed <b>500<b> characters.',
	addScope: 'Add scope',
	editInstruction: 'Edit custom instruction',
	editKnowledgeInstruction: 'Edit Knowledge instruction',
	editKnowledgeTask: 'Edit Knowledge task',
	editCustomTask: 'Edit custom task',
	saveChangesInstruction: 'Save changes',
	updatedOnInstruction: 'Last updated:',
	knowledgeDescriptionInstruction: 'Knowledge description',
	editDisabledTitle: 'You must have the <b>Manage group</b> permission to take this action. Speak with an Engagement Administrator to request permission.',
	deleteCustomInstruction: 'Delete instruction',
	deleteGroupTask: 'Delete group task',
	areYouSureDeleteCustomInstruction: 'Are you sure that you want to delete this custom instruction?',
	areYouSureDeleteCustomTask: 'Are you sure that you want to delete this custom task?',
	publishAfterDelete: 'If you delete this instruction, you need to publish your changes and resend the newly-published set of instructions to the assigned scopes or teams.',
	publishAfterDeleteGroupTask: 'If you delete this group task, you need to publish your changes and resend the newly-published set of tasks to the assigned scopes or teams.',
	resendPublishInformation: 'You can publish your changes on this step. You can resend the newly-published set of instructions from the summary.',
	resendPublishInformationGroupTask: 'You can publish your changes on this step. You can resend the newly-published set of tasks from the summary.',
	compareVersionsNoVersionSelectedTitle: 'No version has been selected to compare!',
	compareVersionsNoVersionSelectedSubtitle: 'Please select the version from the dropdown to compare with latest version',

	//Add Section
	addSection: 'Add section',
	addSectionInstructionalText: 'Add a section to organize your custom instructions.',
	addSectionPlaceholder: 'Section name',

	//Edit Section
	editSection: "編輯段落名稱",
	editSectionInstructionalText: "變更此自定義段落的名稱。<br>當您完成後，發布您的變更以將更新版本發送至選定的範圍或團隊。",
	editSectionSave: "儲存更改",

	//Delete Section
	deleteCustomSection: "刪除段落",
	areYouSureDeleteCustomSection: "確定要刪除此段落嗎？<br>此段落中的所有指示都將被刪除。當您完成後，發布您的變更以將更新版本發送至選定的範圍或團隊。",
	customSection: "段落",

	//Publish Changes
	publishChanges: 'Publish changes',
	publishChangesInstructional: 'Are you sure that you want to publish changes to the current set of instructions and tasks? <br><br>The previous set of instructions and tasks will be overwritten. Once you publish your changes, you can send the updated set of instructions and tasks from the summary.',
	publishChangesNotAvailable: 'Not available yet',

	//GA Tasks
	costomizeGroupTasks: 'Customize group tasks',
	gaTasksIntro: "預設包含每個EY GAM集團任務，並發送至連結的案件。從EY GAM中客製任務及添加額外的任務(若須)，並指定每個任務是否應指派給一個範圍或一個團隊。當您完成，請發布您的指示，這樣它們就可被發送至指定的範圍或團隊。",
	addCustomTask: 'Add custom task',
	groupTask: 'Group tasks',
	gaTasks: 'Tasks',
	attachments: 'Attachments',
	notAvailable: 'Not available',
	gaDocument: 'document',
	gaDocuments: 'documents',
	gaScope: 'scope',
	gaScopes: 'scopes',
	gaScopesCapitalized: 'Scopes',
	gaTeam: 'team',
	gaTeams: 'teams',
	gaUnassignedScopeTeam: "未指派",
	hideDetails: 'Hide details',
	gaAssignedScopes: 'Assigned scopes',
	gaAssignedTeams: 'Assigned teams',
	addTask: "New task",
	due: 'Due',
	noAttachments: 'No attachments have been added.',

	// Chip component
	chipMore: 'more',

	// GS Group Summary labels
	assignedTeam: 'Assigned team',
	lastPublished: 'Last published',
	versionStatus: 'Version status',
	lastSent: 'Last sent',
	lastSentTooltip: 'This is the date that a version of instructions and tasks was last sent to each team.  Click on the date to view the version sent to the team.',
	lastSentBeforeTooltip: 'There is a new version of instructions and tasks available for <b><<Scope name>><b>. Consider whether you should send the latest version to this team.',
	groupSummary: 'Group summary',
	summarySubTitle: "查看指派給以下每個範圍和團隊的最新版本的指示和任務。要將此版本發送給指定的範圍和團隊，請選擇<b>發送版本</b>。<br/>您還可以透過選擇相關的發送日期以查看發送給特定團隊的版本。",
	compareVersions: 'Compare versions',
	sendVersion: 'Send version',
	compareVersionsInstructional: 'Compare the latest version of published instructions and tasks to the version sent to a team in order to identify differences. If there are differences between the versions, evaluate whether a new version needs to be sent to the team.',
	publishedVersion: 'Published version',
	sentVersion: 'Sent version',
	emptyPublishedVersion: 'There are no scopes available. <br/>Scopes that are assigned to component teams are listed here.',
	emptySentVersion: 'There are no teams available.',
	selectPublishedVersion: 'Select a published version to see data here.',
	selectSentVersion: 'Select a sent version to see data here.',
	dueDate: "到期日期",
	emptyPublishedSnapshot: "所選擇的範圍並未有已發布版本之指示函及任務可供使用。<br/>在此發布一個版本以檢視資料。",
	emptySentSnapshot: "尚未將指示函及任務寄送至所選擇的團隊。<br/>在此發布及寄送指引及任務至該團隊以檢視資料。",
	update: 'Update',
	updates: 'Updates',
	noTeamsPlaceholder: "無團隊 Placeholder",
	noTeamSelected: "請至少選擇一個範圍或團隊以繼續。",
	latestVersionAlreadySent: "尚未有團隊。請建立一個或更多團隊以發布一個版本的指示函與任務。",
	latestHasBeenSended: "最新版本的指示和任務已發送至此團隊",
	noNewVersionToSend: "所選之範圍或團隊已經接收最新版本之指示函與任務。無可用更新可以寄送。",
	notSelectedTask: "未被選擇",
	assignedTeams: "指派團隊",
	noTeamsCreatedYet: "尚未有團隊。請建立一個或更多團隊以發布一個版本的指示函與任務。",
	newersTeamsSended: "最新版本的指示和任務已發送至相關範圍或團隊。",
	LinkRequestNotSent: "未發送連結請求",
	lastVersionSentInstructionalText: "在<b>{sentDate}</b>發送至<b>{teamName}</b> 的任務和指示之版本如下所示。此為發送至該團隊之最新版本。",

	// ReceiveInstructions labels
	receiveInstructionsTitle: "{versionType} 版本的指示函與任務",
	receiveInstructionsInstructional: "{primaryEng} 在 {sentDate}寄送 {versionType} 版本的指示函與任務。複核此版本並選擇接受或退回。您可以使用R <b>比較版本</b>選項以比較此版本與上一版本。",
	fromLabel: "從",
	assignedScope: "所指派的範圍",
	dateSent: "寄送日期",
	acceptVersion: "接受版本",
	returnVersion: "退回版本",
	returnPrimaryButton: "返回",
	returnVersionDescription: "您確定您要退回該版本之指示函與任務給主查團隊?<br>此版本將不會匯入至您的案件。請留下註解說明您的理由給主查團隊。",
	noContent: "此時並無可用之指示函。請稍後重試或連繫desk help",
	editorPlaceHolder: "註解",
	receiveCompareVersionInstructional: "比較從 {primaryEng} 收到的最新版本指示和任務與先前版本以辨識差異。",
	latestReceiveCompareVersionInstructional: "比較從 {primaryEng} 收到的最新版本指示和任務與先前版本以辨識差異。",
	latestVersion: "最新版本",
	earlierVersion: "先前版本",
	earlierVersionEmpty: "沒有先前版本可供比較。",
	selectEarlierVersion: "選擇先前的版本，在此查看資料。",
	pstName: "查看集團案件指示",
	pstDescription: "查看集團查核指示。 完成“執行 - 一般”中的集團任務。 這些任務已在接受集團查指示後新增至任務列表中。",
	selectedVersion: "所選版本",
	issuingEngagement: 'Issuing engagement',
	accountsAndDisclosureLink: "Account and disclosure",
	openRiskAssessmentDocuments: "Open risk assessment documents",
	openRiskAssessmentDocument: "Open risk assessment document",

	//Client engagement name labels
	successQueueMessage: 'The engagement display name has been successfully updated in EY Canvas Client Portal.',
	clientEngagementInstructionalText: 'Add or edit a custom engagement display name here. This name will be visible to external team members who access this engagement in EY Canvas Client Portal.',
	clientEngagementPlaceholder: 'Engagement display name',
	clientEngagementModalTitle: 'Engagement display name in EY Canvas Client Portal',
	clientDisplayName: 'Client display name',
	textExceedsLength: 'Text cannot exceed 100 characters.',

	// Manage client access locations
	location: 'Location',
	locationName: 'Location name',
	accessLocations: 'Access locations',
	inputType: 'Input type',
	ipAddress: 'IP address',
	ipAddresses: 'IP addresses',
	startOfIpRange: 'Start of IP range',
	endOfIpRange: 'End of IP range',
	cidrNotation: 'CIDR notation',
	manageClientAccessLocationsLink: 'Add location',
	manageClientAccessLocationsModalTitle: 'Manage client access locations',
	manageClientAccessLocationsInstructionalText: "新增 IP 位址至下方清單中，以啟用EY Canvas Client Portal基於位址的訪問權限。<br>若啟用用戶端訪問位址，則只有在此處所列IP 位址的外部團隊成員才能訪問此案件。若未新增 IP 位址，則外部團隊成員將能夠從任何位址訪問此案件。<br>點選<b>此處<b>以瞭解更多資訊。",
	manageClientAccessLocationsNoResultFound: 'There are no IP addressess added for this engagement. Internal and external team members can access this engagement from any location.',
	deleteAccessLocations: 'Delete access location(s)',
	deleteAccessLocationsInstructionalText: 'Are you sure that you want to delete the selected access location? <b>If an external team member attempts to access EY Canvas Client Portal from this location, they will no longer be able to access this engagement.',
	locationLengthError: 'The location cannot exceed 100 characters.',
	oneOrMoreIpAddressFormatError: 'One or more of the IP address provided are not valid.',
	ipAddressFormatError: 'The IP address provided is not valid.',
	ipSuffixError: "IP地址的CIDR suffixes必須是 ≥ 1 且 ≤ 32 的十進位數。",
	ipRangeStartSmallerThanEnd: 'Start IP should be less than end IP.',
	ipInputTypeInfo: 'Select IP address to enter an individual IP address or a list of IP addresses. Only IPv4 addresses are supported. <br>Select IP range to enter a range of IP addresses that share the same network prefix (i.e. the first three segments of the address). <br>Select CIDR block to enter a range of IP addresses with CIDR notation. Only CIDR addresses are supported.',
	ipAddressInfo: 'You can enter IP addresses individually, in a list separated by commas, or in a list with each address in a new row. <br>Valid IPv4 addresses contain four integers ranging from 0 to 255, separated by periods.',
	ipCidrInfo: "輸入CIDR notation，表示應能夠訪問此案件的 IP 地址範圍。 <br>有效的CIDR notation包含一個有效的 IPv4 位置、一個slash / character和一個 ≥ 1 且 ≤ 32 的十進位 suffix。",
	ipAddressEg: 'e.g. 192.XXX.X.1, 192.XXX.X.2',
	ipRangeStartEg: 'e.g. 192.XXX.X.1',
	ipRangeEndEg: 'e.g. 192.XXX.X.2',
	ipCidrEg: 'e.g. 192.XXX.X.1/22',
	searchIpPlaceholder: 'Check IP address',
	ipNotAddedMessage: 'has not been added to the allowed list.',
	ipIsAllowedMessage: 'IP address is allowed.',
	importAccessLocationsLink: 'Import access locations',
	importAccessLocationsInstructionalText: 'Access locations can be imported from your previous engagement. <br>Are you sure that you want to import access locations?',
	importAccessLocationsCloseButton: "關閉",
	importAccessLocationsCancelButton: "取消",

	// Export Requests
	exportRequests: "匯出請求",

	// Add custom request labels
	addCustomRequestModal: {
		titleTip: "新請求",
		titleTipAddButton: "新增新的",
		closeTitleTip: "Close",
		modalTitle: "新請求",
		returnModalTitle: 'Return request',
		modalHeader: "新增新請求以發送至 EY Canvas Client Portal",
		requiredAssignedTo: '(required)',
		assignToError: 'Assigned to is required',
		dueDate: "到期日(必要)",
		dueDateError: 'Due date is required',
		titlePlaceholder: "標題（必填）",
		titleError: "標題為必填",
		description: "描述",
		descriptionplaceholder: "輸入描述",
		descriptionError: 'Request description exceeds the maximum length, (4,000 characters)',
		associateDocuments: 'Associate documents',
		emptyAssociatedDocumentsList: 'Drag and drop one or more documents or click Add document',
		addDocumentButton: 'Add document',
		signOffCheckbox: 'Documents uploaded in EY Canvas Client Portal will require sign-off',
		sendRequest: 'Send request',
		returnRequest: 'Return request',
		saveAsDraft: 'Save as draft',
		cancel: 'Cancel',
		copyTitleAndDescription: "從任務複製標題及說明",
		copyAssociatedDocuments: "從任務複製文件",
		priority: "請求優先事項",
		addNewRequestButton: "Add new request",
		addExistingRequestButton: "Add existing request(s)"
	},
	addCustomEventModal: {
		titleTip: "新事件",
		closeTitleTip: "Close",
		modalTitle: "新事件",
		eventDate: "活動日期",
		eventDateError: "日期為必填項目",
		titlePlaceholder: "標題",
		titleError: "標題為必填",
		description: "說明（可選）",
		descriptionplaceholder: "輸入描述",
		descriptionError: "事件說明超出最大長度（4,000 個字元）",
		sendEvent: "發送事件",
		saveAsDraft: "將事件儲存為草稿",
		cancel: 'Cancel',
		eyParticipantsCollaborationError: "至少需要一位安永參與者",
		externalParticipantsCollaborationError: "至少需要一名外部參與者"
	},
	eyHelixInstructionText: "Review linked EY Helix projects and suggested analyzers below. <br/> Click on any of the projects or analyzers to navigate to its specific EY Helix page.",
	smartAutomationInstrText: "Review the Smart Automation solutions that you are currently using below. <br/> Click on a solution to navigate to the Smart Automation Hub.",
	smartAutomationSolutionsNotAvailable: 'Smart Automation solutions are not available for your engagement at this time.',
	noSmartAutomationAvailable: 'There are no Smart Automation solutions available for your engagement.',
	availableSolutions: 'Available solutions',
	useOfSuggestedSolutions: 'Use of suggested solutions',
	useOfOtherSolutions: 'Use of other solutions',
	suggestedSolutions: 'Suggested solutions',
	otherSolutions: 'Other solutions',
	currentlyusing: "正在使用中",
	suggested: 'suggested',
	primaryProject: 'Primary Project',
	noLinkedProjects: 'There are no linked projects for your engagement.',
	noSuggestedAnalyzers: 'There are no suggested analyzers for your engagement.',
	eyHelixNotAvailable: 'EY Helix not available',
	helixNotAvailableMessage: 'EY Helix is not available for your engagement at this time.',

	noGroupTaskCreatedYet: 'No group tasks have been created yet.',
	noInstructionsCreatedYet: "指示尚未被建立",
	documentsReceived: 'Documents received',
	documentsPending: 'Documents pending',

	teamLabel: 'Team',
	scopeLabel: 'Scope',

	documentSignOffby: 'Document signed-off by',
	documentAddedBy: 'Document added by',
	documentModifiedBy: 'Document modified by',
	documentDeletedBy: 'Document deleted by',
	commentAddedBy: "註記加入者為",
	commentClearedBy: "註記清除者為",
	commentClosedBy: "註記解決者為",
	commentReopenedBy: "註記重新開啟者為",

	documentAssignedTo: 'Document assigned to',
	draftDocReceivedFrom: 'Draft document received from',
	finalDocReceivedFrom: 'Final document received from',
	documentReturnedBy: 'Document returned by',
	returnedDocumentClearedBy: 'Returned document cleared by',
	documentConflictResolvedBy: 'Document conflict resolved by',
	draftDocumentSentBy: 'Draft document sent by',
	documentReturnedFrom: 'Document returned from',
	finalDocumentSentBy: 'Final document sent by',
	noActivityAvailable: 'There is no activity available.',
	allEngagementFilterLabel: 'All other engagements',
	otherEngagementComments: "其他案件註記",
	engagements: 'Engagements',
	engagement: 'Engagement',
	view: 'View',
	notesModalInstructionalText: "檢視並回應以下所選{0}註記。",

	//New collaboration Related Labels
	searchRelateFileNoMatchesFound: "找不到相符內容。請重試。",

	//New collaboration Related tasks
	relatedTasksLabel: 'Related tasks',
	selectRelatedTasks: 'Select task',
	searchAndPressEnter: 'Search and press enter',
	noRelatedTasksSelected: 'No related tasks selected',
	relatedTasksCount: 'related tasks',
	notFoundTasks: 'Task not found',
	dueDateDetailLabel: "到期日",
	requestType2MessageTitle: "本請求將開啟新分頁",
	requestType2MessageSubtitle: "請重新整理頁面以檢視任何所作更新。",
	requestType2InTrnasitMessageTitle: "本請求正在傳送中無法開啟。",
	requestType2InTrnasitMessageSubtitle: "等待同步完成並重新整理頁面後重試。",

	//New collaboration Time Phase
	selectTimePhase: "選擇時段",
	timePhaseNotFound: "找不到時段",

	understandITProcess: 'Understand IT processes',

	//New collaboration Access Location
	accessLocationLabel: 'Access location enabled',
	accessLocationTitle: "僅有已授權網絡位置所連線之使用者才可進入該案件之EY Canvas Client Portal。所允許之位置可以在選擇選單中的存取位置進行管理。",

	// Reporting Labels
	summaryScreenLabel: "彙總截圖",
	dataExportLabel: "資料匯出",
	projectManagementLabel: "計畫管理",
	reportingHeaderName: "報告",
	repAllTasks: "全部任務",
	repDeletedTasks: "刪除的任務",
	repMultiEntityTasks: "Multi entity tasks",
	repAllAuditPlan: "查核計畫",
	repITAppSOSummary: "IT 應用程序/SO 彙總",
	repITProcessScotControls: "IT 流程、SCOT 和控制",
	repTaskAssignments: "任務指派事項",
	repTaskDetails: "任務詳情",
	repTaskAnalysis: "任務分析",
	repTaskSummary: "任務概要 (Pilot)",
	repExportToExcel: "匯出資料",
	repExportDate: "匯出日期",
	repEngInfo: "案件資訊",
	repNoRecordMessage: "無記錄可顯示",
	dateInUTC: "in UTC",
	repSCOTsControls: "SCOTs 和控制",
	repITProcessSummary: "IT 流程彙總",
	repCanvasForms: "Canvas 表單",
	repControlForms: "控制表單",
	projectInsight: "Project Insight",
	archiveForm: "歸檔表單",
	archive: "歸檔",
	repCanvasFormResponse: "Canvas表單回覆",
	repCanvasFormRelatedComments: "相關註解",
	repControlFormResponse: "控制表單回覆",
	repNoRecordFound: "沒有找到記錄",
	repCanvasFormsIncomplete: "回覆未完成",
	repCanvasFormRelatedObjects: "相關目標",
	voiceNoteLabel: "語音註記",
	repComponentTeamGroup: "Component team",
	componentTeamCanvasFormExport: 'Canvas form export',

	// Reporting Tasks
	repTaskTitle: "任務標題",
	repTaskDescription: "任務描述",
	repTaskSource: "任務來源",
	repTaskNature: "任務性質",
	repTaskCloseEarly: "提早的",
	repTaskCloseLate: "較晚的",

	// Reporting Documents
	repAllDocuments: "所有文件",
	repSignOffs: "簽核",
	repDocumentsModified: "RRD 後修改的文件",

	//Reporting Collaboration
	repRequestsAndTasks: "請求和任務",
	repRequestsTasksComments: "請求/任務註解",

	SCOTSummaryReportHeader: "SCOT彙總",
	GroupReportHeader: "集團報表",
	SCOTSummaryEffective: "有效的",
	GroupInstructionSummary: "集團指引彙總",
	GroupActivity: "Component account mapping history",
	SEMReportHeader: "SEM",
	GroupComponentAccountReportHeader: "集團組成個體科目對應",
	AccountDisclosuresReportHeader: 'Accounts and disclosures',

	//Reporting Collaboation Details
	collaborationDetails: "合作詳情",
	collaborationSummary: "彙總",
	collaborationActivity: "活動詳情",
	ReviewNotesReportHeader: "複核註記",

	GroupStructureSummary: "集團架構彙總",

	//Reporting CRT Summary
	wcgwSummary: "WCGW彙總",
	crtlabel: "控制複核工具 (CRT)",
	assertionSummary: "聲明彙總",
	scotSummary: "SCOT彙總",
	noRecordsToExport: "沒有可匯出的記錄",
	statisticsSummary: "統計",
	qualityChecks: "品質檢查",
	controlSummary: "控制彙總",
	filterBySCOT: 'Filter by SCOT',

	//Reporting manage team
	independenceSummaryReportTabName: "獨立性彙總",

	//MEST dashboard
	viewAllRiskTypesAndAssertions: "查看所有風險類型和聲明",
	riskRelatedToAssertion: "與聲明相關的風險",
	higherRiskRelatedToAssertion: "與聲明相關的較高風險",
	noRisksAvailable: "無可用風險",
	relatedEstimates: "相關估計",
	viewAllAssertions: "檢視所有聲明",
	wcgwRelatedToAssertion: "WCGW 與聲明相關",
	noWcgwsAvailable: "沒有可用的 WCGW",
	goTo: 'Go to',
	allItems: 'All items',

	// Create TimePhase Labels
	createTimePhaseLabels: {
		modalTitle: "加入時段",
		modalDescription: "新增屬性和點選儲存並關閉或儲存並新增。",
		timephaseNameLabel: "時間階段名稱",
		milestoneSelectLabel: "里程碑",
		timephaseLabel: "時間階段",
		startDateLabel: "開始日期",
		endDateLabel: "結束日期",
		startDateErrorMessage: "開始日期為必要",
		endDateErrorMessage: "結束日期為必要",
		timephaseNameErrorMessage: "名稱為必要。",
		milestoneErrorMessage: "里程碑為必要",
		isKeyEvent: "關鍵事件",
		timephaseDescription: "說明(選擇性)",
		addSuccessMessage: "時間階段新增成功。"
	},

	AccountListHeaderLabels: {
		pspAndosp: 'PSPs/OSPs',
		limitRiskAssertionLabel: 'Limited risk account',
		heading: 'Accounts and disclosures and related',
		accountsOrDisclosure: 'Accounts and disclosures',
		psps: 'PSPs',
		rejected: 'Rejected',
		remove: 'Remove',
		risks: 'Risks',
		assertions: 'Assertions',
		noRecordsFound: 'No accounts or disclosures available',
		noResultsFound: 'No results found',
		responsiveHeading: 'Responsive',
		rejectedPspsHeading: 'Rejected PSPs',
		importPsps: 'Import PSPs',
		importOsps: 'Import OSPs',
		addOsps: 'Add OSPs',
		pspEnded: 'to get started.',
		noPspsandOsps: "No {0} available.",
		allAreRejected: 'All PSPs have been rejected.',
		rejectButton: 'Reject',
		acceptButton: 'Accept',
		additionalInfo: ' Rationale:',
		noAssertionsAvailableLabel: 'No assertions available',
		noAssertionAvailableTooltip: 'No assertion available. Click <strong>Manage accounts and disclosures</strong> to add assertions.',
		importFromKnowledge: 'Import from knowledge',
		disabledAddOspTooltip: 'At least one assertion must be available to add a substantive task. Click <strong>Manage accounts and disclosures</strong> to add assertions.',
		noPsps: 'No PSPs available. {0} to get started.',
		noOspsPsps: 'No PSPs/OSPs available. {0}, {1}, or {2} to get started.',
		acceptErrorMsg: 'Unable to accept the rejected task. Refresh the page and try again. If the issue persists contact the Help Desk.',
		build7NoPspOrOspAttachedToAssertion: "Each assertion must have at least one responsive substantive procedure. The following assertion(s) do not have any responsive PSPs/OSPs: <b>{orphanAssertions}</b>. {0}, {1}, or add a {2} to address all assertions for the account or click on the edit icon for existing PSPs/OSPs responsive to this account to relate them to other assertions.",
		build7NoPspOrOsp: "Each assertion must have at least one responsive substantive procedure. None of the assertions have responsive PSPs/OSPs. {0}, {1}, or create a {2} to address all assertions for the account.",
		build7NoOspsAndAllPspAreRejected: "Each assertion must have at least one responsive substantive procedure. All PSPs have been rejected and none of the assertions have responsive PSPs/OSPs. {0} or create a {1} to address all assertions for the account.",
		build6And7NoAssertions: "Each significant account or significant disclosure must have at least one related assertion available to add a substantive procedure. Click {0} to add assertions.",
		build7LimitedAccountNoPspOsp: "Each limited risk account must have at least one responsive substantive procedure. {0} or create a {1} to respond to the risks of this account.",
		manageAccountAndDisclosures: "Manage accounts and disclosures"
	},

	AddTaskLabels: {
		accountLabel: 'Account:',
		taskSectionLabel: 'Task section:',
		ospModelTitle: 'New OSP',
		ostModelTitle: 'New OST',
		saveAndClose: 'Save',
		saveAndCreate: 'Save and create another',
		cancel: 'Cancel',
		prefix: 'Prefix',
		title: 'Title',
		suffix: 'Suffix',
		timePhase: 'Time phase',
		description: 'Customized description',
		descriptionPlaceholder: "Customized task description (required)",
		assertions: 'Assertions',
		optional: '(optional)',
		required: 'Required',
		noResultFound: 'No results found',
		of: 'of',
		characters: 'characters',
		descriptionMaxLengthError: 'Description length exceeded maximum allowed length',
		noteDiscriptionErrorMessage: 'Response contains {0} characters which exceeds the maximum of {1} characters. Adjust the description by reducing text or formatting and try again. If the issue persists, contact the Help Desk.',
		customizeDescription: "Customized task description (required)",
		errorMsg: 'Failed to add the OSP. Refresh the page and try again. If the issue persists contact the Help Desk.',
		customizeTaskDescription: 'Customize task description'
	},

	RemoveTaskLabels: {
		modelOspTitle: 'Delete OSP',
		modelOstTitle: 'Delete OST',
		deleteBtn: 'Delete',
		cancel: 'Cancel',
		confimationOspMsg: 'Are you sure that you want to delete the selected OSP?',
		confimationOstMsg: 'Are you sure that you want to delete the selected OST?',
		warning1Msg: 'Related evidence that is not related to any other tasks in this engagement will be moved to temporary files.',
		warning2Msg: 'Findings and response tasks that are not related to any other evidence will be deleted.'
	},

	TaskReportHeaderLabels: {
		Tasktype: "任務類型",
		Taskstatus: "任務狀態",
		Taskassignedto: "指派給的任務",
		Tasktitleprefix: "任務標題置前",
		Tasktitle: "任務名稱",
		Tasktitlesuffix: "任務標題置後",
		Taskdescription: "任務描述",
		Knowledgetasktitle: "知識任務標題",
		Knowledgetaskdescription: "知識任務描述",
		Oldtaskname: "舊任務名稱",
		Oldtaskdetail: "舊任務詳細資料",
		Rejected: "拒絕",
		Rationalforrejection: "拒絕的理由",
		Auditphase: "查核階段",
		Timephasetype: "里程碑",
		Timephase: "時間階段",
		Timephasestartdate: "時間階段開始日期",
		Timephaseduedate: "時間階段截止日期",
		Keyevent: "關鍵事件",
		Tasksource: "任務來源",
		Tasknature: "任務性質",
		Lasttaskstatuschangedate: "上次任務狀態更改日期",
		Taggroup: "標籤群組",
		Tags: "標籤",
		RelatedMESTentities: "相關 MEST 實體",
		Schedulednextwaveservices: "預定的 nextwave 服務",
		Priority: "優先",
		Taskid: "任務 ID",
		Roleid: "角色 ID",
		Tasktypeid: "任務類型 ID",
		Taskstatusid: "任務狀態 ID",
		Auditphaseid: "查核階段 ID",
		Timephasetypeid: "里程碑 ID",
		Tasksourceid: "任務來源 ID",
		Tasknatureid: "任務性質ID"
	},

	glAccountDocumentLabels: {
		modelTitle: 'GL Account',
		modelName: 'Relate evidence',
		documentName: 'Document Name',
		documentCounter: '{0} Document',
		documentsCounter: '{0} Documents',
		btnCancel: 'Cancel',
		btnSave: 'Save',
		errorMessage: 'Select a document to continue',
		noResultsFound: 'No results found',
		newTickMark: "New tickmark",
		bulkModePlaceholder: "Select an evidence to relate and select <strong>\'Save\'</strong> to finish."
	},

	// Edit TimePhase Labels
	editTimePhaseLabels: {
		modalTitle: "編輯時段",
		modalDescription: "編輯屬性並點選<b>儲存。</b>",
		editSuccessMessage: "時間階段更新成功。"
	},

	// Delete TimePhase Labels
	deleteTimePhaseLabels: {
		deleteTimePhaseModalTitle: "刪除時段",
		deleteDescription: "您確定您要刪除此時段?",
		showTimePhaseName: "時段",
		showMileStone: "里程碑",
		showStartDate: "開始日期",
		showEndDate: "結束日期",
		showDescription: "說明：",
		showAssignedTasks: "指派任務之計數",
		showAssignedAssignments: "指派事項之計數",
		deleteSuccessMessage: "時間階段刪除成功。"
	},

	// Create Tag Labels
	createTagGrouplabels: {
		modalTitle: "新增標記群組",
		modalDescription: "輸入名稱和點選儲存並關閉或儲存並新增以繼續。",
		tagGroupNameLabel: "標記群組",
		tagGroupNameErrorMessage: "標記必要的群組",
		saveAndClose: "儲存並關閉",
		saveAndAdd: "儲存並新增",
		addSuccessMessage: "標記群組新增成功。"
	},

	// Bulk Tags
	tags: {
		noTagsAvailabel: "沒有可使用的標記",
		deleteTag: "刪除標記",
		deleteDescription: "刪除標記無法復原，您確定要繼續嗎？",
		showDeleteTagName: "標記",
		showDeleteTagGroupName: "標記群組",
		showAssignedTasks: "指派的任務",
		deleteSuccessMessage: "標記刪除成功。",
		task: "任務",
		tasks: "任務",
		addTagGrouplabels: "新增標記群組",
		addTag: "新增標記",
		action: "行動",
		addTagDesc: "<h3>新增標記</h3><p>點選'新增標記群組'以建立新的標記群組，用以新增標記。</p>",
		assignTagDesc: "<h3>指派標記</h3><p>將選定的項目拖放至標記群組下的所須之標記上。</p>",
		editTagDesc: "<h3>編輯標記</h3><p>點選功能表(三個點)並選擇'編輯'以編輯標記屬性。</p>",
		deleteTagDesc: "<h3>刪除標記</h3><p>點選功能表(三個點)並選擇'刪除'以刪除標記。</p>",
		removeTagDesc: "<h3>移除標記</h3><p>要移除標記，請將一個或多個現有標記項目拖放至標記群組下的相關標記名稱。</p>",
		expand: "展開",
		collapse: "收合",
		TagName: "標記名稱",
		TagGroupName: "標記群組名稱",
		addTagSuccessMessage: "標記新增成功。",
		editTagSuccessMessage: "標記更新成功。",
		addTagModalTitle: "將標記新增至",
		editTagModalTitle: "編輯標記",
		addTagModalDescription: "建立新標記和點選儲存並關閉或儲存並新增以繼續。",
		editTagModalDescription: "編輯屬性並點選<b>儲存。</b>",
		tagSetSuccessMessage: "標記設置成功。",
		tagsSetSuccessMessage: "標記設置成功。",
		tagRemoveSuccessMessage: "標記移除成功。",
		tagsRemoveSuccessMessage: "標記移除成功。",
		tagRemovedSuccessfully: "標記移除成功。"
	},

	relateEvidenceHeader: 'Relate evidence that provides information about the adjustment.',
	relatedDocumentCounter: '{0} Document',
	relatedDocumentsCounter: '{0} Documents',
	documentsLocationLabel: 'Documents location',
	relateTemporaryFilesHeader: "Relate a temporary document from this engagement.",

	// Create Assignment Labels
	addAssignmentlabels: {
		modalTitle: "加入指派事項",
		modalDescription: "輸入名稱並在完成後點選儲存。",
		assignmentNameLabel: "指派事項名稱",
		assignmentNameErrorMessage: "指派事項名稱不能為空白",
		saveAndClose: "儲存並關閉",
		saveAndAdd: "儲存並新增",
		addSuccessMessage: "指派事項新增成功。"
	},
	addUserOrRoleLabelto: "新增使用者或角色至",
	addUserOrRoleheader: "搜尋您要新增的團隊成員或角色。",
	saveAndAdd: "儲存與新增",

	// Bulk Assignment
	BulkActionsLabel: "批次動作",
	BulkAssignmentAction: "行動",
	BulkShow: "顯示",
	BulkActionsInstructionalText: "使用拖放以對任務群組執行批次動作。欲檢視一個任務群組中的個別任務，請將滑鼠游標移動到該任務群組並點選箭頭圖標。",
	bulkOperationsModalDescription: "Perform bulk operations for tasks. To view individual tasks for a task grouping, mouse over the task group and click the arrow icon.",
	selectRequest: "Select a request to send.",
	replaceLabel: "取代",
	labelStaff: "staff-",
	addModeLabel: "新增",
	replaceModeLabel: "取代",
	dueDateModeLabel: "更新到期天數",
	searchByAssignmentName: "搜尋",
	addTeamMemberLabel: "新增團隊成員",
	noTeamMembersFound: "無可用團隊成員",
	addMemberSuccessMessage: "團隊成員新增成功。",
	addAssignmentLabel: "加入指派事項",
	addAssignmentNameLabel: "加入指派事項名稱",
	noAvailableAssignmentsMessage: "無可用之指派事項",
	showDuplicateError: "選擇的團隊成員或角色在選定的任務上不能有重複的指派。請選擇其他的指派、團隊成員或角色以繼續進行。",
	infoBulkAssignments: "批次指派事項",
	infoBulkAssignmentDesc: "請選擇一個或多個任務群組以建立新的指派事項或取代已存在的指派事項。當指派事項被建立或編輯，目前有指派事項之團隊成員將被重新計算指派事項最早到期日。",
	infoAssignmentsDueDate: "設定指派事項截止日期",
	infoAssignmentsDueDateDesc: "使用“選擇日期/計算日期”切換按鈕來設定指派事項的截止日期。該切換按鈕可用於為任務提供具體截止日期，或提供相對於時間階段結束日期的天數。",
	infoAddAssignmentExisting: "向現有團隊成員新增指派事項",
	infoAddAssignmentExistingDesc: "新增指派事項需要在截止日期前幾天設定。 或者，可以使用行事曆控制來設定確切的截止日期。 完成設定後，拖放選定的項目以建立一組新的指派事項。",
	infoAddAssignmentNew: "加入指派事項給新的團隊成員",
	infoAddAssignmentNewDesc: "若團隊成員或角色並未顯示在所指定的指派事項中，請點選加入團隊成員以檢視可用之團隊成員及角色列表。一旦選擇後，該團隊成員即會加入至列表最下方並可用以拖放指派事項。",
	infoRemove: "移除指派事項",
	infoRemoveDesc: "要移除指派事項，請將一個或多個項目拖放至指派事項名稱下的團隊成員。 該團隊成員的任何未完成的指派事項都將被移除。 已完成的指派事項不會被移除。",
	infoReplace: "取代指派事項",
	infoReplaceDesc: "拖曳一或多個項目至一個指派事項名稱下之一位團隊成員以取代指派事項。相同指派事項名稱之原存在的指派事項將被重新指派至所選團隊成員。倘若多個團隊成員具有該名稱的指派事項，他們將被合併為所選擇之使用者。當使用取代指派事項，設定早於結束日期的天數為選擇性。若早於結束日期的天數未被設定，原存在的設定將被使用。",
	infoUpdateDueDate: "更新到期日",
	infoUpdateDueDateDesc: "使用“選擇日期”或“計算日期”設定新的“到期日”，然後拖放到要變更其到期日的團隊成員上。 這將會更新該團隊成員所有進行中和未完成的指派事項的到期天數。但已完成的指派事項不會受到影響，將保持不變。",
	infoDelete: "刪除指派事項",
	infoDeleteDesc: "點選右側的指派事項，將出現刪除該指派事項的選項。",
	infoExecutive: "主管指派事項",
	infoExecutiveDesc: "使用篩選及搜尋功能以篩選適用於主管的任務，使指派事項更加迅速",
	infoSpecificTask: "指派事項至特定任務",
	infoSpecificTaskDesc: "若需要於任務層級進行指派事項，將滑鼠停留在該群組的左手邊並選擇檢視個別任務選項。這將會顯示該群組的個別任務並可使指派事項更好更精準。",
	unassignedLabel: "未指派",
	replaceSignleSuccessMessage: "任務更新成功。",
	replaceMultipleSuccessMessage: "任務更新成功。",
	dueDateSingleSuccessMessage: "指派事項更新成功。",
	dueDateMultipleSuccessMessage: "指派事項更新成功。",
	invalidAssignmentUpdate: "將任務指派給同一個人以繼續更新到期日。",
	removeSuccessMessage: "指派事項更新成功。",
	colorCode: "色碼",
	removeSuccessSingleMessage: "指派事項更新成功。",
	removeSuccessMultipleMessage: "指派事項更新成功。",
	assignmentRemovedSuccessfully: "指派事項移除成功。",

	// Bulk Task
	itemsSelected: "任務已選擇",
	itemSelected: "任務已選擇",
	dragAndDrop: "拖放",
	currentApplication: "目前應用",
	allAssignmentsClosed: "所有指派事項均已關閉",
	allAssignmentsCompleted: "所有指派事項均已完成",

	onOrBeforeCurrentDate: "於或早於當日",
	withInCurrentWeek: "本週",
	quickFilter: "快速篩選",
	suggestedFilters: "建議篩選",
	showXMore: "顯示 {0} 更多",

	// Task due date Events
	addEventlabels: {
		modalTitle: "新增事件",
		startDateLabel: "開始日期",
		modalDescription: "新增屬性和點選儲存並關閉或儲存並新增。",
		eventNameLabel: "事件名稱",
		eventType: "事件類型",
		singleDay: "單日",
		dateRange: "日期範圍",
		eventDate: "活動日期",
		eventDescription: "說明(選擇性)",
		isEvent: "與客戶分享事件",
		EventNameErrorMessage: "活動名稱為必須的。",
		eventDateErrorMessage: "事件日期為必要的。",
		addSuccessMessage: "事件新增成功。"
	},

	// Bulk Notes
	DeleteSomeNotesAreClosed: "<b>您所選的註記僅有部分為已解決狀態且可以被刪除。</b> <br /> 若您選擇繼續，下列註記將不會被刪除。",
	DeleteSomeNotesAreNotClosed: "下列註記無法被刪除因為他們尚未被關閉。",
	DeleteDontHaveClosedNotes: "下列註記無法被刪除因為他們尚未被關閉。",
	someNotesAreOpen: "<b>您所選的註記僅有部分為未解決狀態。</b> <br/> 若您選擇繼續，下列註記將會被更新。",
	someNotesAreNotOpen: "下列註記將不會被更新因為他們已經被清除或關閉。",
	dontHaveOpenNotes: "下列註記無法被更新因為他們已經被清除或關閉。",
	ShowNumberMore: "顯示{0}更多",

	// Drag and Drop
	assignmentLabel: "指派事項",
	assignmentsLabel: "指派事項",
	singleAssignmentCreatedMessage: "指派事項建立成功。",
	multipleAssignmentCreatedMessage: "指派事項建立成功。",
	daysPriorWarning: "建立指派事項前設定到期前天數",



	// Related Tasks - Engagement selector
	selectEngagement: "選擇案件",
	thisEngagement: "此案件",
	noResultsFoundLabel: "未找到結果",
	taskLocationLabel: "任務地點",

	// Delete Assginment
	deleteDescription: 'Deleting assignment cannot be undone, are you sure you want to continue?',
	deleteAssignmentModalTitle: "刪除指派事項無法復原，您確定要繼續?",
	deleteSingleSuccessMessage: "指派事項刪除成功。",
	deleteMultipleSuccessMessage: "指派事項刪除成功。",
	teamMemberLabel: "團隊成員",
	assignedTasksCountLable: "所指派之任務",
	deleteAssignmentLabel: "指派事項",
	selectengagement: "選擇案件",

	//Due Days
	dueDateTitle: "請輸入到期天數",
	dueDatedescription: "請輸入該指派事項必須於時段到期日前完成之天數。",
	dueDateAssign: "指派",
	dueDateSelect: "選擇",
	dueDateCalculate: "計算",

	// Tasklist - bulk markcomplete
	markComplete: "標示為完成",
	markCompleteMessgae1: "您確定您要<b>完成所選擇之任務</b>? <br />若所選任務中有未完成之指派事項，它們將會被關閉。",
	markCompleteMessgae2: "您所選擇的任務中僅有部分可被標示為完成。<br /> 若您選擇繼續，<b>下列任務將被標示為完成</b>。若您有任何未完成之指派事項，它們將被關閉。",
	markCompleteMessgae3: "<b>下列任務將不會被標示為完成</b>因為它們沒有任何連結證據或所連結的證據遺失簽核。",
	markCompleteMessgae4: "<b>下列任務將不會被標示為完成</b> 因為它們沒有任何連結證據或所連結的證據遺失簽核。",

	// Tasklist - bulk handoff
	handOffLabel: "移交",
	confirmHandOff: "確認移交",
	handOffMessgae1: "您確定您要<b>移交所選擇之任務</b>給下一位指派團隊成員? <br />若所選任務中您有任何未完成之指派事項，它們將會被關閉。",
	handOffMessgae2: "您所選擇的任務中僅有部分有下一位指派團隊成員。<br />若您選擇繼續，<b>下列任務將會被移交</b>。若所選任務中您有任何未完成之指派事項，它們將會被關閉。",
	handOffMessgae3: "<b>下列任務將不會被移交</b>因為它們沒有任何未完成指派事項。",
	handOffMessgae4: "<b>下列任務無法被移交</b>因為它們沒有任何未完成指派事項。",
	closeMyAssignments: "關閉我的指派事項",

	saveQuickFilter: "儲存快速篩選",
	saveQuickFilterModalHeader: "Save the filter chips that you applied as a quick filter.",
	saveQuickFilterModalText: "Select saved and suggested quick filters to save time when you access this engagement again. You can create up to five saved quick filters per engagement.",
	quickfiltername: "快速篩選名稱",
	taskCategory: "任務類別",

	cannotsavefilter: "無法儲存客製快速篩選",
	cannotsavefiltermodalheadertext: "<b>每個案件您僅可儲存五組客製快速篩選。</b> <br />若您要繼續，請從已存在的客製快速篩選中刪除一組並重試。",
	savedFilters: "所儲存篩選",
	taskassignedto: "任務指派給",
	noteassignedto: "註記指派給",
	taskPrefix: "Task prefix",
	taskSuffix: "Task suffix",

	// Mark complete/HandOff Evidences category
	noSignOffs: "無簽名",
	noSignOffsByMe: "無由我簽核",
	myPreparerSignOffs: "我的編製者簽名",
	myReviewerSignOffs: "我的複核者簽名",
	myPreparerAndReviewerSignOffs: "我的編製者及複核者簽名",

	notificationDownErrorMessage: "通知功能暫時不可使用。請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	notificationUpbutSomeLoadingErrorMessage: "通知中心暫時不可使用。請重新整理頁面並重試 - 將很快便可使用。",

	timeTrackerErrorFallBackMessage: "時間追蹤功能暫時不可用。請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	timeTrackerLoadingFallbackMessage: "時間追蹤功能暫時不可使用。將很快便可使用。",

	signOffOnAllAs: "簽核所有為",
	accountType: "科目類型",

	openDocumentInstructionalText: "該文件將自動開啟。<b>您無需點選即可開啟它。</b> <br>文件開啟後，您可以關閉此選項標記。",
	closeTab: "關閉標記",

	// Build Step - Add Due Date
	milestones: "里程碑",
	events: "事件",
	noTimePhasesHaveBeenIdentified: "沒有已被確認的時間階段。",

	wcgws: "WCGWs",
	relatedControls: "相關控制，",
	relatedControlsWCGWsRatio: "相關控制/WCGW",
	wcgwsToControlsRatio: "WCGWs與控制比率",
	controlsToWCGWsRatio: "控制與WCGWs比率",
	testedControls: "已測試控制",

	// Collaboration request to Task relation
	CollaborationModalTitle: "Relate requests to tasks",
	CollaborationModalDescription: "To relate a request to a task, drag and drop one or more request(s) to the task below.",
	noDataFound: "沒有找到資料",
	taskName: "任務",
	showMessage: "選擇要開始的類別和任務群組",
	showCategory: "類別",
	showTaskGroup: "任務群組",
	optionITProcesses: "IT流程",
	optionExecutionGeneral: "執行一般",
	relatedRequestsLabel: 'Related requests',
	relatedRequestsFormatted: "{0} Related requests", //97 Related tasks
	relatedRequestFormatted: "{0} Related request", //1 Related task
	relatedRequests: 'Related requests',
	relatedTasks: 'Related tasks',
	relatedSuccessSingleMessage: '{0} request has been related to task successfully.',
	relatedSuccessMultipleMessage: '{0} requests have been related to task successfully.',
	showUnrelated: 'Show {0} unrelated',
	unrelate: 'Unrelate',
	noRequestsMessage: 'No requests available',
	requestNumber: 'Request number',
	sortAscending: 'Sort ascending',
	sortDescending: 'Sort descending',
	removeSorting: 'Remove sorting',

	// PIC Dashboard
	groupBy: "群組由",
	allTasks: "所有任務",
	iTSOs: "IT/SO",
	generalExecution: "一般執行",
	PICSignOff: "PIC簽核",
	EQRSignOff: "EQR簽核",
	completed: "完成的",
	allAssigned: "全部指派",
	picTaskAssignmentLabel: "您的指派事項",
	assignReadyForReview: "目前的",
	assignUpcomingForReview: "即將到來",
	assignReadyForReviewTasks: "Current assignments",
	assignUpcomingForReviewTasks: "Upcoming assignments",
	picTaskSignoffInComplete: "<b>PIC</b> 簽核未完成的任務",
	picDocSignoffInComplete: "<b>PIC</b> 簽核未完成的文件",
	eqrTaskSignoffInComplete: "<b>EQR</b> 簽核未完成的任務",
	eqrDocSignoffInComplete: "<b>EQR</b> 簽核未完成的文件",
	collapseCards: "收起卡片",
	expandCards: "展開卡片",
	noUserSelectedPlaceholder1: "{0} 尚未被辨識或被邀請至案件。",
	noUserSelectedPlaceholder2: "點擊這裡",
	noUserSelectedPlaceholder3: "辨識或邀請 {0}。",
	notInvitedLabel: "未邀請",
	noTasksPlaceholder: "沒有與<br/>此查核階段的里程碑相關的任務。",
	noTasksTilesPlaceholder: 'No tasks assigned to the selected user',
	noAssignmentPlaceholder: "No assignments found",
	dueDateAssignmentPlaceholder: "Assignments by due date",
	countAssignmentPlaceholder: "Assignment count",
	OverduetPlaceholder: "Overdue",
	TodayPlaceholder: "Today",
	tasksView: "任務視圖",
	documentsView: "文檔視圖",
	picAndEqr: "PIC 和 EQR",
	ResponsiveToSR: "關於⚡SR",
	responsiveToFR: "關於⚡FR",
	relatedTasksFormatted: "{0} 攸關任務",
	relatedTaskFormatted: "{0} 攸關任務",
	autoAssignWarning2: "點擊這裡",
	toAssign: "指派",
	taskAssignWarning: "未指派 {0} 個簽核要求的任務，",
	tasksAssignWarning: "未指派 {0} 個簽核要求的任務，",
	taskAdditionalFuncText1: '<b>This task has additional functionality. Please </b>',
	taskAdditionalFuncText2: '<b> to navigate to it.</b><p>Build Tasks do not require evidence to be associated to mark complete, unless the task requires PIC/EQR review.</p>',
	taskadditionalfunctionality: "<b>此任務具有附加功能。 請</b> {0} <b>至該任務。</b><p>建立任務不須關聯證據即可標記為完成，除非該任務須 PIC/EQR 複核。</p>",
	taskclickhere: "點擊這裡",
	taskAutoAssignModalTitle: "自動指派",
	taskAutoAssignModalDescription: "有 {0} 個具有 EQR 簽核要求的任務尚未指派給 {1}。 點擊“指派”為 {1} 建立 EQR 指派。",
	tasksAutoAssignModalDescription: "有 {0} 個具有 EQR 簽核要求的任務尚未指派給 {1}。 點擊“指派”為 {1} 建立 EQR 指派。",
	picTaskAutoAssignSuccessMessage: "指派有 PIC 簽核要求的任務給",
	picTasksAutoAssignSuccessMessage: "指派有 PIC 簽核要求的任務給",
	eqrTaskAutoAssignSuccessMessage: "指派有 EQR 簽核要求的任務給",
	eqrTasksAutoAssignSuccessMessage: "指派有 EQR 簽核要求的任務給",
	taskEntityDocumentValidationMsg: "This task has entities that do not have any responsive evidence. Toggle to view by entities to see which entities need additional documentation.",
	// PIC/EQR Sign-Off validation message
	picSignOffValidationMsg: "此任務需要 PIC 簽名，但沒有相關 PIC 文件。 請至少新增一個此要求的文件。",
	eqrSignOffValidationMsg: "此任務需要 EQR 簽名，但沒有相關 EQR 文件。 請至少新增一個此要求的文件。",
	picAndEQRSignOffValidationMsg: "此任務需要 PIC/EQR 簽名，但沒有相關 PIC/EQR 文件。 請至少新增一個此要求的文件。",
	updateDataOnPicEqrDashboardBannerMessage: "所做的變更尚未在下方更新。 請{0}重新整理頁面。",
	showMissingSignOffByLabel: "Show documents missing {0} sign-off",

	FindingsReportName: "發現",
	FindingsDeficiencyReportTabName: "缺失",
	FindingsMisstatementReportTabName: "錯誤",
	FindingsDeficiencyITReportTabName: "缺失-IT",
	auditPlanRelatedEvidenceReporLabel: "查核計畫及相關證據",
	groupStructureSummaryReportReportLabel: "集團架構彙總",
	auditPlanReportLabel: "查核計畫報表",
	itAppSOSummaryReportLabel: "IT app和 SO 彙總",
	craSummaryReportLabel: "CRA彙總",
	teamMembersLabel: "團隊成員",
	ipeLabel: 'Information produced by the entity (IPE)',
	validationChecksReportLabel: "驗證檢查",
	trialBalanceReportLabel: "試算表",
	trialBalanceReportTabLabel: "試算表報表",
	reportLabelYes: "是",
	reportLabelNo: "否",
	assignedBy: "指派者",
	openInReviewNotesHub: "在複核註記中心打開",
	nextNote: "下一個",
	previousNote: "上一個",

	//component team group tab names
	accountInfoCanvasFormExport: "Account information",

	//project insight tab names
	projectInsightCanvasFormExport: "Canvas表單匯出",
	projectInsightSCOTToWCGWToControl: "SCOT 至 WCGW 至控制",
	projectInsightControlToITApplication: "IT應用控制",
	projectInsightControlToAssertion: "控制至聲明",
	projectInsightRiskToWCGW: "Risks to WCGWs",

	//IPE Report
	ipeControlsReport: 'Controls',
	ipeSubstantiveReport: 'Substantive',
	ipeITGCReport: 'ITGC',

	// Milestone tab names
	milestonesReport: "里程碑報表",
	unmappedTasks: "未配對的任務",

	// Effective
	isEffective: "有效的",
	inEffective: "無效",
	nonEffective: "無效的",

	clientRequests: "客戶要求",
	externalTasks: "外部任務",
	requestPriority: "請求優先事項",
	scot: "SCOT",
	assertionR: "聲明",
	wcgwToControlMappingTotal: "WCGW to Controls mapping totals",

	//CRA build step
	buildStep2EntityHeaderText: 'Significant accounts and disclosures, assertions, related WCGWs and controls',
	buildStep4EntityHeaderText: 'Significant accounts, disclosures and related assertions',
	accountNameHeader: 'Significant accounts and disclosures',
	noAssertionsLabel: 'No related assertions. Click <a>Manage accounts and disclosures</a> to get started.',
	noAssertionsBuildStep2text1: 'At least one assertion must be related to this account. Click',
	accountWithoutAssertionsBuildStep2text1: 'Each significant account or disclosure must have at least one related assertion. Click',
	noAssertionsBuildStep2text2: 'Manage accounts and disclosures',
	noAccountsLabel: 'No significant accounts or disclosures have been created. Click <span class="bold-text">Manage accounts and disclosures</span> to get started.',
	noAccountsLabelPlaceHolder: 'No significant accounts or disclosures have been created. <span class="bold-text">Manage accounts and disclosures</span> to get started.',
	noAccountsOrDiscloserPreText: 'No significant accounts or disclosures have been created.',
	noAccountsOrDiscloserText: 'Manage accounts and disclosures',
	noAccountsOrDiscloserPostText: ' to get started.',
	noAssertionsBuildStep1text1: 'At least one assertion must be related to this risk. Click',
	noAssertionsBuildStep1text1Msg: 'Each risk must have at least one related assertion.',
	noAssertionsBuildStep1text2: 'Relate assertions',
	noAssertionsBuildStep1text3: ' to get started.',
	editRisk: 'Edit risk',
	deleteRisk: 'Delete risk',
	noControlsRelatedWWCGW: 'No related controls.',
	noControlsRelatedWCGW: 'For each WCGW related to an assertion with a control risk of Rely, at least one control must be selected for testing. Create a',
	noControlsRelatedWCGWNewCont: ' New control',
	noControlsRelatedWCGWor: ' or',
	noControlsRelatedWCGWRelateCont: ' Relate an existing control',
	noControlsForWCGW: 'Assertions with a control risk of Not Rely do not have a requirement to identify controls.',
	noControlsRelatedWCGWFooter: ' to get started.',
	relateWCGWs: '<a>Relate WCGWs</a>',
	noWCGWs: 'No related WCGWs.',
	noWCGWsClick: ' Click',
	noWCGWsFooter: ' to get started.',
	showOnlyRisksWithNoAssertion: 'Show only risks without any related assertions',
	showIncomplete: 'Show only assertions with incomplete CRA',
	showOnlyInvalidBuildStep2: 'Show only accounts missing required details',
	noTestedControlsWithRelyAssertion: 'For each WCGW related to an assertion with a control risk of Rely, at least one control must be selected for testing.',

	// Account build step
	accountOrDisclosure: "科目/揭露",
	relatedAssertions: "相關聲明",
	relatedAccountsAndAssertions: "相關科目和聲明",
	pspIndexTitle: "PSP 索引",
	statementTypeTitle: "報表類型",
	significantAccountLabel: "重大的",
	limitedRiskLabel: "有限風險",
	insignificant: "不重大",
	significantDiscloure: "重大揭露",
	accountAddedMessage: "科目“##”已成功建立",
	accounHeaderText: "Accounts and disclosures",

	// Add accounts / disclosures Modal labels
	accountsListTitle: "科目/揭露及相關聲明",
	addAccountsDisclosures: "新增科目/揭露",
	editAccountsDisclosures: "編輯科目/揭露",
	accountNameLabel: "科目名稱（必須的）",
	accountDesignationLabel: "職稱（必須的）",
	accountEstimateLabel: "科目有一個估計",
	accountStatementTypeLabel: "報表類型（必須的）",
	pspIndexDropdownLabel: "PSP 索引（必須的）",
	removePSPIndexLabel: "刪除 PSP 索引",
	assertionsLabel: "聲明（必須的）",
	noAccounsMessage: "未找到科目。 新增科目即可開始。",

	//Delete account / disclosure modal labels
	deleteAccountDisclosure: "刪除科目/揭露",
	deleteAcConfirmMessage: "您確定要刪除科目/揭露 {0} 嗎？ 所有相關聲明將被刪除。 任何僅與所選科目/揭露相關的任務也將被刪除。",

	true: "正確的",
	false: "錯誤的",
	taskSummaryReportEngagementInfo: "多案件",
	viewPriority: "查看優先順序",
	priorityRequestsSent: "發送的優先請求",

	//reactive frame
	maxTabsLocked: "已達到最大允許的標籤頁數量。若要開新標籤，請先將其中一個標籤取消固定並關閉。",
	openInNewTab: "在新分頁中開啟",
	copyLink: 'Copy link',
	copySuccess: 'Link copied to clipboard',
	copyFailure: 'Failed to copy link to clipboard',
	minimize: 'Minimize',

	//Risk status for account cards
	riskStatusLabels: {
		NoAssertionsAvailableLabel: "沒有可用的聲明",
		SignificanceNotSelectedLabel: "未選擇重大性",
		InsignificantLabel: "不重大"
	},

	lockTab: "釘選標籤",
	keyDocuments: "關鍵文件",
	suggestedDocuments: "建議文件",
	noSuggestedDocuments: "沒有建議的文件",
	exitBulkMode: "退出批次模式",
	bulkLabel: "Bulk",

	me: "Me",
	viewByUser: "按使用者查看",
	unsentDraftCapitalized: "未發送的草稿",
	picSignoffInComplete: "  PIC 簽核不完整",
	eqrSignOffIncomplete: "EQR 簽核不完整",

	tableView: "表格視圖",
	noRelatedAssertions: 'No related assertions.',

	multiEntityTileMessage1: "Click",
	multiEntityTileMessage2: "這裡",
	multiEntityTileMessage3: " to see status by entity",
	allItemsMessage: ' to see all items',

	EntitySelector: 'Select an entity to get started',
	allEntities: "所有個體",
	multiEntity: "多個體",
	ungrouped: "未分群組",
	numberSelected: "已選則{0}",
	allTimePhases: "全部",
	timePhases: "時間階段",
	noTimePhaseFound: "未找到時間階段",
	unrelatedAssignments: "不相關的指派事項",
	unrelatedRequests: 'Unrelated requests',
	relateRequests: 'Relate requests',
	taskWithoutAnyAssignments: "此任務無任何指派事項",
	privacyNotice: "隱私權聲明",
	lastPublishedAndSent: "Last published and sent",
	drafts: "Drafts",
	allEntitiesTask: "This is an engagement-wide task related to all entities",
	noRelatedEntities: "No related entities",
	clickNewRisk: "to get started.",
	relatedAccountsDisclosuresAndAssertions: 'Related significant accounts, disclosures and assertions',
	relateAssertion: 'Relate assertions',
	taskByEntity: 'Task by entity',
	engagementWideTask: 'Engagement-wide task',
	componentEngagementPill: 'CT',
	primaryAndComponentEngagementPill: 'PT/CT',
	// Scot build steps
	scotHeader: 'SCOTs',
	searchScot: 'Search',
	manageScots: 'Manage SCOTs',
	superModelStep1ScotMessage: 'Significant accounts and disclosures and related SCOTs',
	scotRelatedITApplicationServiceOrg: "SCOTs and related IT applications and service organizations",
	noScotsAvailable: 'No result found',
	searchScotPlaceholder: 'Search',
	searchScotClearHoverText: 'Clear',
	showOnlyUnrelatedScotToggleSwitch: 'Show only unrelated',
	newScot: 'New SCOT',
	importFromKnowledgeScot: 'Import SCOTs',
	importAccountsAndDisclosures: 'Import accounts and disclosures',
	showOnlyAccountRelatedScot: 'Show only SCOTs without any related significant account and disclosure',
	warningMessageEstimateScotNotAssociatedWithEstimatedAccount: 'Each estimate SCOT must be related to at least one significant account or significant disclosure with an estimate.  Drag and drop this SCOT to a relevant significant account or significant disclosure.',
	warningMessageScotNotAssociatedWithAccount: 'Each SCOT must be related to at least one significant account or significant disclosure.  Drag and drop this SCOT to a relevant significant account or significant disclosure.',
	showvalidations: 'Show validations',

	scotRelatedWCGWandControls: 'SCOTs and related WCGWs and controls',
	newWcgw: 'New WCGW',
	manageWCGWs: 'Manage WCGWs',
	manageControl: 'Manage controls',
	importWCGWs: 'Import WCGWs',
	relateWCGWs: 'Relate WCGWs',
	newControl: 'New control',
	importControl: 'Import control',
	importControls: 'Import controls',
	relateControl: 'Relate controls',
	scotStrategyIsControlMessage: 'No controls identified for this WCGW. SCOT strategy is not defined.',
	scotStrategyIsWCGWMessage: 'No WCGWs identified for this SCOT. SCOT strategy is not defined.',
	controlsPlaceholderWithNoRelatedWCGWsMessage: ' Each SCOT must be related to at least one WCGW.  Create a',
	controlsPlaceholderWithNoRelatedControlsMessage: 'Each WCGW must be related to at least one Control.  Create a',
	noITApplicationSOMessage: 'No IT applications or service organizations identified for this SCOT. Click',
	relatedItAppSOHeaderMessage: 'Related IT applications and service organizations',
	substantivePlaceholderWithNoRelatedControlsMessage: 'No Controls identified for this SCOT. For SCOTs with substantive strategy no controls need to be identified.',
	substantivePlaceholderWithNoRelatedWCGWsMessage: 'No WCGW identified for this SCOT. For SCOTs with substantive strategy, WCGWs need to be identified.',
	noITApplicationSOMessageText: 'to relate where required.',
	notSelected: 'Not selected',
	or: 'or',

	//WCGWControls
	showOnlyWCGWRelatedControls: "Show only related",

	createorRelateControl: 'Create a new control or relate an existing control',

	//Accounts Scot build steps
	accountHeader: "科目",
	searchAccount: 'Search account',
	searchAccountPlaceholder: 'Search',
	manageAccounts: ' Manage accounts and disclosures',
	showOnlyUnrelatedAccountToggleSwitch: 'Show only unrelated',
	searchAccountClearHoverText: 'Clear',
	noAccountsAvailable: 'No results found',
	showOnlyScotRelatedAccount: 'Show only significant accounts and disclosures without any related SCOT',
	warningMessageEstimateAccountNotAssociatedWithEstimatedScot: 'Each significant account or disclosure with an estimate must be related to at least one estimate SCOT. Drag and drop an existing relevant SCOT to this significant account or significant disclosure',
	warningMessageAccountNotAssociatedWithScot: 'Each significant account or disclosure must be related to at least one SCOT. Drag and drop an existing relevant SCOT to this significant account or significant disclosure',
	significantAccountsAndDisclosures: 'Significant accounts and disclosures',
	// Independence Only

	independenceOnlyStatus: 'Independence only',

	//Controls
	controlDesignEffectivenessWarningValidation: 'Controls must have a design effectiveness selected',
	controlHeader: 'SCOTs and related controls',
	manageControls: 'Manage controls',
	manageITApplications: 'Manage IT applications',
	searchControlClearHoverText: 'Clear',
	searchControlPlaceholder: 'Search',
	noControlsAvailable: 'No results found',
	controlName: 'Control name',
	frequency: 'Frequency',
	type: "類型",
	newSO: 'New SO',
	designEffectiveness: 'Design effectiveness',
	testing: "測試",
	strategyTypeName: 'SCOT strategy',
	controlTestingYes: 'Yes',
	controlTestingNo: 'No',
	effective: 'Effective',
	ineffective: 'Ineffective',
	noControlsResult: "No results found",
	noControlsLabel: "No results found",
	relatedControl: 'Related control',
	relateControls: 'Relate controls',
	controlTypeValues: {
		itApplication: 'IT Application Controls',
		itDependentManual: 'IT Dependent Manual Control',
		manualPrevent: 'Manual Prevent',
		manualDetect: 'Manual Detect'
	},
	controlFrequencyTypes: {
		manyTimesPerDay: 'Many times per day',
		daily: 'Daily',
		weekly: 'Weekly',
		monthly: 'Monthly',
		quarterly: 'Quarterly',
		annually: 'Annually',
		iTApplicationControl: 'IT Application Control',
		other: 'Other'
	},
	filterTypeOfScots: "SCOTs",
	noScotsAvailable: 'No results found',


	onlyShowControlsWithNoDesignEffectiveness: 'Show only controls with no design effectiveness selected',

	// control Tasks
	controlCount: '{0} controls',

	//Create and Edit WCGW
	wcgwInputName: "WCGW name",
	editWCGW: "Edit WCGW",
	createNewWCGW: "Create new WCGW",
	editTheWCGW: "Edit the WCGW",
	createEditWCGWSave: "Save",
	createEditWCGWClose: "Cancel",
	createEditWCGWModelScot: "SCOT",
	newWCGWTitel: "New WCGW",
	wcgwNameIsRequired: "WCGW name is required",
	deleteWCGW: "Delete WCGW",


	//Audit Plan
	importPSPButtonText: 'Import PSPs',
	commonContentUpdateSuccessMessage: 'Content update in progress. This may take up to fifteen minutes to complete. Refresh the page to see newly imported PSPs.',
	responsivetoRisks: 'Responsive to risks',
	procedures: 'Procedures',
	toc: "TOC",
	significantandFraudRisksHeading: 'Significant and fraud risks and their responsive procedures and controls',
	risksBeingRespondedToByComponentTeam: 'Risks are being responded to by component team(s).',
	responsivecontrolsandTOCs: 'Responsive controls and TOCs',
	ResponsivePSPOSP: 'Responsive PSP/OSP',
	responsivePSPsOSPs: 'Responsive PSPs/OSPs',
	responsiveTOC: 'Responsive TOC',
	responsiveControl: 'Responsive control',
	responsivePSPOPSMessage: 'At least one substantive procedure should be identified as being responsive for this assertion for this risk. Click {0} to identify responsive substantive procedures.',
	responsiveControlMessage: 'At least one control (with completed design effectiveness evaluation) should be identified as being responsive for this assertion for this risk. Click {0} to identify responsive controls. Click {1} to set the design effectiveness or testing strategy.',
	responsiveTOCMessage: 'Assertions with control risk of Rely must have at least one TOC that is responsive to the risk for a control is (1) not designated as lower risk and (2) has a completed design effectiveness. Click <b>Responsive TOC</b> to identify responsive TOCs.',
	notcompleted: 'Not completed',
	noResponsiveTOCAvailable: 'No responsive TOCs have been identified for this control.',
	refresh: 'Refresh data',
	tocHoverOverWhenControlTestingHasNoorNotCompleted: 'This control has not been selected for testing. Use <b>Manage controls</b> to change the testing selection.',
	noresponsiveTOCIdentified: 'No responsive TOC has been identified.',
	taskAssertionnotModified: 'The task assertions have not been modified. Edit the assertion relationship to proceed or click cancel to exit.',
	failedToEditRelatedAssertions: 'Failed to edit the assertions related to the task. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	assertionCannotEdited: 'Assertions with a disabled checkbox have been set by EY methodology and cannot be edited.',
	editAssertionInfoMessage: 'Add or remove assertions for the task. There must be at least one assertion selected.',
	editRelatedAssertions: 'Edit related assertions',
	loweRiskHeader: 'Lower risk',
	placeholderWhenControlTestingHasNotCompleted: 'This control has not been selected for testing. Use {0} to change the testing selection.',
	pspandOSP: 'PSPs/OSPs',
	tocs: 'TOCs',
	norelatedAssertionPlaceHolder: 'Each significant or fraud risk must have at least one assertion identified as being related to this risk. Click {0} to identify related assertions.',
	assertionMustHaveOneControlWithCompleteDesignEffectiveness: 'Each assertion must have at least one control with completed design effectiveness identified as being responsive to the risk. Click {0} to identify a responsive control.',
	controlRiskRelyNotLowerRisk: 'Each assertion with control risk of rely must have at least one control that is (1) not designated as lower risk, (2) designed effectively and (3) selected for testing. Click {0} to identify responsive control.',
	controlRiskRelyWithDesignEffectively: 'Each assertion with control risk of rely must have at least one control that is (1) designed effectively and (2) selected for testing. Click {0} to identify responsive control.',

	assertionWithControlRiskNotRely: 'Assertions with control risk of not rely do not have a requirement to identify a test of control.',
	thisControlNotSelectedForTesting: 'This control has not been selected for testing. Click {0} to change the testing selection.',
	testControlRelatedToControlAsLowerRisk: 'A test of control related to a control that is designated as a lower risk will not address the risk for this assertion.',
	testControlWithoutCompleteDE: "A test of control related to a control without a completed design effectiveness evaluation will not address the risk for this assertion. Click {0} to set the design effectiveness.",
	testControlrelatedToineffective: "A test of control related to a control with an ineffective design effectiveness evaluation will not address the risk for this assertion. Click {0} to change the design effectiveness.",
	anotherTestControlIdentified: 'Another test of control has been identified that responds to the risk of this assertion and no further tests of controls need to be identified. No responsive TOCs have been identified for this control.',
	eachControlMustHaveOneToc: 'Each assertion with control risk of rely must have at least one TOC that is responsive to the risk for a control that is (1) not designated as lower risk, (2) designed effectively and (3) selected for testing. No responsive TOCs have been identified for this control. Click {0} to identify responsive TOCs.',
	eachAssertionControlHaveAtleasetOneTOC: 'Each assertion with control risk of rely must have at least one TOC that is responsive to the risk for a control that is (1) designed effectively and (2) selected for testing. No responsive TOCs have been identified for this control. Click {0} to identify responsive TOCs.',
	norepsonsivePSPOSPplaceholder: 'Each assertion must have at least one substantive procedure identified as being responsive to this risk. Click {0} to identify a responsive substantive procedure.',

	//Reject Task
	rejectPspModalTitle: 'Reject PSP',
	rationaleRequired: 'Required',
	rationaleTextEditorLabel: 'Rationale for rejecting PSP',
	rejectTaskErrorMessage: 'Unable to reject the task. Refresh the page and try again.  If the issue persists, contact the Help Desk.',
	rejectTaskModalHeader: 'Are you sure that you want to reject the selected PSP?',
	rejectTaskModaWarningText: 'Related evidence that is not related to any other tasks in this engagement will be moved to temporary files.',
	rejectTaskRationaleLabel: "Rationale (required)",

	// Adobe Analytics
	aaCookieConsentTitle: 'Welcome to',
	aaCookieContentPrompt: 'Do you want to allow cookies?',
	aaCookieConsentExplanation: '<p>In addition to cookies that are strictly necessary to operate this website, we use the following types of cookies to improve your experience and our services: <strong>Functional cookies</strong> to enhance your experience (e.g. remember settings), <strong>Performance cookies</strong> to measure the website\'s performance and improve your experience, <strong>Advertising/Targeting cookies</strong>, which are set by third parties with whom we execute advertising campaigns and allow us to provide you with advertisements relevant to you.</p><p>Review our <a target="_blank" href="https://www.ey.com/en_us/cookie-policy">cookie policy</a> for more information.</p>',
	aaCookieConsentExplanationWithDoNotTrack: '<p>In addition to cookies that are strictly necessary to operate this website, we use the following types of cookies to improve your experience and our services: <strong>Functional cookies</strong> to enhance your experience (e.g. remember settings), <strong>Performance cookies</strong> to measure the website\'s performance and improve your experience, <strong>Advertising/Targeting cookies</strong>, which are set by third parties with whom we execute advertising campaigns and allow us to provide you with advertisements relevant to you.</p><p>We have detected that you have enabled the Do Not Track setting in your browser; as a result, Advertising/Targeting cookies are automatically disabled.</p><p>Review our <a target="_blank" href="https://www.ey.com/en_us/cookie-policy">cookie policy</a> for more information.</p>',
	aaCookieConsentDeclineOptionalAction: 'I decline optional cookies',
	aaCookieConsentAcceptAllAction: 'I accept all cookies',
	aaCookieConsentCustomizeAction: 'Customize cookies',
	aaCookieConsentCustomizeURL: 'https://www.ey.com/en_us/cookie-settings',

	//Task Sections
	taskSectionLabels: {
		taskSectionHeader: "Task groups and related tasks",
		manageTaskSections: "Manage task groups",
		taskSectionsAccordionHeader: "Task groups",
		phaseAccordionHeader: 'Phase',
		tasksAccordionHeader: 'Tasks',
		rejectedAccordionHeader: 'Rejected',
		noRelatedTasksMessage: 'No PSTs/OSTs available. Create a {0} to get started.',
		taskSectionTaskHeader: 'Tasks',
		newOSTButtonText: 'New OST',
		cutomTaskSectionBadgeText: 'Custom',
		rejectedTasksLabel: "Rejected PSTs",
		additionalInfo: 'Rationale',
		rejectButton: 'Reject',
		acceptButton: 'Accept',
		removeButton: 'Remove',
		addButton: 'Add',
		allPSTsRejectedMessage: 'All PSTs have been rejected.',
		rejectModalTitle: 'Reject PST',
		rationaleTextEditorLabel: 'Rationale for rejecting PST',
		rejectTaskModalHeader: 'Are you sure that you want to reject the selected PST?',
		noResultsMessage: 'No results found',
		noTaskSetionsAvailableMessage: 'No task sections available',
		rejectTaskModaWarningText: 'Related evidence that is not related to any other tasks in this engagement will be moved to temporary files. PSTs with EY Canvas delivered documents cannot be rejected.',
		rejectTaskRationaleLabel: "Rationale (required)"
	},

	// Cookie Settings
	cookieSettings: {
		title: 'Cookie Settings',
		explanation: 'Please provide your consent for cookie usage on ey.com and the My EY platform. Select one or more of the cookie types listed below, and then save your selection(s). Refer to the listing below for details on the types of cookies and their purpose.',
		emptyCookieListNotice: 'Cookies from this category are not used in this app',
		nameTableHeader: 'Name of cookie',
		providerTableHeader: 'Cookie provider',
		purposeTableHeader: 'Purpose of cookie',
		typeTableHeader: 'Type of cookie',
		durationTableHeader: 'Duration of cookie',
		formSubmit: 'Save my selection',
		requiredCookieListTitle: 'Required Cookies',
		functionalCookieListTitle: 'Functional Cookies',
		functionalCookieAcceptance: 'I accept the functional cookies below',
		functionalCookieExplanation: 'Functionality cookies, which allow us to enhance your experience (for example by remembering any settings you may have selected).',
		performanceCookieListTitle: 'Performance Cookies',
		performanceCookieAcceptance: 'I accept the performance cookies below',
		performanceCookieExplanation: 'Performance cookies, which help us measure the website’s performance and improve your experience. In using performance cookies we do not store any personal data, and only use the information collected through these cookies in aggregated and anonymised form.',
		advertisingCookieListTitle: 'Targeting Cookies',
		advertisingCookieAcceptance: 'I accept the advertising/targeting cookies below',
		advertisingCookieExplanation: 'Advertising/targeting cookies, which we use to track user activity and sessions so that we can deliver a more personalized service, and (in the case of advertising cookies) which are set by the third parties with whom we execute advertising campaigns and allow us to provide advertisements relevant to you.',
		doNotTrackNotice: 'We have detected that you have enabled the Do Not Track setting in your browser; as a result, advertising/targeting cookies are automatically disabled.'
	},

	//Task Sections and related Tasks
	taskSectionAndRelatedTask: 'Task sections and related tasks',
	manageTaskSections: 'Manage task sections',

	// Financial Statments
	financialStatementLabels: {
		financialStatements: "Financial statements",
		trialBalance: 'Trial Balance',
		okButton: 'OK',
		leadSheet: "Lead sheet",
		balanceSheet: 'Balance sheet',
		incomeStatement: 'Income statement',
		eyreferences: 'Reference',
		currenPeriod: "Analysis date",
		comparativePeriod: "Comparative date",
		changeFrom: 'Change from',
		percentageChangeFrom: '% Change from',
		notesColumn: 'Notes',
		viewTrialBalanceType: 'View by trial balance type',
		multiEntity: 'Multi-entity',
		placeHolderText: "Search account classes",
		currencyType: 'Currency type',
		currencyCode: 'Currency code',
		businessUnit: 'Business unit',
		periodEnded: "date ended",
		periodsEnded: "dates ended",
		searchGLAccountPlaceholder: 'Search GL Accounts',
		eyReferenceDocuments: '{0} documents',
		relatedNotes: 'Related notes',
		notAvailable: 'Not available',
		significantDisclosures: "Significant disclosures",
		noResultFound: 'No results found',
		openEYHelixProjects: "Open EY Helix projects",
		openAdjustmentModule: "Open adjustment module",
		goToSubstantiveProcedureLink: "Go to substantive procedures",
		cancel: 'Cancel',
		remove: 'Remove'
	},

	financialStatementsClassView: {
		bulk: 'Bulk',
		eyAccount: 'EY account',
		placeHolderText: "Search GL accounts",
		noAccountDesignation: 'Account designation has not been set.',
		insignificantLeadSheetMessage: 'Lead sheets are not presented for insignificant accounts',
		unmappedGLAccounts: 'Lead sheets are not presented for unmapped accounts',
		unmappedAccountText: 'Unmapped'
	},
	financialStatementTypeIds: [{
		id: 1,
		label: "Assets"
	},
	{
		id: 4,
		label: "Liabilities"
	},
	{
		id: 7,
		label: "Equity"
	},
	{
		id: 8,
		label: "Revenue"
	},
	{
		id: 9,
		label: "Expenses"
	},
	{
		id: 17,
		label: "Net income"
	}
	],
	copyrightMessage: 'Copyright © <year> all rights reserved',
	createNotes: {
		notesPlaceholderText: 'Add notes by clicking on {0} or {1}.',
		newNote: "Add note",
		relateNote: 'Relate note',
		addNewNotesHeader: 'Enter note details below and select <b>\'Save and close\'</b> to finish. To create another note, select <b>\'Save and create another\'</b>.',
		noteIndex: 'Index',
		noteIndexRequired: 'Index (required)',
		noteDescription: 'Description',
		noteDescriptionRequired: 'Description (required)',
		saveAndClose: 'Save and close',
		newTickmarkDescription: "Select the reason why there is no evidence referenced to this GL Account.",
		newTickmarkBulkModalDescription: " Select the reason why there is no evidence referenced to the selected GL accounts."
	},
	deleteNotes: {
		deleteNote: 'Delete note',
		deleteNoteTitle: 'Are you sure that you want to delete the selected note?',
		delete: 'Delete',
		cancel: 'Cancel'
	},
	editNotes: {
		editNote: "Edit note",
		editNotesHeader: "Edit note details below and select <b>\'Save and close\'</b> to finish.",
		edit: "Edit",
		cancel: 'Cancel'
	},
	notesListLabels: {
		actions: 'Actions',
		noteCount: '{0} note',
		notesCount: '{0} notes'
	},
	relateNotes: {
		relateNoteLabel: 'Relate note',
		searchPlaceholder: 'Search',
		accountLabel: 'Account',
		indexLabel: 'Index',
		descriptionLabel: 'Description',
		addedLabel: 'Added',
		showOnlyRelatedLabel: 'Show only related',
		noResultsFoundMessage: 'No results found',
		noteCount: '{0} Note',
		notesCount: '{0} Notes',
		closeBtnTitle: 'Close'
	},
	uploadEvidenceDocuments: {
		addnewEvidencesPlaceholderandLinks: "Add evidence by clicking on {0}, {1} or designate no evidence required by clicking {2}.",
		newEvidence: 'New evidence',
		relateEvidence: 'Relate evidence',
		newTickMark: "New tickmark",
		relateTasks: 'Relate task',
		noTasksSeleted: 'Select a task to continue.',
		relateTaskPlaceholder: 'New references must be related to at least one task. Select a task that this document should be added to as evidence.',
		confirmButtonTitle: 'Continue',
		closeButtonTitle: 'Cancel',
		noResultsFound: 'No results found',
		taskType: 'Type',
		taskName: 'Task name',
		taskCount: '{0} Task',
		tasksCount: '{0} Tasks',
		title: 'Reference',
		removeReference: 'Remove reference'
	},
	glAccountAssociatedNotes: {
		aggregatedNotesPlaceholder: 'No notes available. Select a GL Account to create a note.',
		notes: 'Notes',
		relatedGlAccountPlaceholder: 'Related GL Accounts'

	},
	finacialStatementsBulkOperations: {
		relateEvidenceLabel: "Relate evidence",
		selectedCountGLAccount: "{0} GL account selected",
		selectedCountGLAccounts: "{0} GL accounts selected",
		selectAll: "Select all",
		deselectAll: "Deselect all",
		exitBulkMode: "Exit bulk mode",
		noGLAccountsSelectedValidationMessageEvidence: "Select at least one GL account to relate evidence or click Exit bulk mode.",
		noGLAccountsSelectedValidationMessageTickmark: "Select at least one GL account to new tickmark or click Exit bulk mode.",
		noGLAccountsSelectedValidationMessageRemoveReference: "Select at least one GL account to remove reference or click Exit bulk mode.",
		relateTickmarkLabel: "New tickmark",
		removeReferenceLabel: "Remove reference",
		removeReferenceConfirmationMsg: "Confirm if you would like to remove references for all selected GL accounts."

	},
	financialStatementsFilters: {
		referenceFilterKey: "GL accounts missing references",
		accountFilterKey: "GL accounts without mapping",
		noResultsPlaceholder: "No results found",
		trialBalance: "Trial balance",
		noneAvailable: "None available",
		search: "Search",
		multityEntity: "Multi-entity",
		placeHolderMessageWhenHelixMappingIsTrue: "No imported trial balance. Click {0} to relate a new analyzer.",
		placeHolderMessageWhenHelixMappingIsFalse: "Integration with EY Helix is not available. Refresh the page and try again. If the issue persists, contact the Help Desk.",
		eyHelixIntegrationLinkText: 'EY Helix integration',
		noEntitiesAvailablePlaceholder: "No entities created. Create entities to get started."
	},
	//Group instructions
	assertionTabButton: 'Assertions',
	inherentRiskFactorButton: "Inherent risk factors",
	accountsAndDisclosure: "Accounts/Disclosures",
	assertions: 'Assertions',
	assertionC: 'C',
	assertionEO: 'E/O',
	assertionMV: 'M/V',
	assertionRO: 'R&O',
	assertionPO: 'P&D',

	complexity: 'Complexity',
	subjUncertainty: 'Subject Uncertainty',
	fraudOrError: 'Fraud or error',
	change: 'Change',
	natureOfAccount: 'Nature of Account',
	relatedParties: 'Related Parties',
	higherInherentRiskLabel: 'Higher inherent risk',
	lowerInherentRiskLabel: 'Lower inherent risk',
	relevantLabel: 'Risk associated',
	relevantContributeLabel: 'Risk associated and contributes to the higher inherent risk',
	incompleteInherentRiskTooltip: 'Incomplete inherent risk',
	estimateLabel: 'Estimate',
	riskAssociatedLabel: 'Risk associated',
	greaterExtentLabel: 'Greater extent',
	lesserExtentLabel: 'Lesser extent',
	accordionNoRiskLabel: "No risk related to this account assertion.",
	accordionNoRiskAccountLabel: "No risk related to this account",
	accordionNoAssertionsLabel: "No assertions related to this account.",
	accordionLimitedRiskLabel: "The account has been identified as a limited risk.",

	maps: 'Maps',
	financialStatements: "Financial Statements",
	serviceGatewayAutomation: "Service Gateway & Automation",
	manageTaskGroups: "Manage task groups",
	openAssignmentsLabel: "Open assignments",
	inProgressAssignmentsLabel: "In progress assignments",
	// My Progress collaboration view.
	calendarDays: [
		"Sunday",
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday"
	],
	calendarMonths: [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December"
	],
	myProgressToday: "Today",
	noDueDateAssignedGroup: "No due date assigned",
	myProgressStatusTile: {
		yourRequests: "Your requests",
		totalCount: "Total count",
		requestStatus: "Request status",
		draft: 'Draft',
		pending: 'Pending',
		received: 'Received',
		accepted: "已接受",
		overdue: "Overdue",
		noRelatedTasks: "{0} with no related tasks",
		oneNoRelatedTask: "1 with no related task",
		addRequest: "New request",

		//Requests dues tile 2
		pendingRequestsByDueDate: "Pending requests by due date",
		requestsYAxisLabel: "Requests",
		requestsXAxisLabel: "Days",
		tooltipDaysLabel: "days",
		tooltipTotalLabel: "Total:",
		normalLabel: "Normal",
		highLabel: "High",
		criticalLabel: "Critical",
		overdueLabel: "Overdue",
		overDueCatFirst: "Overdue > 90",
		overDueCatSecond: "Overdue 31-90",
		overDueCatThird: "Overdue 10-30",
		overDueCatFourth: 'Overdue 1-9',
		catFifth: '1-9',
		catSixth: '10-30',
		catSeventh: '31-90',
		catEighth: '> 90',
		noRequestsFound: "No requests found",
		daysOverdue: 'Days overdue',
		daysComingDue: 'Days coming due'
	},
	documentAttributeReference: {
		name: 'Name',
		notes: 'Notes',
		signOffs: 'Sign-offs',
		tasks: "Related tasks",
		open: 'Open',
		openReadOnly: 'Open read-only',
		delete: 'Delete',
		rename: 'Rename',
		signOffRequirements: 'Sign-off requirements',
		confidentiality: 'Confidentiality',
		unlink: 'Unlink',
		relateTasks: "Relate tasks"
	},
	aiChatbot: 'EYQ Assurance Knowledge',
	selectDueDate: "Select a due date",
	daysOverdue: 'Days overdue',
	daysComingdue: 'Days coming due',
	loadingDataMessage: 'Loading data... this may take a few seconds'
};

/*RBAC Errors*/
export const RbacErrors = {
	106: "Insufficient roles to edit content. Work with an engagement administrator to get sufficient rights."
};

/*Errors*/
export const Errors = {
	/*Doc Helper Custom Messages */
	0: "連接遺失。請重新連接並重試。若問題仍然存在，請聯絡Help desk。",
	101: "無效案件狀態。",
	102: "找不到有效案件使用者。",
	103: "缺少案件使用者獨立性遵循。",
	104: "缺少必要Azure AD範圍",
	105: "取得案件權限時發生錯誤。請重新整理頁面並重試。若問題持續，請聯絡Help Desk。",
	106: "您無執行此動作所要求之權限。",
	107: "找不到有效案件使用者。請重新整理頁面並重試。若問題仍然存在，請聯絡Help Desk。",
	108: "Engagement profile is incomplete. Please go to Landing page and Complete Profile.",
	303: "相同名稱之文件目前已上傳。",
	401: "Unable to complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	403: "為不支援之檔案格式且尚未更新。請將文件重新儲存為有效之檔案格式並重試。若問題仍然存在，請聯絡Help Desk。",
	410: "This document has been deleted and therefore it cannot be opened.",
	411: "Empty documents are not permitted.",
	412: "此案件已存在相同名稱之文件。",
	413: "Document exceeds the maximum allowable file size (250mb) and cannot be uploaded. Reduce the file size and try again.",
	500: "連接遺失。請重新連接並重試。若問題仍然存在，請聯絡Help Desk。",
	414: "名稱超過最大長度（{0} 個字符）。",
	600: "Operation cannot be complete at this time. Refresh the page and try again. If the issue persists contact the Help Desk.",
	601: "Document with the same name exists.",
	602: "Document is already in collaboration",
	603: "Document not found.",
	'zip': "無法上傳.zip檔案，因其包含未支援檔案類型，或其內嵌.zip檔案超過最大數量。",
	401000: "偵測到網路變更，請重新載入頁面以繼續",

	/*Accounts*/
	1001: "建立科目失敗。",
	1002: "缺少科目名稱。",
	1003: 'The selected Account has been deleted. Close this modal to see the updated list.',
	1004: 'No results found. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	1005: "無效的案件Id。",
	1006: "無效的科目類型。",
	1007: "無效的報表類型。",
	1008: 'The selected Account has been deleted. Close this modal to see the updated list.',
	1009: "由Id取得科目失敗。",
	1010: "由案件Id取得科目失敗。",
	1011: "由於無效的請求，取得科目Id SEM彙總失敗。",
	1012: "無效的彙總類型。",
	1013: "建立科目複核失敗。",
	1014: "刪除科目複核失敗。",
	1015: "無效的科目複核建立請求。",
	1016: "無效的科目複核ID。",
	1017: "科目非此案件之一部分或已被刪除。",
	1018: "科目複核係由其他使用者建立。",
	1019: 'Account has been deleted by another user. Refresh the page and try again.',
	1020: 'Account need PSP to update',
	1024: 'Account name is more than 500 characters.',
	1025: 'Limited Risk or Insignificant account cannot be estimated',
	1026: 'Account cannot have duplicate assertions',
	1027: 'Invalid assertion id',
	1037: 'Cannot have duplicate PSP Indexes',
	1039: 'The selected Account has been deleted. Close this modal to see the updated list.',
	1048: 'Account has been invalid execution type.',
	1053: 'Account has Risk or Estimate associated, can not set to Limited Risk Account or Insignificant Account.',
	1054: 'Assertions to be deleted have associated with Risk or Estimate',
	1065: "You cannot make changes to assertion(s) that have a Significant risk, or Fraud risk, or Risk of material misstatement or an estimate related.You need to remove these relations first.",

	1266: 'Engagement has reached maximum number of multi-edit mode documents.  Check some documents back in and try again.  If the issue persists contact the Help Desk.',
	1267: 'Document is conflicted. Resolve conflicts and try again.  If the issue persists, contact the Help Desk.',
	1268: 'Document is already in co-edit mode. end co-edit mode and try again.  If the issue persists, contact the Help Desk.',
	1269: 'Document is a shared evidence. Unlink and try again.  If the issue persists, contact the Help Desk.',

	/*Assertions*/
	2001: "建立請求無效。",
	2002: "缺少聲明名稱。",
	2003: "缺少聲明。",
	2004: "取得聲明失敗。",
	2005: "無效的案件Id。",
	2006: "由Id取得聲明失敗。",
	2007: "取得聲明WCGW失敗。",
	2050: 'Assertion not found. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	/*Tags*/
	5120: "找不到標註ID。",
	5121: "缺少標註ID。",
	5123: "重複標記連結。",
	5124: "找不到標記連結。",


	/*Risks*/
	4001: 'Operation could not be completed at this time. Refresh the page and try again. If the issue persists, contact the Help desk.',
	4002: "缺少風險名稱。",
	4003: "缺少風險。",
	4004: "取得風險失敗。",
	4005: "無效的案件Id。",
	4006: "由Id取得風險失敗。",
	4007: "無效的查詢請求。",
	4008: 'The selected Risk has been deleted. Close this modal to see the updated list.',
	4009: "無效的更新請求。",
	4010: "特定WCGW已被指派到此風險",
	4011: "WCGW清單不能為空值。",
	4012: "取得風險類型失敗。",
	4013: "建立請求無效。",
	4014: "相關聲明無效。請重新整理頁面並重試。若錯誤仍然存在，請聯絡Help Desk。",
	4015: "WCGW無效。請重新整理頁面並重試。若錯誤仍然存在，請聯絡Help Desk。",
	4016: 'The selected Risk has been deleted. Close this modal to see the updated list.',
	4017: "風險聲明無效。請重新整理頁面並重試。若錯誤仍然存在，請聯絡Help Desk。",
	4018: "風險類型id無效。",
	4019: 'RiskName is not valid.',
	4020: 'Invalid Document ID.',
	4021: 'RiskName should not be more than 500 characters.',
	4023: 'AssertionIds list cannot be null.',
	4024: 'Limited risk documentation form could not be created due to an error. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4025: 'Invalid account id.',
	4026: 'Invalid assertion id.',
	4027: 'AssertionRisk Model cannot be empty',
	4031: 'Invalid Risk or Form Body option.',

	4035: 'Cannot edit IsHigherRisk for Significant or Fraud Risks.',
	4036: 'KnowledgeAssertionId cannot be empty if no AssertionId is passed in. KnowledgeAssertionId must be in enums',
	4037: 'KnowledgeAssertionId already exists for this account.',
	4038: 'RiskTypeId does not match permissible options.',
	4040: 'This action cannot be taken. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*TASK*/
	5001: "取得所有失敗。",
	5002: "此任務不再存在於此案件。",
	5003: "取得任務文件失敗。無效的請求參數。",
	5004: "取得任務相關文件失敗。無效的請求參數。",
	5005: "由Id取得任務失敗。",
	5006: "取得任務類別失敗。",
	5007: "取得任務子類別失敗。",
	5008: "取得任務說明失敗。",
	5009: "取得客戶請求任務失敗。",
	5010: "儲存客戶請求任務失敗。",
	5011: "您欲連結項目之任務已被刪除或拒絕。",
	5012: "您欲連結之項目已被刪除。",
	5013: "您欲連結項目之任務已被刪除或拒絕。",
	5014: "您欲連結之文件已被刪除。",
	5015: "取得任務證據失敗。",
	5016: "取得WCGW任務失敗。",
	5017: "案件Id應大於零。",
	5018: 'This action cannot be taken. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5019: "任務說明為空白。",
	5020: "所選任務已被刪除或拒絕。故目前無法完成此動作。",
	5021: "缺少來源案件Id。",
	5022: "儲存註解失敗",
	5023: "找不到案件使用者。",
	5024: "刪除任務失敗。",
	5025: "刪除任務失敗。",
	5026: "任務清單為空白",
	5027: "找不到複核註記。",
	5028: "檔案名稱為必填。",
	5029: "檔案副檔名為必填。",
	5030: '檔案名稱不能含有: */:<>\\?|\"',
	5031: "更新文件名稱錯誤。",
	5032: "無效的文件Id。",
	5033: "找不到操作類型。",
	5034: "變更任務狀態失敗",
	5035: "您欲執行之動作目前無法完成。請稍後重試。若錯誤仍然存在，請聯絡Help Desk。",
	5036: "內文不得為空值或空白。",
	5037: "請求不得為空值。",
	5038: "請輸入唯一的文件名稱以繼續。",
	5039: "檔案名稱為必填。",
	5040: "檔案名稱限制100字元。",
	5041: '檔案名稱不能含有: */:<>\\?|\"',
	5042: "所選擇的任務被拒絕。",
	5043: "此任務為建立步驟任務。",
	5044: "此任務為里程碑任務。",
	5045: "此任務非PSP或OSP類型。",
	5046: "超過字元限制。",
	5047: "超過字元限制。",
	5048: "必填欄位。",
	5049: "所選文件無法從任務移除。請重新整理頁面並重試。若問題仍然存在。請聯絡Help Desk。",
	5050: "任務群組id不得為零或無效",
	5051: "任務段落id不得為零或無效",
	5052: "嘗試加入此文件至目前任務錯誤。失敗。",
	5053: "嘗試於目前任務更新此文件錯誤。失敗。",
	5054: "嘗試於目前任務加入此文件副本錯誤。失敗。",
	5055: "嘗試重新命名文件錯誤。失敗。",
	5056: "knowledge或集團任務無法編輯任務標題",
	5057: "任務類型應為OST類型",
	5058: 'This document cannot be removed from the task because is system associated.',
	5059: "無效的時段值。",
	5060: "加入證據錯誤。失敗。",
	5061: "其他使用者已更新所顯示資訊。請重新整理頁面並重試。若錯誤仍然存在，請聯絡Help Desk。",
	5062: "您的案件所選EY Atlas Channel無所要求文件。請聯絡Help Desk以提供資訊給內容編輯者於未來加入。",
	5063: "無效的補丁操作。",
	5064: "所選任務已被刪除或拒絕。故目前無法完成此動作。",
	5065: "無法更新任務來源類型。請求無效。",
	5066: "取得指引錯誤。失敗。",
	5067: "無法更新任務性質類型。請求無效。",
	5068: "無法更新任務性質類型。請求無效。",
	5069: "刪除任務指派事項失敗。",
	5070: "所選任務已被刪除。請重試，若錯誤仍然存在，請聯絡Help Desk。",
	5071: "無法更新指派事項。請求無效。",
	5072: "找不到編製者。請求無效。",
	5073: "找不到指派事項",
	5074: "儲存任務指派事項失敗",
	5075: "所選團隊成員或角色於所選任務不可有重複指派事項。請選擇不同指派事項、團隊成員或角色以繼續。若錯誤仍然存在，請聯絡Help Desk。",
	5076: "所選團隊成員不是案件使用中成員。請重試，若錯誤仍然存在，請聯絡Help Desk。",
	5077: "所選任務已刪除。請重試，若錯誤仍然存在，請聯絡Help Desk。",
	5078: "選定的任務指派事項已被刪除。請重試，若錯誤仍持續，請聯絡Help Desk。",
	5079: "一個以上所選任務已被刪除。若錯誤仍然存在，請重試或聯絡Help Desk。",
	5080: "文件版本紀錄不存在。",
	5081: "目前被指派至此任務之使用者無法被重新指派為「編製者」。若錯誤仍然存在，請重試或聯絡Help Desk。",
	5082: "更新失敗。案件文件名稱不得重複。請重新整理頁面以移除此訊息。",
	5083: "任務詳細內容超過字元限制。",
	5084: "任務文件建立失敗。",
	5085: "任務文件刪除失敗。",
	5086: "任務移交建立失敗。",
	5087: "任務補丁失敗。",
	5088: "此任務應包括證據以移交。請重試或聯絡Help Desk。",
	5089: "連結至此任務之全部證據(紙本檔案除外)應至少有一位編製者及複核者以標示完成。若錯誤仍然存在，請重試並聯絡Help Desk。",
	5091: "紙本檔案名稱已存在於案件。",
	5092: "名稱不可包含任何以下字元： */:<>\\?|\\",
	5093: "紙本檔案名稱超過最大長度(100字元)。",
	5101: "Create Task failed.",
	5102: "Task Description is missing.",
	5103: "Task title is missing.",
	5104: "Task timephase is missing.",
	5105: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5106: "Audit phase is invalid.",
	5107: "Audit phase should either be 'Scope and Strategy' or 'Execution'.",
	5108: "Task Description is too long.",
	5109: "Invalid Role Type parameter.",
	5110: "Assignment id must be greater than zero.",
	5111: "The item that you are attempting to relate tasks to has been deleted. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5112: "The item that you are attempting to relate tasks to has been deleted. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5113: "The item that you are attempting to relate tasks to has been deleted. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5116: "無效的文件類型。",
	5119: "所選任務之任務狀態尚未更新。請重新整理頁面並重試。若錯誤仍然存在，請聯絡Help Desk。",
	5127: "Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5129: "Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5133: "Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5137: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5138: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5140: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5146: "欲將一個任務標示為完成，所有連結的證據(除了紙本paper profile外)必須有至少一個編製者及一個複核者的簽名。重新整理該頁面並重試。若錯誤仍存在，請聯絡Help Desk。",
	5150: "One or more automations could not be related to the selected task at this time. Refresh the page and try again. Contact the Help Desk if the error persists.",
	5156: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5157: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5159: "Shared document type is not valid.",
	5160: "嘗試連結文件時發生錯誤。 請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	5174: "任務必須與一個或多個個體相關。 若要將任務改為全案件範圍，請切換為「按個體區分的任務」。",
	5184: "Task type is not a Primary Standard Task or Primary Substantive Procedure Task.",
	5185: "Task with EY Canvas delivered documents cannot be rejected.",
	5188: "Invalid Document or unlink in progress.",
	5189: "Task has documents which are Linked Evidence or Linked Response.",
	5190: "Task should have at least one assertion.",
	5191: "Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5192: "The item that you are attempting to relate tasks to has been deleted. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5193: "The selected item has been deleted. Refresh the page and try again. If the issue persists, contact the Help Desk.",


	/*WCGW*/
	6001: "建立WCGW失敗。",
	6002: "缺少WCGW名稱。",
	6003: "缺少WCGW。",
	6004: "取得WCGW失敗。",
	6005: "無效的案件Id。",
	6006: 'Could not complete the requested action, as the assertion ID is invalid or has been deleted. Refresh the page and try again.',
	6007: "由Id取得WCGW失敗。",
	6008: "無效的請求。",
	6009: 'Could not complete the requested action, as the WCGW ID is invalid or has been deleted. Refresh the page and try again.',
	6010: "此任務不能連結WCGW。",
	6011: "所選WCGW已刪除。",
	6012: "任務及WCGW未連結相同聲明。",
	6013: "所選任務並不屬於相同案件。",
	6014: "任務無法從WCGW取消連結。",
	6015: "任務不能連結WCGW。",
	6016: "任務已拒絕且無法連結WCGW。",
	6017: "任務並非里程碑任務且無法連結WCGW。",
	6018: "任務非建立步驟任務且無法連結至WCGW。",
	6019: "此任務非PSP或OSP且無法連結WCGW。",
	6020: "任務及WCGW連結至相同聲明且無法連結至WCGW。",
	6027: "Invalid WCGWId or ControlId.",
	6028: 'Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	6029: 'Cannot complete removal. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*Engagement*/
	7001: "透過ID取得找不到。",
	7002: "透過工作區ID取得案件失敗。",
	7003: "取得全部案件個體失敗。",
	7004: "透過ID取得案件失敗。",
	7005: "取得全部案件使用者失敗。",
	7006: "姓氏不可超過250字元。",
	7007: "無效的使用者類型錯誤。",
	7008: "名字不可超過250字元。",
	7009: 'User GUI cannot be null.',
	7010: "無效的使用者狀態錯誤。",
	7011: "建立案件使用者失敗。",
	7012: "無法邀請{0} {1}因他/她已是使用中或擱置中團隊成員",
	7013: "縮寫不可超過3字元。",
	7014: "EY Canvas Landing Page現在無法登入，請重試，若問題仍然存在，請聯絡Help Desk。",
	7015: "無法邀請{0} {1} ，因以下登入群組：{2} 已從案件刪除。請重新整理並重試。",
	7016: "無法邀請{0} {1} ，因使用者已為以下登入群組之使用中團隊成員：{2}",
	7017: "不允許所選群組之網域：{0}",
	7018: "電子郵件地址不得為空值。",
	7019: "名字不得為空值。",
	7020: "姓氏不得為空值。",
	7021: "使用者縮寫不得為空值。",
	7022: "使用者主要辦公室不得為空值。",
	7023: "使用者登入名稱不得為空值。",
	7024: "使用者EY角色不得為空值。",
	7025: "使用者案件角色不得為空值。",
	7026: "無法完成動作。請重試，若問題仍然存在，請聯絡Help Desk。",
	7027: "無效之電子郵件位址",
	7028: "Patch Engagement User call failed.",
	7029: "案件使用者 - 無效案件使用者狀態Id。",
	7030: "案件使用者 - 無效案件使用者角色Id。",
	7031: "找不到案件使用者id。",
	7032: "電子郵件不得超過250字元。",
	7033: "請求使用者不得為空值。",
	7034: "Universal Message Processor Queue Failed.",
	7035: "縮寫不可超過3字元。",
	7036: "名字不可超過250字元。",
	7037: "姓氏不可超過250字元。",
	7038: "建立外部使用者失敗。",
	7039: "無法邀請使用者，因其已為使用中或擱置中的團隊成員。請重新整理頁面並重試，若問題仍然存在，請聯絡Help Desk。",
	7040: "名字不可超過250字元。",
	7041: "姓氏不可超過250字元。",
	7042: "縮寫不可超過3字元。",
	7043: "GPN不能超過250字元。",
	7044: "GUI不能超過250字元。",
	7045: "透過ID取得外部使用者失敗。",
	7046: "使用者不能為空值。",
	7047: "目前無法儲存變更。請重試，若問題仍然存在，請聯絡Help Desk。",
	7048: "目前無法登入EY Canvas Landing Page且需要編輯。請重試，若問題仍然存在，請聯絡Help Desk。",
	7049: "更新案件使用者失敗。",
	7050: "無法停用成員。案件必須至少有一位成員有權限管理案件。請更新您的選擇並重試。若問題仍然存在，請聯絡Help Desk。",
	7051: "透過ID取得內部使用者失敗。",
	7052: "找不到使用者。",
	7053: "透過ID取得找不到。",
	7054: "透過案件ID取得快速連結失敗。",
	7055: "無足夠權限加入前期成員。請由有權限之案件團隊成員進行此動作。",
	7056: "EY Canvas目前無法儲存變更。請重試，若問題仍然存在，請聯絡Help Desk。",
	7057: "無足夠權限加入新成員。請由有權限之案件團隊成員進行此動作。",
	7058: "使用者狀態已變更。請重新整理頁面並重試。若問題仍然存在，請聯絡Help Desk。",
	7062: "EY Canvas Client Portal目前無法登入且需要更新現有成員資訊。請重試且若問題仍然存在，請聯絡Help Desk。",
	7063: "無法停用外部成員。請重新整理頁面並重試。若問題仍然存在，請聯絡Help Desk。",
	7064: "Invalid Patch Operation.",
	7065: "{0} {1} 無法於登群組啟用。網域不允許所選群組：{2}。",
	7066: "{0}不是有效使用者。",
	7067: "Put external user call failed.",
	7068: "EY Canvas Client Portal目前無法登入且需要更新現有成員資訊。請重試且若問題仍然存在，請聯絡Help Desk。",
	7069: "所選登入群組為非使用中{0}。請移除並重試。",
	7072: "於取消連結案件流程發生錯誤。請重新整理頁面並重試。若錯誤仍然存在，請聯絡Help Desk。",
	7074: "無法儲存變更。案件必須至少有一位使用中成員有權限管理案件並解決獨立性。若問題仍然存在，請聯絡Help Desk。",
	7075: "無法邀請{0} {1} 因其已是使用中團隊成員。",
	7077: "無法停用使用者。請重新整理頁面並重試，若問題仍然存在，請聯絡Help Desk。",
	7079: "網域不允許。請重試且若問題仍然存在，請聯絡Help Desk。",
	7080: "您無權限邀請第三方成員。請重新整理頁面並重試。若問題仍然存在，請聯絡Help Desk以取得權限(如適當)。",
	7094: "所選團隊成員已於此案件文件簽名且無法移除。",
	7100: "無法處理編輯動作至受限制欄位。請重新整理並重試。",

	/*SCOT*/
	8001: "建立SCOT失敗。",
	8002: "缺少SCOT名稱。",
	8003: "缺少SCOT。",
	8004: "取得SCOT失敗。",
	8005: "無效的案件Id。",
	8006: "無效的聲明Id。",
	8007: "由Id取得SCOT失敗。",
	8008: "請求無效。",
	8009: 'The selected SCOT has been deleted. Close this modal to see the updated list.',
	8028: 'The selected SCOT has been deleted. Close this modal to see the updated list.',

	/*User*/
	10001: "登入使用者偏好設定找不到。",
	10002: "使用者取得全部失敗。",
	10003: "使用者狀態取得失敗。",

	/*Risk Type*/
	11001: "建立請求無效。",
	11002: "缺少風險類型名稱。",
	11003: "缺少風險類型。",
	11004: "取得風險類型失敗。",
	11005: "無效的案件Id。",

	/* Annotation Errors*/
	12001: "無效請求參數。",
	12002: "建立註釋失敗。",
	12003: "取得註釋失敗。",
	12004: "無效案件ID。",
	12005: "ID集合必須大於零。",
	12006: "ID集合不得為空白。",
	12007: "無效任務ID。",
	12008: "無效文件ID。",
	12009: "必須具有有效的 DocumentId 或 TaskId 或 FinancialStatementId。",
	12010: "回覆需要親項。",
	12011: "無效狀態ID。",
	12012: "文件類型應為440GL。",
	12013: "無效註釋類型。",
	12014: "無效案件使用者。",
	12015: "此文件已被其他使用者刪除。",
	12016: "更新註釋失敗。",
	12017: "您正在回覆的註記已被其他團隊成員刪除。請重新整理頁面並重試。",
	12018: "註釋變更動作類型不應為Null。",
	12019: "複核註記已刪除。",
	12020: "無效執行動作。",
	12021: "使用者非註釋編輯。",
	12022: "缺少編輯使用者。",
	12023: "編輯使用者不存在或不在案件中。",
	12024: "必須指派使用者。",
	12025: "所指派使用者不存在或不在案件中。",
	12026: "無效註記。",
	12027: "註記不得為空白。",
	12028: "必須有到期日。",
	12029: "需要有效優先順序。",
	12030: "此註記之狀態已變更。您無法再編輯或回應註記。請關閉並重新開啟視窗以檢視更新資料並繼續編輯。",
	12031: "註釋必須為最高層級。",
	12032: "註釋不得為最高層級。",
	12033: "以下值至少一個不得為空白：優先順序類型、到期日、狀態或被指派使用者。",
	12034: "註記超過最大長度(4,000字元)",
	12035: "搜尋字串超過最大長度(500字元)。",
	12036: "僅可接受任務Id或文件Id，不允許兩者。",
	12037: "無效補釘作業。",
	12038: "您欲編輯之註記不再存在。請重新整理頁面並重試。",
	12039: "您與其他團隊成員欲編輯相同註記。請重新整理頁面並重試。",
	12040: "取得註釋使用者失敗。",
	12041: "取得註釋使用者失敗。無效查詢值。",
	12042: "文件類型不可建立註釋。",
	12043: "您欲加入註記之任務或文件不存在。請重新整理頁面並重試。",
	12044: "您欲編輯回覆之註記不再存在。請重新整理頁面並重試。",
	12045: "找不到複核註記。",
	12046: "您要刪除的註記已由其他團隊成員刪除，請重新整理頁面並重試。",
	12047: "您僅能刪除開啟狀態註記的回覆，請重新整理頁面並重試。",
	12048: "您要變更狀態的註記已不存在，請重新整理頁面並重試。",
	12049: "您正在嘗試刪除之註記回覆已被其他團隊成員刪除。請重新整理頁面並重試。",
	12050: "您僅可刪除「已解決」狀態之註記。",
	12059: 'Review notes can only be deleted by the user who created the note.',
	12066: "您僅可回覆未解決註記。",
	12067: "您正在嘗試刪除已被其他團隊成員刪除的註解回覆。 請重新整理頁面並重試。",
	12068: "無法新增評論。請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	12070: "每份財務報表只能新增一條評論。 請編輯現有的。",
	12071: "刪除訊息失敗。請重試。若錯誤仍持續，請聯絡Help Desk。",

	/*Configuration*/
	13001: "Configurations not found.",
	13002: "Get Configurations API call failed.",

	/*Documents*/
	14001: "無法執行因請求為空值。",
	14002: "找不到文件。失敗。",
	14003: "案件Id應大於零。",
	14004: "文件Id不得為空值或空白。",
	14005: "嘗試連結任務時錯誤。Call failed.",
	14006: "所選文件無法刪除。請稍後重試。若問題仍然存在，請聯絡Help Desk。",
	14007: "發生非預期錯誤。",
	14008: "簽名時發生非預期錯誤。",
	14009: "加入簽名時發生錯誤。",
	14010: "核准ID應大於0。",
	14011: "刪除簽名時發生錯誤。",
	14012: "內文不得為空白。",
	14013: "所選文件無法取消連結。請稍後重試。若問題仍然存在，請聯絡Help Desk。",
	14014: "Get Account By Document Id Call Failed.",
	14015: "無效的相關個體。",
	14016: "取得文件核准失敗。",
	14017: "取得全部文件發現失敗。",
	14018: "取得全部文件失敗。",
	14019: "未有簽核。",
	14020: "無效動作值。",
	14021: "無效發現類型。",
	14022: "文件不屬於案件。",
	14023: "文件變動類型無效。",
	14024: "取得全部文件失敗。參數無效。",
	14025: "建立文件複核時發生錯誤。API已失敗。",
	14026: "刪除文件複核時發生錯誤。API已失敗。",
	14027: "案件ID不得為空值或空白。",
	14028: "使用者ID無效。",
	14029: "使用者無權限執行此動作",
	14030: "No Document with the passed ID was found in this Engagement.",
	14031: "文件複核ID無效。",
	14032: "找不到文件複核",
	14033: "文件已核准",
	14034: "工作區其他案件正在進行解除連結處理，或文件已解除連結。請重新整理頁面並重試，若問題仍然存在，請聯絡Help Desk。",
	14035: "文件未與指定的案件共享",
	14036: "版本號碼應大於零。",
	14037: "目前無法完成動作。請重新整理頁面並重試。若問題仍然存在，請聯絡Help Desk",
	14038: "取得文件變更理由失敗。",
	14039: "透過ID取得文件變更理由失敗。",
	14040: "更新變更理由失敗。",
	14041: "無效的變更理由。",
	14042: "更新變更理由失敗。",
	14043: "建立變更理由失敗。",
	14044: "刪除變更理由失敗。",
	14045: "無效的變更理由Id。",
	14046: "文件不存在。請重新整理頁面並重試。若問題仍然存在，請聯絡Help Desk。",
	14047: "文件已指派變更理由。",
	14048: "文件有衝突，請先解決後繼續。",
	14049: "無效的資料，檢查文件是否加入團隊或使用者。",
	14050: "移除參照文件錯誤。",
	14051: "找不到取消連結全部共享證據檢查表。",
	14052: "搜尋文字超過最大允許長度(500字元)。",
	14053: "無法執行因請求無效。",
	14054: "Invalid Patch Operation.",
	14055: "解決文件歷程紀錄失敗。",
	14056: "當嘗試排序訊息時發生錯誤。",
	14057: "案件中已存在相同名稱之文件。",
	14058: 'More than one document version with the same number has been found. Please contact Help Desk for further assistance.',
	14059: 'The selected document version couldnt be found. Please refresh the page and try again. If the issue persists, please contact Help Desk for further assistance.',
	14060: 'The operation couldnt be completed at the time. Please try again later. If the issue persists, please contact Help Desk for further assistance.',
	14061: 'Document is not shared, cant unlink the document. If the issue persists, please contact Help Desk for further assistance.',
	14062: 'The document confidentiality type id is not valid.',
	14063: 'Cannot change confidentiality type of this document type.',
	14064: 'User doesnt have permission.',
	14065: 'Invalid custom description.',
	14066: 'Failed to update extension.',
	14067: 'Invalid extension.',
	14068: 'Failed to get document extensions.',
	14069: 'This document has already been unlinked by another team member. Refresh the page and contact the Help Desk if the error persists.',
	14070: "無效之文件類型。",
	14071: 'The selected document version is no longer available. Please close and reopen this window to see the latest set of historical versions for the document.',
	14072: 'Source document Id should not be null or empty.',
	14073: 'Canvas form ids should not be null or empty.',
	14074: "Canvas form ID's should not be duplicates.",
	14075: 'Failed to associate document to canvas forms.',
	14076: "未找到與Canvas表單相連結的來源文件。",
	14077: 'Source document not found. Call failed.',
	14078: 'Current document is already associated with given canvas forms.',
	14079: "此檔案已被刪除，因此無法打開。",
	14080: 'The source approval user id is invalid.',
	14081: 'The source approval user id should valid GUID and must not be empty GUID.',
	14082: 'The modify user id is invalid.',
	14083: 'The modify user id should be a valid GUID and must not be empty GUID.',
	14084: 'File name cannot include: */:<>\\?|""',
	14085: 'The document name exceeded maximum length allowed.',
	14086: 'DocService failed while updating document details.',
	14087: 'The input is not valid.',
	14088: 'A input has duplicate document names.',
	14089: 'The bookmark observation is not valid.',
	14090: 'Request status has changed. Please refresh the page and try again if required. If the issue persists, contact the help desk.',
	14091: 'This request has been deleted. Refresh the page to view updated data. If the issue persists, contact the Help Desk.',
	14092: 'Document not eligible for update. Refresh the page and try again.  If the issue persists, contact the Help Desk.',

	/*SEM*/
	15001: "由於請求無效，取得科目Id SEM彙總失敗。",
	15002: "無效的科目Id。",
	15003: "無效的案件Id。",
	15004: "無效的彙總類型。",
	15005: "無法找到相關科目。請重新整理頁面並重試。若問題仍然存在，請聯絡Help Desk。",

	/*Timephase*/
	16001: "取得時段失敗。",
	16002: "案件必須大於零。",
	16003: "時段必須大於零。",
	16004: "無效任務ID值。",
	16005: "無效時段值。",

	/*Validations*/
	17001: "缺少建立步驟id或文件類型id。",

	/*TaskGroupSection*/
	18001: "GetAll task group group call failed.",
	18005: "This task group is no longer available in this engagement.",
	18006: 'This task group is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	18016: "Task groups can only be deleted when there are no related tasks. Delete or move the related tasks and try again.",
	18019: "The task group that you are trying to update has been already deleted.",

	/*Assignments*/
	19001: "建立指派事項失敗。",
	19002: "取得指派事項失敗。",
	19003: "指派事項名稱必須為唯一",
	19004: "無效之指派事項名稱",
	19005: "指派事項名稱長度超過100字元",
	19006: "無效之指派事項類型",
	19007: "搜尋指派事項長度超過500字元。",
	19008: "指派事項名稱被其他團隊成員刪除。請重新整理頁面並重試。",

	19012: "TaskIds 不能重複。",
	19013: "RoleId 和 UserId 字段不能同時有值。",
	19014: "UserId 不能是預設值。",
	19016: "無法邀請無效的 PIC 使用者或 PIC 使用者。",
	19017: "無法邀請無效的 EQR 使用者或 EQR 使用者。",
	19018: "到期日值必須大於 0 且小於 1000。",
	19019: "建立任務自動指派指令失敗。",

	/*Client Request*/
	21001: 'Request could not be sent to EY Canvas Client Portal. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	21002: "此請求已被刪除。 請重新整理頁面以查看更新的資料。 若錯誤仍持續，請聯絡Help Desk。",
	21009: 'Delete client request document call failed.',
	21010: 'The comment that you are replying to has been deleted by another team member. Refresh the page and try again.',
	21011: 'Client request document has been deleted.',
	21012: 'Client request document was not found.',
	21013: 'Document request is Empty.',
	21014: 'Document id is Empty.',
	21015: 'Client request id is Empty.',
	21016: 'Create client request document call failed.',
	21017: "One or more of the associated documents has been deleted from the engagement. Please either remove the deleted document(s) from this request or refresh the page and try again.",
	21018: 'Document was not found.',
	21019: 'Client request status has changed.',
	21030: 'Client Group Id does not match.',
	21031: 'Request status has changed. Please refresh the page and try again if required. If the issue persists, contact the Help Desk.',
	21032: 'Client Group contact user is not active.',
	21033: 'Client Group is not active.',
	21034: 'Client Group contains no active user.',
	21045: 'The request status has changed. Please refresh the page to see latest changes.',
	21046: 'Request could not be sent to EY Canvas Client Portal. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	21050: "無法刪除請求。請重新整理頁面並重試。若問題仍然存在，請聯絡Help Desk。",
	21053: 'Task is no longer available in the engagement. Refresh the page to update the list.',
	21057: 'EY Contact could not be assigned. Refresh the page and try again.',
	21028: "到期日為必須。",
	21036: "找不到時段。",
	21064: "任務無法與請求相連結。 請求最多可以連結到 25個任務。移除一項或多項連結任務以連結至新任務。",
	21065: "一份或多份機密文件已新增至請求中。您沒有適當的保密層級，無法將這些一份或多份文件發送至 EY Canvas客戶端。請刪除您無權訪問的任何機密文件以便繼續。",
	21066: "檢索資料時發生錯誤。請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	21067: "無法更新優先事項。請重新整理頁面並重試。 若錯誤仍持續，請聯絡Help Desk。",
	21035: 'Client request not found.',
	21074: 'Received request is not allowed changes to Title, Description, Priority.',
	21075: 'Accepted request is not allowed changes to Title, Description, Assigned to (group), Assigned to (user), Due date, Priority.',
	21077: 'Due date is required for Client Requests in Received and Pending status.',
	21039: 'Client Group ID not found.',
	21078: 'Group and User are both required, when updating the Assigned To Group or Assigned To User.',
	21079: 'Date format is invalid.',
	21027: 'Request title is required.',
	21041: 'Request title length exceeds maximum allowed characters.',
	21042: 'Request description length exceeds maximum allowed characters.',
	21060: 'Client User ID is Empty.',
	21076: 'Priority Type is not allowed.',

	/* Group Components*/
	22001: "取得相關組成個體失敗。",
	22002: 'Get group components call failed.',
	22003: 'Create group components call failed.',
	22004: 'Invalid parent component id, the parent component you specified does not exist.',
	22005: 'The team name has excedeed maximum lengdes.',
	22006: 'The team legal name has excedeed maximum lengodes.',
	22008: 'The scope you specified does not exist.',
	22009: 'Invalid component short name.',
	22010: 'Invalid component legal name.',
	22011: 'Invalid component scope id.',
	22012: 'If the point of contact email was supplied then the point of contact guid cannot be null or empty.',
	22013: 'If the point of contact email was supplied then the point of contact text cannot be null or empty.',
	22016: 'This team has already been deleted by another team member. Refresh the page and try again.',
	22022: 'Team name already exists in this engagement.',
	22043: "發送指示通知失敗。",

	/*User Presence*/
	23001: "登入使用者狀態找不到。",
	23002: "使用者狀態取得失敗。",
	23003: "使用者狀態文件驗證失敗。",
	23004: "使用者狀態刪除失敗。",
	23005: "文件不再由其他使用者開啟。請重新整理頁面並重試。若問題仍然存在，請聯絡Help Desk。",

	/* Forms */
	24001: "取得表單失敗。",
	24002: "無效案件ID。",
	24003: "文件Id不應為零或空白。",
	24004: "無效文件ID。",
	24005: "無效表單標題ID。",
	24006: "無效表單段落ID。",
	24007: "無效請求參數。",
	24008: "標題Id不應為零或空白。",
	24009: "段落Id不應為零或空白。",
	24010: "表單內文回應更新動作失敗。",
	24011: "無效請求表單內文回應更新。",
	24012: "無效內文ID。",
	24013: "無效表單內文選項ID。",
	24014: "無效表單內文類型ID。",
	24015: "內文類型ID為無效請求內文。",
	24016: "內文類型ID為無效自訂文字。",
	24017: "字元(包括RTF格式)上限。請減少長度或刪除不必要之格式並重試。",
	24018: "For given Body Type ID response is not allowed.",
	24019: "Body ID不能為空白",
	24020: "Invalid Request Body.",
	24021: "Body is deleted.",
	24038: "文件無效或不存在。",
	24049: "所選擇物件已被刪除。請重新整理頁面並重試。若錯誤仍然存在請聯絡Help Desk。",
	24057: "文件表單基本資料驗證失敗。",
	24063: "Country ID is invalid.",
	24064: "Language ID is invalid.",

	/*Document Change Types*/
	25001: "取得文件變更類型失敗。",
	25002: "無效的案件ID。",
	25003: "無效請求。",

	/* Manage team */
	26001: "ClientUserGroups GetAll call failed.",
	26002: "建立新客戶群組/電子郵件網域失敗。",
	26003: "群組名稱不能為空值。",
	26004: "電子郵件網域不能為空值。",
	26005: "{0} 電子郵件網域標籤不應超過263字元。",
	26006: "{0} 電子郵件網域不應超過263字元。",
	26007: "{0} First part of email domain can be * or alphanumeric, other special chars not allowed.",
	26008: "{0} If first part is a wild card, then it must have 2 or more part followed.",
	26009: "{0} First part can be * or alphanumeric, other domain parts special chars not allowed.",
	26010: "Email domain should be Unique.",
	26011: "所提供客戶登入群組id無效。",
	26012: "刪除登入群組時發生錯誤。請確認是否無請求/外部任務指派給此群組或此群組成員並重試",
	26013: "登入群組已刪除，請重新整理頁面以取得最新資料",
	26014: "至少需要一個電子郵件網域。",
	26015: "EY Canvas Client Portal目前無法登入且需要更新現有成員資訊。請重試且若問題仍然存在，請聯絡Help Desk。",
	26016: "進行刪除時發生錯誤。",
	26017: "取得資料動作失敗。",
	26018: "同時發生問題，登入群組不再可用。請重新整理頁面並重試。",
	26019: "儲存動作失敗。",
	26020: "當已指派使用中的使用者時電子郵件網域不得移除。變更尚未儲存。",


	/* TimePhaseTypes - Milestones */
	27001: "取得里程碑細節失敗",

	/*Client Request Counts*/
	28001: "Get Client Requests Info call did not fetch any results.",

	/*Content updates Error messages*/
	29001: "透過ID取得找不到。",
	29002: "Acton type not found.",
	29003: "找不到內容ID。",
	29004: "內容更新API失敗。",
	29005: "內容更新處理中，請稍後重試，若問題仍然存在，請聯絡Help Desk。",
	29006: "無效的請求參數。",
	29010: "內容已重新整理。請稍後重試。若問題仍然存在，請聯絡IT Help Desk。",
	29012: 'Engagement is missing applicable standards profile question. Contact IT Help Desk.',
	29013: "當共享 EY Canvas FIT enablement活動時，不允許進行主要標準任務 (PST) 和基本資料內容更新。要更新 PST 或基本資料內容，請取消連結這些活動。若選擇了多個內容更新類型，請取消選擇主要標準任務 (PST) 和/或基本資料，然後重新初始化更新。",
	/*IT Process*/
	30001: "取得全部IT流程失敗。",
	30002: "取得全部IT流程 - 無效的案件ID。",
	30003: 'ITProcess name cannot be empty.',
	30004: 'ITProcessName should not be more than 500 characters.',
	30005: 'ItProcessID is invalid.',
	30006: 'Get itprocess by id call failed.',
	30007: 'Invalid request.',
	30008: "IT 流程無效。",
	30009: 'Document not found.',
	30010: 'ITProcess delete failed.',
	30012: 'Invalid ITRisk.',

	/*Checklist*/
	31001: "GetAll CheckLists call failed.",
	31002: "Put CheckLists call failed.",
	31003: "無效的檢查表參數。",
	31004: "無效案件錯誤。",
	31005: "無效的請求參數錯誤。",
	31006: "Invalid IsChecked request parameter Error.",

	/*Archive*/
	32001: 'Engagement status is invalid, resolve the validation, and try again the archive process. Contact the Help Desk if the error persists.',
	32002: 'Archive failed while updating form bodies display status, please try again. Contact the Help Desk if the error persists.',
	32003: 'Archive failed while updating engagement status, please try again. Contact the Help Desk if the error persists.',
	32004: 'Archive failed while invalidating engagement cache, please try again. Contact the Help Desk if the error persists.',
	32005: 'Content Update is in progress. You cannot archive this engagement until the content update is complete. Try again later and Contact the Help Desk if the error persists.',
	32006: 'There are unresolved validations in this engagement. Refresh the page, resolve the validations, and try the archive process again. Contact the Help Desk if the error persists.',
	32007: 'Archive failed while building ARC Request Model, please try again. Contact the Help Desk if the error persists.',
	32008: 'Archive failed while Getting Arc API URL, please try again. Contact the Help Desk if the error persists.',
	32009: 'Archive failed while Making Arc API Call, please try again. Contact the Help Desk if the error persists.',
	32010: "Archive failed due to missing data in the Arc API Response, please try again. Contact the Help Desk if the error persists.",
	32011: 'Archive failed while Saving Arc Form Details, please try again. Contact the Help Desk if the error persists.',
	32012: 'Archive failed while Updating the Engagement Status for Retry, please try again. Contact the Help Desk if the error persists.',
	32013: 'Archive failed while Queuing Archival Message, please try again. Contact the Help Desk if the error persists.',
	32014: 'Archive succeeded, but error occurred while queuing Universal status update message. Contact the Help Desk if the error persists.',
	32015: 'Archive succeeded, but error occurred while queuing CCP status update message. Contact the Help Desk if the error persists.',
	32016: 'Engagement status should be in Archive Error status to Retry the Archival Process.',
	32017: 'Engagement not found, please try again. Contact the Help Desk if the error persists.',
	32019: 'We are not able to process your request at this time. Please try again. If the issue persists, please contact EY Support.',
	32020: 'ARC URL is not configured, please try again. Contact the Help Desk if the error persists.',
	32200: "您的案件尚有未解決之驗證。請於報告中心執行「驗證檢查」報告或於更多選項中索引至「驗證協助」連結以取得更多資訊。若錯誤仍持續，請聯絡Help Desk。",
	32400: "與ARC系統通訊時發生以下錯誤。請聯絡Help Desk並提示此錯誤訊息以繼續。",

	/*RBAC*/
	33001: "找不到案件ID。",
	33002: "找不到使用者ID。",

	/*Helix Linked Projects*/
	34001: "EY Helix Project已被解除連結，請重新整理頁面並重試。若問題仍然存在，請聯絡Help Desk。",
	34002: "案件ID不得為空值或空白。",
	34003: "Body不得為空值或空白。",
	34004: "Project ID不可為空值或空白。",
	34005: "Project名稱不可為空值或空白。",
	34006: "EY Helix Project已被連結，請重新整理頁面並重試。若問題仍然存在，請聯絡Help Desk。",
	34007: "取得全部Helix Projects失敗。",
	34008: "案件ID不得超過零。",
	34009: 'Operation could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	34020: "無法連結Helix Project。 請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	34024: "Unable to send a notification to Helix. Region information is missing for the project.",
	34029: "項目未連結，因為其地區與 EY Canvas 案件的地區不符。",
	34030: "Analyzer cannot be linked. You are not an authorized team member of the selected analyzer. Contact the EY Helix project administrator to get access and try again.",
	34031: "您之前似乎沒有訪問過 EY Helix 應用程式。",
	34038: "所選分析不可再使用。請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	34043: `The selected EY Helix project is no longer available. Click 'Link project' to link a different project.`,
	34044: `The selected EY Helix project is marked for deletion. Click 'Link project' to link a different project.`,
	34045: `The selected EY Helix project is marked for storage. Click 'Link project' to link a different project.`,
	34046: `Invalid or missing analyzer in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.`,
	34047: `The selected analyzer is not available in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.`,
	34048: `Analytics are not available in the linked project. Go to EY Helix and complete the data & analytics processing steps to continue.`,
	34080: "Maximum number of Engagement Helix connections has been exceeded.",

	/* PAANS */
	35001: "EY Policy編輯、核准及通知服務目前無法使用。我們無法確認所有攸關政策是否已完成。若您尚未複核攸關政策，請重新整理頁面並重試。若問題仍然存在，請聯絡Help Desk。",

	/*Engagement Comments*/
	38001: "建立 EngagementComments 回應失敗",
	38002: "GetAll EngagementComments 回應失敗",
	38003: "無法完成此操作。請重新整理頁面並重試。 若錯誤仍持續，請聯絡Help Desk。",
	38004: "無法完成此操作。請重新整理頁面並重試。 若錯誤仍持續，請聯絡Help Desk。",
	38005: "無法完成此操作。請重新整理頁面並重試。 若錯誤仍持續，請聯絡Help Desk。",
	38006: "無法完成此操作。請重新整理頁面並重試。 若錯誤仍持續，請聯絡Help Desk。",
	38007: "無法完成此操作。請重新整理頁面並重試。 若錯誤仍持續，請聯絡Help Desk。",
	38008: "無法完成此操作。請重新整理頁面並重試。 若錯誤仍持續，請聯絡Help Desk。",
	38009: "無法完成此操作。請重新整理頁面並重試。 若錯誤仍持續，請聯絡Help Desk。",
	38010: "正文不應為空白",
	38011: "CommentText 不應為 null 或為空白",
	38012: "個體不存在於給定的案件中",
	38013: "EngagementCommentStatusId 應大於 0",
	38014: "ParentEngagementCommentId 應大於 0",
	38015: "沒有符合指定條件的Canvas表單正文",
	38016: "您正在回覆的註記已被其他團隊成員刪除。請重新整理頁面並重試",
	38017: "提供的母案件註解已清除",
	38018: "提供的母案件註解本身就是回覆",
	38019: "所提供的註解文字不應短於 1 且不超過 4000 個字符",
	38020: "提供的個體 uid 無效",
	38021: "提供的母公司個體 uid 無效",
	38022: "刪除 EngagementComments 回應失敗",
	38023: "註解id不能為空白",
	38024: "該操作應是有效的操作",
	38025: "註記狀態已變更。請重新整理頁面並重試。",
	38026: 'Review notes can only be deleted by the user who created the note.',
	38027: "您正在嘗試編輯不再存在的註解。 請重新整理頁面並重試。",
	38028: "不允許更新已清除的註解",
	38029: "只有作者可以更改註解的文字",
	38030: "案件註解 ID 無效",
	38031: "註解狀態Id不能為空白",
	38032: "請求的使用者與案件之間沒有關係記錄。請重新整理頁面並重試。 若錯誤仍持續，請聯絡Help Desk。",
	38033: "更新操作無效",
	38034: "請求的 CommentId 已被其他註解使用",
	38035: "提供的註解 ID 無效",
	38036: "文件 ID 不應為 null 或為空白",
	38037: "註解所指派的使用者 ID 不應為空白。",
	38038: "開啟或關閉註解時不應重新指派註解",
	38039: "您要從中刪除回覆的註記已被刪除。請重新整理頁面並重試",
	38040: "回覆不應有到期日",
	38041: "回覆不應有優先事項",
	38042: "註解應該有到期日",
	38043: "註解應該有優先事項",
	38044: "您正在嘗試編輯對不再存在的註解的回覆。 請重新整理頁面並重試",
	38045: "不允許同時編輯案件狀態 ID 及其內容、指派給使用者或優先事項",
	38046: "更新 EngagementComments 回應失敗",
	38047: "您只能回覆開啟的註記",

	/*Tags*/
	39004: "您正在編輯之標註群組已被其他團隊成員刪除。請重新整理頁面並重試。",
	40003: "所選標註群組已被其他團隊成員刪除。請選擇其他標註群組以繼續。",
	40007: 'One or more selected notes have been deleted. Refresh the page and try again. Contact the Help desk if the error persists.',
	40011: 'Note index cannot exceed 5 characters.',
	40012: 'Tag color code is invalid. Refresh the page and try again.',
	40014: "包含您正在編輯之標註的標註群組已被其他團隊成員刪除。請重新整理頁面並重試。",
	40016: 'Tags could not be added to or removed from one or more of the tasks that you selected. Refresh the page and try again. Contact the Help Desk if the error persists.',
	40019: 'One or more tags that you are editing have been deleted by another team member. Refresh the page and try again.',
	40020: 'One or more tags could not be synced right now. Refresh the page and try again. Contact the Help Desk if the error persists.',
	40021: 'One or more of the tags that you selected have been deleted. Refresh the page and try again.',
	40022: 'Add one or more external team members to this engagement, then try this operation again. Contact the Help Desk if this error persists.',
	40027: 'Description is too long.',

	// Scheduler request
	70022: "無任務連結至此服務請求。請重新整理頁面並選擇未刪除任務以繼續。若錯誤仍然存在請聯絡Help Desk。",
	70024: "Centralized services are not available for your engagement. Refresh the page and try again. Contact the Help Desk if the error persists.",
	70025: "Centralized services are not currently available for your country. Refresh the page and try again. Contact the Help Desk if the error persists.",

	/* TaskDocumnet */
	80001: "建立任務文件連結失敗。",
	80002: "請求必須至少有一個任務。",
	80003: "Document ID should be present.",
	80004: "所選擇的任務已被刪除。請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	80005: "文件Id無效。",
	80006: "使用者無足夠權限以執行操作。",
	80007: "任務文件連結失敗。",
	80008: "任務文件連結後，任務狀態變更失敗。",
	80011: "機密文件不得共享。",
	80012: 'Invalid or empty request payload.',
	80013: 'Task limit exceeded. Please select 300 or less tasks at a time.',
	80014: "嘗試連結文件時發生錯誤。 請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",

	/* ITApplication / SO */
	81001: 'Get all ITApplication failed.',
	81002: 'Get all ITApplication - invalid engagementid.',
	81003: "The selected IT application has been deleted. Close this modal to see the updated list.",
	81004: '"Name" should not be empty.',
	81005: '"Name" should not be more than 500 characters.',
	81006: 'Invalid StrategyTypeId.',
	81007: 'Invalid Document Id.',
	81008: 'Get ITApplication by ID failed.',
	81009: 'Invalid classification.',
	81010: 'Invalid SCOT.',
	81011: 'Invalid Control.',
	81012: 'ITApplicationID should not be null or empty.',
	81013: 'ITApplication not found.',
	81014: 'Delete ITApplicationITProcess call failed.',
	81015: '"ITApplicationITProcessId" should not be empty.',
	81016: 'Invalid ITApplicationITProcessId.',
	81017: 'ITApplicationITProcess not found.',
	81018: 'Create ITApplicationITProcess call failed.',
	81019: 'Passed Service Organization instead of ITApplication.',

	/* Controls */
	83001: 'Failed to get controls.',
	83002: 'This action cannot be taken. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	83003: 'Control Id is null or empty.',
	83004: 'The selected Control has been deleted. Close this modal to see the updated list.',
	83005: 'Document Id is invalid.',
	83006: 'Missing control name.',
	83007: 'Invalid control name length.',
	83008: 'Invalid request.',
	83009: 'Invalid control FrequencyId.',
	83010: 'Invalid control TypeId.',
	83011: 'Invalid control ITApplications.',
	83012: 'Invalid Control DesignEffectivenessTypeId.',
	83013: 'Invalid ITApplications.',
	83014: 'Only SO type ITApplications are allowed, If the control type is manual prevent or manual detect type.',
	83015: 'Only ITDM may have manual IPE testing selected.',
	83016: 'Lower Risk controls are not allowed for engagements with this profile.',
	83017: 'Duplicate FilterSCOTs',
	83018: 'Control name is more than 500 characters.',
	83019: 'Invalid WCGW Ids.',
	83020: 'Duplicate WCGW Ids are not allowed.',
	83021: 'Duplicate ITApplication Ids are not allowed.',
	83023: 'Invalid current page.',
	83024: 'Invalid page size.',
	83025: 'Search String should not be more than 100 characters.',
	83026: 'IT APP without service organisation can only be associated to control of type ITDependentManualControl or ITApplicationControl.',
	83027: 'Duplicate FilterWCGWs.',
	83028: 'Invalid knowledge control Id.',

	/* ITControl */
	84001: 'Failed to get IT controls.',
	84002: 'Failed to get IT control by id.',
	84003: 'IT Control Id is null or empty.',
	84004: 'Invalid IT control Id.',
	84005: 'Document Id is invalid.',
	84006: 'Missing IT control name.',
	84007: 'Invalid IT control name length.',
	84008: 'Invalid IT Control FrequencyId.',
	84009: 'Invalid IT Control ApprochTypeId.',
	84010: 'Invalid IT Control DesignEffectivenessTypeId.',
	84011: 'Invalid IT Control Testing value.',
	84012: 'Invalid IT Control OperatingEffectivenessTypeId.',
	84013: 'Missing IT control frequency.',
	84014: 'Delete IT Control failed.',
	84015: 'Search String should not be more than 100 characters.',

	/*GroupTasks*/
	85001: "所選動作目前無法完成。請重新整理頁面並重試。若錯誤仍然存在請聯絡Help Desk。",
	85002: "目前無法完成所選操作。請重新整理頁面並重試。若錯誤仍然存在，請聯絡Help Desk。",
	85003: "所選動作目前無法完成。請重新整理頁面並重試。若錯誤仍然存在請聯絡Help Desk。",
	85004: "所選動作目前無法完成。請重新整理頁面並重試。若錯誤仍然存在請聯絡Help Desk。",
	85005: "所選動作目前無法完成。請重新整理頁面並重試。若錯誤仍然存在請聯絡Help Desk。",
	85006: "所選動作目前無法完成。請重新整理頁面並重試。若錯誤仍然存在請聯絡Help Desk。",
	85007: "所選動作目前無法完成。請重新整理頁面並重試。若錯誤仍然存在請聯絡Help Desk。",
	85008: "所選動作目前無法完成。請重新整理頁面並重試。若錯誤仍然存在請聯絡Help Desk。",
	85009: "所選動作目前無法完成。請重新整理頁面並重試。若錯誤仍然存在請聯絡Help Desk。",
	85010: "所選動作目前無法完成。請重新整理頁面並重試。若錯誤仍然存在請聯絡Help Desk。",
	85011: "所選動作目前無法完成。請重新整理頁面並重試。若錯誤仍然存在請聯絡Help Desk。",
	85012: "The selected document has already been assigned to another region or component. Therefore, it is not available for assignment. Refresh the page and try again.",
	85013: "所選動作目前無法完成。請重新整理頁面並重試。若錯誤仍然存在請聯絡Help Desk。",
	85014: "所選動作目前無法完成。請重新整理頁面並重試。若錯誤仍然存在請聯絡Help Desk。",
	85015: "所選動作目前無法完成。請重新整理頁面並重試。若錯誤仍然存在請聯絡Help Desk。",
	85016: "案件ID應該大於零。",
	85017: "此任務在此案件中不再可使用。",
	85018: "無效的文件ID。",
	85019: "您沒有適當的保密層級來發送此些文件。請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	85020: "您嘗試發送的一份或多份文件無法發送。請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	85021: "表單無法發送給主查團隊。",
	85022: "一份或多份文件未能發送。請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",

	/* ITRisk */
	86001: 'ITRisk name cannot be empty.',
	86002: 'ITRisk name should not be more than 500 characters.',
	86003: 'Invalid ITRisk Id.',
	86004: 'Get itrisk by id call failed.',
	86005: 'ITRisk not found.',
	86006: 'Create ITRiskITControl call failed.',
	86007: 'Invalid ITControl Id.',
	86008: 'Delete ITRiskITControl call failed.',
	86009: 'Invalid ITRiskITControl Id.',
	86010: 'Delete IT Risk failed.',


	/*Copyhub*/
	88017: "Export process service is down - package creation partially succeeded",
	88018: "Selected user for sending package is not valid (invalid email, Gui or fullname)",
	88033: 'Invalid copy package status to import.',
	88042: 'You do not have permission for bulk export.',
	88045: 'You do not have permission for create template engagement.',
	88048: 'Package is currently being imported by another User. Please try again later.',
	88049: 'Package no longer exist. Please refresh the tab.',
	88050: "其他案件複製正在進行中。",
	88051: "該案件有太多複製在進行。在開始另一個前，請稍候待複製完成。",
	88056: "Action cannot be completed. Refresh the page and try again. If the issue persists contact the Help Desk.",
	88057: "Some document(s) selected contain related evidence(s) in active multi-user edit mode. Please check-in the related evidences to proceed. If the error persists, please contact the help desk.",

	/* Group Scopes */
	92001: 'Get all group scopes call failed.',
	92002: 'Create group scope call failed.',
	92003: 'Invalid group scopes update request.',
	92004: 'Invalid scope name.',
	92005: 'Invalid parent scope id.',
	92006: 'Parent scope does not exist.',
	92007: 'Invalid scope description.',
	92008: 'Group scope name length exceeds more than 100 characters.',
	92009: 'Group scope description length exceeds more than 500 characters.',
	92010: 'Delete group scopes call failed.',
	92011: 'The custom sub-scope that you are editing has been deleted by another team member. Refresh the page and try again. Contact the Help Desk if the error persists.',
	92012: 'The specified scope id is not valid.',
	92013: 'This custom sub-scope has been assigned to one or more teams and cannot be deleted.',
	92014: 'The custom sub-scope that you are attempting to delete has already been deleted by another team member. Refresh the page and try again.',
	92015: 'The user does not have permissions to perform the operation.',
	92016: 'Scope name already exists in this engagement',
	92017: "Get by id group scopes call failed.",

	/* Group Sections */
	101001: "建立集團段落通知失敗。",
	101002: "集團名稱不能為空或為空。",
	101003: "集團段落名稱長度超過 100 個字元。",
	101004: "此約定中已存在部分名稱。",
	101005: "編輯集團段落通知失敗。",
	101006: "段落 ID 無效。",
	101007: "集團段落不存在。",
	101008: "案件 ID 無效。",
	101009: "集團知識段落無效。",

	/* Group Documents */
	110001: "無效的案件 ID。",
	110002: "無效的指示狀態。",
	110003: "透過 ID 通知獲取案件失敗。",

	/* ClientEngagement */
	93001: 'Client engagement description not found.',
	93002: 'Client engagement description should not be longer than 100 characters.',
	93003: 'Client engagement request is Empty.',
	93004: 'Client engagement Get call failed.',
	93005: 'Client engagement Update call failed.',
	93006: 'The engagement display name could not be updated at this time.  Refresh the page and try again.  Contact the Help Desk if the error persists.',

	/*IP FIltering */
	96005: "{0} 尚未被新增至可允許清單。",
	96015: "There are no access locations available to import from the source engagement.",
	96016: "There are no access locations available to import from the source engagement.",

	/*RBAC SchedulerRequests */
	'permissionIssueForScheduler': "You do not have permission to request services. Contact an engagement administrator and request permission to take this action.",

	/* GroupInstructions */
	98001: 'Get group instructions call failed.',
	98002: 'One or more of the knowledge instruction section IDs is not valid.',
	98003: 'Create group instructions call failed.',
	98004: 'Instruction name cannot be empty.',
	98005: 'Instruction name cannot exceed 500 characters.',
	98006: 'Instruction description cannot be empty.',
	98007: "指示說明不可超過4000字元。",
	98008: 'Instruction should be assigned to scopes or teams.',
	98009: 'Instruction name already exists in this engagement.',
	98011: 'This group instruction has already been deleted by another team member. Refresh the page and try again. Contact the help desk if the error persists.',
	98012: 'This group instruction has been deleted by another team member. Refresh the page and try again. Contact the help desk if the error persists.',
	98016: 'The group instruction that you are editing has been deleted by another team member. Refresh the page and try again. Contact the Help Desk if the error persists.',
	98017: 'This group task has already been deleted by another team member. Refresh the page and try again. Contact the help desk if the error persists.',
	98018: 'This group task has been deleted by another team member. Refresh the page and try again. Contact the help desk if the error persists.',
	98019: "未找到個體",

	/* Group Snapshots */
	102001: "Create group instruction snapshot call failed.",
	102002: "無效請求參數錯誤。",
	102003: "無效案件錯誤。",
	102004: "Get all group snapshtos call failed.",
	102005: "Get By Id group snapshot call failed.",
	102006: "找不到Snapshot。",
	102007: "所選擇的Snapshot無效",

	/* Group Links - Send link request */
	106001: "Send group link call failed.",
	106002: "團隊清單不可為空白。",
	106003: "一個或多過所選團隊為無效。",
	106004: "Queuing group link message failed.",
	106005: "團隊不可重複。",
	106006: "The concurrency tokens cannot be repeated.",

	/* GroupInstructions - Send Version request */
	22019: "該團隊被消除。",
	22023: "Send Instructions call failed.",
	22024: "您所嘗試寄送指示函的組成個體不可使用或已經被刪除。",
	22025: "案件id不可為空白。",
	22026: "組成個體id不可為空白。",
	22027: "所找到集團指示函沒有到期日。",
	22028: "給組成個體之範圍指示函尚未被發布。",
	22029: "無新發布給組成個體之指示函可供寄送。",
	22030: "此版本的指示和任務已被其他團隊成員接受。請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",

	22031: "集團版本通知失敗。",

	/* GroupVersion */
	22032: "指示函不存在。",

	22034: "透過ID通知獲得集團版本失敗。",
	22035: "指示設置ID不能為空白。",

	/* Return instruction concurrency scenario*/
	22036: "新版本的指示和任務已可使用。請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	22037: "此版本的指示和任務已被其他團隊成員接受。請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	22038: "此版本的指示和任務已被其他團隊成員退回。請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",

	37018: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	37019: "Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.",
	37030: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	37032: "Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.",
	37033: "Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.",
	37034: "Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.",
	37037: "This adjustment is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",

	/* EngagementReports */
	111001: "取得報告類型的要求失敗。",
	113015: "Trial balance unavailable. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	113025: 'Filter account class id or filter account id required, cannot proceed.',
	113050: "TrialBalance or FinancialStatement does not belongs to this engagement or it might be deleted, cannot proceed.",

	/*Information Security */
	200001: "The action taken was forbidden by EY Information Security. Refresh the page and try again. If the issue persists, contact the Help Desk.",

	/*GL account concurrency scenario*/
	113043: "This reconciling account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113019: "This reconciling account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113022: "Action cannot be completed. Refresh the page and try again. If the issue persists contact the Help Desk.",
	113039: "A reference is already associated with this GL account. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113021: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113035: "A reference is already associated with this GL account. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113020: "This evidence is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113037: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	40029: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",

	/*Trial balance*/
	113060: "MultiEntity required for MEST engagement.",
	113061: "MultiEntity not required for none MEST engagement.",
	113057: "Engagement helix not found.",
	113094: "Trial Balance to update must be Planning and IstrialBalance true.",
	113095: "Trial Balance to update should not be Planning and IstrialBalance true when financial type is trial balance.",
	113069: "Scope and Strategy already exists for the engagement.",
	113009: "Invalid Trial balance id, cannot proceed.",
	113092: "Trial Balance is both Planning and Financial Statements. Can not proceed to soft delete.",
	114033: "All business units mapped to a given entity must share at least one currency type and currency code. Please re-map your data and try again."

};

export const controlRiskTypeStep2 = [{
	id: 1,
	name: 'Rely'
},
{
	id: 2,
	name: 'Not rely'
},
{
	id: 3,
	name: 'Test MP'
}
];

/*Label Collections */
//Canvas Forms Statuses
export const canvasFormStatus = [{
	id: 1,
	value: "更新進行中"
},
{
	id: 3,
	value: "錯誤"
},
{
	id: 5,
	value: "更新進行中"
},
{
	id: 6,
	value: "錯誤"
}
];

export const riskTypes = [{
	id: 1,
	name: 'Significant risks',
	abbrev: 'SR',
	title: 'Significant risk'
},
{
	id: 2,
	name: 'Fraud risks',
	abbrev: 'FR',
	title: 'Fraud risk'
},
{
	id: 3,
	name: 'Risks of material misstatement',
	abbrev: 'R',
	title: 'ROMM/Inherent risk'
}
];

export const riskTypesToolTip = [{
	id: 1,
	name: 'Significant risks',
	abbrev: 'SR',
	label: 'Significant',
	title: 'Significant risk'
},
{
	id: 2,
	name: 'Fraud risks',
	abbrev: 'FR',
	label: 'Fraud',
	title: 'Fraud risk'
},
{
	id: 3,
	name: 'Risk of material misstatement',
	abbrev: 'R',
	label: 'Risk of material misstatement',
	title: 'Risk of material misstatement'
}
];

export const risksTypes = [{
	id: 1,
	name: 'Significant risks',
	abbrev: 'SR',
	title: 'Significant risks'
},
{
	id: 2,
	name: 'Fraud risks',
	abbrev: 'FR',
	title: 'Fraud risks'
},
{
	id: 3,
	name: 'Risks of material misstatement',
	abbrev: 'R',
	title: 'Risks of material misstatement'
}
];

export const emptyRiskTypes = [{
	id: 1,
	label: 'No significant risks have been identified'
},
{
	id: 2,
	label: 'No fraud risks have been identified'
},
{
	id: 3,
	label: 'No risks of material misstatement have been identified'
}
];

export const controlRiskType = [{
	id: 1,
	name: "仰賴"
},
{
	id: 2,
	name: 'Not rely'
},
{
	id: 3,
	name: "測試MP"
}
];
export const inherentRiskType = [{
	id: 1,
	name: "較高"
},
{
	id: 2,
	name: "較低"
}
];
export const CRAStrings = {
	Minimal: "極低",
	Low: "低度",
	'Low +SC': "低度+特別考量",
	Moderate: "中度",
	High: "高度",
	'High +SC': "高度+特別考量"
};
export const priorityType = [{
	id: 1,
	name: "低",
	className: 'Low',
	label: "L"
},
{
	id: 2,
	name: "中",
	className: 'Medium',
	label: "M"
},
{
	id: 3,
	name: "高",
	className: 'High',
	label: "H"
},
{
	id: 4,
	name: "重要",
	className: 'Critical',
	label: "C"
}
];
export const reviewNoteFilterTypes = [{
	value: 0,
	label: "全部"
},
{
	value: 1,
	label: "未解決"
},
{
	value: 2,
	label: "已清除"
},
{
	value: 3,
	label: "已關閉"
}
];
export const reviewStatus = [{
	id: 1,
	name: "未解決"
},
{
	id: 2,
	name: "已清除"
},
{
	id: 3,
	name: "已關閉"
}
];
export const reviewNoteOpenStatusOption = [{
	value: 2,
	label: "清除"
},
{
	value: 3,
	label: "關閉"
}
];
export const reviewNoteClearedStatusOption = [{
	value: 1,
	label: "重新開啟"
},
{
	value: 3,
	label: "關閉"
}
];
export const reviewNoteBulkClearedStatusOption = [{
	value: 1,
	label: "重新開啟"
},
{
	value: 2,
	label: "清除"
},
{
	value: 3,
	label: "關閉"
}
];
export const reviewNoteClosedStatusOption = [{
	value: 1,
	label: "重新開啟"
}];
export const signOffTypes = [{
	value: 0,
	label: "編製者"
},
{
	value: 1,
	label: "複核者"
},
{
	value: 2,
	label: "無"
}
];
export const RNHNoteStatusOptions = [{
	value: 1,
	label: "未解決"
},
{
	value: 2,
	label: "已解決"
},
{
	value: 3,
	label: "已清除"
}
];
export const assertions = [{
	id: 1,
	assertionname: "完整性",
	assertionabbreviation: "C",
	statementtypeid: 2,
	displayorder: 1
},
{
	id: 2,
	assertionname: "存在性",
	assertionabbreviation: "E",
	statementtypeid: 2,
	displayorder: 2
},
{
	id: 3,
	assertionname: "評價",
	assertionabbreviation: "V",
	statementtypeid: 2,
	displayorder: 3
},
{
	id: 4,
	assertionname: "權利與義務",
	assertionabbreviation: "R&O",
	statementtypeid: 2,
	displayorder: 4
},
{
	id: 5,
	assertionname: "表達與揭露",
	assertionabbreviation: "P&D",
	statementtypeid: 2,
	displayorder: 5
},
{
	id: 6,
	assertionname: "完整性",
	assertionabbreviation: "C",
	statementtypeid: 1,
	displayorder: 6
},
{
	id: 7,
	assertionname: "發生",
	assertionabbreviation: "O",
	statementtypeid: 1,
	displayorder: 7
},
{
	id: 8,
	assertionname: "分攤",
	assertionabbreviation: "M",
	statementtypeid: 1,
	displayorder: 8
},
{
	id: 9,
	assertionname: "表達與揭露",
	assertionabbreviation: "P&D",
	statementtypeid: 1,
	displayorder: 9
},
{
	id: 10,
	assertionname: "完整性",
	assertionabbreviation: "C",
	statementtypeid: 3,
	displayorder: 10
},
{
	id: 11,
	assertionname: "存在/發生",
	assertionabbreviation: "E/O",
	statementtypeid: 3,
	displayorder: 11
},
{
	id: 12,
	assertionname: "分攤/評價",
	assertionabbreviation: "M/V",
	statementtypeid: 3,
	displayorder: 12
},
{
	id: 13,
	assertionname: "權利與義務",
	assertionabbreviation: "R&O",
	statementtypeid: 3,
	displayorder: 13
},
{
	id: 14,
	assertionname: "表達與揭露",
	assertionabbreviation: "P&D",
	statementtypeid: 3,
	displayorder: 14
}
];
//Add Review Note
export const priorityTypes = [{
	value: 1,
	label: "低"
},
{
	value: 2,
	label: "中"
},
{
	value: 3,
	label: "高"
},
{
	value: 4,
	label: "重要"
}
];
/*Cog Menu*/
export const cogMenuOptions = {
	Open: "開啟",
	'Start Co-edit mode': "Start multi-user editing",
	'End Co-edit mode': "End multi-user editing",
	'Open read-only': "以唯讀方式開啟",
	'View history': "檢視歷史資料",
	CopyLink: "Copy link",
	Rename: "重新命名",
	Delete: "刪除",
	'Remove from task': "從任務移除",
	Remove: "移除",
	Unlink: "解除連結",
	RelateTasks: "連結任務",
	RelateEntities: "Relate entities",
	Restore: "還原",
	PermanentlyDelete: "永久刪除",
	ChangeReason: "編輯理由",
	Confidentiality: "機密",
	SignoffRequirements: "簽核要求",
	AssignRegionComponent: "指派給區域或組成個體",
	UnassignRegionComponent: "取消指派區域或組成個體",
	ReturnToRegionComponent: "退回給區域或組成個體",
	ClearReturnToRegionComponent: "清除退回給區域或組成個體",
	OverwriteForm: "覆寫表單",
	Finalize: "完成文件"
};

export const pagingSvgHoverText = {
	first: "第一頁",
	previous: "上一頁",
	next: "下一頁",
	last: "最後頁"
};
export const controlFrequencyType = {
	1: "一天多次",
	2: "每天",
	3: "每週",
	4: "每月",
	5: "每季",
	6: "每年",
	7: "IT應用系統控制",
	8: "其他"
};
export const itApproachType = {
	1: "控制",
	2: "證實性"
};
export const controlType = {
	1: "IT應用系統",
	2: "仰賴IT人工",
	3: "人工預防",
	4: "人工偵查"
};
export const aggregateITEvaluationType = {
	1: "支援",
	2: "不支援",
	3: "支援FS & ICFR",
	4: "僅支援FS"
};
export const entityType = {
	'ENTITY3': "科目",
	'ENTITY4': "SCOT",
	'ENTITY5': "IT流程",
	'ENTITY7': "風險",
	'ENTITY18': "WCGW",
	'ENTITY19': "控制",
	'ENTITY20': "ITSOApplication",
	'ENTITY24': "聲明",
	'ENTITY34': "IT控制",
	'ENTITY35': "IT風險"
};
export const trueFalseToYesNo = {
	'true': "是",
	'false': "否"
}
export const trueFalseToYesOnly = {
	'true': "是"
}
export const yesNoLocalized = {
	'Yes': "是",
	'No': "否"
}
export const iTProcessEvaluationType = {
	1: "有效",
	2: "無效",
	3: "可仰賴",
	4: "未測試"
};

export const strategyType = {
	1: "控制",
	2: "證實性",
	3: "仰賴",
	4: "不仰賴"
};
export const accountType = {
	1: "重大科目",
	2: "有限風險科目"
};

export const scotTypes = {
	1: "例行性",
	2: "非例行性",
	3: "估計"
};
export const taskNavigation = {
	1: "我的任務",
	2: "所有任務",
	3: "範圍與策略",
	4: "SCOTs",
	5: "IT/SOs",
	6: "科目",
	7: "一般執行",
	8: "結論",
	9: "團隊概要",
	10: "風險"
};
export const subCategoty = {
	1: "顯示全部",
	2: "編製",
	3: "複核"
};
export const subCategoryType = {
	AllTasks: {
		id: 1,
		title: "顯示全部",
		label: "顯示全部"
	},
	ToPrepare: {
		id: 2,
		title: "給編製者",
		label: "給編製者"
	},
	ToReview: {
		id: 3,
		title: "供我複核",
		label: "供我複核"
	},
	Preparers: {
		id: 2,
		title: "編製者",
		label: "編製者"
	},
	Reviewers: {
		id: 3,
		title: "複核者",
		label: "複核者"
	}
};
/*Task Types*/
export const taskType = {
	1: "標準任務",
	2: "主要標準任務",
	3: "簡易測試(Walkthrough)任務",
	4: "控制任務",
	5: "證實性任務",
	6: "主要證實性查核程序任務",
	7: "回應任務",
	8: "集團任務"
};

export const taskTypesForAddTask = {
	importfromknowledge: "從Knowledge匯入",
	custom: "自訂",
	account: "科目",
	itsubstantive: "IT證實程序",
	scotwalkthroughtask: "SCOT簡易測試(walkthrough)",
	scotcontroltask: "SCOT控制",
	itwalkthroughtask: "IT簡易測試(walkthrough)",
	itcontroltask: "IT控制"
};

export const taskTypeBadge = {
	1: "OST",
	2: "PST",
	3: "WT",
	4: "TOC",
	5: "OSP",
	6: "PSP",
	7: "RT",
	8: "GT",
	9: "PIC",
	10: "EQR",
	11: "PIC/EQR",
	22: "ACT",
	23: 'UDP'
};
/*Task Types*/
export const taskTypeAbbreviation = {
	1: "TOC",
	2: "TOC",
	3: "TOC",
	4: "TOC",
	5: "TOC",
	6: "TOC",
	7: "RT",
	8: "RT",
	9: "RT",
	10: "RT",
	11: "RT",
	13: "OST",
	14: "PST",
	16: "OSP",
	17: "PSP",
	18: "WT",
	19: "UDP",
	20: "WT",
	22: "ACT",
	23: "GT",
	24: "GT",
	25: "GT",
	26: "OSP",
	27: "GT"
};
export const auditPhase = {
	1: "範圍與策略",
	2: "執行",
	3: "總結"
};
export const ProfileActionType = {
	1: "提交基本資料-首次",
	2: "提交基本資料-後推",
	3: "編輯基本資料",
	4: "Global內容更新",
	5: "匯入PSPs",
	6: "匯入PSTs",
	7: "Canvas表單內容更新",
	8: "匯入GA指示",
	9: "加入人工表單",
	10: "Profile Delivery",
	11: "Mandatory Content Update",
	12: 'Canvas Form Profile Sync'
};

export const taskGroup = {
	1: "執行其他規劃程序",
	2: "科目流",
	3: "重大交易類別 (SCOT) 流",
	4: "IT 應用系統及委外服務機構流",
	5: "綜合風險評估 (CRA) 流",
	6: "查核計畫流",
	7: "執行總結程序",
	8: "審計差異彙總表 (SAD)",
	9: "評估查核結果",
	10: "執行其他查核程序",
	11: "集團查核架構",
	12: "集團查核建立指示",
	13: "主要集團任務",
	14: "集團組成個體集團任務",
	15: "工作計畫",
	16: "Accounts Flow - MEST",
	17: "執行複核程序",
	18: "完成初步案件活動",
	19: "建立團隊",
	20: "啟用案件資料",
	21: 'Perform RA analytical procedures and determine materiality',
	22: "Identify significant accounts - MEST",
	23: "額外程序以告知風險評估",
	24: "辨認來源",
	25: "辨認重大科目",
	26: "辨認並瞭解SCOTs",
	27: "辨認並瞭解IT流程及服務機構",
	28: "確認策略及CRA",
	29: "執行額外所須風險辨認程序",
	30: "考量使用內部稽核",
	31: "回應風險評估",
	32: "最終確定策略",
	33: "EQR程序",
	34: "設計程序",
	35: "評估並總結查核證據",
	36: "出具溝通及交付事項",
	37: "EQR程序",
	38: "編製及出具查核報告",
	39: "完成文件紀錄並歸檔",
	40: "測試企業層級控制",
	41: "分析用於自動化技術之資料",
	42: "執行必要舞弊程序",
	43: "執行內部稽核及專家程序",
	44: "評估IT流程",
	45: "會議紀錄、合約及訴訟複核",
	46: "執行財務報表程序",
	47: "執行關係人、繼續經營及法令程序",
	48: "討論查核策略修正",
	49: "執行結論",
	50: "EQR程序",
	51: "Complete scope and strategy quality activities",
	52: "執行初步查核程序",
	53: "執行風險評估程序",
	54: 'Identify service organizations',
	55: "Digital - Task Group 5",
	56: 'Identify and understand IT processes',
	57: "Perform planning procedures",
	58: 'Group Structure, Instructions and Involvement',
	59: "Identify significant disclosures",
	60: "Identify and understand significant reporting processes",
	61: 'Digital - Task Group 11',
	62: "Digital - Task Group 12",
	63: "Digital - Task Group 13",
	64: "Digital - Task Group 14",
	65: "Digital - Task Group 15",
	66: "Digital - Task Group 16",
	67: "Digital - Task Group 17",
	68: "完成期中後案件管理活動",
	69: 'Execute substantive procedures - Governance',
	70: 'Execute substantive procedures - Strategy',
	71: 'Execute substantive procedures - Risk Management',
	72: 'Execute substantive procedures - Metrics and Targets',
	73: "Execute substantive procedures - Other",
	74: "Evaluate work of others",
	75: "Digital - Task Group 25",
	76: "Digital - Task Group 26",
	77: "Digital - Task Group 27",
	78: "Digital - Task Group 28",
	79: "Digital - Task Group 29",
	80: "Digital - Task Group 30",
	81: "Digital - Task Group 31",
	82: "Digital - Task Group 32",
	83: "Digital - Task Group 33",
	84: "Digital - Task Group 34",
	85: "評估並總結核閱證據",
	86: "Perform general assurance procedures",
	87: "Evaluate and conclude on evidence",
	88: "Digital - Task Group 38",
	89: "Digital - Task Group 39",
	90: "Digital - Task Group 40",
	91: "Digital - Task Group 41",
	92: "Digital - Task Group 42",
	93: "Digital - Task Group 43",
	94: "Digital - Task Group 44",
	95: "Digital - Task Group 45",
	96: "Digital - Task Group 46",
	97: "Digital - Task Group 47",
	98: "Digital - Task Group 48",
	99: "Digital - Task Group 49",
	100: "Digital - Task Group 50"
};
export const AutomationHubRequestStatus = {
	Draft: "草稿",
	Submitted: "已提交",
	Sent: "傳送處理中",
	InProgress: "進行中",
	Failed: "進行錯誤",
	Completed: "已完成",
	FailedToSendToBP: "進行錯誤",
	QueueingFailed: "提交失敗",
	ActionRequired: "須採取行動"
};
export const milestonesLabels = {
	1: "範圍",
	2: "策略",
	3: "簡易測試(Walkthroughs)",
	4: "期中控制測試",
	5: "期中證實測試",
	6: "簡易測試(Walkthroughs)(年末流程)",
	7: "年末控制測試",
	8: "年末證實測試",
	9: "總結",
	10: "不適用",
	11: "執行",
	12: "Scope and strategy quality activities",
	13: "其他範圍與策略",
	14: "CRA",
	15: "風險評估及重大性",
	16: "總結範圍與策略",
	17: "期中過後案件管理"
};

export const TasksFilterGroups = {
	Tasks: "任務",
	Assignments: "指派事項",
	ReviewNotes: "複核註記",
	ProjectManagement: "案件管理",
	Other: "其他"
};

export const TasksFilterTypes = {
	TaskStatus: "任務狀態",
	TaskType: "任務類型",
	AssignedTo: "指派給",
	OpenAssignments: "開啟指派事項",
	ReviewNotesStatus: "複核註記狀態",
	ReviewNotesAssignedTo: "複核註記指派給",
	ReviewNotesCreatedBy: "複核註記建立由",
	TimePhase: "時段",
	Milestone: "里程碑",
	AuditPhase: "查核階段",
	DocumentConflict: "文件衝突",
	Findings: "發現",
	Entity: "企業",
	IsBookmarked: "離線下載"
};

export const quickFilterTaskStatus = [{
	value: '1',
	label: "開啟"
},
{
	value: '2',
	label: "進行中"
},
{
	value: '3',
	label: "複核中"
},
{
	value: '4',
	label: "完成"
}
];

export const quickFilterAssignmentStatus = [{
	value: '1',
	label: "開啟"
},
{
	value: '2',
	label: "進行中"
},
{
	value: '3',
	label: "已關閉"
},
{
	value: '4',
	label: "未指派"
}
];

export const dataExport = [
	// 'Archive Form',
	// 'Canvas Forms',
	"Collaboration",
	// 'Control Forms',
	'Documents',
	"任務",
	"Scott Summary",
	// 'Team Members',
	// 'Trial Balance'
];
export const dataExportReportNames = {
	'Archive Form': "歸檔表單",
	'Canvas Forms': "Canvas表單報告",
	'Collaboration': "Collaboration",
	'Control Forms': "控制報告",
	'Documents': "所有文件報告",
	'Tasks': "所有任務報告",
	'Team Members': "團隊成員",
	'Trial Balance': "數字報告"
};
export const projectManagement = [
	"Collaboration詳情",
	// 'Digital scorecard',
	// 'Milestones',
	// 'Review Notes',
	// 'Validation Checks'
];

export const projectManagementReportNames = {
	'Collaboration Details': "Client Collaboration Dashboard",
	'Milestones': "里程碑報告",
	'Review Notes': "複核註記報告",
	'Validation Checks': "驗證檢查報告"
};

export const taskQuickFilterOptions = [{
	id: 'taskToPreparer',
	label: "可編製的任務",
	uiViewId: uiViews.taskSystemSuggestedFilter
},
{
	id: 'tasksReadyForReview',
	label: "準備好供複核的任務",
	uiViewId: uiViews.taskSystemSuggestedFilter
},
{
	id: 'allAssignedTasks',
	label: "所有已指派的任務",
	uiViewId: uiViews.taskSystemSuggestedFilter
},
{
	id: 'allOverdueTasks',
	label: "過期的任務",
	uiViewId: uiViews.taskSystemSuggestedFilter
},
{
	id: 'allTasksDueThisWeek',
	label: "本週即將到期的任務",
	uiViewId: uiViews.taskSystemSuggestedFilter
}
];

export const noDefaultFilter = {
	id: 'noDefaultFilter',
	label: "無預設篩選"
};

export const taskTypes = [{
	id: '1',
	label: "控制任務"
},
{
	id: '2',
	label: "控制任務 - 控制"
},
{
	id: '3',
	label: "控制任務 - ELC"
},
{
	id: '4',
	label: "控制任務 - IT/SO"
},
{
	id: '5',
	label: "控制任務 - MP"
},
{
	id: '6',
	label: "控制任務 - SO"
},
{
	id: '7',
	label: "回覆任務"
},
{
	id: '8',
	label: "現金流不實表達回覆任務"
},
{
	id: '9',
	label: "缺失回覆任務"
},
{
	id: '10',
	label: "揭露不實表達回覆任務"
},
{
	id: '11',
	label: "不實表達回覆任務"
},
{
	id: '12',
	label: "標準任務"
},
{
	id: '13',
	label: "其他標準任務"
},
{
	id: '14',
	label: "主要標準任務"
},
{
	id: '15',
	label: "證實任務"
},
{
	id: '16',
	label: "其他證實程序任務"
},
{
	id: '17',
	label: "主要證實程序任務"
},
{
	id: '18',
	label: "穿透測試任務"
},
{
	id: '19',
	label: "穿透測試任務 - IT/SO"
},
{
	id: '20',
	label: "穿透測試任務 - SCOT"
},
{
	id: '21',
	label: "Todo"
},
{
	id: '22',
	label: "科目結論任務"
},
{
	id: '23',
	label: "集團任務"
},
{
	id: '24',
	label: "主查團隊任務"
},
{
	id: '25',
	label: "組成團隊任務"
},
{
	id: '26',
	label: "IT/SO 其他證實程序任務"
},
{
	id: '27',
	label: "組成團隊任務未連結"
}
];

export const filterAssignmentType = [{
	value: '1',
	label: "編製者"
},
{
	value: '2',
	label: "詳細複核者"
},
{
	value: '3',
	label: "一般複核者"
},
{
	value: '4',
	label: "會計師"
},
{
	value: '5',
	label: "EQR"
},
{
	value: '6',
	label: "其他"
}
];

export const filterTaskStatus = [{
	value: '1',
	label: "未完成"
},
{
	value: '2',
	label: "進行中"
},
{
	value: '3',
	label: "複核中"
},
{
	value: '4',
	label: "完成"
},
{
	value: '5',
	label: "無證據"
}
];

export const filterAssignmentStatus = [{
	value: '1',
	label: "未完成"
},
{
	value: '2',
	label: "進行中"
},
{
	value: '3',
	label: "已完成"
},
{
	value: '4',
	label: "未指派"
}
];

export const filterTaskType = [{
	value: '1',
	label: "控制任務"
},
{
	value: '7',
	label: "回應任務"
},
{
	value: '13',
	label: "其他標準任務"
},
{
	value: '14',
	label: "主要標準任務"
},
{
	value: '16',
	label: "其他證實程序任務"
},
{
	value: '17',
	label: "主要證實程序任務"
},
{
	value: '18',
	label: "穿透測試/UDP 任務"
},
{
	value: '22',
	label: "科目結論任務"
},
{
	value: '999',
	label: "需要 PIC 簽核"
},
{
	value: '1000',
	label: "EQR必須簽名"
}
];

export const filterTaskTypeGroupEngagement = [{
	value: '1',
	label: "控制任務"
},
{
	value: '7',
	label: "回應任務"
},
{
	value: '13',
	label: "其他標準任務"
},
{
	value: '14',
	label: "主要標準任務"
},
{
	value: '16',
	label: "其他證實程序任務"
},
{
	value: '17',
	label: "主要證實程序任務"
},
{
	value: '18',
	label: 'Walkthrough/ UDP task'
},
{
	value: '22',
	label: "科目結論任務"
},
{
	value: '23',
	label: "集團任務"
},
{
	value: '999',
	label: "需要 PIC 簽核"
},
{
	value: '1000',
	label: "EQR必須簽名"
}
];

export const filterTaskTypeInterimEngagement = [{
	value: '14',
	label: "主要標準任務"
},
{
	value: '13',
	label: "其他標準任務"
},
{
	value: '23',
	label: "集團任務"
},
{
	value: '999',
	label: "PIC簽核是必須的"
},
{
	value: '1000',
	label: "EQR必須簽名"
}
];

export const filterMilestones = [{
	value: '1',
	label: "範圍",
	hideFromMenu: true
},
{
	value: '2',
	label: "策略",
	hideFromMenu: true
},
{
	value: '12',
	label: "Scope and strategy quality activities"
},
{
	value: '13',
	label: "其他範圍與策略"
},
{
	value: '14',
	label: "CRA"
},
{
	value: '15',
	label: "風險評估及重大性"
},
{
	value: '16',
	label: "最終完成範圍與策略"
},
{
	value: '17',
	label: "期中過後案件管理"
},
{
	value: '3',
	label: "簡易測試(Walkthroughs)"
},
{
	value: '4',
	label: "期中控制測試"
},
{
	value: '5',
	label: "期中證實測試"
},
{
	value: '6',
	label: "簡易測試(Walkthroughs) (年末流程)"
},
{
	value: '7',
	label: "年末控制測試"
},
{
	value: '8',
	label: "年末證實測試"
},
{
	value: '11',
	label: "執行"
},
{
	value: '9',
	label: "結論"
},
{
	value: '10',
	label: "不適用"
},
{
	value: '0',
	label: "無里程碑"
}
];

export const documentListMilestones = [{
	value: '1',
	label: "範圍"
},
{
	value: '12',
	label: "範圍與策略計畫管理"
},
{
	value: '13',
	label: "其他範圍與策略"
},
{
	value: '2',
	label: "策略"
},
{
	value: '14',
	label: "CRA"
},
{
	value: '15',
	label: "風險評估及重大性"
},
{
	value: '16',
	label: "確定範圍與策略"
},
{
	value: '17',
	label: "期中後計畫管理"
},
{
	value: '3',
	label: "穿透測試"
},
{
	value: '4',
	label: "期中控制測試"
},
{
	value: '5',
	label: "期中證實測試"
},
{
	value: '6',
	label: "穿透測試（期末流程）"
},
{
	value: '7',
	label: "期末控制測試"
},
{
	value: '8',
	label: "期末證實測試"
},
{
	value: '11',
	label: "執行"
},
{
	value: '9',
	label: "結論"
},
{
	value: '10',
	label: "不適用"
}
];

export const filterAuditPhases = [{
	value: '1',
	label: "範圍與策略"
},
{
	value: '2',
	label: "執行"
},
{
	value: '3',
	label: "結論"
}
];


export const filterDocListReviewNoteStatus = [{
	value: 1,
	label: 'Open'
},
{
	value: 5,
	label: 'Cleared'
},
{
	value: 2,
	label: 'Closed'
}
];

export const filterDocumentConflicts = [{
	value: '1',
	label: "是"
}, {
	value: '0',
	label: "否"
}];
export const filterDownloadedForOffline = [{
	value: '1',
	label: "是"
}, {
	value: '2',
	label: "否"
}];

export const missingEntityDocuments = [{
	value: 10034,
	label: "Yes"
}]


export const filterTaskFindings = [{
	value: '1',
	label: "缺失"
},
{
	value: '2',
	label: "不實表達"
}
];

export const ConfidentialityTypes = [{
	id: 1,
	Name: "預設"
},
{
	id: 2,
	Name: "低"
},
{
	id: 3,
	Name: "中"
},
{
	id: 4,
	Name: "高"
},
{
	id: 5,
	Name: "機密"
}
];

export const RoleForMember = [{
	id: 1,
	role: "主辦會計師(Partner in Charge)",
	roleAbbreviation: "PIC",
	displayOrder: 9
},
{
	id: 2,
	role: "案件會計師(Engagement Partner)",
	roleAbbreviation: "案件會計師(EP)",
	displayOrder: 8
},
{
	id: 3,
	role: "執行總監(Executive Director)",
	roleAbbreviation: "ED",
	displayOrder: 5
},
{
	id: 4,
	role: "主要的",
	roleAbbreviation: "主要的",
	displayOrder: 6
},
{
	id: 5,
	role: "資深經理(Senior Manager)",
	roleAbbreviation: "Sr.Manager",
	displayOrder: 4
},
{
	id: 6,
	role: "經理(Manager)",
	roleAbbreviation: "Manager",
	displayOrder: 3
},
{
	id: 7,
	role: "組長(Senior)",
	roleAbbreviation: "Senior",
	displayOrder: 2
},
{
	id: 8,
	role: "組員(Staff)",
	roleAbbreviation: "Staff",
	displayOrder: 1
},
{
	id: 9,
	role: "實習生(Intern)",
	roleAbbreviation: "Intrn"
},
{
	id: 10,
	role: "案件品質複核者(EQR)",
	roleAbbreviation: "EQR",
	displayOrder: 10
},
{
	id: 11,
	role: "Other Partner",
	roleAbbreviation: "Other Partner",
	displayOrder: 7
},
{
	id: 12,
	role: "GDS - Staff",
	roleAbbreviation: "GDS Staff",
	displayOrder: 13
},
{
	id: 13,
	role: "Advisory (ITRA,TAS,Human Capital or Other)",
	roleAbbreviation: "ADV"
},
{
	id: 14,
	role: "Tax",
	roleAbbreviation: "Tax"
},
{
	id: 15,
	role: "Executive Support Services",
	roleAbbreviation: "ESS"
},
{
	id: 16,
	role: "總顧問(General Counsel)",
	roleAbbreviation: "GCO",
	displayOrder: 12
},
{
	id: 17,
	role: "案件品質會計師(AQR)",
	roleAbbreviation: "AQR",
	displayOrder: 11
},
{
	id: 18,
	role: "ML組成個體查核團隊(Component Team)",
	roleAbbreviation: "MCT"
},
{
	id: 19,
	role: "客戶主管人員(Client Supervisor)",
	roleAbbreviation: "C. Supervisor"
},
{
	id: 20,
	role: "客戶員工(Client Staff)",
	roleAbbreviation: "C. Staff"
},
{
	id: 21,
	role: "內部稽核主管人員(Internal Audit Supervisor)",
	roleAbbreviation: "IA Supervisor"
},
{
	id: 22,
	role: "內部稽核員工(Internal Audit Staff)",
	roleAbbreviation: "IA Staff"
},
{
	id: 23,
	role: "主管機關(Regulator)",
	roleAbbreviation: "Regulator"
},
{
	id: 24,
	role: "其他(例如：due diligence review)",
	roleAbbreviation: "Other"
},
{
	id: 25,
	role: "Office",
	roleAbbreviation: "Office"
},
{
	id: 26,
	role: "Area",
	roleAbbreviation: "Area"
},
{
	id: 27,
	role: "Industry",
	roleAbbreviation: "IND"
},
{
	id: 28,
	role: "National",
	roleAbbreviation: "NAT"
},
{
	id: 29,
	role: "Global",
	roleAbbreviation: "GBL"
},
{
	id: 30,
	role: "GDS - Senior",
	roleAbbreviation: "GDS Senior",
	displayOrder: 14
},
{
	id: 31,
	role: "GDS - Manager",
	roleAbbreviation: "GDS Manager",
	displayOrder: 15
}
];

export const SubServiceLines = [{
	subServiceLineId: 1,
	subServiceLineName: 'Audit',
	displayOrder: 1
},
{
	subServiceLineId: 2,
	subServiceLineName: 'FIDS',
	displayOrder: 2
},
{
	subServiceLineId: 9,
	subServiceLineName: 'FAAS',
	displayOrder: 3
},
{
	subServiceLineId: 11,
	subServiceLineName: 'CCaSS',
	displayOrder: 4
},
{
	subServiceLineId: 12,
	subServiceLineName: 'BTS',
	displayOrder: 5
},
{
	subServiceLineId: 13,
	subServiceLineName: 'Human Capital',
	displayOrder: 6
},
{
	subServiceLineId: 14,
	subServiceLineName: 'Law',
	displayOrder: 7
},
{
	subServiceLineId: 15,
	subServiceLineName: 'Indirect Tax',
	displayOrder: 8
},
{
	subServiceLineId: 16,
	subServiceLineName: 'GCR',
	displayOrder: 9
},
{
	subServiceLineId: 17,
	subServiceLineName: 'Transaction Tax',
	displayOrder: 10
},
{
	subServiceLineId: 18,
	subServiceLineName: 'ITS',
	displayOrder: 11
},
{
	subServiceLineId: 19,
	subServiceLineName: 'GCO',
	displayOrder: 12
},
{
	subServiceLineId: 20,
	subServiceLineName: 'Business Consulting',
	displayOrder: 13
},
{
	subServiceLineId: 21,
	subServiceLineName: 'Technology Consulting',
	displayOrder: 14
},
{
	subServiceLineId: 22,
	subServiceLineName: 'Transactions and Corporate Finance',
	displayOrder: 15
},
{
	subServiceLineId: 23,
	subServiceLineName: 'EY Parthenon',
	displayOrder: 16
},
{
	subServiceLineId: 24,
	subServiceLineName: 'Other',
	displayOrder: 17
},
{
	subServiceLineId: 25,
	subServiceLineName: "Technology Risk",
	displayOrder: 18
}
];

export const SchedulerRequestRole = [{
	id: 31,
	userTypeId: 4,
	label: "GDS Manager"
},
{
	id: 31,
	userTypeId: 3,
	label: "Request Manager"
}
];

/* Task Status */
export const TaskStatus = [{
	id: 1,
	label: "開啟"
},
{
	id: 2,
	label: "處理中"
},
{
	id: 3,
	label: "複核中"
},
{
	id: 4,
	label: "完成"
},
{
	id: 5,
	label: "已移除"
},
{
	id: 6,
	label: "PIC/EQR 簽核完成"
}
];
/* GATaskSendStatus*/
export const GATaskSendStatus = [{
	id: 1,
	label: "尚未傳送"
},
{
	id: 2,
	label: "進行中"
},
{
	id: 3,
	label: "已傳送"
},
{
	id: 4,
	label: "已退回"
}
];
// 9 - Return error (UI value, doesn't exist in database)
export const GAComponentDocumentStatusLabels = [{
	id: GAComponentDocumentStatus.Open,
	label: "開啟"
},
{
	id: GAComponentDocumentStatus.InProgress,
	label: "已接收"
},
{
	id: GAComponentDocumentStatus.Submitted,
	label: "已提交"
},
{
	id: GAComponentDocumentStatus.Returned,
	label: "已退回"
},
{
	id: GAComponentDocumentStatus.InReview,
	label: "已編製"
},
{
	id: GAComponentDocumentStatus.Complete,
	label: "已複核"
},
{
	id: GAComponentDocumentStatus.Dismissed,
	label: "已取消"
},
{
	id: GAComponentDocumentStatus.RejectInTransit,
	label: "Return in progress"
},
{
	id: GAComponentDocumentStatus.ReturnError,
	label: 'Return error'
}
];
export const TeamSummaryPreparerTaskStatus = [{
	id: 1,
	label: "開啟"
},
{
	id: 2,
	label: "進行中"
},
{
	id: 3,
	label: "已關閉"
}
];
export const TeamSummaryReviewerTaskStatus = [{
	id: 1,
	label: "開啟"
},
{
	id: 2,
	label: "進行中"
},
{
	id: 3,
	label: "已關閉"
}
];

export const DocumentHelper = {
	401: "目前無法完成動作。請重新整理頁面並重試。若錯誤仍然存在，請聯絡Help Desk。",
	413: "文件超過最大可允許檔案大小(250mb)且無法上傳。請減少檔案大小並重試。",
	412: "文件名稱已存在於此案件",
	414: "名稱超過最大長度（{0} 個字符）。",
	410: "該文件已被刪除，因此無法開啟。",
	411: "不允許使用空白文件。"
};

export const reviewNoteCategories = [{
	value: reviewNoteRoutes.path.all.id,
	path: reviewNoteRoutes.path.all.path,
	label: "所有註記"
},
{
	value: reviewNoteRoutes.path.document.id,
	path: reviewNoteRoutes.path.document.path,
	label: "文件註記"
},
{
	value: reviewNoteRoutes.path.task.id,
	path: reviewNoteRoutes.path.task.path,
	label: "任務註記"
},
{
	value: reviewNoteRoutes.path.form.id,
	path: reviewNoteRoutes.path.form.path,
	label: "Canvas表單註解"
}
];

export const reviewNoteStatus = [{
	value: '1',
	label: "未解決"
},
{
	value: '2',
	label: "已清除"
},
{
	value: '3',
	label: "已解決"
}
];

/* RNH Review note hub */
export const reviewNoteTypes = [{
	id: 1,
	type: 'document',
	label: "文件註記"
},
{
	id: 2,
	type: 'task',
	label: "任務註記"
}
];

export const accountConclusionTabs = {
	details: "Details",
	conclusions: "結論"
};


export const rnhFilterType = [{
	id: 0,
	filterType: rnhFilterTypeQuery.annotationStatusIds,
	name: "註記狀態Id",
	inDropDown: false
},
{
	id: 1,
	filterType: rnhFilterTypeQuery.authoredBy,
	name: "編輯由",
	inDropDown: true
},
{
	id: 2,
	filterType: rnhFilterTypeQuery.assignedTo,
	name: "指派給",
	inDropDown: true
},
{
	id: 3,
	filterType: rnhFilterTypeQuery.priority,
	name: "優先順序",
	inDropDown: true,
	filterOptions: [{
		id: "1",
		label: "低"
	}, {
		id: "2",
		label: "中"
	}, {
		id: "3",
		label: "高"
	}, {
		id: "4",
		label: "重要"
	}]
},
{
	id: 4,
	filterType: rnhFilterTypeQuery.dueBefore,
	name: "到期或之前",
	inDropDown: true,
	isDateTime: true
},
{
	id: 5,
	filterType: rnhFilterTypeQuery.dueAfter,
	name: "Due on or after",
	inDropDown: true,
	isDateTime: true
}
];

export const rnhSortingOptions = [{
	id: 'Number',
	label: '#'
},
{
	id: 'DueDate',
	label: "Due"
},
{
	id: 'Priority',
	label: "Priority"
},
{
	id: 'Status',
	label: "Status"
}
];

export const userConfidentiality = [{
	id: 1,
	value: "一般"
},
{
	id: 2,
	value: "低"
},
{
	id: 3,
	value: "中"
},
{
	id: 4,
	value: "高"
},
{
	id: 5,
	value: "限制"
},
{
	id: 6,
	value: "保密"
}
];

export const externalUserStatus = {
	active: "使用中",
	inactive: "非使用中"
};

export const engagementStatus = {
	1: "使用中",
	2: "待處理",
	3: "已拒絕",
	4: "非使用中",
	13: "Scheduled - Inactive"
};

export const copyRequestStatus = {
	0: "Expired",
	1: "Ready",
	2: "Sent",
	3: "Received",
	4: "正在導出",
	5: "導出成功",
	6: "導出錯誤",
	7: "正在導入",
	8: "導入成功",
	9: "導入錯誤",
	10: "Declined",
	11: "複製中",
	13: "Draft",
	14: "發送中",
	15: "交貨中",
	16: "送貨錯誤"
}

export const copyObjectGrouptype = {
	21: "Engagement",
	22: "Accounts",
	23: "SCOTs",
	20: "Evidence",
	24: "Roll forward from existing",
	25: "Template",
	26: "Bulk Export",
	27: "External document",
	28: "Guided Workflows",
	29: "Engagement by Entity"
}

export const independenceStatus = {
	0: labels.undefined,
	1: labels.incomplete,
	2: labels.nomattersidentified,
	3: labels.matteridentifiedpendingaction,
	4: labels.matterresolveddeniedaccess,
	5: labels.matterresolvedgrantedaccess,
	6: labels.notapplicable,
	7: labels.restored,
	8: labels.overriden,
	9: labels.priornomattersidentified,
	10: labels.priormatteridentifiedpendingaction,
	11: labels.priormatterresolvedgrantedaccess,
	12: labels.priormatterresolveddeniedaccess
};

export const independenceStatusFilterOptions = [{
	value: 3,
	label: labels.matteridentifiedpendingaction
},
{
	value: 4,
	label: labels.matterresolveddeniedaccess
},
{
	value: 5,
	label: labels.matterresolvedgrantedaccess
},
{
	value: 8,
	label: labels.override
},
{
	value: 1,
	label: labels.incomplete
},
{
	value: 2,
	label: labels.nomattersidentified
},
{
	value: 7,
	label: labels.restored
},
{
	value: 6,
	label: labels.notapplicable
}
];

export const independenceConfirmationStatus = {
	0: labels.undefined,
	1: labels.incomplete,
	2: labels.nomattersidentified,
	3: labels.matteridentifiedpendingaction,
	4: labels.matterresolveddeniedaccess,
	5: labels.matterresolvedgrantedaccess,
	6: labels.notapplicable,
	7: labels.restored,
	8: labels.override,
	9: labels.priornomattersidentified,
	10: labels.priormatteridentifiedpendingaction,
	11: labels.priormatterresolvedgrantedaccess,
	12: labels.priormatterresolveddeniedaccess
};

export const timePhaseTypes = {
	1: "範圍",
	2: "策略",
	3: "簡易測試(Walkthrough)",
	4: "期中控制測試",
	5: "期中證實測試",
	6: "簡易測試(Walkthrough)(年末流程)",
	7: "年末控制測試",
	8: "年末證實測試",
	9: "總結",
	10: "N/A",
	11: "執行",
	12: "Scope and strategy quality activities",
	13: "其他範圍及策略",
	14: "CRA",
	15: "風險分析及重大性",
	16: "最終完成範圍及策略",
	17: "期中過後案件管理"
};

export const engagementMetricsComingDueOptions = [{
	value: 1,
	label: "明天"
},
{
	value: 3,
	label: "3日後"
},
{
	value: 5,
	label: "5日後",
	isDefault: true
},
{
	value: 10,
	label: "10日後"
},
{
	value: 30,
	label: "30日後",
	isMax: true
}
];

export const engagementMetricsWhatsNewOptions = [{
	value: 1,
	label: "昨天"
},
{
	value: 3,
	label: "3日前"
},
{
	value: 5,
	label: "5日前",
	isDefault: true
},
{
	value: 10,
	label: "10日前",
	isMax: true
}
];

export const engagementMetricsDisplayedAttributes = {
	preparer: "進行編製",
	forMyReview: "進行複核",
	upcomingReview: "即將複核",
	reviewNotesAssigned: "給我的註記",
	reviewNotesAuthored: "我下的註記",
	partnerTasks: "會計師任務",
	eqrTasks: "EQR任務",
	timephases: "時段",
	groupTasks: "集團任務",
	groupDeliverables: "Group deliverables",
	automation: "Automation",
	requests: "請求"
};

export const quickLinks = {
	linkAccountSummary: "Accounts summary",
	linkScotSummary: "SCOTs summary",
	linkITSummary: "IT summary",
	linkCRASummary: "CRA summary",
	linkGAStructureSummary: "Group structure summary",
	linkGAInstrcutionSummary: "Group instructions summary",
	linkSEM: "Substantive evaluation matrix",
	linkAuditPlan: "查核計畫",
	linkWorkPlan: "工作計畫",
	linkITProcessEvaluation: "IT評估",

	linkGeneral: "一般",
	linkScots: "SCOT",
	linkITSO: "IT/SO",
	linkAccounts: "科目",
	linkResponseTask: "回應任務",
	linkWrapupEngagement: "完成案件",
	linkArchive: "歸檔檢查表"
};

export const customKeyEvents = {
	reportDate: "報告日",
	endDatePeriodCovered: "涵蓋期間結束日",
	archiveDeadlineDate: "歸檔期限日期"
};

export const filterReviewNoteStatus = [{
	value: filters.reviewNoteStatus.open,
	label: "開啟"
},
{
	value: filters.reviewNoteStatus.cleared,
	label: "Cleared"
},
{
	value: filters.reviewNoteStatus.closed,
	label: "關閉"
}
];

export const filterFileExtension = [{
	value: filters.fileExtension.canvasForm,
	label: "Canvas表單"
},
{
	value: filters.fileExtension.email,
	label: "電子郵件"
},
{
	value: filters.fileExtension.excel,
	label: "Excel"
},
{
	value: filters.fileExtension.paperProfile,
	label: "紙本檔案"
},
{
	value: filters.fileExtension.pdf,
	label: "PDF"
},
{
	value: filters.fileExtension.powerPoint,
	label: 'PowerPoint'
},
{
	value: filters.fileExtension.smartAutomation,
	label: 'Smart Automation'
},
{
	value: filters.fileExtension.visio,
	label: "Visio"
},
{
	value: filters.fileExtension.word,
	label: "Word"
},
{
	value: filters.fileExtension.zip,
	label: "Zip"
},
{
	value: filters.fileExtension.other,
	label: "其他"
}
];

export const filterDocumentContent = [{
	value: filters.documentContent.trackedChanges,
	label: "追蹤修訂"
},
{
	value: filters.documentContent.comments,
	label: "註解"
},
{
	value: filters.documentContent.formulaError,
	label: "公式錯誤 (僅限Excel文件)"
},
{
	value: filters.documentContent.highlightsWordFilesOnly,
	label: "醒目提示 (僅限Word檔案)"
},
{
	value: filters.documentContent.hiddenSheets,
	label: "隱藏工作表"
},
{
	value: filters.documentContent.embeddedFiles,
	label: "嵌入文件"
},
{
	value: filters.documentContent.ProtectedFiles,
	label: "受保護"
},
{
	value: filters.documentContent.DocumentContentNotAvailable,
	label: "文件內容不可使用"
},
{
	value: filters.documentContent.DocumentsInCollaborationMode,
	label: "Documents in multi-user edit mode"
}
];

export const filterSharedEvidence = [{
	value: filters.sharedEvidence.source,
	label: "來源"
},
{
	value: filters.sharedEvidence.target,
	label: "目標"
}
];

export const filterFindings = [{
	value: filters.findings.misstatement,
	label: "不實表達"
},
{
	value: filters.findings.deficiency,
	label: "缺失"
}
];

export const filterSignoffRequirements = [{
	value: filters.signoffRequirements.picMandatory,
	label: "PIC強制的"
},
{
	value: filters.signoffRequirements.picTeamAssigned,
	label: "指定 PIC 團隊"
},
{
	value: filters.signoffRequirements.eqrMandatory,
	label: "EQR強制的"
},
{
	value: filters.signoffRequirements.eqrTeamAssigned,
	label: "EQR 團隊指派"
}
];

export const filterResponsiveToRisks = [{
	value: filters.responsiveToRisk.responsiveToSignificantRisk,
	label: "顯著風險"
},
{
	value: filters.responsiveToRisk.responsiveToFraudRisk,
	label: "舞弊風險"
},
{
	value: filters.responsiveToRisk.responsiveToHigherInherentRisk,
	label: "更高的固有風險"
}
];

export const filterMissingRelatedTask = [{
	value: filters.missingRelatedTask.picSignoffRequired,
	label: "需要 PIC 簽核"
},
{
	value: filters.missingRelatedTask.eqrSignoffRequired,
	label: "需要 EQR 簽核"
}
];

export const filterCanvasForms = [{
	value: filters.canvasForms.incompleteResponses,
	label: "未完成回覆"
},
{
	value: filters.canvasForms.unresolvedComments,
	label: "未解決註解"
}
];

export const documentChangeTypes = {
	0: "未選擇變更理由",
	1: "非行政變更",
	2: "當使用追蹤修訂功能時接受修改",
	3: "加入額外參照索引至已存在證據",
	4: "加入先前收到傳真或電子郵件函證回函之正本",
	5: "自訂變更",
	6: "完成 AP 表格和實質性角色評估",
	7: "刪除或捨棄被取代文件",
	8: "編製管理階層建議書",
	9: "於相關歸檔流程完成檢查表簽名",
	10: "分類、核對、並交叉索引最終文件",
	11: "When adjusted to the local time zone, the modification is on or before the report date (Americas only)"
};

export const documentChangeTypesOptions = [{
	value: 1,
	label: 'Non-administrative change'
},
{
	value: 2,
	label: 'Accepting revisions/comments when such functionalities were used'
},
{
	value: 3,
	label: "加入額外參照索引至已存在證據"
},
{
	value: 4,
	label: "加入先前收到傳真或電子郵件函證回函之正本"
},
{
	value: 5,
	label: "自訂變更"
},
{
	value: 6,
	label: "完成 AP 表格和實質性角色評估"
},
{
	value: 7,
	label: 'Deleting or discarding documentation that does not constitute audit evidence'
},
{
	value: 8,
	label: 'Preparing or adding documents that do not support our opinion'
},
{
	value: 9,
	label: "於相關歸檔流程完成檢查表簽名"
},
{
	value: 10,
	label: "分類、核對、並交叉索引最終文件"
},
{
	value: 12,
	label: "MEST only: 與修改證據相關之企業報告日晚於EY Canvas之報告日"
},
{
	value: 11,
	label: "When adjusted to the local time zone, the modification is on or before the report date (Americas only)"
}
];

export const FourFortyFilterTypes = [{
	id: 0,
	filterType: 'QuickFilter',
	name: "快速篩選",
	hasChild: false
},
{
	id: 1,
	filterType: 'TaskStatus',
	name: "任務狀態",
	hasChild: false
},
{
	id: 2,
	filterType: 'TaskType',
	name: "任務類型",
	hasChild: false
},
{
	id: 3,
	filterType: 'AssignedTo',
	name: "指派給",
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 4,
	filterType: 'OpenAssignment',
	name: "開啟指派事項",
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 5,
	filterType: 'AssignmentsUsersEngagementRoles',
	name: "開啟指派事項",
	hideDisplay: true,
	loadOptionsFromServer: true
},
{
	id: 6,
	filterType: 'ReviewNotesStatus',
	name: "複核註記狀態",
	hasChild: false
},
{
	id: 7,
	filterType: 'ReviewNotesAssignedTo',
	name: "複核註記指派給",
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 8,
	filterType: 'ReviewNotesCreatedBy',
	name: "複核註記建立由",
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 9,
	filterType: 'TimePhase',
	name: "時段",
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 10,
	filterType: 'Milestone',
	name: "里程碑",
	hasChild: false
},
{
	id: 11,
	filterType: 'AuditPhase',
	name: "查核階段",
	altName: "案件階段",
	hasChild: false
},
{
	id: 12,
	filterType: 'DocumentConflict',
	name: "文件衝突",
	hasChild: false
},
{
	id: 13,
	filterType: 'Findings',
	name: "發現",
	hasChild: false,
	hideForNonAudit: true
},
{
	id: 14,
	filterType: 'Entity',
	name: "企業",
	hasChild: false,
	loadOptionsFromServer: true,
	hideForNonMest: true
},
{
	id: 15,
	filterType: 'IsBookmarked',
	name: "下載離線",
	hasChild: false
}
];

/* Arc Timeline */
export const arcValidationGroups = [{
	id: 1,
	label: "Build Step 29 ???"
},
{
	id: 2,
	label: "Build Step 30 ???"
},
{
	id: 3,
	label: "SEM (Evaluation Matrix) ???"
},
{
	id: ArcTimelineGroups.FinalizeEvidence,
	label: "總結證據"
},
{
	id: ArcTimelineGroups.CompleteRemainingTasks,
	label: "完成剩餘任務"
},
{
	id: ArcTimelineGroups.ResolveValidations,
	label: "解決剩餘驗證檢查"
},
{
	id: 7,
	label: "準備歸檔"
},
{
	id: 8,
	label: "案件儀錶板"
},
{
	id: 9,
	label: "Canvas 表單 (個別)"
},
{
	id: 10,
	label: "Canvas 表單 (全部)"
}
];

export const checkListTypes = [{
	id: 7,
	label: "紙本檔案及資料夾定稿"
},
{
	id: 13,
	label: "確認關鍵案件日期正確性"
},
{
	id: 14,
	label: "確認案件編號正確性"
},
{
	id: 15,
	label: "確認客戶編號正確性"
},
{
	id: 10,
	label: "從集團內解除此案件連結"
},
{
	id: 16,
	label: "驗證報告類型"
},
{
	id: 17,
	label: "複核報告發布日後修改之暫存檔案"
},
{
	id: 18,
	label: "複核報告發布日後修改之刪除檔案"
},
{
	id: 19,
	label: "Ensure changes to the engagement profile are submitted"
},
{
	id: 20,
	label: "複核受保護的文件"
},
{
	id: 95,
	label: "指定整體負責人員"
}
];

export const arcValidationTypes = [{
	id: ArcTimeLineValidationTypes.DocumentConflict,
	label: "解決剩餘文件衝突"
},
{
	id: ArcTimeLineValidationTypes.DocumentsInMultiUserEditMode,
	label: "Documents in multi-user editing"
},
{
	id: ArcTimeLineValidationTypes.DocumentsWithIsProtected,
	label: "複核受保護的文件"
},
{
	id: ArcTimeLineValidationTypes.DocumentIsNotFinalized,
	label: "文件內容不可使用"
},
{
	id: ArcTimeLineValidationTypes.AddressAllOpenReviewNotes,
	label: "關閉所有未解決複核註記"
},
{
	id: ArcTimeLineValidationTypes.RemoveTrackedChangesFromEvidence,
	label: "從證據移除追蹤修訂"
},
{
	id: ArcTimeLineValidationTypes.FinalizeSmartAutomationEvidenceFiles,
	label: "完成智慧自動化證據資料"
},
{
	id: ArcTimeLineValidationTypes.FinalizeCompleteAllPICSignoffRequirements,
	label: "完成所有 PIC 簽名要求"
},
{
	id: ArcTimeLineValidationTypes.FinalizeCompleteAllEQRSignoffRequirements,
	label: "完成所有 EQR 簽名要求"
},
{
	id: ArcTimeLineValidationTypes.PICEvidenceWithoutAtLeastOneRelatedPICTask,
	label: "將 PIC 文件與 PIC 任務相連結"
},
{
	id: ArcTimeLineValidationTypes.EQREvidenceWithoutAtLeastOneRelatedEQRTask,
	label: "將 EQR 文件與 EQR 任務相連結"
},
{
	id: ArcTimeLineValidationTypes.EvidencemissingSignoffs,
	label: "於所有證據簽名"
},
{
	id: ArcTimeLineValidationTypes.CanvasFormComment,
	label: "解決Canvas表單註解"
},
{
	id: ArcTimeLineValidationTypes.UnlinkedSharedEvidence,
	label: "取消連結共享證據"
},
{
	id: ArcTimeLineValidationTypes.TaskswithoutEvidence,
	label: "加入證據以開啟任務"
},
{
	id: ArcTimeLineValidationTypes.PICTaskWithoutAtLeastOneRelatedPICEvidence,
	label: "驗證所有 PIC 任務都包含 PIC 文件"
},
{
	id: ArcTimeLineValidationTypes.EQRTaskWithoutAtLeastOneRelatedEQREvidence,
	label: "驗證所有 EQR 任務都包含 EQR 文件"
},
{
	id: ArcTimeLineValidationTypes.RelateEvidenceToEntityTask,
	label: "Relate evidence to entity task"
},
{
	id: ArcTimeLineValidationTypes.MarkTasksComplete,
	label: "標示任務為完成"
},
{
	id: ArcTimeLineValidationTypes.AccountsSummary,
	label: "Accounts summary"
},
{
	id: ArcTimeLineValidationTypes.ScotSummary,
	label: "SCOTs summary"
},
{
	id: ArcTimeLineValidationTypes.CraSummary,
	label: "CRA summary"
},
{
	id: ArcTimeLineValidationTypes.ITSummary,
	label: "IT summary"
},
{
	id: ArcTimeLineValidationTypes.ConfirmAccuracyOfAuditorReport,
	label: "確認會計師報告正確性"
},
{
	id: ArcTimeLineValidationTypes.CompleteArchiveForm,
	label: "完成歸檔表單"
},
{
	id: ArcTimeLineValidationTypes.CompleteArchiveTask,
	label: "完成歸檔任務"
},
{
	id: ArcTimeLineValidationTypes.UnlinkGroupSharedEvidence,
	label: "取消連結集團共享證據"
},
{
	id: ArcTimeLineValidationTypes.AuditPlan,
	label: "查核計畫"
},
{
	id: ArcTimeLineValidationTypes.UnassociateFinding,
	label: "未連結發現"
},
{
	id: ArcTimeLineValidationTypes.IndependenceCompliance,
	label: "獨立性遵循"
},
{
	id: ArcTimeLineValidationTypes.IncompleteCanvasFormResponses,
	label: "未完成之Canvas表單回覆定稿"
},
{
	id: ArcTimeLineValidationTypes.WCGWwithNoRelatedsubstantivetask,
	label: "Substantive evaluation matrix"
},
{
	id: ArcTimeLineValidationTypes.ITEvaluation,
	label: "IT評估"
},
{
	id: ArcTimeLineValidationTypes.DocumentModifiedAfterReportReleaseDate,
	label: "文件修改於報告發布日後"
},
{
	id: ArcTimeLineValidationTypes.DuplicateFileNames,
	label: "重新命名具有重複文件名稱的證據文件"
},
{
	id: ArcTimeLineValidationTypes.ITFlowCanvasForm,
	label: 'IT Flow'
},
{
	id: ArcTimeLineValidationTypes.AdjustmentsModule,
	label: "Adjustments"
},
{
	id: ArcTimeLineValidationTypes.CanvasFormsWithNoContent,
	label: "複核無內容之Canvas表單"
},
{
	id: ArcTimeLineValidationTypes.PersonInCharge,
	label: "負責人員"
},
{
	id: ArcTimeLineValidationTypes.EstimateAccountWithoutEstimatePSPindex,
	label: ''
},
{
	id: ArcTimeLineValidationTypes.TempFilesWithPreparerAndReviewerSignoffsError,
	label: "複核具有編製者和複核者簽核的暫存文件，以查找應包含在證據中或刪除的文件"
},
{
	id: ArcTimeLineValidationTypes.TemporaryFilesWithPICRequirementUserOrKnowledge,
	label: "請複核具有 PIC 標籤的暫存檔案，以確定應包含在證據中的文件或刪除標籤。"
},
{
	id: ArcTimeLineValidationTypes.TemporaryFileWithEQRRequirementUserOrKnowledge,
	label: "請複核具有 EQR 標籤的暫存檔案，以確定應包含在證據中的文件或刪除標籤。"
},
{
	id: ArcTimeLineValidationTypes.DeletedFilesWithPICRequirementUserOnly,
	label: "請複核具有 PIC 標籤的暫存檔案，以確定應包含在證據中的文件或刪除標籤。"
},
{
	id: ArcTimeLineValidationTypes.DeletedFilesWithEQRRequirementUserOnly,
	label: "請複核具有 EQR 標籤的暫存檔案，以確定應包含在證據中的文件或刪除標籤。"
},
{
	id: ArcTimeLineValidationTypes.DocumentAssociatedToInvalidObject,
	label: "與案件中已不再存在的項目相關的文件"
}
];

export const ArchiveErrors = {
	32204: "案件中有任務沒有證據。",
	32209: "案件中Canvas表單有未完成的回覆。",
	32210: "案件中有未解決的複核註記。",
	32212: "案件中有未完成的任務。",

	32402: "歸檔ID為零或空白。",
	32403: "檔案GUID為零或空白。",
	32404: "ARC FileStoreHost為零或空白。",
	32424: "主要案件編號遺失或無效。",
	32425: "報告發布日期不可為未來日期。",
	32426: "報告發布日期必須在案件結束日後。",
	32427: "會計師必須被邀請至該案件。",
	32428: "ARC於工作底稿類型遺失資料。",
	32429: "歸檔表單之報告類型選擇為必要。",
	32430: "歸檔表單中修正式報告之選擇為必要。",
	32431: "由於與ARC整合導致歸檔流程發生錯誤。請聯絡Help Desk以通報此錯誤。"
};

export const validationTypes = [{
	id: 1,
	label: "未完成之獨立性遵循",
	altLabel: "Incomplete form",
	errorLabel: "獨立性遵循尚未完成"
},
{
	id: 2,
	label: "獨立性表單非最新版本",
	altLabel: "Out of date form",
	errorLabel: "獨立性表單版本並非最新"
},
{
	id: 3,
	label: "由不適當的角色允許登入",
	altLabel: "Not approved by PPEDD",
	errorLabel: "由無資格角色授予存取權限"
},
{
	id: 4,
	label: "由不適當的角色進行覆蓋",
	altLabel: "Not overridden by PPEDD",
	errorLabel: "由無資格角色踰越"
},
{
	id: 5,
	label: "未連結之SCOTs (無科目)",
	errorLabel: "未連結之SCOT"
},
{
	id: 6,
	label: "未連結之控制 (無WCGW)",
	errorLabel: "未連結之控制"
},
{
	id: 7,
	label: "所選控制策略無相關WCGWs",
	errorLabel: "所選控制策略無相關WCGW"
},
{
	id: 8,
	label: "所選控制策略無相關控制",
	errorLabel: "所選控制策略無相關控制"
},
{
	id: 9,
	label: "所選控制策略無相關控制選作測試",
	errorLabel: "所選控制策略無相關選擇測試之控制"
},
{
	id: 10,
	label: "選擇控制策略且WCGW無相關控制選作測試",
	errorLabel: "選擇控制策略卻有WCGW無相關選擇測試之控制"
},
{
	id: 11,
	label: "未連結之風險",
	errorLabel: "未連結之風險"
},
{
	id: 12,
	label: "完成此聲明之CRA",
	errorLabel: "完成此聲明之CRA"
},
{
	id: 13,
	label: "未連結之WCGWs",
	errorLabel: "未連結之WCGW"
},
{
	id: 14,
	label: "重大科目無相關SCOTs",
	errorLabel: "重大科目無相關SCOT"
},
{
	id: 15,
	label: "所選仰賴策略無相關WCGWs",
	errorLabel: "所選仰賴策略無相關WCGW"
},
{
	id: 16,
	label: "所選仰賴策略無相關控制",
	errorLabel: "所選仰賴策略無相關控制"
},
{
	id: 17,
	label: "所選仰賴策略無相關控制選作測試",
	errorLabel: "所選仰賴策略無相關選擇測試之控制"
},
{
	id: 18,
	label: "選擇仰賴策略且WCGW無相關控制選作測試",
	errorLabel: "選擇仰賴策略卻有WCGW無相關選擇測試之控制"
},
{
	id: 19,
	label: "未連結之IT App/SO",
	errorLabel: "未連結之IT App/SO"
},
{
	id: 20,
	label: "未連結之控制 / IT證實程序",
	errorLabel: "未連結的控制/IT證實程序(ITSP)"
},
{
	id: 21,
	label: "無相關IT App/SO",
	errorLabel: "無相關的IT App/SO"
},
{
	id: 22,
	label: "無相關風險",
	errorLabel: "無相關風險"
},
{
	id: 23,
	label: "無相關控制 / IT證實程序",
	errorLabel: "無相關控制/IT證實程序(ITSP)"
},
{
	id: 24,
	label: "無相關控制 / IT證實程序選作測試",
	errorLabel: "無相關選擇測試的控制/IT證實程序(ITSP)"
},
{
	id: 25,
	label: "風險無相關控制 / IT證實程序選作測試",
	errorLabel: "有一個風險無相關選擇測試的控制/IT證實程序(ITSP)"
},
{
	id: 26,
	label: "有限風險科目無任何相關證實任務",
	errorLabel: "有限風險科目沒有任何相關的證實任務"
},
{
	id: 27,
	label: "無證實任務連結至聲明",
	errorLabel: "無證實任務連結至該聲明"
},
{
	id: 28,
	label: "未連結之TOC",
	errorLabel: "未連結的TOC"
},
{
	id: 29,
	label: "未連結之簡易測試(Walkthrough)",
	errorLabel: "未連結的Walkthrough"
},
{
	id: 30,
	label: "無簡易測試(Walkthrough)任務連結至SCOT",
	errorLabel: "無Walkthrough任務連結至該SCOT"
},
{
	id: 31,
	label: "無控制任務連結至選作測試之控制",
	errorLabel: "無控制任務連結至所選擇要測試之控制"
},
{
	id: 32,
	label: "未連結之IT/SO簡易測試(Walkthrough)",
	errorLabel: "未連結之IT/SO Walkthrough"
},
{
	id: 33,
	label: "未連結之IT/SO TOC",
	errorLabel: "未連結之IT/SO TOC"
},
{
	id: 34,
	label: "未連結之IT/SO OSP",
	errorLabel: "未連結之IT/SO OSP"
},
{
	id: 35,
	label: "IT/SO流程無相關簡易測試(walkthrough)任務",
	errorLabel: "該IT/SO流程沒有相關的walkthrough任務"
},
{
	id: 36,
	label: "控制無相關TOC",
	errorLabel: "控制沒有相關的TOC"
},
{
	id: 37,
	label: "IT證實程序無相關OSP",
	errorLabel: "IT證實程序沒有相關的OSP"
},
{
	id: 38,
	label: "文件衝突",
	errorLabel: "未解決之衝突"
},
{
	id: 39,
	label: "同步衝突 - 共享證據 - Canvas未顯示驗證檢查",
	errorLabel: "共享證據-同步衝突"
},
{
	id: 40,
	label: "證據沒有簽名",
	errorLabel: "簽核所有證據"
},
{
	id: 41,
	label: "任務沒有證據",
	errorLabel: "新增證據至未完成任務"
},
{
	id: 42,
	label: "無效的案件編號",
	errorLabel: "無效的案件編號"
},
{
	id: 43,
	label: "無效的客戶編號",
	errorLabel: "無效的客戶編號"
},
{
	id: 44,
	label: "重複的檔案名稱",
	errorLabel: "重複的檔案名稱"
},
{
	id: 45,
	label: "不一致的IT評估",
	errorLabel: "IT 流程評估不完整"
},
{
	id: 46,
	label: "IT 流程評估不完整",
	errorLabel: "IT 流程評估不完整"
},
{
	id: 47,
	label: "未完成綜合IT評估",
	errorLabel: "未完成的綜合IT評估"
},
{
	id: 48,
	label: "回應未完成",
	errorLabel: "支持理由未完成"
},
{
	id: 49,
	label: "未連結之不實表達",
	errorLabel: "未連結之不實表達"
},
{
	id: 50,
	label: "未連結之缺失",
	errorLabel: "未連結之缺失"
},
{
	id: 51,
	label: "WCGW無相關證實任務",
	errorLabel: "WCGW沒有相關的證實任務"
},
{
	id: 52,
	label: "風險無相關WCGW",
	errorLabel: "風險沒有WCGW"
},
{
	id: 53,
	label: "估計科目無估計PSP index",
	errorLabel: "估計科目沒有估計PSP index"
},
{
	id: 54,
	label: "估計科目無估計SCOT",
	errorLabel: "估計科目沒有估計SCOT"
},
{
	id: 55,
	label: "估計SCOT無估計科目",
	errorLabel: "估計SCOT沒有估計科目"
},
{
	id: 56,
	label: "仰賴控制風險聲明無回應之TOC",
	errorLabel: "控制風險為仰賴的聲明沒有回應的TOC"
},
{
	id: 57,
	label: "仰賴控制風險聲明無至少一個回應之TOC、連結至非較低風險且回應該等風險之設計有效控制",
	errorLabel: "控制風險為仰賴的聲明沒有至少一個回應的TOC連結至設計有效非較低風險且回應至該風險之控制"
},
{
	id: 58,
	label: "聲明無回應之證實任務",
	errorLabel: "聲明沒有回應的證實任務"
},
{
	id: 59,
	label: "聲明無回應之控制",
	errorLabel: "聲明沒有回應的控制"
},
{
	id: 60,
	label: "Canvas表單註解",
	errorLabel: "Canvas表單註解"
},
{
	id: 61,
	label: "Canvas表單不完整的回應",
	errorLabel: "Canvas表單不完整的回應"
},
{
	id: 62,
	label: "應關閉或刪除的開啟或清除的複核註記",
	errorLabel: "應關閉或刪除的開啟或清除的複核註記"
},
{
	id: 63,
	label: "有追蹤修訂的證據",
	errorLabel: "有追蹤修訂的證據"
},
{
	id: 64,
	label: "未標示為完成之任務",
	errorLabel: "標記任務為完成"
},
{
	id: 65,
	label: "共享證據未取消連結",
	errorLabel: "解除連結的共享證據"
},
{
	id: 66,
	label: "文件未選擇修改類型",
	errorLabel: "文件沒有選擇修正類型"
},
{
	id: 67,
	label: "無變更原因的非行政變更（基本理由）",
	errorLabel: "無變更原因的非行政變更（基本理由）"
},
{
	id: 68,
	label: "非行政變更未由適當角色核准修改",
	errorLabel: "由適當角色進行的非行政變更非授權修正"
},
{
	id: 69,
	label: "440 GL missing executive reviewer sign-off",
	errorLabel: "440 GL欠缺高階複核者之簽名"
},
{
	id: 70,
	label: "尚未解除關聯的團體案件",
	errorLabel: "自集團將此案件解除連結"
},
{
	id: 71,
	label: "沒有任何標題的Canvas表單",
	altLabel: "沒有任何標題的Canvas表單",
	errorLabel: "沒有任何標題的Canvas表單"
},
{
	id: 72,
	label: "集團組成個體彙總文件缺少內容",
	errorLabel: "集團組成個體彙總文件缺少內容"
},
{
	id: 73,
	label: "不完整的 Canvas 表單響應，無論是否獲得批准",
	errorLabel: "未完成Canvas表單"
},
{
	id: 74,
	label: "配置文件 V2 更改未提交",
	errorLabel: "Profile變更未提交"
},
{
	id: 75,
	label: "0 byte電子檔案",
	errorLabel: "0 byte電子檔案"
},
{
	id: 76,
	label: "Independence form edited after submission",
	altLabel: "Form not submitted",
	errorLabel: "獨立性表單於提交後被編輯"
},
{
	id: 77,
	label: "獨立性範本與個體不同",
	altLabel: "獨立性範本與個體不同",
	errorLabel: "獨立性範本與個體不同"
},
{
	id: 78,
	label: "IT應用系統(非SO)沒有至少一個相關的IT流程",
	errorLabel: "未連結的IT應用系統"
},
{
	id: 79,
	label: "ITGC沒有相關的IT風險或連結至HasNoITGC = 1的IT風險",
	errorLabel: "未連結的ITGC"
},
{
	id: 80,
	label: "ITSP沒有相關的IT風險",
	errorLabel: "未連結的ITSP"
},
{
	id: 81,
	label: "IT流程沒有相關的IT應用系統",
	errorLabel: "未連結的IT流程"
},
{
	id: 82,
	label: "IT流程無IT風險卻透過IT應用系統連結了ITAC或ITDM(且非例外狀況)",
	errorLabel: "缺少IT風險"
},
{
	id: 83,
	label: "IT風險 (HasNoITGC = 0) 沒有相關的ITGC",
	errorLabel: "缺少ITGC或標記為不存在"
},
{
	id: 84,
	label: "ITDM/ITAC沒有相關的IT應用系統",
	errorLabel: "應用系統/ITDM控制沒有IT應用系統"
},
{
	id: 85,
	label: "ITSP並未被刪除當相對應之內文未被顯示",
	errorLabel: "ITSP將被刪除"
},
{
	id: 86,
	label: "ITGC並未被刪除當相對應之內文未被顯示",
	errorLabel: "ITGC將被刪除"
},
{
	id: 87,
	label: "IT風險並未被刪除當相對應之內文未被顯示",
	errorLabel: "IT風險將被刪除"
},
{
	id: 88,
	label: "HasITControlTesting = 1的ITGC存在當相對應之內文未被顯示",
	errorLabel: "ITGC使用無效之測試策略"
},
{
	id: 89,
	label: "ITGC沒有所選擇之設計有效性",
	errorLabel: "欠缺ITGC設計評估"
},
{
	id: 90,
	label: "控制沒有所選擇之設計有效性",
	errorLabel: "控制沒有所選擇之設計有效性"
},
{
	id: 91,
	label: "SCOT沒有IT應用系統當HasNoITApplication = 0",
	errorLabel: "取消連結SCOT"
},
{
	id: 92,
	label: "Substantive procedures and tests of controls that are responsive to a significant risk but not to the risk's related WCGW",
	errorLabel: "不一致的風險任務關係與風險 > WCGW > 任務關係"
},
{
	id: 93,
	label: "對於測試控制有不一致的回覆",
	errorLabel: "對於測試控制有不一致的回覆"
},
{
	id: 94,
	label: "HasNoITApplication = 0的SCOT有 ITDM或AC",
	errorLabel: "SCOT缺少IT應用系統"
},
{
	id: 95,
	label: "尚未有團隊成員被指派全面負責",
	altLabel: "尚未有團隊成員被指派全面負責",
	errorLabel: "尚未有團隊成員被指派全面負責"
},
{
	id: 96,
	label: "風險因子未連結至任何一個風險或未被標記為非ROMM",
	errorLabel: "風險因子未連結至任何一個風險或未被標記為非ROMM"
},
{
	id: 97,
	label: "Risks unrelated to an Assertion",
	errorLabel: "Risks unrelated to an Assertion"
},
{
	id: 98,
	label: "未完成的衡量基礎預測金額",
	errorLabel: "未完成的衡量基礎預測金額"
},
{
	id: 99,
	label: "未完成衡量基礎預測金額之理由",
	errorLabel: "未完成衡量基礎預測金額之理由"
},
{
	id: 100,
	label: "未完成的衡量基礎調整後金額",
	errorLabel: "未完成的衡量基礎調整後金額"
},
{
	id: 101,
	label: "未完成的規劃重大性(PM)",
	errorLabel: "未完成的規劃重大性(PM)"
},
{
	id: 102,
	label: "規劃重大性(PM)超過上限金額",
	errorLabel: "規劃重大性(PM)超過上限金額"
},
{
	id: 103,
	label: "未完成規劃重大性(PM)之理由",
	errorLabel: "未完成規劃重大性(PM)之理由"
},
{
	id: 104,
	label: "未完成的可容忍錯誤(TE)",
	errorLabel: "未完成的可容忍錯誤(TE)"
},
{
	id: 105,
	label: "TE未設定在可允許值之範圍內",
	errorLabel: "TE未設定在可允許值之範圍內"
},
{
	id: 106,
	label: "未完成可容忍錯誤(TE)之理由",
	errorLabel: "未完成可容忍錯誤(TE)之理由"
},
{
	id: 107,
	label: "未完成的SAD",
	errorLabel: "未完成的SAD"
},
{
	id: 108,
	label: "SAD超過上限",
	errorLabel: "SAD超過上限"
},
{
	id: 109,
	label: "未完成SAD之理由",
	errorLabel: "未完成SAD之理由"
},
{
	id: 110,
	label: "未完成PACE選擇",
	errorLabel: "未完成PACE選擇"
},
{
	id: 111,
	label: "無相關文件",
	errorLabel: "無相關文件"
},
{
	id: 112,
	label: "沒有至少一項跟 PIC 相關的證據的 PIC 任務",
	errorLabel: "沒有至少一項跟 PIC 相關的證據的 PIC 任務"
},
{
	id: 113,
	label: "沒有至少一項跟 EQR 相關的證據的 EQR 任務",
	errorLabel: "沒有至少一項跟 EQR 相關的證據的 EQR 任務"
},
{
	id: 114,
	label: "沒有至少一項跟 PIC 任務相關的 PIC 證據",
	errorLabel: "沒有至少一項跟 PIC 任務相關的 PIC 證據"
},
{
	id: 115,
	label: "沒有至少一項跟 EQR 任務相關的 EQR 證據",
	errorLabel: "沒有至少一項跟 EQR 任務相關的 EQR 證據"
},
{
	id: 116,
	label: "沒有至少一個 PIC 簽核的 PIC 證據",
	errorLabel: "沒有至少一個 PIC 簽核的 PIC 證據"
},
{
	id: 117,
	label: "沒有至少一個 EQR 簽核的 EQR 證據",
	errorLabel: "沒有至少一個 EQR 簽核的 EQR 證據"
},
{
	id: 118,
	label: "不應歸檔的證據仍然存在",
	errorLabel: "不應歸檔的證據仍然存在"
},
{
	id: 119,
	label: "有編製者和複核者簽核的暫存檔案",
	errorLabel: "有編製者和複核者簽核的暫存檔案"
},
{
	id: 120,
	label: "所有開啟或清除的Canvas表單註解",
	errorLabel: "所有開啟或清除的Canvas表單註解"
},
{
	id: 121,
	label: "具有 PIC 要求的暫存檔案",
	errorLabel: "具有 PIC 要求的暫存檔案"
},
{
	id: 122,
	label: "具有 EQR 要求的暫存檔案",
	errorLabel: "具有 EQR 要求的暫存檔案"
},
{
	id: 123,
	label: "已刪除具有 PIC 要求的文件",
	errorLabel: "已刪除具有 PIC 要求的文件"
},
{
	id: 124,
	label: "已刪除具有 EQR 要求的文件",
	errorLabel: "已刪除具有 EQR 要求的文件"
},
{
	id: 125,
	label: "Review protected documents",
	errorLabel: "Review protected documents"
},
{
	id: 126,
	label: "文件內容不可用",
	errorLabel: "文件內容不可用"
},
{
	id: 127,
	label: "無資料的損益表",
	errorLabel: "無資料的損益表"
},
{
	id: 128,
	label: "無資料的資產負債表",
	errorLabel: "無資料的資產負債表"
},
{
	id: 129,
	label: "多個體 - 多個體並未與所有相關科目的PSP / ACT有所關聯",
	errorLabel: "多個體 - 多個體並未與所有相關科目的PSP / ACT有所關聯"
},
{
	id: 130,
	label: "沒有單獨風險評估表單的科目",
	errorLabel: "沒有單獨風險評估表單的科目"
},
{
	id: 131,
	label: "Estimate without Estimate documentation",
	errorLabel: "Estimate without Estimate documentation"
},
{
	id: 132,
	label: "沒有單獨分析表單的科目",
	errorLabel: "沒有單獨分析表單的科目"
},
{
	id: 133,
	label: "沒有基本資料表單的多個體",
	errorLabel: "沒有基本資料表單的多個體"
},
{
	id: 134,
	label: "科目 - AccountTypeID 與操作不相應",
	errorLabel: "科目 - AccountTypeID 與操作不相應"
},
{
	id: 135,
	label: "科目 - HasEstimate 與操作不相應",
	errorLabel: "科目 - HasEstimate 與操作不相應"
},
{
	id: 136,
	label: "科目 - 科目表單選項具有與科目無關的相關風險",
	errorLabel: "科目 - 科目表單選項具有與科目無關的相關風險"
},
{
	id: 137,
	label: "科目 - 較高固有風險聲明，無相關 IsHigherRisk 風險",
	errorLabel: "科目 - 較高固有風險聲明，無相關 IsHigherRisk 風險"
},
{
	id: 138,
	label: "多個體 - 多個體的相關科目未有任何相關的證實程序",
	errorLabel: "多個體 - 多個體的相關科目未有任何相關的證實程序"
},
{
	id: 139,
	label: "沒有集團參與表單的組成個體（不包括僅供參考的組成個體）",
	errorLabel: "沒有集團參與表單的組成個體（不包括僅供參考的組成個體）"
},
{
	id: 140,
	label: "沒有相關集團風險評估說明的組成個體（完整/特定）（不包括僅供參考的組成個體）",
	errorLabel: "沒有相關集團風險評估說明的組成個體（完整/特定）（不包括僅供參考的組成個體）"
},
{
	id: 141,
	label: "MultiEntity - Account without any related MultiEntity",
	errorLabel: "MultiEntity - Account without any related MultiEntity"
},
{
	id: 142,
	label: "Document.SmartEvidenceSourceID associated to an invalid object",
	errorLabel: "Document.SmartEvidenceSourceID associated to an invalid object"
},
{
	id: 143,
	label: "科目 - 較高固有風險聲明，無相關 IsHigherRisk 風險",
	errorLabel: "科目 - 較高固有風險聲明，無相關 IsHigherRisk 風險"
},
{
	id: 144,
	label: "Group - Accounts (Executed in other engagements) without a related Component",
	errorLabel: "Group - Accounts (Executed in other engagements) without a related Component"
},
{
	id: 145,
	label: "Account - Estimate Account without estimate PSP index",
	errorLabel: "Account - Estimate Account without estimate PSP index"
},
{
	id: 146,
	label: "MultiEntity - MultiEntity Individual Profile Change Not Submited (Individual Document)",
	errorLabel: "MultiEntity - MultiEntity Individual Profile Change Not Submited (Individual Document)"
},
{
	id: 147,
	label: "MultiEntity - MultiEntity Individual Profile Change Not Submited (Individual Document)",
	errorLabel: "MultiEntity - MultiEntity Individual Profile Change Not Submited (Individual Document)"
},
{
	id: 148,
	label: "Account - Incomplete or invalid account properties",
	errorLabel: "Account - Incomplete or invalid account properties"
},
{
	id: 149,
	label: "Document Upload - Missing required PIC/EQR Sign-offs",
	errorLabel: "Document Upload - Missing required PIC/EQR Sign-offs"
},
{
	id: 150,
	label: "Document Upload - Missing required PIC/EQR Sign-off Requirements",
	errorLabel: "Document Upload - Missing required PIC/EQR Sign-off Requirements"
},
{
	id: 151,
	label: "Account - Significant Account / Disclosure without any related assertions",
	errorLabel: "Account - Significant Account / Disclosure without any related assertions"
},
{
	id: 152,
	label: "Document upload - Missing Preparer or Reviewer Sign-offs",
	errorLabel: "Document upload - Missing Preparer or Reviewer Sign-offs"
},
{
	id: 153,
	label: "Adjustment without any evidence",
	errorLabel: "Adjustment without any evidence"
},
{
	id: 154,
	label: "Estimate without account related",
	errorLabel: "Estimate without account related"
},
{
	id: 155,
	label: "Higher/Lower risk estimate related to non-estimate account",
	errorLabel: "Higher/Lower risk estimate related to non-estimate account"
},
{
	id: 156,
	label: "Estimate category response not aligned to designation in 'Edit estimate'",
	errorLabel: "Estimate category response not aligned to designation in 'Edit estimate'"
},
{
	id: 157,
	label: "Estimate without valid SCOT",
	errorLabel: "Estimate without valid SCOT"
},
{
	id: 158,
	label: "Account without valid estimate",
	errorLabel: "Account without valid estimate"
},
{
	id: 159,
	label: "Estimate account without Higher or Lower risk Estimate",
	errorLabel: "Estimate account without Higher or Lower risk Estimate"
},
{
	id: 160,
	label: "Estimate SCOT without Higher or Lower risk Estimate",
	errorLabel: "Estimate SCOT without Higher or Lower risk Estimate"
},
{
	id: 161,
	label: "Adjustments that do not net",
	errorLabel: "Adjustments that do not net"
},
{
	id: 162,
	label: "Higher risk estimate without valid risk related",
	errorLabel: "Higher risk estimate without valid risk related"
},
{
	id: 163,
	label: "Document - Document checked out or in the process of being checked out for collaboration",
	errorLabel: "Document - Document checked out or in the process of being checked out for collaboration"
},
{
	id: 164,
	label: "Non-Engagement wide tasks missing evidence",
	errorLabel: "Non-Engagement wide tasks missing evidence"
},
{
	id: 165,
	label: "EP or EQR Signoff requirement does not match response",
	errorLabel: "EP or EQR Signoff requirement does not match response"
},
{
	id: 166,
	label: "Significant/Fraud risk related to an estimate that is not a Higher risk",
	errorLabel: "Significant/Fraud risk related to an estimate that is not a Higher risk"
}
];

export const contentType = {
	1: "主要標準任務 (PSTs)",
	2: "主要證實程序索引 (PSP index)",
	3: "主要證實程序 (PSPs)",
	4: "集團查核聯絡書",
	5: "methodology規定為必要之Canvas表單",
	6: "Canvas 表單由使用者建立 (例如: SCOT form)",
	7: "獨立性",
	9: "Profile",
	10: 'Canvas maps'
};

export const contentTypeByName = {
	'PST': "主要標準任務 (PSTs)",
	'PSPIndex': "主要證實程序Index (PSP index)",
	'PSP': "主要證實程序 (PSPs)",
	'GAInstructions': "集團查核指示函",
	'CanvasFormKnowledge': "來自Knowledge之Canvas表單",
	'CanvasFormUserAdded': "由使用者建立之Canvas表單(例如：SCOT表單)",
	'IndependenceForm': "獨立性",
	'Profile': "Profile",
	'Maps': 'Canvas maps'
};

export const reportTypes = {
	1: "無保留 - 有強調事項段",
	2: "無保留 - 無強調事項段",
	3: "保留 - 有強調事項段",
	4: "保留 - 無強調事項段",
	5: "否定意見 - 有強調事項段",
	6: "否定意見 - 無強調事項段",
	7: "無法表示意見 - 有強調事項段",
	8: "無法表示意見 - 無強調事項段",
	100: "無",
	101: "不適用",
	102: "未選擇"
};

export const internalUserRoles = [{
	roleKey: 3,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "權限",
	roleNameUI: "歸檔案件",
	displayName: "歸檔案件",
	roleDisplayOrder: 2,
	tooltipText: "可歸檔案件"
},
{
	roleKey: 4,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "權限",
	roleNameUI: "管理案件",
	displayName: "Administer engagement",
	roleDisplayOrder: 1,
	tooltipText: "可邀請內部及外部成員並指派內部成員之許可"
},
{
	roleKey: 5,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "權限",
	roleNameUI: "更新內容",
	displayName: "更新內容",
	roleDisplayOrder: 6,
	tooltipText: "可編輯基本資料並接受內容更新"
},
{
	roleKey: 7,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "權限",
	roleNameUI: "建立服務請求",
	displayName: "Manage service requests",
	roleDisplayOrder: 4,
	tooltipText: "Ability to create service requests and mark service requests complete"
},
{
	roleKey: 8,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "權限",
	roleNameUI: "管理集團",
	displayName: "Manage group",
	roleDisplayOrder: 5,
	tooltipText: "接受或拒絕從主要或區域團隊收到的集團指引"
},
{
	roleKey: 9,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "權限",
	roleNameUI: "複製、後推、還原歸檔案件",
	displayName: "複製、後推、還原歸檔案件",
	roleDisplayOrder: 3,
	tooltipText: "能夠複製案件、後推和還原其歸檔",
},
{
	roleKey: 0,
	sectionId: 1,
	groupDisplayOrder: 200,
	groupName: "機密",
	roleNameUI: "預設",
	displayName: "None (Default)",
	roleDisplayOrder: 1,
	tooltipText: "Default Confidential Documents Role"
},
{
	roleKey: 10,
	sectionId: 1,
	groupDisplayOrder: 200,
	groupName: "機密",
	roleNameUI: "低",
	displayName: "低",
	roleDisplayOrder: 8,
	tooltipText: "低度機密文件角色"
},
{
	roleKey: 11,
	sectionId: 1,
	groupDisplayOrder: 200,
	groupName: "機密",
	roleNameUI: "高",
	displayName: "高",
	roleDisplayOrder: 10,
	tooltipText: "高度機密文件角色"
},
{
	roleKey: 12,
	sectionId: 1,
	groupDisplayOrder: 200,
	groupName: "機密",
	roleNameUI: "中度",
	displayName: "中",
	roleDisplayOrder: 9,
	tooltipText: "中度機密文件角色"
},
// {
// roleKey: 13,
// sectionId:1,
// groupDisplayOrder: 200,
// groupName: "Confidentiality",
// roleNameUI: "機密",
// displayName: "機密",
// roleDisplayOrder: 11,
// tooltipText: "嚴格保密文件角色"
// },
{
	roleKey: 14,
	sectionId: 3,
	groupDisplayOrder: 100,
	groupName: "Restrictions",
	roleNameUI: "唯讀",
	displayName: "唯讀",
	roleDisplayOrder: 12,
	tooltipText: "此功能應僅用於允許第三方複核者至此EY Canvas案件。應從Professional Practice取得適當核准及授權。"
},
{
	roleKey: 16,
	sectionId: 3,
	groupDisplayOrder: 100,
	groupName: "Restrictions",
	roleNameUI: "Review only",
	displayName: "Review only",
	roleDisplayOrder: 13,
	tooltipText: "Review only gives this user the ability to view information in the EY Canvas engagement, sign-off, and use the review note functionality. This should be used when other EY users need to review this engagement but not be able to make edits."
},
{
	roleKey: 37,
	sectionId: 3,
	groupDisplayOrder: 100,
	groupName: "Restrictions",
	roleNameUI: "Independence only",
	displayName: "Independence only",
	roleDisplayOrder: 14,
	tooltipText: 'Independence only gives this user the ability to complete their independence form for the engagement, but will not allow user to fully access the EY Canvas engagement. This should be used when a user has performed work for the engagement, but does not need to have access to EY Canvas.',
},
{
	roleKey: 6,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "權限",
	roleNameUI: "復原編輯",
	displayName: "回復/批次刪除文件",
	roleDisplayOrder: 7,
	tooltipText: "Ability to rollback documents if changes were accidentally made after the report release date and remove them from the 440 EY Canvas Form"
},
{
	roleKey: 35,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "權限",
	roleNameUI: "管理 EY Canvas FIT enablement的共享",
	displayName: "管理引導式工作流程",
	roleDisplayOrder: 14,
	tooltipText: "能夠在 EY Canvas 案件之間共享引導式工作流程"
},
{
	roleKey: 36,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "權限",
	roleNameUI: "匯入 EY Helix 資料",
	displayName: "匯入 EY Helix 資料",
	roleDisplayOrder: 15,
	tooltipText: "能夠從 EY Helix 匯入資料"
}
];

export const ValidationSubGroups = [{
	id: 9008,
	label: "獨立性遵循"
},
{
	id: 9001,
	label: "Account summary"
},
{
	id: 9002,
	label: "SCOT summary"
},
{
	id: 9004,
	label: "IT summary"
},
{
	id: 9003,
	label: "CRA summary"
},
{
	id: 9005,
	label: "查核計畫"
},
{
	id: 9011,
	label: "Substantive evaluation matrix"
},
{
	id: 9012,
	label: "Canvas表單驗證檢查"
},
{
	id: 9009,
	label: "IT評估"
},
{
	id: 49,
	label: "未連結之不實表達"
},
{
	id: 50,
	label: "未連結之缺失"
},
{
	id: 44,
	label: "重複的檔案名稱"
},
{
	id: 38,
	label: "未解決衝突"
},
{
	id: 9013,
	label: "修改於報告發布日後"
},
{
	id: 9014,
	label: 'IT flow'
},
{
	id: 9015,
	label: "EY Canvas FIT enablement"
},
{
	id: 71,
	label: "無內容之表單"
},
{
	id: 9016,
	label: 'Incomplete canvas form response'
},
{
	id: 9017,
	label: 'Adjustment module'
},
];

export const engagementIndustry = {
	116: "Not Sector Specific",
	61: "Aerospace and Defense – Aerospace Manufacturing",
	112: "Aerospace and Defense – Defense Contracts Manufacturing",
	59: "Airlines – Air Transportation",
	92: "Asset Management – Commodity Funds",
	57: "Asset Management – Other Funds",
	43: "Asset Management – Private Equity / Venture Capital",
	85: "Asset Management – Registered / Listed Funds",
	53: "Asset Management – Structured Products",
	60: "Asset Management – Unregulated Hedge Funds",
	10: "Asset Management – Unregulated Segregated Accounts",
	90: "Audit of Compliance Management Systems",
	51: "Automotive – Automotive Dealers and Repairs",
	101: "Automotive – Automotive Manufacturing",
	5: "Automotive – Automotive Suppliers",
	71: "Banking and Capital Markets – Banks",
	89: "Banking and Capital Markets – Broker Dealers",
	27: "Banking and Capital Markets – Credit Unions",
	54: "Banking and Capital Markets – Diversified and Other Financial Institutions",
	32: "Banking and Capital Markets – Investment Banking",
	4: "Biotechnology – Biotech – Emerging Growth Markets",
	109: "Biotechnology – Health Research and Testing",
	66: "Chemicals – Chemicals Manufacturing",
	41: "Cleantech",
	37: "Consolidations",
	130: "Construction – Engineering and Architectural Services",
	68: "Construction – Highway and Heavy Construction",
	65: "Construction – Specialty Contractors",
	82: "Consumer Products – Consumer Non– Durable Goods Manufacturing",
	17: "Consumer Products – Food and Beverages Manufacturing",
	35: "Consumer Products – Food Crops, Livestock, Fishing",
	33: "Consumer Products – Household Appliances and Electronics Manufacturing",
	75: "Consumer Products – Other Consumer Durable Goods Manufacturing",
	39: "Consumer Products – Textiles and Apparel Manufacturing",
	21: "Diversified Industrial Products – Fabricated Metals",
	31: "Diversified Industrial Products – Forestry, Pulp, and Paper",
	29: "Diversified Industrial Products – Industrial Instruments Manufacturing",
	40: "Diversified Industrial Products – Industrial Machines Manufacturing",
	26: "Diversified Industrial Products – Industrial Packaging",
	42: "Diversified Industrial Products – Lumber and Wood Manufacturing",
	105: "Diversified Industrial Products – Other Industrial Products",
	100: "Diversified Industrial Products – Primary Metals",
	45: "Diversified Industrial Products – Printing",
	1: "Diversified Industrial Products – Rubber and Plastics Manufacturing",
	118: "Diversified Industrial Products – Stone, Clay, and Glass Manufacturing",
	76: "General",
	79: "Government and Public Sector – Education",
	78: "Government and Public Sector – Federal, National, and International Governments",
	131: "Government and Public Sector – Health Commissioner",
	132: "Government and Public Sector – Health Provider",
	97: "Government and Public Sector – Local government, including State or other levels below National",
	2: "Health – Academic Medical Centers",
	72: "Health – Government Hospitals",
	74: "Health – Managed Health Care",
	8: "Health – Multi Hospital Systems",
	128: "Health – Non System Hospitals",
	94: "Health – Other Health Care Entities",
	73: "Health – Physician Groups",
	121: "Health – Post Acute Care",
	58: "Health – Specialty Hospitals",
	16: "Hospitality and Leisure – Gaming and Gambling",
	7: "Hospitality and Leisure – Hotels, Motels, and Lodging",
	126: "Hospitality – Restaurants / Eating and Drinking Establishments",
	84: "IFRS",
	55: "Insurance – Health Insurance",
	111: "Insurance – Insurance Agents and Brokers",
	69: "Insurance – Life Insurers",
	96: "Insurance – Other Insurance",
	11: "Insurance – Property and Casualty Insurers",
	117: "Insurance – Reinsurers",
	23: "Life Sciences – Medical Technology",
	48: "Media and Entertainment – Advertising",
	14: "Media and Entertainment – Broadcast, Cable Network, Online Video",
	18: "Media and Entertainment – Cable Provider, Satellite, MVPD",
	86: "Media and Entertainment – Film",
	46: "Media and Entertainment – Integrated Media and Entertainment",
	15: "Media and Entertainment – Music Industry",
	25: "Media and Entertainment – Other Media and Entertainment",
	20: "Media and Entertainment – Publishing",
	30: "Media and Entertainment – Sports",
	28: "Mining – Mining Operations",
	3: "Non-complex SMEs",
	120: "Not for Profit – Foundations and Charitable Trusts",
	107: "Not for Profit – Other Not For Profit Organizations",
	70: "Oil and Gas – Energy Trading",
	22: "Oil and Gas – Exploration and Production",
	67: "Oil and Gas – Refining",
	113: "Other Transportation – Local and Urban Transportation",
	38: "Other Transportation – Other Transportation",
	83: "Other Transportation – Rail Transportation",
	88: "Other Transportation – Road Transport and Warehousing",
	6: "Other Transportation – Water Transportation",
	87: "Pension Funds / Benefit Plans",
	95: "Pharmaceutical – Medical Devices Manufacturing",
	123: "Pharmaceutical – Pharmaceuticals Manufacturing and Wholesale",
	115: "Power and Utilities – Electricity",
	119: "Power and Utilities – Natural Gas",
	110: "Power and Utilities – Other Utilities",
	102: "Power and Utilities – Waste and Water",
	125: "Professional Firms and Services – Business Services",
	34: "Professional Firms and Services – Other Services",
	47: "Professional Firms and Services – Personal Services",
	124: "Professional Firms and Services – Professional Service Firms",
	127: "Professional Firms and Services – Rental and Leasing Services",
	108: "Professional Firms and Services – Travel Services",
	49: "Real Estate – Commercial Real Estate Owners/ Developers",
	56: "Real Estate – Other Real Estate Owners/ Developers",
	62: "Real Estate – Real Estate Investment Trusts",
	122: "Real Estate – Real Estate Investors",
	12: "Real Estate – Real Estate Service Companies",
	91: "Real Estate – Residential Real Estate Owners/ Developers",
	24: "Retail and Wholesale – Department Stores",
	93: "Retail and Wholesale – Internet Retail and Mail Order",
	80: "Retail and Wholesale – Mass Merchandisers / Discount Stores",
	9: "Retail and Wholesale – Other Specialty Retailers",
	77: "Retail and Wholesale – Retail Apparel and Accessory Stores",
	114: "Retail and Wholesale – Supermarkets, Grocery, and Convenience Stores",
	36: "Retail and Wholesale – Wholesale Durable Goods",
	64: "Retail and Wholesale – Wholesale Non– Durable Goods",
	104: "Sustainability",
	63: "Technology – Communication and Networking Equipment",
	52: "Technology – Computers and Electronics",
	138: "Technology – Internet and Social Commerce",
	103: "Technology – IT Services",
	19: "Technology – Other Technology",
	98: "Technology – Semiconductors",
	13: "Technology – Software / SaaS / Apps",
	81: "Telecommunications – Cable Communications Services",
	106: "Telecommunications – Integrated Communications Providers",
	129: "Telecommunications – Internet Service Providers",
	99: "Telecommunications – Mobile Wireless Communications Services",
	50: "Telecommunications – Other Communications",
	44: "Telecommunications – Satellite Communications Services"
};

export const rnhQuickFilterLabel = [{
	id: rnhQuickFilter.all,
	label: "顯示全部"
},
{
	id: rnhQuickFilter.assigned,
	filterType: rnhFilterTypeQuery.assignedTo,
	label: "指派給我"
},
{
	id: rnhQuickFilter.authored,
	filterType: rnhFilterTypeQuery.authoredBy,
	label: "由我編輯"
}
];

export const relatedItemStatus = [{
	id: 1,
	label: "草稿"
},
{
	id: 2,
	label: "無客戶聯絡資訊"
},
{
	id: 3,
	label: "已傳送"
},
{
	id: 4,
	label: "系統錯誤"
},
{
	id: 5,
	label: "無效的客戶聯絡資訊"
},
{
	id: 6,
	label: "待回覆"
},
{
	id: 7,
	label: "已接收"
},
{
	id: 8,
	label: "已接受"
},
{
	id: 9,
	label: "已退回"
},
{
	id: 10,
	label: "已撤銷"
},
{
	id: 11,
	label: "傳送中"
},
{
	id: 12,
	label: "接受中"
},
{
	id: 13,
	label: "撤銷中"
},
{
	id: 14,
	label: "刪除中"
},
{
	id: 15,
	label: "退回中"
},
{
	id: 16,
	label: "回覆中"
},
{
	id: 17,
	label: "已刪除"
},
{
	id: 18,
	label: "無效的客戶聯絡資訊已退回"
},
{
	id: 19,
	label: "回收中"
},
{
	id: 20,
	label: "已回收"
},
{
	id: 21,
	label: "完成中"
},
{
	id: 22,
	label: "回收中"
}
];

export const GroupDocuments = [{
	id: 33,
	label: "Group instructions sent by the primary team"
},
{
	id: 37,
	label: "Documents returned from the primary team"
}
];

export const engagementUserStatus = {
	1: "Active",
	2: "Pending",
	3: "Rejected",
	4: "De-Activated",
	5: "Request for Archive Access",
	6: "Reject Archive Access",
	7: "Copy Engagement - Inactive",
	8: "Unlinked-Inactive",
	9: "Template - Inactive",
	10: "Roll Forward - Inactive",
	11: "Localized to Isolated Universal",
	12: "Invitation in Progress",
	13: "Scheduled - Inactive"
};
export const CGTTaskSendStatus = [{
	id: 1,
	label: "Not sent"
},
{
	id: 2,
	label: "文件傳送中"
},
{
	id: 3,
	label: "草稿版本已傳送"
},
{
	id: 4,
	label: "Returned"
},
{
	id: 5,
	label: "In review"
},
{
	id: 6,
	label: "Complete"
},
{
	id: 7,
	label: "Dismissed"
},
{
	id: 8,
	label: "Reject in transit"
},
{
	id: 9,
	label: "最終版本已傳送"
},
{
	id: 999,
	label: "傳送失敗"
}
];

export const ServiceRequestStatus = [{
	id: 11,
	cssClass: 'accepted-text',
	statusLabel: "已接受"
},
{
	id: 12,
	cssClass: 'pending-text',
	statusLabel: "發送"
},
{
	id: 13,
	cssClass: 'rejected-text',
	statusLabel: "取消"
},
{
	id: 14,
	statusLabel: "草稿"
},
{
	id: 15,
	cssClass: 'completed-text',
	statusLabel: "已完成"
},
{
	id: 16,
	statusLabel: "前期完成"
},
{
	id: 17,
	statusLabel: "提交錯誤"
},
{
	id: 22,
	statusLabel: "不適用"
},
{
	id: 24,
	statusLabel: 'Action required'
}
];

export const assignmentsSectionLabels = [{
	id: bulkAssignment.assign,
	label: "指派事項"
},
{
	id: bulkAssignment.timephase,
	label: "時段"
},
{
	id: bulkAssignment.tag,
	label: "標記"
}
];

export const assignmentsSectionLabelsNew = [{
	id: bulkAssignment.assign,
	label: "指派事項"
},
{
	id: bulkAssignment.timephase,
	label: "時段"
}
];

export const assignmentTypeLabels = [{
	id: assignmentTypes.preparer,
	label: "編製者"
},
{
	id: assignmentTypes.detailReviewer,
	label: "詳細複核者"
},
{
	id: assignmentTypes.generalReviewer,
	label: "一般複核者"
},
{
	id: assignmentTypes.partner,
	label: "會計師"
},
{
	id: assignmentTypes.eqr,
	label: "EQR"
},
{
	id: assignmentTypes.other,
	label: "其他"
}
];

export const assignmentActionsLabels = [{
	id: bulkAssignmentConstants.actionIds.add,
	label: "新增"
},
{
	id: bulkAssignmentConstants.actionIds.remove,
	label: "移除"
},
{
	id: bulkAssignmentConstants.actionIds.replace,
	label: "取代"
},
{
	id: bulkAssignmentConstants.actionIds.updateDueDays,
	label: "到期更新天數"
}
];

export const tagActionsLabels = [{
	id: bulkAssignmentConstants.actionIds.add,
	label: "新增"
},
{
	id: bulkAssignmentConstants.actionIds.remove,
	label: "移除"
}
];

export const manageAssigmentsActionTypeLabel = [{
	id: actionTypes.edit,
	label: "編輯"
},
{
	id: actionTypes.delete,
	label: "刪除"
}
];

export const confidentialityLevels = {
	[confidentialityTypes.DEFAULT]: "Default",
	[confidentialityTypes.LOW]: "Low",
	[confidentialityTypes.MODERATE]: "Moderate",
	[confidentialityTypes.HIGH]: "High"
};

export const milestoneTaskLabels = [{
	id: milestoneBuildTaskIds.accounts,
	label: "Accounts flow tasks"
},
{
	id: milestoneBuildTaskIds.scots,
	label: "SCOTs flow tasks"
},
{
	id: milestoneBuildTaskIds.itso,
	label: "IT/SO flow tasks"
},
{
	id: milestoneBuildTaskIds.cra,
	label: "CRA flow tasks"
},
{
	id: milestoneBuildTaskIds.auditPlan,
	label: "Audit plan flow tasks"
},
{
	id: milestoneBuildTaskIds.groupStructure,
	label: "Group structure flow tasks"
},
{
	id: milestoneBuildTaskIds.groupInstructions,
	label: "Group instructions flow tasks"
},
{
	id: milestoneBuildTaskIds.review,
	label: "Review flow tasks"
}
];

//Filters for RegionComponentEvidence
export const gaDocFilters = {
	scope: "範圍",
	teamName: "團隊名稱",
	groupStructure: "集團架構",
	region: "Region",
	component: "Component"
};

export const filterSourceOfForm = [{
	value: '1',
	label: "Custom"
},
{
	value: '2',
	label: "Knowledge"
},
{
	value: '3',
	label: "Independence"
}
];

export const independenceActions = [{
	id: independenceActionIds.createIndependenceForm,
	label: "Create independence form"
},
{
	id: independenceActionIds.removeTeamMember,
	label: "Remove team member"
},
{
	id: independenceActionIds.removeOverride,
	label: "Remove override"
}
];


export const reviewNoteModalLabels = {
	/*Review Notes*/
	commentThread: "Note thread",
	singleNoteInstructionalText: "檢視並回覆以下所選註解。",
	emptyNoteDetailsMessage: 'Select a note to view details. To enable bulk controls, use the control or shift key and select multiple review notes. If you would like to work on an individual note, then select that note from the list.',
	documentReviewNotesLabel: "文件註記",
	addNewReviewNoteButtonText: "New note",
	noNotesAssociatedWithDocumentLabel: "使用下方輸入留言。將註記指派給使用者並指定優先事項和到期日。",
	noNotesFound: "找不到註記",
	noNotesAssociatedWithTaskLabel: "任務無相關{0}註記。",
	allNotesLabel: "全部註記",
	charactersLabel: "characters",
	myNotesLabel: "我的註記",
	showClearedLabel: "Show cleared",
	showClosedLabel: "Show closed",
	assignedToLabel: "指派給",

	ofLabel: "of",
	enterNoteText: "輸入註記",
	addNewNoteModalClose: "Close",
	addNewNoteModalTitleLabel: "加入新註記",
	editNoteModalTitleLabel: "編輯註記",
	deleteIconHoverText: "Delete",
	deleteIconModalAcceptText: "Delete",
	deleteIconModalConfirmMessage: 'Are you sure that you want to delete your reply to this note?',
	deleteIconModalConfirmMessageParent: 'Are you sure that you want to delete the selected note?',
	deleteIconModalTitleLabel: "刪除註記",
	deleteReplyIconModalTitle: "Delete reply",
	emptyRepliesMessage: "No replies yet",
	replyInputPlaceholder: "回覆本註記",
	replyInputPlaceholderEdit: 'Edit reply to review note',
	noteInputPlaceholderEdit: 'Edit review note',
	replyText: "Reply text",
	editReplyModelTitle: "Edit reply",
	editReplyPlaceholder: "Enter reply",
	noteDueDateLabel: "Due",

	priorityLabel: "Priority",
	dueDateLabel: "Due date",
	dueLabel: "Due",
	status: "Status",
	noteModifiedDateLabel: "Modified",
	cancelLabel: "Cancel",
	saveLabel: "Save",
	clearedBy: "Cleared by",
	closedBy: "Closed by",
	reopenedBy: "Reopened by",
	reply: "Reply",
	editIconHoverTextLabel: "Edit",
	required: "Required",
	closeTitle: "Close",
	otherEngagementNotes: "其他案件註記",
	closeLabel: "Close",
	showMore: "Show more",
	showLess: "Show less",
	showMoreEllipsis: "Show more...",
	showLessEllipsis: "Show less...",
	noResultFound: "No results found",
	engagementNameLabel: "Engagement name:",
	taskReviewNotesLabel: "任務註記",
	fromUserLabel: labels.fromUserLabel,
	toUserLabel: labels.toUserLabel
};

//Copyhub create package
export const createPackageLabels = {
	packageType: "Package type",
	categories: "Categories",
	itemsToCopy: "Items to copy",
	createPackage: "Create package",
	selectPackageType: "Select package type",
	selectPackageTypeTitle: "Select package type",
	selectCategoriesTitle: "Select categories",
	selectEntitiesTitle: 'Select entities',
	relateCanvasFormsTitle: 'Relate documents',
	relateAnObjectTitle: "Relate an object",
	step1InstructionalText: "Select package type, name it and select recipient. Ensure compliance with all applicable laws, regulations and EY policies regarding data privacy, transfer of data between jurisdictions and protection of confidential information before creating or sending a Copy Package.",
	packageTypes: [{
		value: 21,
		text: 'Engagement'
	}, {
		value: 20,
		text: 'Evidence'
	}, {
		value: 24,
		text: 'Roll forward from existing'
	}, {
		value: 22,
		text: 'Accounts'
	}, {
		value: 23,
		text: 'SCOTs'
	}, {
		value: 26,
		text: 'Bulk export'
	}, {
		value: 25,
		text: 'Template'
	}, {
		value: 27,
		text: 'External documents'
	}, {
		value: 28,
		text: "Guided workflows"
	}, {
		value: 29,
		text: 'Engagement by entity'
	}],

	packageName: "Package name",
	packageDetailsText: 'Package details',
	required: "Required",
	sendTo: "Send to",
	nameOrEmail: "Name or email",
	sendToName: "Name",
	sendToEmail: "Email",
	clearAllValues: "Clear all values",
	engagementIdErrorMessage: "The engagement id is not specified.",
	emptyCategoriesStep2Text: '...',
	insufficientPermissionsMessage: "Insufficient permissions to create copy package. Contact your engagement administrator and request permission to create copy package.",
	CopyHubCanvasFormTooltip: "For EY Canvas forms only",
	CopyEngagementInProgress: "一次僅能處理一個案件副本。",

	//Step 3 labels
	step3Header: "Select {0} to copy",
	selectAllText: "Select all",
	delectAllText: "Deselect all",
	documentsSelectedText: "documents selected",
	scotsSelectedText: "SCOTs selected",
	accountsSelectedText: "Accounts selected",
	entitiesSelectedText: 'entities selected',
	step3InstructionText: "Ensure compliance with all applicable laws, regulations and EY policies regarding data privacy, transfer of data between jurisdictions and protection of confidential information before creating or sending a Data Package.",
	step3InstructionTextEvidence: 'Ensure compliance with all applicable laws, regulations and EY policies regarding data privacy, transfer of data between jurisdictions and protection of confidential information before sending engagement data.',
	step3InstructionTextWarning: "EY Canvas Forms will not include related objects (e.g. SCOTs, Controls).",
	step3InstructionTextWarningFIT: "Guided Workflows的副本可以包含已辨識的相關事件、條件及其相關描述。 它們不會包含其他相關項目（例如科目、風險）。",
	availableCanvasFormsColumnName: 'Available documents',
	availableFITDocuments: "Available guided workflows",
	availableAccountsColumnName: "Available accounts",
	availableSCOTsColumnName: "Available SCOTs",
	availableExternalDocumentsColumnName: 'Available external documents',
	step3NoItemeSelectedError: "Select at least one item to proceed",
	searchPackagePlaceholder: "Search",
	searchPackageClearHoverText: "Clear",

	//step2:
	step2Header: "Select categories for {0} package",
	step2AccountsHdr: "Select categories to include in copy package. The core package includes all related assertions, PSPs and OSPs.",
	step2scotshdr: "Select categories to include in copy package. The core package includes all related WCGWs, Controls and tasks",
	step2canformhdr: "Select categories to include in copy package",
	step2InstructionTextEngagementByEntity: 'Select entities to include in copy package',
	availableEntitiesColumnName: "Available entities",
	step2HeaderEntities: 'Select {0} for engagement package',
	entitiesLabel: 'entities',

	scots: "SCOTs",
	itso: "IT application/ SO structure",
	evidence: "Evidence",
	realtedevidence: "Related Evidence",
	signoffs: "Sign-Offs",
	tempfiles: "Temporary Files",
	priorperiodevidence: "Prior Period Evidence",
	recentlydeletedfiles: "Recently Deleted Files",
	historyfiles: "History Files",
	extgrp: "External Groups and External Team members",
	eydocument: "EY Documents",
	extdoc: "External Documents",
	totalfilesize: 'The total file size of all selections is',
	requestandexernaltasks: "Requests and External Tasks",
	rollForwardFromExisting: 'Roll forward from existing',
	template: 'Template',
	bulkExport: 'Bulk export',

	fileSizeWaring: "The selected categories include files that {0}. EY Canvas does not support copy packages exceeding this limit.",
	fileSizeWarningline2: "Consider removing document categories to reduce overall file size of the copy package.",
	coloredExceedLable: "exceed {0} GB",
	step2EngHdr: "Select categories to include in copy package. The base package includes engagement profile, all knowledge documents, Primary Standard tasks, Other standard tasks, time phases; accounts/ disclosures, assertions and their related tasks; SCOTs, WCGWs, Controls and their related tasks; IT applications/ Service Organizations, Risks, ITGCs/ ITSPs and related tasks; Maps. If Group Audit engagement, package will include also group audit data.",
	step2EngByEntityHdr: "Select categories to include in copy package. The base package includes engagement and selected entity profile, knowledge documents, Primary Standard tasks, Other standard tasks, time phases; accounts/ disclosures, assertions and their related tasks; SCOTs, WCGWs, Controls and their related tasks; IT applications/ Service Organizations, Risks, ITGCs/ ITSPs and related tasks; Maps. If Group Audit engagement, package will include also group audit data.",
	step2BulkExpHdr: 'Select document categories to be exported.',
	gb: "GB",
	step2And: "and",
	step2Files: "document(s)",
	lessThanMinGB: "少於 0.01 GB",
	CategoryFileSizeCount: " {0} GB 及 {0} 文件",

	cancelLabel: "Cancel",
	showSelected: "Show selected",
	showSelectedDocuments: "Show {0} selected document(s)",
	showSelectedEntities: "Show {0} selected entity/entities",
	showSelectedGuidedWorflows: "Show {0} selected guided workflow(s)",
	showSelectedAccounts: "Show {0} selected account(s)",
	showSelectedSCOTs: "Show {0} selected SCOT(s)",
	noDataFoundLabel: "No data found",
	copyPackageSuccessMessage: '{0} data export has been initiated.',
	copyPackageWarningLabel: "Warning : The package could not be sent to below members due to invalid information :- {0}",
	noResultFound: "找不到結果",
	canvasForms: "EY Canvas Forms",
	canvasFormsInformationText: "EY Canvas Forms can be exported only as Evidence and/or Temporary Files.<br/>Please select one of these options to enable EY Canvas Forms download.",
	coEditSelectAllWarningMessage: "Some documents are currently in active multi-user edit mode and cannot be included in the copy package",
	coEditDocumentTooltip: "Document is in active multi-user edit mode and cannot be copied. Please check-in the document to copy it as a part of this package",
	coEditCopyWarningMessage: "{0} documents are in active multi-user edit mode within the {1} category/categories. Please check-in all documents within each category in order to include them as a part of this package"
};

export const documentTypes = [{
	id: 1,
	label: "證據"
},
{
	id: 2,
	label: "暫時"
},
{
	id: 3,
	label: "前一年度證據"
},
{
	id: 4,
	label: "客戶檔案"
},
{
	id: 5,
	label: "Snapshot"
},
{
	id: 6,
	label: "Smartform"
},
{
	id: 29,
	label: "紙本檔案"
},
{
	id: 47,
	label: "批次文件匯出"
},
{
	id: 48,
	label: "Canvas表單"
},
{
	id: 51,
	label: "自動化中心"
},
{
	id: 59,
	label: "封包"
},
{
	id: 72,
	label: "智慧工作底稿(SWP)"
}
];

export const activityTypes = [{
	id: activityType.primaryLinkAccept,
	label: "Link request accepted by {0}"
},
{
	id: activityType.primaryLinkReject,
	label: "Link request rejected by {0}"
},
{
	id: activityType.primaryUnlink,
	label: "{0}從集團取消連結案件"
},
{
	id: activityType.primaryComponentUnlink,
	label: "{0}從集團取消連結案件"
},
{
	id: activityType.componentPrimaryUnlink,
	label: "{0}從集團取消連結案件"
},
{
	id: activityType.primarySendLink,
	label: "Link request sent by {0} to {1}"
},
{
	id: activityType.documentsReceived,
	label: "Documents received by {0}"
},
{
	id: activityType.primarySendInstruction,
	label: "Instructions sent from {0} to {1}"
},
{
	id: activityType.primaryRejectInstruction,
	label: "{0}退回指示函"
},
{
	id: activityType.primaryAcceptInstruction,
	label: "{0}接受指示函"
},
{
	id: activityType.componentReceivedInstruction,
	label: "Instructions received"
},
{
	id: activityType.componentAcceptInstruction,
	label: "{0}接受指示函"
},
{
	id: activityType.componentRejectInstruction,
	label: "{0}退回指示函"
},
{
	id: activityType.componentAcceptUpdatetInstruction,
	label: "{0}接受指示函"
},
{
	id: activityType.componentRejectUpdateInstruction,
	label: "{0}退回指示函"
},
{
	id: activityType.primaryEvidenceReceived,
	label: "Version received by {0}"
},
{
	id: activityType.documentVersionConflictResolved,
	label: "Conflict resolved by {0}"
},
{
	id: activityType.documentOverwrite,
	label: "{0}覆寫文件內容"
},

{
	id: activityType.primaryAssignComponent,
	label: "Document assigned to {0}"
},
{
	id: activityType.componentUnassigned,
	label: "Document unassigned from {0}"
},
{
	id: activityType.clearDocumentReturnedtoComponent,
	label: "Version finalized by {0}"
},
{
	id: activityType.componentClearReturnedDocument,
	label: "Version resolved by {0}"
},
{
	id: activityType.primaryReturnEvidence,
	label: "Version returned by {0}"
},
{
	id: activityType.componentEvidenceSent,
	label: "Version sent by {0}"
},
{
	id: activityType.componentReturnEvidence,
	label: "Version returned by {0}"
},
{
	id: activityType.createReviewNote,
	label: "Note opened by {0}"
},
{
	id: activityType.openReviewNote,
	label: "Note opened by {0}"
},
{
	id: activityType.clearReviewNote,
	label: "Note cleared by {0}"
},
{
	id: activityType.closeReviewNote,
	label: "Note closed by {0}"
},
{
	id: activityType.reviewerSignOff,
	label: "Signed off by {0}"
},
{
	id: activityType.preparerSignOff,
	label: "Signed off by {0}"
},
{
	id: activityType.canvasSendClientRequest,
	label: labels.sent
},
{
	id: activityType.clientRespondToClientRequest,
	label: "已回應"
},
{
	id: activityType.canvasRejectClientRequest,
	label: labels.rejected
},
{
	id: activityType.canvasWithdrawClientRequest,
	label: labels.WithdrawLabel
},
{
	id: activityType.canvasDeleteClientRequest,
	label: "已刪除"
},
{
	id: activityType.canvasAcceptClientRequest,
	label: labels.accepted
},
{
	id: activityType.CEARecallClientRequest,
	label: "已召回"
},
{
	id: activityType.canvasCompleteClientRequest,
	label: labels.completed
}
];


export const gaLinkStatus = [{
	id: GALinkStatus.Undefined,
	label: "Undefined"
},
{
	id: GALinkStatus.NoPointOfContact,
	label: "No point of contact"
},
{
	id: GALinkStatus.Pending,
	label: "Pending"
},
{
	id: GALinkStatus.Accepted,
	label: "Accepted"
},
{
	id: GALinkStatus.Rejected,
	label: "Rejected"
},
{
	id: GALinkStatus.Expired,
	label: "Expired"
},
{
	id: GALinkStatus.Unlinked,
	label: "Unlinked"
},
{
	id: GALinkStatus.Delegated,
	label: "Delegated"
},
{
	id: GALinkStatus.SystemError,
	label: "System error"
},
{
	id: GALinkStatus.Sent,
	label: "Sent"
},
{
	id: GALinkStatus.InvalidPointOfContact,
	label: "Invalid point of contact"
},
{
	id: GALinkStatus.ComponentNotUsingCanvas,
	label: "Component not using Canvas"
}
];

export const gaInstructionStatus = [{
	id: 0,
	label: labels.notApplicable
},
{
	id: instructionStatus.notSent,
	label: "Not sent"
},
{
	id: instructionStatus.pending,
	label: "Pending"
},
{
	id: instructionStatus.accepted,
	label: "Accepted"
},
{
	id: instructionStatus.rejected,
	label: "Returned"
},
{
	id: instructionStatus.systemError,
	label: "System error"
},
{
	id: instructionStatus.expired,
	label: "Expired"
},
{
	id: instructionStatus.sent,
	label: "Sent"
},
{
	id: instructionStatus.unlinked,
	label: "Unlinked"
},
{
	id: instructionStatus.queued,
	label: "Queued"
}
];

export const gsSnapshotComparisonStatus = [{
	id: snapshotComparisonIds.noChange,
	value: "空"
},
{
	id: snapshotComparisonIds.new,
	value: "新"
},
{
	id: snapshotComparisonIds.added,
	value: "已加入"
},
{
	id: snapshotComparisonIds.modified,
	value: "已修正"
},
{
	id: snapshotComparisonIds.updated,
	value: "已更新"
},
{
	id: snapshotComparisonIds.removed,
	value: "已移動"
},
{
	id: snapshotComparisonIds.itemsRemoved,
	value: "移除項目"
},
]

export const gaRoleType = [{
	id: GARoleTypeId.Primary,
	label: "Primary"
},
{
	id: GARoleTypeId.Region,
	label: "Region"
},
{
	id: GARoleTypeId.Component,
	label: "Component"
}
];

export const linkRequestTypes = [{
	id: linkType.sent,
	label: "Sent"
},
{
	id: linkType.unlinked,
	label: "Unlinked"
},
{
	id: linkType.accepted,
	label: "Accepted"
}
];

export const instructionTypes = [{
	id: instructionType.sent,
	label: "Sent"
},
{
	id: instructionType.rejected,
	label: "Returned"
},
{
	id: instructionType.received,
	label: "Received"
},
{
	id: instructionType.accepted,
	label: "Accepted"
}
];

export const syncStatusLabels = [{
	id: syncStatus.notSynchronized,
	label: 'Not Synchronized'
},
{
	id: syncStatus.syncInTransit,
	label: 'Sync in transit'
},
{
	id: syncStatus.syncInProcess,
	label: 'Sync in process'
},
{
	id: syncStatus.synchronized,
	label: 'Synced'
},
{
	id: syncStatus.deleteInTransit,
	label: 'Delete in transit'
},
{
	id: syncStatus.deleteInProcess,
	label: 'Delete in process'
},
{
	id: syncStatus.deleted,
	label: "已刪除"
},
{
	id: syncStatus.noHostEngagement,
	label: 'No host engagement'
},
{
	id: syncStatus.syncError,
	label: 'Sync error'
}
];

export const colorOptionsLabels = {
	Red: 'Red',
	Orange: 'Orange',
	Teal: 'Teal',
	Blue: 'Blue',
	Purple: 'Purple',
	Green: 'Green',
	Yellow: 'Yellow',
	Gray: 'Gray'
};

export const todoListTimeFrameLabels = [{
	id: todoListTimeframeOptions.byDay,
	label: "By day"
},
{
	id: todoListTimeframeOptions.byWeek,
	label: "By week"
},
{
	id: todoListTimeframeOptions.byMonth,
	label: "By month"
},
{
	id: todoListTimeframeOptions.all,
	label: "All"
},
{
	id: todoListTimeframeOptions.overdue,
	label: "Overdue"
}
];

export const clientRequestsStatusFilter = [{
	value: 'Draft',
	label: 'Draft'
},
{
	value: 'Pending',
	label: 'Pending response'
},
{
	value: 'Received',
	label: 'Received'
},
{
	value: 'Accepted',
	label: 'Accepted'
}
];

export const clientRequestsTypeFilter = [{
	value: 'Required',
	label: 'Sign-off required'
},
{
	value: 'NotRequired',
	label: 'Sign-off not required'
}
];

export const clientRequestsPriorityFilter = [{
	value: 'Normal',
	label: "普通的"
},
{
	value: 'High',
	label: "高度的"
},
{
	value: 'Critical',
	label: "重要的"
}
];

export const clientRequestsAttachmentsFilter = [{
	value: 'Analytics',
	label: 'Analytics'
},
{
	value: 'ExternalAttachments',
	label: 'External attachments'
},
{
	value: 'EyAttachments',
	label: 'EY attachments'
},
{
	value: 'None',
	label: 'None'
}
];

export const clientRequestsCreatedByFilter = [{
	value: 'Client',
	label: 'Client'
},
{
	value: 'EY',
	label: 'EY'
}
];

export const filterTimePhase = [{
	value: -1,
	label: 'No Time Phase'
}];

export const clientRequestsBooleanFilters = [{
	value: 1,
	label: 'Yes'
},
{
	value: 0,
	label: 'No'
}
]

export const bulkClientRequestsNoRelatedTaskFilter = [{
	value: false,
	label: 'Yes'
},
{
	value: true,
	label: 'No'
}
]

export const controlsTestingFilters = [{
	value: 'true',
	label: 'Yes'
},
{
	value: 'false',
	label: 'No'
},
{
	value: 'null',
	label: 'Not selected'
}
];

export const controlsDesignEffectivenessFilters = [{
	value: '1',
	label: 'Effective'
},
{
	value: '2',
	label: 'Ineffective'
},
{
	value: '0',
	label: 'Not selected'
}
];

export const clientRequestAnnotationTabs = [{
	id: clientRequestNoteTab.comments,
	label: 'Comments'
},
{
	id: clientRequestNoteTab.history,
	label: 'History'
}
];

export const riskTypeOptions = [{
	id: 1,
	name: 'Significant risks'
},
{
	id: 2,
	name: 'Fraud risks'
},
{
	id: 3,
	name: "Risk of material misstatement"
}
];

export const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const longDays = ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays'];
export const shortDays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
// GA Scopes
export const gaScopesResource = [{
	id: gaScopes.full,
	label: 'Full'
},
{
	id: gaScopes.specific,
	label: 'Specific'
},
{
	id: gaScopes.specificAuditProcedures,
	label: 'Specified audit procedures'
},
{
	id: gaScopes.review,
	label: 'Review'
}
]

// GA Instructions
export const gaRecommendationTypeResource = [{
	id: gaRecommendationType.required,
	label: "必填"
},
{
	id: gaRecommendationType.optional,
	label: "可选"
},
{
	id: gaRecommendationType.notApplicable,
	label: "不适用"
}
]

// GS Group Summary
export const gsTabsResource = [{
	id: groupSummaryTabs.assignedTeams,
	label: "分配的项目组"
},
{
	id: groupSummaryTabs.instructions,
	label: "指引"
},
{
	id: groupSummaryTabs.tasks,
	label: "任务"
}
]

export const receiveInstructionsTypeResource = {
	true: {
		title: "新的",
		instructional: "一個新的"
	},
	false: {
		title: "更新的",
		instructional: "一個更新的"
	}
}

export const clientRequestSystemGeneratedMessages = {
	sent: "Request sent to",
	accepted: "Request accepted",
	received: "Request received",
	returned: "Request returned",
	withdrawn: "Request withdrawn",
	complete: "Request was completed by EY",
	recalled: "Request recalled",
	notification_submit: "Request submitted to automation",
	notification_success: "Request submitted successfully to automation",
	notification_error: "An error occurred submitting to automation.  Click 'Submit to automation' to try again.",
	restore_document: "Document restored -",
	delete_document: "Document deleted -",
	assignedto: "項目重新指派給",
	editrequest: "請求已編輯",
	prioritychange: "請求優先順序更新為"
};

export const externalTaskSystemGeneratedMessages = {
	sent: "External Task sent to",
	accepted: "External Task accepted",
	received: "Response received",
	returned: "External Task returned",
	withdrawn: "External Task withdrawn",
	complete: "External Task was completed from EY Canvas",
	recalled: "External Task recalled",
	restore_document: "Document restored -",
	delete_document: "Document deleted -",
	assignedto: "項目重新指派給",
	editrequest: "外部任務已編輯",
	prioritychange: "外部任務優先順序更新為"
};

export const ipInputLabels = [{
	id: ipInputType.ipAddress,
	label: 'IP address'
},
{
	id: ipInputType.ipRange,
	label: 'IP range'
},
{
	id: ipInputType.cidrBlock,
	label: 'CIDR block'
}
];

export const ipFilterTypeLabels = {
	[ipFilterType.ipAddress]: "IP Address",
	[ipFilterType.ipRange]: "IP Range",
	[ipFilterType.cidrBlock]: "CIDR Block"
};

export const gaLinkStatusObj = {
	[GALinkStatus.Undefined]: 'Undefined',
	[GALinkStatus.NoPointOfContact]: 'No point of contact',
	[GALinkStatus.NotSent]: "未寄送",
	[GALinkStatus.Pending]: 'Link request pending',
	[GALinkStatus.Accepted]: 'Link request accepted',
	[GALinkStatus.Rejected]: "已拒絕",
	[GALinkStatus.Expired]: "已到期",
	[GALinkStatus.Unlinked]: 'Unlinked',
	[GALinkStatus.Delegated]: 'Delegated',
	[GALinkStatus.SystemError]: "系統錯誤",
	[GALinkStatus.Sent]: 'Sent',
	[GALinkStatus.InvalidPointOfContact]: "無效聯繫窗口",
	[GALinkStatus.ComponentNotUsingCanvas]: 'Not using EY Canvas',
	[GALinkStatus.ComponentReferenceOnly]: 'Reference only'
};

export const epTasksObj = [{
	value: '3',
	label: 'No documents signed-off'
},
{
	value: '2',
	label: 'Some documents signed-off'
},
{
	value: '1',
	label: 'All documents signed-off'
}
];

export const eqrTasksObj = [{
	value: '6',
	label: 'No documents signed-off'
},
{
	value: '5',
	label: 'Some documents signed-off'
},
{
	value: '4',
	label: 'All documents signed-off'
}
];

export const groupsFilterEntity = [{
	id: 1,
	label: 'Tasks'
},
{
	id: 2,
	label: 'Documents'
}
];

export const scopesFilterEntity = [{
	id: 1,
	label: 'Full'
},
{
	id: 2,
	label: 'Specific'
},
{
	id: 3,
	label: 'Specified audit procedures'
},
{
	id: 4,
	label: 'Review'
}
];

export const notesFilterLabels = [{
	id: notesFilter.allNotes,
	label: "全部註記"
},
{
	id: notesFilter.myNotes,
	label: "我的註記"
},
{
	id: notesFilter.authoredByMeNotes,
	label: 'Assigned to me'
}
];

//Client Request Advanvce Search
export const advancedSearchValues = [{
	id: 1,
	value: labels.advancedSearchTitleCheck
},
{
	id: 2,
	value: labels.advancedSearchRefereceNumberCheck
},
{
	id: 3,
	value: labels.advancedSearchDocumentsCheck
},
{
	id: 4,
	value: labels.advancedSearchCommentsCheck
}
];


export const TaskTypeLabels = [{
	id: TaskListTypes.ScopeAndStrategy,
	label: taskNavigation[TaskListTypes.ScopeAndStrategy]
},
{
	id: TaskListTypes.SCOTs,
	label: taskNavigation[TaskListTypes.SCOTs]
},
{
	id: TaskListTypes.ITSOs,
	label: taskNavigation[TaskListTypes.ITSOs]
},
{
	id: TaskListTypes.Accounts,
	label: taskNavigation[TaskListTypes.Accounts]
},
{
	id: TaskListTypes.GeneralExecution,
	label: taskNavigation[TaskListTypes.GeneralExecution]
},
{
	id: TaskListTypes.Conclusion,
	label: taskNavigation[TaskListTypes.Conclusion]
}
];

export const TaskCategoryLabels = [{
	id: TaskListTypes.ScopeAndStrategy,
	label: taskNavigation[TaskListTypes.ScopeAndStrategy],
	displayOrder: 1
},
{
	id: TaskListTypes.Risks,
	label: taskNavigation[TaskListTypes.Risks],
	displayOrder: 2
},
{
	id: TaskListTypes.SCOTs,
	label: taskNavigation[TaskListTypes.SCOTs],
	displayOrder: 3
},
{
	id: TaskListTypes.ITSOs,
	label: taskNavigation[TaskListTypes.ITSOs],
	displayOrder: 4
},
{
	id: TaskListTypes.Accounts,
	label: taskNavigation[TaskListTypes.Accounts],
	displayOrder: 5
},
{
	id: TaskListTypes.GeneralExecution,
	label: taskNavigation[TaskListTypes.GeneralExecution],
	displayOrder: 6
},
{
	id: TaskListTypes.Conclusion,
	label: taskNavigation[TaskListTypes.Conclusion],
	displayOrder: 7
},
];

export const kendoLabels = {
	alignLeft: "靠左對齊",
	alignRight: "靠右對齊",
	alignCenter: "置中對齊",
	alignFull: "左右對齊",
	addComment: "新增註解",
	addColumnBefore: "新增左方欄",
	addColumnAfter: "新增右方欄",
	addRowAbove: "新增上方列",
	addRowBelow: "新增下方列",
	bulletList: "插入未排序清單",
	bold: "粗體",
	backColor: "醒目提示",
	createLink: "插入超連結",
	createTable: "建立表格",
	cleanFormatting: "清除格式",
	deleteRow: "刪除列",
	deleteColumn: "刪除欄",
	deleteTable: "刪除表格",
	fontSizeInherit: "字體大小",
	foreColor: "顏色",
	format: "格式",
	fontSize: "字體大小",
	hyperlink: "插入網頁連結",
	italic: "斜體",
	indent: "縮排",
	insertTableHint: "建立一個 {0} 使用 {1} 表格",
	'hyperlink-dialog-content-address': "網址",
	"hyperlink-dialog-title": "插入超連結",
	"hyperlink-dialog-content-title": "標題",
	"hyperlink-dialog-content-newwindow": "在新視窗開啟連結",
	"hyperlink-dialog-cancel": "取消",
	"hyperlink-dialog-insert": "插入",
	outdent: "凸排",
	orderedList: "插入未排序清單",
	print: "列印",
	pdf: "匯出至pdf",
	redo: "重做",
	strikethrough: "刪除線",
	subscript: "下標",
	superscript: "上標",
	underline: "底線",
	undo: "復原"
};

export const kendoFormatOptions = [{
	text: "段落",
	value: "p"
},
{
	text: "標題1",
	value: "h1"
},
{
	text: "標題2",
	value: "h2"
},
{
	text: "標題3",
	value: "h3"
},
{
	text: "標題4",
	value: "h4"
},
{
	text: "標題5",
	value: "h5"
},
{
	text: "標題6",
	value: "h6"
}
];

export const kendoFontSize = [{
	text: '8',
	value: '8px'
},
{
	text: '9',
	value: '9px'
},
{
	text: '10',
	value: '10px'
},
{
	text: '11',
	value: '11px'
},
{
	text: '12',
	value: '12px'
},
{
	text: '14',
	value: '14px'
},
{
	text: '16',
	value: '16px'
},
{
	text: '18',
	value: '18px'
},
{
	text: '20',
	value: '20px'
},
{
	text: '22',
	value: '22px'
},
{
	text: '24',
	value: '24px'
},
{
	text: '26',
	value: '26px'
},
{
	text: '28',
	value: '28px'
},
{
	text: '36',
	value: '36px'
},
{
	text: '48',
	value: '48px'
},
{
	text: '72',
	value: '72px'
}
];

export const monthsList = [
	"一月",
	"二月",
	"三月",
	"四月",
	"五月",
	"六月",
	"七月",
	"八月",
	"九月",
	"十月",
	"十一月",
	"十二月"
];

export const pspContentStatus = {
	1: "需要更新",
	2: "正在更新",
	3: "更新完成",
	4: "更新錯誤"
}

export const handOffLabels = {
	handoff: "移交",
	handOffTitleTip: "移交以複核",
	markCompleteTitleTip: "標記完成",
	handoffModalTitle: "移交至下一位團隊成員",
	handoffConfirmButtonText: "移交",
	return: "退回",
	handModalDescription: "要簽名證據資料，請從以下選項中進行選擇。",
	markCompleteTextLine1: "將此任務移交至下一位團隊成員。",
	markCompleteTextLine2: "要簽名證據資料，請從以下選項中進行選擇。 若您有一個指派事項任務並已完成，請選擇<b>是</b> 將其關閉。 若此任務需要 PIC 或 EQR 簽名，請從以下選項中選擇。",
	closeLabel: "關閉",
	handoffto: "移交至下一位團隊成員",
	missingToUserError: "必須的",
	markCompleteConfirm: "標記完成",
	markCompleteModalHeaderTextPart1: "此任務將標記為完成。",
	markCompleteModalHeaderTextPart2: "要簽名證據資料，請從以下選項中進行選擇。 若您有一個指派事項任務並已完成，請選擇<b>是</b> 將其關閉。 若此任務需要 PIC 或 EQR 簽名，請從以下選項中選擇。",
	signOffOnAllAs: "全部簽名為",
	preparer: "編製者",
	reviewer: "複核者",
	none: "不適用",
	noSignOffsByMe: "無由我簽名的",
	myPreparerSignOffs: "我的編製者簽核",
	myReviewerSignOffs: "我的複核者簽核",
	myPreparerAndReviewerSignOffs: "我的編製者和複核者簽名",
	preparerTitle: "編製者簽名",
	reviewerTitle: "複核者簽名",
	autoAssignmentMessage: "該團隊成員沒有指派事項。 {0} 將建立到期日為 {1} 的指派事項。 要編輯此指派事項 {2}。",
	clickHere: "點擊這裡",
	noTaskEvidencesHandoffModal: "沒有與此任務關聯的證據資料。",
	// Create Assignment
	createAssignment: "建立指派事項",
	create: "建立",
	cancelLabel: "取消",
	createassignmentheader1: "選擇的團隊成員沒有此任務的指派事項。",
	createassignmentheader2: "在此處建立指派事項。",
	dueDate: "到期日",
	teamMemberAssigmentLabel: "團隊成員",
	daysPriorToEndDate: "到期日前的天數",
	// Add Assignment
	addAssignmentTitle: "新增指派事項名稱",
	confirmButtonLabel: "新增",
	cancelButtonLabel: "取消",
	assignmentTypeInstructionalText: "選擇指派事項類型並在下方輸入名稱。 完成後點擊+F204<b>新增</b>。",
	assignmentType: "指派事項類型",
	required: "必須的",
	clearHoverText: "清除",
	unmarkcomplete: "取消標記完成",
	markCompleteErrorMessage: "無法將任務標記為完成。 請重新整理頁面並重試。若錯誤仍持續，請聯絡Help Desk。",
	// Assignment Dropdown
	noResultFound: "未找到結果",
	addTaskGroupLabel: "新增任務群組",
	addAssignmentName: "新增指派事項名稱",
	assignmentName: "指派事項名稱",
	additionalSignOff: "額外必須的簽名",
	signoffRequirementsModalPICLabel: "PIC",
	signoffRequirementsModalEQRLabel: "EQR",
	closeMyAssignment: "關閉我的指派事項",
	filterYes: "是",
	filterNo: "否",
	assignmentTypeLabels: [{
		id: assignmentTypes.preparer,
		label: "編製者"
	},
	{
		id: assignmentTypes.detailReviewer,
		label: "詳細複核者"
	},
	{
		id: assignmentTypes.generalReviewer,
		label: "一般複核者"
	},
	{
		id: assignmentTypes.partner,
		label: "會計師"
	},
	{
		id: assignmentTypes.eqr,
		label: "EQR"
	},
	{
		id: assignmentTypes.other,
		label: "其他"
	}
	]
};

export const displayedOn = {
	"Account": "科目",
	"SCOT": "SCOT",
	"IT/SO": "IT/SO",
	"Scope & Strategy": "範圍與策略",
	"Execution": "執行",
	"Conclusion": "結論"
}

export const auditPlanReportLabels = {
	adc: "相關對象",
	secondaryObject: "次要相關對象",
	taskTypeColumn: "任務類型",
	taskNamePrefix: "Task prefix",
	taskName: "任務標題",
	taskNameSuffix: "Task suffix",
	taskDescription: "任務描述",
	auditTaskStatus: "任務狀態",
	rationaleForRejection: "拒絕解釋",
	knowledgeTaskTitle: "知識任務標題",
	knowledgeTaskDescription: "知識任務描述",
	assignedTo: "指派給",
	engagementTagGroupName: "標記團隊",
	engagementTagName: "標記",
	prioritized: "優先的",
	viewDisplayedOn: "顯示於視窗上",
	engagementPhase: "案件階段",
	milestone: "里程碑",
	periodName: "時間階段",
	riskTypeAbbr: "相關風險類型",
	riskName: "相關風險名稱",
	relatedMESTEntityName: "相關 MEST 個體",
	scheduledNextWaveservices: "集中服務",
	taskID: "任務 ID",
	timephaseID: "時間階段 ID",
	taskTypeID: "任務類型 ID",
	timephaseTypeID: "時間階段類型 ID"
}

export const reportingTaskAll = {
	taskType: labels.taskType,
	taskStatus: labels.taskStatusLabel,
	taskAssignedTo: labels.taskassignedto,
	taskNamePrefix: labels.taskPrefix,
	task_Name: labels.repTaskTitle,
	taskNameSuffix: labels.taskSuffix,
	taskDescription: labels.repTaskDescription,
	knowledge_Task_Title: "知識任務標題",
	knowledge_Task_Description: "知識任務描述",
	rejected: labels.rejected,
	rationale_for_Rejection: "Rationale for rejection",
	audit_Phase: labels.auditPhasesLabel,
	milestonename: labels.filterMilestoneLabel,
	periodName: labels.timephase,
	timephasestartdateinutc: "時間階段開始日期（UTC）",
	timephaseduedateinutc: "時間階段到期日（UTC）",
	taskSourceType: labels.repTaskSource,
	taskNatureType: labels.repTaskNature,
	lastTaskChangeDateInUTC: "上次任務狀態更改日期（UTC）",
	engagementTagGroupName: labels.manageTagGroupName,
	engagementTagName: labels.tagsLabel,
	mesT_Entity_Name: "相關 MEST 個體",
	multiEntityType: "Multi entity type",
	taskID: "任務 Id",
	taskTypeID: "任務類型 ID",
	taskStatusID: "任務狀態 id",
	auditPhaseID: "查核階段 id",
	timephaseTypeID: "里程碑 id",
	taskSourceTypeID: "任務來源 ID",
	taskNatureTypeID: "任務性質 id",
	cgTaskID: "KnowledgeTaskID",
	knowledgeContentID: "KnowledgeContentID"
}

export const reportTaskAssignments = {
	taskNamePrefix: labels.taskPrefix,
	taskName: labels.repTaskTitle,
	taskNameSuffix: labels.taskSuffix,
	taskDescription: labels.repTaskDescription,
	taskTypeName: labels.taskType,
	taskSourceType: labels.repTaskSource,
	taskNatureType: labels.repTaskNature,
	auditPhaseName: labels.engagementPhase,
	milestones: labels.filterMilestoneLabel,
	periodName: labels.timephase,
	PICSignoffRequired: "須 PIC 簽核",
	EQRSignoffRequired: "須 EQR 簽核",
	taskStatusName: labels.taskStatusLabel,
	taskDueDateInUTC: "任務到期日（UTC）",
	engagementTagGroupName: labels.manageTagGroupName,
	engagementTagName: labels.tagsLabel,
	completedAssignment: labels.completedAssignments,
	totalAssignment: "所有指派事項",
	closedTaskAssignmentPercent: "已關閉的任務指派百分比",
	assignmentOrder: "指派順序",
	firstNameVal: "任務指派團隊成員的名字",
	lastNameVal: "任務指派團隊成員的姓氏",
	assignmentName: labels.assignmentName,
	assignmentTypeName: labels.filterAssignmentTypeLabel,
	roleName: "案件使用者角色",
	assignmentStatusVal: "任務指派狀態",
	dueDays: "到期日",
	completedDateInUTC: "完成日期（UTC）",
	assignmentDueDateInUTC: "指派事項到期日（UTC）",
	daysCompleteBeforeDueDate: "任務指派到期日前的剩餘天數",
	daysCompleteAfterDueDate: "任務指派到期日後的逾期天數",
	closedEarlyOrLate: "提早/較晚關閉",
	closedDaysEarly: "提早關閉",
	closedDaysLate: "較晚關閉",
	oldTaskName: "遺留任務標題",
	oldTaskDetail: "遺留任務說明",
	taskID: 'Task ID',
	assignmentID: 'Assignment ID',
	roleID: 'Role ID',
	userID: 'User ID'
}

export const reportingMultiEntityTask = {
	engagementID: "EngagementId",
	taskID: "TaskId",
	taskNamePrefix: labels.taskPrefix,
	task_Name: labels.repTaskTitle,
	taskNameSuffix: labels.taskSuffix,
	taskDescription: labels.repTaskDescription,
	mesT_Entity_Name: "Related entity",
	multiEntityType: "MultiEntityType",
	taskTypeID: "TaskTypeID",
	taskStatusID: "TaskStatusID"
}

export const reportingManageteamInternal = {
	firstName: labels.firstnameLabel,
	lastName: labels.lastnameLabel,
	userInitials: labels.initialsLabel,
	emailAddress: labels.editExternalEmailLabel,
	gui: "GUI",
	engagementRole: labels.engagementrole,
	hasOverallResponsability: "全面負責",
	userStatus: "狀態",
	independenceStatus: "獨立狀態",
	grantedAccess: "歸檔後授予訪問權限",
	primaryOffice: "主要辦公室",
	preferredContactPhone: "電話號碼",
	engagementUserStatusID: "案件使用者狀態 ID",
	engagementRoleID: "案件角色 ID",
	independenceStatusID: "獨立狀態 ID"
}

export const reportingManageteamExternal = {
	clientGroupName: "團隊名字",
	firstName: labels.firstnameLabel,
	lastName: labels.lastnameLabel,
	userInitials: labels.initialsLabel,
	emailAddress: labels.editExternalEmailLabel,
	domain: "使用者網域",
	validDomainWithinGroup: "團隊內的有效網域",
	userStatus: "使用者狀態",
	preferredContactPhone: "首選電話號碼"
};

export const controlDesignEffectivenessType = {
	1: "有效的",
	2: "無效的"
};

export const itAppSOSummaryReportLabels = {
	itApplicationName: "IT應用程序/服務機構",
	strategyTypeName: "IT策略",
	typeName: "類型",
	itProcessName: "IT流程",
	itRiskName: "IT風險",
	itControlName: "ITGC/ITSP",
	natureOfTest: "測試性質",
	controlFrequencyTypeNameColumn: 'Frequency',
	testing: "測試",
	designEffectiveness: "設計有效性",
	evaluation: 'IT process evaluation'
};

export const ArchiveReportLabels = {
	engagementDescription: "案件說明",
	archiveReportQualifiedNameSection: "Report qualified",
	archiveReportQualifiedTypeNameSection: "Report qualified 類型",
	archiveFolderDescription: "歸檔資料夾說明",
	archiveFolderTypeNameSection: "資料夾類型",
	location: "地點",
	archiveComments: "歸檔註解",
	engagementID: "案件 ID",
	archiveCountryOfficeRegionID: "歸檔 country office region ID",
	archiveReportQualifiedID: "歸檔 report qualified ID",
	archiveReportQualifiedTypeID: "歸檔 report qualified type ID"
};

export const canvasFormRelatedCommentsLabels = {
	canvasFormName: "Canvas表單名稱",
	order1: "HeaderOrder",
	formHeaderName: "Header",
	order2: "SectionOrder",
	order3: "BodyOrder",
	formBodyResponseValue: "回覆",
	commentNumber: "註解數",
	author: "作者",
	assignedTo: "指派給",
	createDateSection: "建立日期",
	commentStatusSection: "狀態",
	commentText: "註解",
	commentVoiceNote: "有語音註記",
	reply: "回覆",
	replyVoiceNote: "有語音註記"
};

export const canvasFormRelatedObjectsLabels = {
	canvasFormName: "Canvas表單名稱",
	order1: "HeaderOrder",
	formHeaderName: "Header",
	formHeaderID: "FormHeaderID",
	order2: "SectionOrder",
	formSectionID: "FormSectionID",
	formSectionName: "段落",
	firstLevelEntityColumn: "First level entity",
	firstLevelRelatedObject: "First level related object",
	secondLevelEntityColumn: "Second level entity",
	secondLevelRelatedObject: "Second level related object"
};

export const canvasFormResponseLabels = {
	canvasFormName: "Canvas表單名稱",
	order1: "標題指令",
	formHeaderName: "標題",
	knowledgeFormHeaderID: "標題知識ID",
	headerKnowledgeContentID: "標題知識內容ID",
	order2: "段落指令",
	formSectionName: "段落",
	knowledgeFormSectionID: "段落知識ID",
	sectionKnowledgeContentID: "段落知識內容ID",
	order3: "內文指令",
	formBody: "內文",
	knowledgeFormBodyID: "內文知識ID",
	bodyKnowledgeContentID: "內文知識內容ID",
	formBodyResponse_Value: 'Response'
};

export const CanvasFormsIncompleteLabels = {
	canvasFormName: "Canvas表單名稱",
	header: "Header",
	headerOrder: "HeaderOrder",
	sectionOrder: "SectionOrder",
	bodyOrder: "BodyOrder",
	body: "Body",
	formHeaderID: "FormHeaderID",
	formSectionID: "FormSectionID",
	formBodyID: "FormBodyID"
};

export const controlFormResponseLabels = {
	controlName: "控制",
	documentName: "文件",
	engagementDescription: "案件說明",
	formHeader: "Header",
	headerKnowledgeDisplayOrder: "HeaderKnowledgeDisplayOrder",
	formSection: "Section",
	sectionKnowledgeDisplayOrder: "SectionKnowledgeDisplayOrder",
	formBodyVal: "Body",
	bodyKnowledgeDisplayOrder: "BodyKnowledgeDisplayOrder",
	ControlTesting: "有控制測試",
	controlFrequencyType: "控制頻率",
	Effective: "是有效的",
	formBodyOptionVal: "Form option body value",
	controlType: "控制類型",
	controlDesignEffectivenessType: "控制設計有效性類型"
};

export const itProcessSummaryLabels = {
	itProcessName: "IT流程",
	itProcessEvaluation: "IT流程評估",
	itProcesSupportingRationale: "支持解釋",
	itRiskName: "IT風險",
	itControlName: "ITGCs/ITSPs",
	natureOfTest: "測試性質",
	controlFrequencyTypeId: "頻率",
	testing: "測試",
	designEffectiveness: "設計有效性",
	operatingEffectiveness: "Operating effectiveness"
}

export const itProcessScotControlsLabels = {
	itProcessName: "IT流程",
	scotName: "SCOT",
	controlName: "控制",
	controlDesignEffectivenessTypeName: "設計有效性",
	testing: "測試",
	operatingEffectiveness: "經營效益",
	controlTypeName: "控制類型",
	isIPEManuallyTestedName: "是 IPE 人工測試",
	itApplicationName: "IT應用程序",
	aggregateITEvaluationTypeName: "綜合 IT 評估"
};

export const scotsControlsReportLabels = {
	scotName: "SCOT",
	controlName: "控制",
	operatingEffectiveness: "經營效益",
	itApplicationName: "IT應用程序",
	aggregateITEvaluation: "綜合 IT 評估",
	supportingRationaleControlLabel: "支持解釋"
}

export const sCOTSummaryReportHeaderLabels = {
	scotName: "SCOT",
	scotTypeName: "交易類型",
	strategyTypeName: "SCOT策略",
	itApplicationName: "SCOT IT 應用程序/SO",
	wcgwName: labels.wcgw,
	controlName: labels.control,
	controlFrequencyTypeName: labels.frequencyLabel,
	controlTypeName: "控制類型",
	testing: "測試",
	operatingEffectiveness: "經營效益",
	controlITApplication: "控制 IT 應用程序/SO",
	aggregateITEvaluationTypeName: "綜合 IT 評估",
	supportingRationale: "支持解釋",
	scotId: "SCOT ID",
	strategyTypeID: "策略類型 ID",
	scotTypeID: "SCOT 類型 ID",
	wcgwid: "WCGW ID",
	controlID: "控制 ID",
	controlFrequencyTypeID: "控制頻率類型 ID",
	controlTypeID: "控制類型 ID",
	aggregateITEvaluationTypeID: "彙總 IT 評估類型 ID"
};

export const findingsDeficiencyHeaderLabels = {
	description: "缺失描述",
	controls: "控制",
	controlsIsEffective: "控制的運行有效性",
	type: "缺失類型",
	magnitude: "重要性",
	responseText: "回應文字",
	remediatedAtYearEnd: "年底補救",
	mitigatingControls: "補償性控制",
	mitigatingControlsIsEffective: "補償性控制的運行效果",
	mitigatingTasks: "減免任務",
	foundIn: "在文件中找到",
	accountsAndAssertions: "科目和聲明",
	scoTs: "SCOTs",
	deficiencyID: "缺失 ID",
	controlID: "控制 ID",
	mitigatedControlID: "減免控制 ID",
	mitigatedTaskID: "減免任務 ID",
	documentID: "文件 ID",
	accountID: "科目 ID",
	scotID: "SCOT ID"
};

export const findingsMisstatementHeaderLabels = {
	description: "不實表達說明",
	type: "不實表達類型",
	trialBalance: "試算表",
	period: "期間",
	accountNumber: "科目編號",
	accountName: "科目名稱",
	accountType: "科目類型",
	debit: "借方",
	credit: "貸方",
	responseText: "回應文字",
	correctedUncorrected: "正確/未更正",
	mitigatingTasks: "減免任務",
	foundInDocument: "在文件中找到",
	accountsAndAssertions: "科目和聲明",
	misstatementID: "不實表達ID",
	trialBalanceID: "試算表 ID",
	misstatementAdjustmentID: "不實表達調整 ID"
};

export const findingsDeficiencyITHeaderLabels = {
	itApplicationName: "IT應用程序名稱",
	itProcessName: "IT 流程名稱",
	itControlName: "IT 控制名稱",
	itApproachTypeName: "IT 方法類型",
	isEffective: "控制效果",
	referenceNumber: "參考編號",
	description: "缺失描述",
	deficiencyMagnitudeName: "缺失重要性",
	deficiencyTypeName: "缺失類型"
};

export const auditPlanRelatedEvidenceReportHeaderLabels = {
	adc: "相關對象",
	secondaryObject: "相關控制/證實性程序",
	taskName: "任務標題",
	taskDescription: "任務描述",
	taskTypeColumn: "任務類型",
	taskStatusValue: "任務狀態",
	rationaleForRejection: "拒絕解釋",
	engagementPhase: "案件階段",
	milestone: "里程碑",
	periodName: "時間階段",
	assignedTo: "指派給",
	engagementTagGroupName: "標記團隊",
	engagementTagName: "標記",
	displayedOn: "顯示於視窗上",
	documentName: "文件名稱",
	preparersValue: "編製者（UTC 日期）",
	reviewersValue: "複核者（UTC 日期）",
	openReviewNotes: "打開複核註記",
	closedReviewNotes: "清除複核註記",
	trackChangesValue: "追蹤變化",
	lastModifiedBy: "最後修改者",
	lastModifiedDateValue: "最後修改日期（UTC）",
	taskID: "任務 ID",
	timephaseID: "時間階段 ID",
	taskTypeID: "任務類型 ID",
	documentTypeID: "文件類型 ID",
	parentDocumentTypeID: "母文件類型 ID",
	timePhaseTypeID: "時間階段類型 ID"
};

// group instruction summary
export const groupInstructionSummaryReportHeaderLabels = {
	sectionName: "部分",
	gaInstructionName: "指引標題",
	gaInstructionDescription: "指引說明",
	documents: "文件名稱",
	knowledgeInstructionName: "知識指引標題",
	knowledgeInstructionDescription: "知識指引說明",
	gaScopeName: "相關範圍/子範圍",
	componentOnly: "範圍/單獨指引",
	shortName: "區域/組成名稱",
	cSection: "自定義部分",
	customInstruction: "自定義指引",
	gAinstructionID: "GA 指引 ID"
};

// GIS last publish and send
export const gIsLastPublishAndSendReportHeaderLabels = {
	primaryEngagementID: "Engagement ID",
	gaScopeID: "GA scope ID",
	gaScopeName: "Scope",
	gaComponentID: "GA component ID",
	shortName: "Component name",
	lastPublishedDateInUTC: "Last published date",
	lastSentDateInUTC: "Last sent date",
	gaLinkStatusId: "Link status",
	gaInstructionStatusId: "Instruction status"
};

// Group Activity
export const groupActivityReportHeaderLabels = {
	engagementID: "Engagement ID",
	gaScopeID: "GA scope ID",
	gaScopeName: "Scope",
	gaComponentID: "GA component ID",
	shortName: "Component name",
	gaLinkStatusId: "Link status",
	accountID: "Account ID",
	accountName: "Account name",
	accountType: "Account designation",
	activityTypeID: 'Activity type ID',
	activityTypeText: 'Activity type',
	modifyDateInUTC: "Modify date",
	modifyUser: "Modify user",
};

export const AccountDisclosuresReportHeadeLabels = {
	engagementID: "Engagement ID",
	accountID: "Account ID",
	accountName: "Account name",
	accountTypeID: "Account type ID",
	accountTypeId: "Account designation",
	knowledgeAssertionId: "Assertion Abbreviation",
	inherentRiskTypeId: "Inherent risk assessment",
	controlRiskTypeId: "Control risk assessment",
	craValue: "CRA",
	riskID: "Risk ID",
	riskTypeID: "Risk type ID",
	riskType: "Risk type",
	riskName: "Risk name",
	isHigherRiskValue: "Is higher risk",
};

// CRA summary
export const craSummaryReportHeaderLabels = {
	accountName: "科目",
	accountTypeName: "科目類型",
	rationale: "解釋",
	pspIndex: "PSP索引",
	conclusionStatement: "科目結論聲明",
	scotName: "SCOTs",
	transactionType: "交易類型",
	strategyTypeName: "SCOT策略",
	wcgwName: "WCGW",
	controlName: "控制",
	controlFrequencyTypeName: "頻率",
	controlTypeName: "控制類型",
	testing: "測試",
	operatingEffectiveness: "經營效益",
	itApplicationName: "SCOT IT 應用程序/SO",
	controlITApplication: "控制 IT 應用程序/SO"
};

export const craSummaryAssertionReportHeaderLabels = {
	accountName: "科目",
	accountTypeName: "科目類型",
	rationale: "解釋",
	pspIndex: "PSP索引",
	assertionAbbreviation: "聲明",
	riskName: "風險",
	inherentRiskTypeName: "固有風險評估",
	controlRiskTypeName: "控制風險評估",
	craValue: "CRA",
	wcgwName: "WCGW",
	controlName: "控制",
	controLFrequencyTypeName: "頻率",
	controlTypeName: "控制類型",
	testing: "測試",
	isLowerR: "降低風險",
	operatingEffectiveness: "經營效益",
	itApplicationName: "IT 應用程式/ SO"
};

export const craSummaryDataReportHeaderLabels = {
	wcgwName: "WCGW",
	controlName: "控制",
	controLFrequencyTypeName: "控制頻率",
	controlTypeName: "控制類型",
	itApplicationName: "IT application",
	assertionName: "聲明",
	statementTypeName: "Statement type",
	accountTypeName: "科目類型",
	assertionAbbreviation: "聲明縮寫",
	inherentRiskTypeName: "固有風險",
	controlRiskTypeName: "控制風險",
	craValue: "CRA",
	riskTypeAbbreviation: "風險縮寫",
	frequency: "頻率",
	accountName: "科目",
	riskName: "風險",
	pspIndex: "PSP index",
	testing: "測試",
	operatingEffectiveness: "Operating effectiveness",
	isLowerRiskColumn: "Is lower risk",
	scotName: "SCOT",
	controlitApplicationName: "Control IT application",
	rationale: "Rationale",
	accountID: "科目ID",
	riskID: "Risk ID",
	scotid: "SCOT ID",
	wcgwid: "WCGW ID",
	controlID: "控制 ID",
	itApplicationID: "IT application ID",
	knowledgeAssertionID: "Knowledge assertion ID",
	controlTypeID: "控制類型 ID",
	controlFrequencyTypeID: "控制頻率類型 ID",
	accountTypeID: "科目類型 ID",
	riskTypeID: "風險類型 ID",
	inherentRiskTypeID: "固有風險類型 ID",
	controlRiskTypeID: "控制風險類型 ID",
	statementTypeID: "Statement type ID",
	conclusionStatement: "科目結論陳述"
};

export const reportingRequestsAndTasks = {
	requestTitle: "請求/任務標題",
	request_Description: "請求/任務描述",
	type: "類型",
	tasks: "任務標題",
	engagementTagName: "標記",
	eyAssigned: "安永指定使用者",
	clientGroupName: "外部團隊",
	externalAssignedUser: "外部指定使用者",
	periodName: "時間階段",
	dueDateInUTC: "到期日（UTC）",
	requestStatus: "請求/任務狀態",
	documentType: "文件類型",
	documentName: 'Current year document name',
	priorYearDocumentName: 'Prior year document name',
	externalDocumentSignOffInUTC: "外部文件簽核（UTC）",
	clientRequestReferenceNumber: "客戶請求參考編號"
};

export const reportingRequestComment = {
	requestTitle: "請求/任務標題",
	request_Description: "請求/任務描述",
	type: "類型",
	tasks: "任務標題",
	engagementTagName: "標記",
	eyAssigned: "安永指定使用者",
	clientGroupName: "外部團隊",
	externalAssignedUser: "外部指定使用者",
	periodName: "時間階段",
	dueDateInUTC: "到期日（UTC）",
	requestStatus: "請求/任務狀態",
	externalDocumentSignOffInUTC: "外部文件簽核（UTC）",
	annotationTextData: "註解",
	createDateInUTC: "註解日期（UTC）",
	annotationUserInitials: "註解由"
};

export const reportingAllDocuments = {
	documentName: "文件名稱",
	fileExt: "文件副檔名",
	canvasFormType: "Canvas表單類型",
	docType: "文件類型",
	confidentiality: "機密",
	docFileSize: "文件大小 (KB)",
	preparers: 'Preparers (in UTC)',
	reviewers: 'Reviewers (in UTC)',
	relatedTask: "相關任務",
	openReviewNote: "打開複核註記",
	clearedReviewNote: "清除複核註記",
	trackChanges: "追蹤變化",
	hiddenSheets: "隱藏頁籤",
	comments: "評論",
	highlighted: "強調",
	conflicted: "衝突",
	docModifyUser: "最後修改者",
	docModifyDateInUTC: "最後修改日期（UTC）",
	documentID: "文件 ID"
};

export const signOffDocuments = {
	documentName: "文件名稱",
	fileExt: "檔案副檔名",
	canvasFormType: "Canvas表單類型",
	docType: "文件類型",
	confidentiality: "保密",
	docFileSize: "文件大小 (KB)",
	docModifyUser: "最後修改者",
	docModifyDateInUTC: "最後修改日期（UTC）",
	signOffDate: "簽核日期（UTC）",
	signedOffBy: "簽核人",
	role: "角色",
	preparerReviewer: "編製者/複核者"
};

export const reportingDocumentsModified = {
	documentName: "文件名稱",
	lastModifiedDateInUTC: "最後修改日期（UTC）",
	lastModifiedUser: "最後修改的使用者",
	reason: "原因",
	documentChangeComment: "解釋",
	preparersInUTC: "編製者（UTC）",
	reviewersInUTC: "複核者（UTC）",
	approver: "核准（UTC）"
};

export const reportingDeletedTaskReport = {
	taskNamePrefix: labels.taskPrefix,
	taskName: "任務標題",
	taskNameSuffix: labels.taskSuffix,
	taskDescription: "任務說明",
	taskTypeAbbreviation: "任務類型",
	taskSourceType: "任務來源",
	taskNatureType: "任務性質",
	last_Modified_By: "最後修改者",
	modifyDateInUTC: "最後修改日期（UTC）",
	oldTaskName: "遺留任務標題",
	oldTaskDetail: "遺留任務說明"
};

export const SEMReportHeaderLabel = {
	accountAssertion: "科目/聲明",
	craValue: "CRA",
	riskOfMaterialMisstatements: labels.riskOfMaterialMisstatement,
	relatedRisks: "相關風險",
	taskType: "任務類型",
	taskTitle: "任務標題",
	taskSource: labels.source,
	taskNature: labels.nature,
	taskTypeID: "任務類型 ID",
	taskSourceTypeID: "任務源類型 ID",
	taskNatureTypeID: "任務性質類型 ID"
}

export const MilestonesReportHeaderLabels = {
	taskName: labels.repTaskTitle,
	taskType: labels.taskType,
	taskStatus: labels.taskStatusLabel,
	auditPhase: labels.auditPhasesLabel,
	periodName: labels.timephase,
	timephase: "目前的里程碑",
	correctTimephase: "正確的里程碑"
}

export const MilestonesReportHeader = {
	milestone: "里程碑",
	status: "里程碑狀態",
	taskStatus: "任務狀態",
	taskTitle: "任務標題",
	taskTypeAbbreviationColumn: "任務類型縮寫",
	taskType: "任務類型",
	timePhase: "時間階段",
	assignedTo: "指派給",
	taskName: "任務名稱",
	task_Detail: "Task detail",
	due_Date: 'Due date',
	documentName: "文件名稱",
	preparers: "編製者",
	reviewers: "複核者",
	tagGroup: "標籤群組",
	tags: "標籤",
	engagementID: "案件 ID",
	taskID: "任務 ID",
	taskTypeID: "任務類型 ID",
	taskStatusID: "任務狀態 ID",
	timephaseID: "時間階段 ID",
	timephaseTypeID: "時間階段類型 ID",
	documentID: "文件 ID"
}

export const groupStructureSummaryReportHeaderLabels = {
	gaScopeName: "範圍說明",
	gaScopeDescription: "範圍/子範圍名稱",
	shortName: "區域/組成名稱",
	legalName: "法定名稱",
	gaRoleTypeName: "集團角色",
	relatedRegion: "相關地區",
	pocText: "聯絡人",
	gaLinkStatusName: "連結狀態",
	gaInstructionStatusName: "指引狀態",
	engagementID: "案件ID",
	gaRoleTypeID: "GARoleTypeID",
	gaLinkStatusID: "GALinkStatusID",
	gaInstructionStatusID: "GA指引狀態ID"
}

export const collaborationSummary = {
	clientRequestID: "請求號碼",
	requestTitle: "標題",
	requestType: "類型",
	engagementTagName: "標記",
	clientUser: "指派給",
	clientEmail: "客戶電子郵件",
	clientStatusName: "狀態",
	isOverDue: "逾期",
	dueDateInUTC: "到期日（UTC）",
	eySentDateInUTC: "EY 發送日期（UTC）",
	eyReceivedDateInUTC: "接收日期（UTC）",
	deliveredLate: "遲交",
	daysLate: "晚了幾天",
	timesReturned: "返回次數"
}

export const collaborationActivity = {
	clientRequestID: "請求號碼",
	requestTitle: "標題",
	requestType: "類型",
	engagementTagName: "標記",
	clientUser: "指派給",
	clientEmail: "客戶電子郵件",
	clientStatusName: "地位",
	isOverDue: "逾期",
	dueDateInUTC: "到期日（UTC）",
	eySentDateInUTC: "EY 發送日期（UTC）",
	eyReceivedDateInUTC: "接收日期（UTC）",
	deliveredLate: "遲交",
	daysLate: "晚了幾天",
	timesReturned: "返回次數",
	activity: "活動",
	activityDateInUTC: "活動日期（UTC）",
	historicalDueDateInUTC: "歷史到期日（UTC）"
}

export const groupReportHeaderLabels = {
	gaInstructionName: "指引名稱",
	gascopeTypeIDName: labels.scope,
	componentName: "組成名稱",
	pointOfContact: labels.pointOfContact,
	dueDateValue: "到期日（UTC）",
	overdueValue: labels.overdueLabel,
	gaStatusIdName: labels.status,
	documentName: labels.documents,
	createDateValue: "簽核日期（UTC）",
	signoffBy: labels.signedOffBy,
	engagementRoleIDName: labels.role,
	isPreparerText: "編製者/複核者",
	documentID: "文件編號",
	gaStatusID: "GA 狀態 ID",
	engagementRoleID: "案件角色 ID"
}

export const wcgwSummaryHeaders = {
	wcgwName: "WCGW",
	scotName: "SCOT",
	controlName: "相關控制",
	itApplications: "相關 IT 應用程序/SO",
	testing: "測試選擇",
	isLowerR: "較低風險",
	controlFrequencyTypeName: "控制頻率",
	controlTypeName: "控制類型",
	wcgwCount: "其他相關 WCGW 的計數"
}

export const allControlsHeaders = {
	engagementID: 'EngagementID',
	scotid: 'SCOTID',
	controlID: 'ControlID',
	scotName: 'SCOT name',
	controlName: 'Control description',
	hasControlTesting: 'Testing selection',
	isLowerRisk: 'IsLowerRisk',
	controlTypeID: 'Control type',
	relatedITApplicationNames: 'Related IT App/SO',
	responsiveToSR: 'Responsive to a Significant Risk',
	IPE: 'IPE'
}


export const qualityChecksHeaders = {
	itemID: "項目 ID",
	itemName: "項目名稱",
	qualityChecks: "Quality check",
	validationDescription: "驗證說明",
	buildGroup: "建立群組",
	impactedItem: "影響項目",
	type: "類型"
}

export const statisticsHeaders = {
	scotname: "SCOT",
	strategyTypeId: "SCOT策略",
	wcgwName: "WCGW",
	controlName: "控制",
	operatingEvaluation: "Operating evaluation",
	itApplicationName: "Related IT app / SO",
	assertions: "聲明",
	controlTypeId: "控制類型",
	testingSelection: "測試選擇",
	controlFrequencyTypeId: "頻率",
	itApplications: "IT applications",
	scotTypeId: "SCOT 類型",
	itType: "IT app 類型",
	isLowerR: "Is lower risk",
	engagementID: "案件 ID",
	workspaceID: "工作區 ID",
	scotID: "SCOT ID",
	scotTypeID: "SCOT 類型 ID",
	wcgwid: "WCGW ID",
	controlID: "控制 ID"
}

export const CRTAssertionCountSummaryHeaders = {
	accountName: "科目",
	assertion: "聲明",
	controlName: "控制",
	ControlTypeName: "控制類型",
	ControlFrequencyTypeName: "頻率",
	Testing: "測試",
	OperatingEvaluation: "Operating evaluation",
	assertionControlCount: "聲明控制數",
	assertionAbbreviation: "聲明縮寫",
	wcgwName: "WCGW",
	engagementID: "案件 ID",
	workspaceID: "工作區 ID",
	assertionID: "聲明 ID",
	wcgwid: "WCGW ID",
	controlID: "控制 ID"
}

export const crtlistcontrolTypeName = {
	'IT Application Control': "IT Application Control",
	'IT Dependent Manual Control': "IT Dependent Manual Control",
	'Manual Prevent': "人工預防",
	'Manual Detect': "人工偵查"
}

export const controlFrequencyNameTypes = {
	'Many times per day': "每天多次",
	'Daily': "每天",
	'Weekly': "每週",
	'Monthly': "每月",
	'Quarterly': "每季",
	'Annually': "每年",
	'IT Application Control': "IT Application Control",
	'Other': "其他"
};

// Folder types
export const archiveFolderTypeNameTypes = {
	'Working Papers': "工作底稿",
	'Perm File Active': "Perm File Active",
	'Perm File Superseded': "Perm File Superseded",
	'Working Papers - CD/DVD': "工作底稿 - CD/DVD",
	'Perm File Active - CD/DVD': "Perm File Active - CD/DVD",
	'Perm File Superseded - CD/DVD': "Perm File Superseded - CD/DVD",
	'Data Storage Devices': "Data Storage Devices"
};

export const operatingEvaluationType = {
	'Effective': "有效的",
	'Ineffective': "無效的",
	'Not Selected': "未選取的"
};

export const CRTSCOTCountSummaryHeaders = {
	scotname: "SCOT",
	strategyTypeName: "SCOT策略",
	wcgwName: "相關 WCGWs",
	controlName: "相關控制",
	operatingEvaluation: "Operating evaluation",
	itApplicationName: "相關 IT app / SO",
	assertions: "聲明",
	controlTypeName: "控制類型",
	testing: "測試選擇",
	controlFrequencyTypeName: "頻率",
	itApplications: "IT applications",
	itAppType: "IT application 類型",
	scotTypeName: "SCOT 類型",
	soctisLowerRisk: "Lower risk control",
	engagementID: "案件 ID",
	workspaceID: "工作區 ID",
	scotID: "SCOT ID",
	scottypeid: "SCOT 類型 ID",
	wcgwid: "WCGW ID",
	controlID: "控制 ID"
};

export const projectInsightCanvasFormExportHeaders = {
	EngagementID: "案件ID",
	DocumentID: "文件ID",
	ControlID: "控制ID"
};

export const projectInsightSCOTToWCGWToControlHeaders = {
	engagementID: "EngagementID",
	scotName: "SCOTName",
	strategyTypeName: "StrategyTypeName",
	wcgwName: "WCGWName",
	controlID: "ControlID",
	controlName: "ControlName",
	controlFrequencyTypeName: "ControlFrequencyTypeName",
	controlTypeName: "ControlTypeName",
	isLowerRiskHeader: "IsLowerRisk",
	hasControlTestingHeader: "HasControlTesting",
	operativeEffectiveness: "Operative Effectiveness"
};

export const ComponentTeamGroupAccountInfoControlHeaders = {
	engagementId: "Engagement ID",
	accountId: "Account ID",
	accountName: "Account name",
	accountTypeId: "Account type ID",
	accountDesignation: "Account designation",
	pspIndexTitle: "PSP index",
	knowledgeAssertion: "Assertion abbreviation",
	inherentRiskType: "Inherent risk assessment",
	controlRiskType: "Control risk assessment",
	craValue: "CRA",
	riskId: "Risk ID",
	riskTypeId: "Risk type ID",
	riskTypeEnum: "Risk type",
	riskName: "Risk name",
	isHigherRiskText: "Is higher risk",
	rejectedTaskId: "Task ID",
	rejectedTaskName: "Rejected PSP",
	rejectedTaskRationale: "Rejected PSP Rationale"
};

export const projectInsightControlToITApplicationHeaders = {
	engagementID: "EngagementID",
	controlID: "ControlID",
	itApplicationID: "ITApplicationID",
	controlITApplication: "ControlITApplication"
};

export const projectInsightControlToAssertionHeaders = {
	engagementID: "EngagementID",
	controlID: "ControlID",
	Accountname: "AccountName",
	AssertionAbbreviation: "AssertionAbbreviation"
};

export const projectInsightRisksToWCGWsHeaders = {
	engagementId: "EngagementID", //show only in excel,
	accountName: "AccountName",
	accountId: "AccountID", //show only in excel,
	knowledgeAssertion: "Assertion",
	CRA: "CRA",
	RelatedRisk: "RelatedRisk",
	riskId: "RiskID", //show only in excel,
	riskType: "RiskType",
	WCGW: "WCGW",
	wcgwId: "WCGWID", //show only in excel,
	RelatedSCOT: "RelatedSCOT",
	scotId: "SCOTID" //show only in excel
};

export const ipeControlsHeaders = {
	EngagementID: "案件 ID",
	DocumentID: "文件 ID"
};

export const ipeSubstantiveHeaders = {
	EngagementID: "案件 ID",
	DocumentID: "文件 ID"
};

export const ipeITGCHeaders = {
	EngagementID: "案件 ID",
	DocumentID: "文件 ID"
};

export const iTAppSOReport = {
	relatedITSO: "Related IT app/SO",
	iTAppType: "IT app 類型",
	iTAppControl: "IT app 控制",
	testingSelection: "測試選擇",
	relatedSCOTs: "相關 SCOTs",
	relatedSCOTStrategy: "相關 SCOT 策略",
	itdm: "ITDM",
	manualPrevent: "人工預防",
	manualDetect: "人工偵查",
	noRelatedControls: "沒有相關控制",
	controlsStatistics: "按控制類型",
	relatedSCOTType: "相關 SCOT 類型",
	controlType: "控制類型",
	grandTotal: "全部的",
	yes: "是",
	no: "否",
	notSelected: "未選取的",
	controls: "控制",
	substantive: "證實",
	routine: "例行性",
	nonRoutine: "非例行性",
	estimation: "估計"
};

export const IndependenceSummaryReport = {
	id: "ID",
	userName: "使用者名稱",
	order: "Order",
	questionFormatted: "Question",
	answer: "回答",
	actionTypeID: "Action type ID",
	independenceStatusID: "獨立性狀態 ID",
	EngagementUserStatusName: "Engagement user status",
	engagementUserStatusID: "Engagement user status ID",
	IndependenceStatusName: "Independence status",
	requiresExecutiveClearance: "Requires executive clearance"
};

export const additionalInfoBasedOnValidationTypeId = {
	1: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	2: "團隊未使用最新版本的 109 - 團隊成員獨立性表單",
	3: "一名團隊成員授予另一名具有獨立性問題的團隊成員訪問權限後，從 PPEDD 角色變更了角色",
	4: "一名團隊成員覆蓋另一名具有獨立性問題的團隊成員後，從 PPEDD 角色變更了角色",
	5: "點選驗證連結，辨認沒有數字徽章的SCOT。將該SCOT與一個科目連結。",
	6: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	7: "辨認相關 WCGW 計數為空白的 SCOT。前往到相應的建置任務。展開 SCOT 並根據需要新增 WCGW",
	8: "辨認相關控制計數為空白的 SCOT。 前往到相應的建置任務。展開 SCOT 並將 WCGW 新增一個控制",
	9: "透過驗證辨認 SCOT，展開 SCOT 細節並驗證每個 WCGW 至少有一個控制已選擇“是”進行測試",
	10: "透過驗證辨認 SCOT，展開 SCOT 細節並驗證每個 WCGW 至少有一個控制已選擇“是”進行測試",
	11: "點選驗證連結，辨認沒有數字徽章的風險。將適當的聲明與風險相連結",
	12: "辨認缺少固有和/或控制風險的聲明。完成缺少的部分",
	13: "點選驗證連結並開啟“新增 WCGW”。 一次選擇一個 SCOT，並辨認沒有數字徽章的 WCGW。 將 WCGW 與適當的聲明相連結",
	14: "辨認沒有數字徽章的科目。 前往至 SCOT 建置流程並將 SCOT 與科目相連結",
	15: "透過驗證辨認科目/聲明，點選新增 WCGW 並將 WCGW 與聲明相連結",
	16: "此驗證檢查確保為控制策略之聲明相關的所有 WCGWs 都有進行測試的控制。透過驗證辨認聲明，點選新增 WCGW 並將 WCGW 與聲明相連結",
	17: "複核與聲明相關的每個 WCGW，並驗證它是否至少有一個測試策略為“是”的控制",
	18: "對於採取仰賴策略的聲明，所有WCGW都必須由測試設定為「是」的控制所涵蓋",
	19: "IT/SO 具有未刪除或與 IT/SO 流程相關的仰賴策略",
	20: "IT/SO 控制/IT 證實程序與 IT/SO 風險不相關",
	21: "建立 IT/SO 流程後，策略從「仰賴」變更為「不仰賴」",
	22: "風險與聲明不相關",
	23: "IT/SO 控制/IT 證實程序與 IT/SO 風險不相關",
	24: "未選擇與 IT/SO 風險相關的 IT/SO 控制/證實程序進行測試",
	25: "IT/SO 控制/IT 證實程序與 IT/SO 風險不相關",
	26: "辨認沒有任何任務的有限風險科目。新增一個或多個 OSP",
	27: "驗證您是否已匯入 PSP。若尚未匯入 PSP，請點選匯入 PSP。若聲明沒有 PSP，則建立 OSP",
	28: "前往至 SCOT 建置流程，開啟“新增控制測試”，辨認沒有數字徽章標記的 TOC 任務。 將 TOC 任務與控制相連結",
	29: "案件包含至少一項穿透測試任務尚未與 SCOT 關聯",
	30: "SCOT 沒有至少一項與其關聯的穿透測試任務",
	31: "前往至 SCOT 建置流程，開啟“新增控制測試”，辨認沒有數字徽章標記的 TOC 任務。 將 TOC 任務與控制相連結",
	32: "IT/SO 穿透測試與至少一個 IT/SO 流程不相關",
	33: "沒有至少一項測試設定為「是」的IT/SO控制/證實程序與IT/SO控制測試相關",
	34: "IT/SO 其他證實程序與至少一個測試設定為「是」的 IT/SO 控制/證實程序不相關",
	35: "IT/SO 流程沒有至少一個與其關聯的穿透測試任務",
	36: "測試設定為「是」的控制沒有與其關聯的控制測試任務",
	37: "IT/SO 其他證實程序與至少一個測試設定為「是」的 IT/SO 控制/證實程序不相關",
	38: "點選驗證連結，從證據列表中點選衝突圖示以解決衝突",
	39: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	40: "點選驗證連結，在缺少編製者或複核者簽名的文件列表上進行簽名。僅簽名您已編製或複核的文件",
	41: "點選驗證連結，從已過濾的任務列表中複核每個任務及相關適當的證據文件",
	42: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	43: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	44: "點選驗證連結，從證據列表中重新命名具有重複名稱的文件",
	45: "IT 流程評估尚未被選擇或與 ITCG/ITSP 營運有效性評估不一致",
	46: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	47: "尚未為一個或多個應用程序/ITDM 控制選擇總計 IT 評估",
	48: "Canvas表單至少有一個欄位尚未填寫",
	49: "點選驗證連結，然後點選新增聲明以連結相關聲明或有限風險科目",
	50: "沒有關聯的聲明或有限風險科目的任務。 點選「新增聲明」以關聯聲明或有限風險科目",
	51: "WCGW 與證實任務不相關",
	52: "該案件至少存在一項固有、重大或舞弊風險，並且未與至少一個WCGW關聯",
	53: "缺少EST會計估計索引的估計科目。請從PSP索引列表中加入",
	54: "辨識具有估計的科目，並打開該科目以檢視其是否有與之相關的估計SCOT。若您發現科目缺少估計的SCOT，您需要將其與估計SCOT相關聯。",
	55: "辨識未與估計科目相關的估計SCOT。若您發現缺少估計科目的估計SCOT，您需要將估計SCOT與估計科目相關聯。",
	56: "重大或舞弊風險必須至少有一項證實程序、一項控制和一項控制任務測試（若適用）",
	57: "重大或舞弊風險必須至少有一項證實程序、一項控制和一項控制任務測試（若適用）",
	58: "點選帶有驗證的風險並展開聲明。 驗證至少有一項任務已選擇“是”",
	59: "點選帶有驗證的風險並展開聲明。 驗證至少有一個控制已選擇“是”。 還需要完成設計有效性的控制",
	60: "點選驗證連結“解決Canvas表單註解”。 開啟每個 Canvas 表單並選擇顯示未解決的註解。所有註解都必須清除或關閉",
	61: "點選驗證連結，完成尚未完成的 Canvas 表單回應。 開啟每個 Canvas 表單並選擇顯示未完成的回覆。 需要完成所有Canvas表單問題",
	62: "點選驗證連結，複核開啟的註解並清除或關閉所有開啟的註解。",
	63: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	64: "點選驗證連結，從過濾的任務列表中複核每個任務並將未完成的任務標記為已完成",
	65: "點選取消全部連結以取消所有共享證據的連結",
	66: "440 表單中至少有一份沒有選擇變更原因的文件",
	67: "440 表單中至少有一份文件選擇了「非行政」變更原因，但未完成填寫理由",
	68: "440 表單中至少有一份文件選擇了「非行政」變更原因，但尚未得到經理或以上人員的核准",
	69: "440 表單尚未由案件會計師或主辦會計師簽核",
	70: "點選歸檔列表上的“取消與集團之連結”",
	71: "Canvas表單沒有標題或標準內容",
	72: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	73: "點擊 Canvas 表單中的驗證檢查圖示以查看未完成回覆的數量",
	74: "點擊連結並提交更新版本的案件設定檔.smt",
	75: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	76: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	77: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	78: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	79: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	80: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	81: "辨識 IT 流程並將其與 IT 應用程序相關聯",
	82: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	83: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	84: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	85: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	86: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	87: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	88: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	89: "IT 流程評估未經過選擇或與 ITCG/ITSP 營運有效性評估不一致",
	90: "控制缺少設計有效性選擇",
	91: "查看與審計相關的 SCOT 和相關 IT 應用程序",
	92: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	93: "使用「如何在 EY Canvas 中記錄 IT 流程」中的逐步指南來解決此驗證問題",
	94: "使用「如何在 EY Canvas 中記錄 IT 流程」中的逐步指南來解決此驗證問題",
	95: "案件沒有指定特定團隊成員作為管理團隊的負責人",
	96: "風險因子與風險不相關或未標記為「不是 ROMM」",
	97: "風險與聲明不相關",
	98: "須輸入金額到預測基礎中",
	99: "須輸入預測基礎的理由",
	100: "須輸入金額到調整後的基礎中",
	101: "尚未選擇規劃重大性百分比",
	102: "規劃重大性百分比超出允許範圍",
	103: "須為所選的規劃重大性百分比輸入理由",
	104: "未輸入可容忍誤差",
	105: "可容忍誤差百分比超出允許範圍",
	106: "須為所選的可容忍誤差百分比輸入理由",
	107: "尚未選擇 SAD 百分比",
	108: "SAD 百分比超出允許範圍",
	109: "需要輸入所選 SAD 百分比的理由",
	110: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	111: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	112: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	113: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	114: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	115: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	116: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	117: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	118: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	119: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	120: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	121: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	122: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	123: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	124: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	125: 'Protected documents should not be retained in engagement files unless necessary',
	126: "刪除文件並重新上傳",
	127: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	128: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	129: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	130: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	131: "Navigate to the Estimate listing form and use 'Create document' option there",
	132: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	133: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	134: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	135: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	136: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	137: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	138: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	139: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	140: "使用「如何在 EY Canvas 中清除驗證檢查」中的逐步指南來解決此驗證問題",
	141: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	142: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	143: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	144: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	145: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	146: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	147: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	148: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	149: 'Click on the validation link Finalize incomplete Canvas form responses. Open each Canvas form and verify all required documents associated to the requirements have the related PIC/EQR sign-off. Only sign-off on those files you have prepared or reviewed.',
	150: 'Click on the validation link Finalize incomplete Canvas form responses. Open each Canvas form and verify all required documents associated to the requirements have the related PIC/EQR sign-off requirement on the documents.',
	151: 'Please check that all significant accounts and disclosures have at least one assertion.',
	152: 'Open each Canvas form and verify all required documents associated to the requirements have Preparer and Reviewer sign-offs. Only sign-off on those files you have prepared or reviewed.',
	153: 'Navigate to the adjustment and use "Add evidence" option to associate appropriate evidence',
	154: 'Navigate to the estimate document and check there that Higher/Lower risk estimates have an Estimate account related. Very low risk estimates should have at least one account related.',
	155: 'Navigate to the estimate document and check there  accounts related. Based on the audit documentation either unrelate non-estimate account or modify it to an estimate account.',
	156: 'Navigate to the estimate document and check responses there.',
	157: 'Navigate to the estimate document and check there that Higher/Lower risk estimates have an Estimate SCOT related. Very low risk estimates should have at least one SCOT related.',
	158: 'Navigate to the account document and check there are at least one  Higher or Lower risk estimate related.',
	159: 'Navigate to the account document and check there are at least one  Higher or Lower risk estimate related.',
	160: 'Navigate to the estimate lead sheet to identify Estimate SCOTs that do not have any estimate related. Based on the audit documentation either modify those SCOTs to non-estimate or relate estimates to those SCOTs',
	161: 'Navigate to the adjustment and check sum of the debit entries equals to the sum of credit entries.',
	162: 'Navigate to the estimate document and c and check there are at least one significant or fraud risk related.',
	163: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	164: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	165: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	166: "Navigate to the estimate document and check there risks related. Based on the audit documentation either unrelate Significant/Fraud risk or update estimate category to Higher risk."
};

export const validationChecksReportHeaderLabels = {
	validationType: "驗證類型",
	validationDescription: "驗證說明",
	itemName: "項目名稱",
	auditPhase: "查核階段",
	additionalInformation: "附加資訊",
	localization: "當地化",
	itemType: "項目種類",
	location: labels.location,
	count: "計數",
	validationCount: "驗證計數",
	itemID: "項目編號",
	validationTypeID: "驗證類型 ID",
	category: "類別",
	auditPhaseID: "查核階段 ID",
	entity: labels.filterEntitiesLabel
};


export const ReviewNotesReportHeaderLabel = {
	annotationID: "註釋ID",
	assignToUserID: "指派給使用者 ID",
	assignedtoUser: labels.assignedTo,
	createUserID: "作者ID",
	createdBy: "作者",
	createdDate: "建立於",
	dueDateLabel: "到期日",
	relatedEvidence: "相關證據",
	reviewNote: labels.reviewNotesLabel,
	lastModifiedBy: "最後修改者",
	modifyUserID: "按使用者 ID 修改",
	lastModifiedOnLabel: "上次修改時間",
	priorityType: labels.priorityLabel,
	annotationParentID: "主要註釋 ID",
	referenceNumber: "參考",
	relatedTasks: "相關任務",
	replies: labels.reply,
	reviewNoteStatus: labels.status,
	statusChangedByUserID: "狀態已根據使用者 ID 更改",
	statusChangedBy: "狀態變更者",
	statusChangedDateLabel: "狀態更改者",
	startDateLabel: 'First created (in UTC)',
	clearedDateLabel: 'Last cleared (in UTC)',
	closedDateLabel: 'Last closed (in UTC)',
	documentTypeID: "狀態更改日期",
	childAnnotationID: "文件類型 ID"
};

export const taskDueDateCategoryIdLabels = {
	0: "過去幾週",
	1: "本週",
	2: "下週",
	3: "未來幾週"
};

export const taskSummaryReportHeaderLabels = {
	engagementID: "案件 ID",
	taskID: "任務 ID",
	displayedTaskName: labels.TaskName,
	taskNamePrefix: "Task prefix",
	taskNameSuffix: "Task suffix",
	dueDateColumn: labels.taskDueDateHeader,
	dueDateWeek: labels.dueLabel,
	assignmentType: labels.assignmentType,
	assignmentTypeID: "指派事項類型 ID",
	assignmentName: labels.assignmentName,
	assignmentStatus: labels.taskAssigmentStatusHeader,
	reviewNoteAssignedOpen: "Assigned open review notes",
	reviewNoteAssignedCleared: "Assigned cleared review notes",
	reviewNoteAuthoredOpen: "Authored open review notes",
	reviewNoteAuthoredCleared: "Authored cleared review notes",
	taskStatus: labels.taskStatusLabel,
	taskStatusID: "任務狀態 ID",
	taskType: labels.taskType,
	taskTypeID: "任務類型 ID",
	milestone: labels.filterMilestoneLabel,
	milestoneID: "里程碑 ID",
	isOverdueColumn: labels.Overdue,
	timephaseName: labels.timephase,
	relatedObjectName: "Related object",
	relatedEntityID: "Related object ID",
	openAssignmentsOverdue: "Open assignments-逾期",
	openAssignmentsThisWeek: "Open assignments-本週",
	openAssignmentsNextWeek: "Open assignments-下週",
	openAssignmentsTotal: "Open assignments-合計",
	inProgressAssignmentsOverdue: "In progress assignments-逾期",
	inProgressAssignmentsThisWeek: "In progress assignments-本週",
	inProgressAssignmentsNextWeek: "In progress assignments-下週",
	inProgressAssignmentsTotal: "In progress assignments-合計"
};

export const crtControlSummaryReportHeaderLabels = {
	scotID: "SCOT ID",
	scotName: "SCOT",
	strategyTypeName: "策略類型",
	wcgwID: "WCGW ID",
	wcgwName: "WCGW",
	controlID: "控制 ID",
	controlName: "控制",
	operatingEvaluation: "Operating evaluation",
	assertions: "聲明",
	controlTypeName: "控制類型",
	testingFormatted: "Testing selection",
	scotStrategy: "SCOT策略",
	itApplicationName: "Related IT app / SO",
	controlFrequencyTypeName: "頻率",
	scotTypeID: "SCOT 類型 ID",
	scotTypeName: "SCOT 類型",
	itAppType: "IT/SO Application",
	lowerRiskControl: "Lower risk control"
};

export const trialBalanceReportHeaderLabels = {
	engagementID: "Engagement ID",
	trialBalanceID: "Trial balance ID",
	trialBalanceTypeID: "Trial balance type ID",
	trialBalanceTypeName: "Trial balance type name",
	financialStatementID: "Financial statement ID",
	financialStatementName: "Financial statement name",
	financialStatementTypeID: "Financial statement type ID",
	financialStatementTypeName: "Financial statement type name",
	financialStatementSubTypeID: "Financial statement sub type ID",
	financialStatementSubTypeName: "Financial statement sub type name",
	analysisPeriodBalance: "Analysis date balance",
	comparativePeriodBalance: "Comparative date balance",
	analysisComparativeBalanceChange: "Analysis comparative balance change",
	analysisComparativeBalanceChangePercent: "Analysis comparative balance change percent",
	secondComparativePeriodBalance: "Second comparative date balance",
	analysisSecondComparativeBalanceChange: "Analysis second comparative balance change",
	analysisSecondComparativeBalanceChangePercent: "Analysis second comparative balance change percent",
	parentFinancialStatementID: "Parent financial statement ID",
	displayOrder: "Display order",
	eyCanvasAccountName: "EY Canvas account name",
	relatedEntities: "Related entities"
};

export const taskSourceTypes = {
	1: labels.internal,
	2: labels.external
};

export const taskNatureTypes = {
	1: labels.testOfDetail,
	2: labels.substantiveAnalyticalProcedure,
	3: labels.testOfControl
};

export const priorityTypesCollaboration = [{
	value: 1,
	label: "普通的"
},
{
	value: 3,
	label: "高度的"
},
{
	value: 4,
	label: "重要的"
}
];

export const StatementType = [{
	id: 1,
	value: "損益表"
}, {
	id: 2,
	value: "資產負債表"
}, {
	id: 3,
	value: "兩個都"
}];

export const AccountTypes = [{
	id: 1,
	accountTypeName: "重大的"
},
{
	id: 2,
	accountTypeName: "有限風險"
},
{
	id: 3,
	accountTypeName: "不重大"
},
{
	id: 4,
	accountTypeName: "其他"
},
{
	id: 5,
	accountTypeName: "重大揭露"
}
];

export const ITAppSOAttributes = [{
	id: 1,
	value: "測試選擇"
}, {
	id: 2,
	value: "Related IT app/SO"
}, {
	id: 3,
	value: "Related SCOTs"
}, {
	id: 4,
	value: "Related SCOT 策略"
}, {
	id: 5,
	value: "Related SCOT 類型"
}];

export const notesEditorLabels = {
	addNoteButtonLabel: reviewNoteModalLabels?.addNewReviewNoteButtonText,
	saveNoteButtonLabel: labels.saveLabel,
	messagePlaceholder: labels.addNewNoteModalTitle,
	messagePlaceholderReply: reviewNoteModalLabels?.replyInputPlaceholder,
	messagePlaceholderEdit: reviewNoteModalLabels?.noteInputPlaceholderEdit,
	messagePlaceholderReplyEdit: reviewNoteModalLabels?.replyInputPlaceholderEdit,
	addReplyButtonLabel: reviewNoteModalLabels?.reply,
	characters: labels.characters,
	of: labels.of,
	formRequired: labels.required,
	formMaxLength: labels.formMaxLength,
	toFieldLabel: labels.assignedTo,
	priorityFieldLabel: labels.rnhPriority,
	dueDateFieldLabel: labels.dueDate,
	voiceNoteButtonLabel: labels.voiceNoteButtonLabel,
	stopRecordingButtonLabel: labels.stopRecordingButtonLabel,
	cancelButtonLabel: labels.cancelButtonLabel,
	noResultsFound: labels.noResultsFound,
	microphoneBlockedMessage: labels.microphoneBlockedMessage,
	microphoneBlockedOnVideoMessage: labels.microphoneBlockedOnVideoMessage,
	notInMainWindowVoice: labels.notInMainWindowVoice,
	notInMainWindowScreen: labels.notInMainWindowScreen,
	voiceNoteNotAvailable: "語音註記和螢幕錄製在側邊欄視窗中不可使用。請切換至全螢幕以使用這些功能。",
	deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
	playButtonTitle: labels.voiceNoteCommentPlayLabel,
	pauseButtonTitle: labels.voiceNoteCommentStopLabel,
	screenRecord: labels.screenRecord,
	playbackReview: labels.playbackReview,
	close: labels.reviewNotesModalClose
};


export const noteModalLabels = {
	...notesEditorLabels,
	closeButton: labels.reviewNotesModalClose,
	closed: labels.closed,
	open: labels.open,
	cleared: labels.cleared,
	allNotes: labels.allNotes,
	myNotes: labels.myNotes,
	assignedToMe: labels.assignedToMe,
	noNotesFound: reviewNoteModalLabels?.noNotesFound,
	noNotesFoundInstructional: reviewNoteModalLabels?.noNotesAssociatedWithDocumentLabel,
	assignedTo: labels.assignedTo,
	dueDate: labels.dueDate,
	edit: labels.edit,
	delete: labels.delete,
	clear: labels.clear,
	reopen: labels.reopen,
	close: labels.closeTitle,
	reply: labels.reply,
	confirm: labels.confirm,
	cancel: labels.cancelButtonLabel,
	deleteModalHeaderNote: reviewNoteModalLabels?.deleteIconModalTitleLabel,
	deleteModalHeaderReply: reviewNoteModalLabels?.deleteReplyIconModalTitle,
	deleteModalTextNote: reviewNoteModalLabels?.deleteIconModalConfirmMessageParent,
	deleteModalTextReply: reviewNoteModalLabels?.deleteIconModalConfirmMessage,
	showMore: reviewNoteModalLabels?.showMore,
	showLess: reviewNoteModalLabels?.showLess,
	view: labels.view,
	notSelected: labels.notSelectedText,
	deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
	playButtonTitle: labels.voiceNoteCommentPlayLabel,
	pauseButtonTitle: labels.voiceNoteCommentStopLabel
};

export const EntitiesLabels = {
	close: "關閉",
	cancel: "取消",
	repNoRecordMessage: "未找到結果",
	edit: "編輯",
	delete: "刪除",
	actions: "行動",
	show: "Show",
	first: 'First Page',
	last: 'Last Page',
	prev: 'Previous Page',
	next: 'Next Page',

	[Entity.Account]: {
		manageEntity: 'Manage accounts and disclosures',
		searchEntity: 'Search accounts',
		createEntity: "新科目",
		entityName: "科目",
		entityNameCaps: "科目",
		entityNamePlural: "科目",
		placeholderText: "Create new accounts and disclosures or edit and delete existing accounts and disclosures below.",
		deleteConfirmLabel: "Are you sure you want to delete this account? All existing relationships will be removed. This action cannot be undone."
	},
	[Entity.Estimate]: {
		manageEntity: 'Manage estimate',
		searchEntity: "搜尋估計",
		createEntity: "新的估計",
		entityName: "估計",
		entityNameCaps: "估計",
		entityNamePlural: "估計",
		placeholderText: "建立新的估計或編輯並刪除下方現有估計。",
		deleteConfirmLabel: "Are you sure you want to delete this estimate? All existing relationships will be removed. This action cannot be undone."
	},
	[Entity.Risk]: {
		manageEntity: "管理風險",
		searchEntity: 'Search risks',
		createEntity: "新風險",
		entityName: "風險",
		entityNameCaps: "風險",
		entityNamePlural: "風險",
		placeholderText: "建立新風險或編輯並刪除下方現有風險。",
		deleteConfirmLabel: "Are you sure you want to delete this risk? All existing relationships will be removed. This action cannot be undone."
	},
	[Entity.STEntity]: {
		manageEntity: 'Manage entities',
		searchEntity: 'Search entities',
		createEntity: 'New entity',
		entityName: 'entity',
		entityNameCaps: 'Entity',
		entityNamePlural: 'Entities',
		placeholderText: 'Create new entities or edit and delete existing entities below.',
		deleteEntity: 'Delete entity',
		deleteConfirmLabel: "Are you sure you want to delete this entity? All existing relationships will be removed. This action cannot be undone."
	},
	[Entity.Control]: {
		manageEntity: 'Manage controls',
		searchEntity: 'Search controls',
		createEntity: 'New control',
		entityName: 'control',
		entityNameCaps: 'Control',
		entityNamePlural: 'Controls',
		placeholderText: 'Create new controls or edit and delete existing controls below.',
		deleteEntity: 'Delete control',
		deleteConfirmLabel: "Are you sure you want to delete this control? All existing relationships will be removed. This action cannot be undone."
	},
	[Entity.SCOT]: {
		manageEntity: 'Manage SCOTs',
		searchEntity: 'Search SCOTs',
		createEntity: 'New SCOT',
		entityName: 'SCOT',
		entityNameCaps: 'SCOT',
		entityNamePlural: 'SCOTs',
		placeholderText: 'Create new SCOTs or edit and delete existing SCOTs below.',
		deleteEntity: 'Delete SCOT',
		deleteConfirmLabel: "Are you sure you want to delete this SCOT? All existing relationships will be removed. This action cannot be undone."
	},
	[Entity.ITApplication]: {
		manageEntity: 'Manage IT applications',
		searchEntity: "Search",
		createEntity: 'New IT application',
		entityName: 'IT application',
		entityNameCaps: 'IT application',
		entityNamePlural: 'IT applications',
		placeholderText: "Create new IT applications or edit and delete existing IT applications below.,",
		deleteEntity: 'Delete IT application',
		deleteConfirmLabel: "Are you sure you want to delete this IT application? All existing relationships will be removed. This action cannot be undone."
	},
	[Entity.TaskSection]: {
		manageEntity: "Manage task groups",
		searchEntity: "Search task group",
		createEntity: "New task group",
		entityName: "task group",
		entityNameCaps: "Task group",
		entityNamePlural: "Task groups",
		placeholderText: "Create a new task group or edit and delete existing task group below.",
		deleteEntity: "Delete task group",
		deleteConfirmLabel: "Are you sure that you want to delete the selected adjustment? This action cannot be undone."
	},
	[Entity.WCGW]: {
		manageEntity: 'Manage WCGWs',
		searchEntity: 'Search WCGWs',
		createEntity: 'New WCGWs',
		entityName: 'WCGW',
		entityNameCaps: 'WCGW',
		entityNamePlural: 'WCGWs',
		placeholderText: "Create new WCGW or edit and delete existing WCGW below.",
		deleteEntity: 'Delete WCGW',
		deleteConfirmLabel: "Are you sure you want to delete this WCGW? All existing relationships will be removed. This action cannot be undone."
	},
	[Entity.Misstatement]: {
		manageEntity: 'Manage adjustments',
		searchEntity: 'Search adjustments',
		createEntity: 'New adjustment',
		entityName: "adjustment",
		entityNameCaps: "Adjustment",
		entityNamePlural: "Adjustments",
		placeholderText: 'Create new adjustments or edit and delete existing adjustments below.',
		deleteConfirmLabel: "Are you sure that you want to delete the selected adjustment? This action cannot be undone."
	},
	[Entity.AdjustmentValidation]: {
		manageEntity: "Manage adjustments with validations checks",
		searchEntity: "Search",
		entityName: "adjustments",
		entityNameCaps: "Adjustments",
		entityNamePlural: "Adjustments",
		placeholderText: 'Each adjustment must have related at least one evidence and for each adjustment the sum of the debit entries should equal the sum of the credit entries. The following adjustment(s) have one or more validation issues. Click on <b>"Edit"</b> to address them.',
		deleteConfirmLabel: "Are you sure that you want to delete the selected adjustment? This action cannot be undone.",
		adjustmentHeader: "Adjustment",
		validationTyeHeader: "Validation type",
		validationTypeAmtMissmatch: "Sum of the debit entries does not equal the sum of the credit entries",
		validationTypeNoEvidence: "No related evidence"
	},
	[Entity.SampleItem]: {
		manageEntity: "Manage sample tags",
		searchEntity: "Search tags",
		createEntity: "New tag",
		createManageTagEntity: "Manage tag groups",
		entityName: "Tag",
		entityNamePlural: "Tags",
		entityNameForTagGroupPlural: "Tag groups",
		placeholderText: "Create new tags or edit and delete existing tags below."
	},
	[Entity.SampleTagGroups]: {
		manageEntity: "Manage sample tag groups",
		searchEntity: "Search",
		createEntity: "New tag group",
		entityName: "Tag group",
		entityNameCaps: "Tag group",
		entityNamePlural: "Tag groups",
		placeholderText: "Create new sample tag groups or edit and delete existing sample tag groups below.",
	}
};

export const executionType = [{
	id: 1,
	label: '',
	toolTip: '',
	value: "在此案件中"
},
{
	id: 2,
	label: 'CT',
	toolTip: "其他案件中的程序 [僅限 PT]",
	value: "在其他案件中[僅限 PT]"
},
{
	id: 3,
	label: 'PT/CT',
	toolTip: "在此案件和其他案件的程序 [僅限 PT]",
	value: "在此案件和其他案件中[僅限 PT]"
}
];

export const AccountType = [{
	id: 1,
	accounttypename: 'Significant account'
},
{
	id: 2,
	accounttypename: 'Limited risk account'
},
{
	id: 3,
	accounttypename: 'Insignificant account'
},
{
	id: 4,
	accounttypename: 'Other account'
},
{
	id: 5,
	accounttypename: 'Significant disclosure'
}
];

export const statementTypes = [{
	id: 1,
	name: "損益表"
},
{
	id: 2,
	name: 'Balance Sheet'
},
{
	id: 3,
	name: 'Both'
}
];

export const CreateEditAccountLabels = {
	createModalDescription: "Enter the new account details below and select '<b>{0}</b>' to finish. To create another account, select '<b>{1}</b>'.",
	editModalDescription: "編輯下方的科目詳細資訊並選擇“<b>{0}</b>”完成。",
	close: "關閉",
	cancel: "取消",
	yes: "是",
	no: "否",
	createAccount: "新科目",
	editAccount: "編輯科目",
	delete: "刪除",
	save: "儲存",
	saveAndCloseLabel: "儲存並關閉",
	saveAndCreateLabel: "儲存並建立另一個",
	accountNameLabel: "科目名稱（必填）",
	accountDesignationLabel: "指定",
	accountExecutionTypeLabel: 'In which Canvas engagement will procedures for this account be performed and documented?',
	accountEstimateLabel: "此科目是否受到估計的影響？",
	accountStatementTypeLabel: "報表類型",
	pspIndexDropdownLabel: 'PSP index (required, select up to 5)',
	removePSPIndexLabel: "刪除 PSP 索引",
	assertionsLabel: "選擇相關聲明",
	assertionOptions: assertions,
	executionTypeOptions: executionType,
	accountTypeOptions: AccountType,
	statementTypeOptions: statementTypes,
	confirm: 'Confirm',
	pspIndexErrorMsg: "Required",
	assertionWarningMessage: "You cannot make changes to assertion(s) that have a Significant risk, or Fraud risk, or Risk of material misstatement or an estimate related. You need to remove these relations first.",
	confirmChanges: 'Confirm changes',
	executionTypeWarningMessage: 'The changes you are going to save to this account will affect the existing assertions and PSPs, the links will be broken. Are you sure that you want to proceed? This action cannot be undone.',
	contentUpdateToastMessage: 'Content update is available for {0}. Please initiate the content update from the Content update page.',
	assertionsRequired: 'At least one assertion should be selected',
	pspIndexDisabledLabel: 'Select up to five PSP Indexes. Deselect one or more options to continue.',
	newSignificantDisclosure: 'New significant disclosure',
	noOptionsMessage: 'No results found',
	accountNameErrorMsg: "Required"
};

export const CreateMestLabels = {
	createModalTitle: "新個體",
	createModalDescription: "在下方輸入個體並選擇'<b>{0}</b>'完成。 若要建立另一個個體，請選擇'<b>{1}</b>'。個體是我們規劃進行查核的方式，可能不是法定個體，而是營運單位或其他聯合個體。",
	close: "關閉",
	cancel: "取消",
	save: "儲存",
	saveAndCloseLabel: "儲存並關閉",
	saveAndCreateLabel: "儲存並建立另一個",
	entityNameLabel: "個體名稱",
	entityStandardIndexLabel: "個體標準索引",
	entityDescriptionLabel: "個體描述（可選擇性的）",
	entityNameErrorMsg: "Required",
	entityStandardIndexErrorMsg: "Required"
}

export const CreateEditSCOTLabels = {
	createModalTitle: 'New SCOT',
	editModalTitle: 'Edit SCOT',
	createModalDescription: "Enter the new SCOT details below and select '<b>{0}</b>' to finish. To create another SCOT, select '<b>{1}</b>'.",
	editModalDescription: "Edit the SCOT details below and select '<b>{0}</b>' to finish.",
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	scotNameLabel: 'SCOT name (required)',
	scotStrategyLabel: 'SCOT strategy',
	scotTypeLabel: 'SCOT type',
	scotTypeOptions: scotTypes,
	hasEstimateLabel: 'Is this SCOT impacted by an estimate?',
	itAPPUsedLabel: 'Are any IT applications used?',
	routine: 'Routine',
	nonRoutine: 'Non-Routine',
	controls: 'Controls',
	substantive: 'Substantive',
	yes: 'Yes',
	scotNameErrorMsg: "Required",
	remove: 'Remove',
	noOptionsMessage: 'No results found',
	wtDetailPrefix: '<p>For all routine and non-routine SCOTs and significant disclosure processes, we confirm our understanding every period by performing walkthrough procedures. In addition, for PCAOB audits, we perform walkthrough procedures of estimation SCOTs.<br/>For all SCOTs when we take a controls reliance strategy, and for controls that address significant risks, we confirm that relevant controls have been appropriately designed and implemented. We confirm that our decision to take a controls reliance strategy is still appropriate.<br/><br/>We conclude that our documentation accurately describes the operation of the SCOT and we have identified all appropriate WCGWs, including risks that arise from using IT, and relevant controls (when applicable).<br/><br/> For estimation SCOTs when we use a substantive only strategy, we determine whether our understanding of the estimation SCOT is appropriate based on our substantive procedures.</p>',
	disabledTabTooltipMessage: 'Select "Are any IT applications used?" to relate IT applications',
	itAppLabels: {
		tabLabel: 'IT apps',
		dropdownLabel: 'Relate IT applications',
		noRelatedItems: 'No related IT applications',
		itApplications: 'IT applications'
	},
	soLabels: {
		tabLabel: 'SOs',
		dropdownLabel: 'Relate service organizations',
		noRelatedItems: 'No related service organizations',
		serviceOrganizations: 'Service organizations'
	}
};

export const CreateEditWCGWLabels = {
	wcgwName: "WCGW name (required)",
	editWCGW: "Edit WCGW",
	editTheWCGW: "Edit the WCGW details below and select '<b>{0}</b>' to finish.",
	createNewWCGW: "Enter the new WCGW details below and select '<b>{0}</b>' to finish. To create another WCGW, select '<b>{1}</b>'.",
	createEditWCGWModelScot: "SCOT",
	newWCGWTitel: "New WCGW",
	editWCGWSave: "Save",
	editWCGWClose: "Cancel",
	closeTitle: "Close",
	wcgwNameIsRequired: "Required",
	saveAndCloseLabel: "儲存並關閉",
	saveAndCreateLabel: "儲存並建立另一個"
};

export const controlFrequencyTypes = [{
	value: 1,
	label: 'Many times per day'
},
{
	value: 2,
	label: 'Daily'
},
{
	value: 3,
	label: 'Weekly'
},
{
	value: 4,
	label: 'Monthly'
},
{
	value: 5,
	label: 'Quarterly'
},
{
	value: 6,
	label: 'Annually'
},
{
	value: 8,
	label: 'Other'
}
];

export const controlTypes = [{
	value: 1,
	label: 'IT application control'
},
{
	value: 2,
	label: 'IT dependent manual control'
},
{
	value: 3,
	label: 'Manual prevent'
},
{
	value: 4,
	label: 'Manual detect'
}
];

export const CreateEditControlLabels = {
	createModalTitle: 'New control',
	editModalTitle: 'Edit control',
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	controlNameLabel: 'Control name (required)',
	frequency: 'Frequency',
	controlType: 'Control type',
	frequencyTypeOptions: controlFrequencyTypes,
	controlTypeOptions: controlTypes,
	designEffectiveness: 'Design effectiveness',
	operatingEffectiveness: 'Operating effectiveness',
	testingLabel: 'Testing',
	lowerRiskLabel: "Is Control lower risk?",
	ITDMControlSubstantiveTestingOptionLabel: "The automated portion of this ITDM control is only the use of system-generated report(s) that are tested substantively",
	effective: 'Effective',
	ineffective: 'Ineffective',
	yes: 'Yes',
	no: 'No',
	required: 'Required',
	remove: 'Remove',
	noOptionsMessage: 'No results found',
	disabledTabTooltipMessage: 'Select "Control type" as "IT application control" or "IT dependent manual control" to relate IT applications',
	itAppLabels: {
		tabLabel: 'IT apps',
		dropdownLabel: 'Relate IT applications',
		noRelatedItems: 'No related IT applications',
		itApplications: 'IT applications'
	},
	soLabels: {
		tabLabel: 'SOs',
		dropdownLabel: 'Relate service organizations',
		noRelatedItems: 'No related service organizations',
		serviceOrganizations: 'Service organizations'
	},
	controlNameErrorMsg: "Required",
	createModalDescriptionLabel: "Enter the new control details below and select '<b>{0}</b>' to finish. To create another control, select '<b>{1}</b>'.",
	editModalDescriptionLabel: "Edit the control details below and select '<b>{0}</b>' to finish.",
	wcgwLabel: 'WCGW'
};

export const CreateEditITApplicationLabels = {
	close: 'Close',
	cancel: 'Cancel',
	yes: 'Yes',
	no: 'No',
	delete: 'Delete',
	save: 'Save',
	closeTitle: "Close",
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	iTApplicationNameLabel: "IT application name (required)",
	iTSOApplicationNameLabel: 'Service organization name',
	newITApplicationLabel: 'New IT application',
	newITSOApplicationLabel: 'New Service Organization',
	editITApplicationLabel: 'Edit IT application',
	confirm: 'Confirm',
	confirmChanges: 'Confirm changes',
	noOptionsMessage: 'No results found',
	iTAppNameErrorMsg: "Required",
	iTSOAppNameErrorMsg: 'Required',
	controls: 'Controls',
	substantive: 'Substantive',
	remove: 'Remove',
	iTApplicationStrategyLabel: 'IT application strategy',
	SCOTsLabel: 'SCOT names',
	StrategyLabel: 'Strategy',
	ControlsLabel: 'Control names',
	ControlTypeLabel: 'Type',
	addDescriptionLabel: "Enter the new IT application details below and select '<b>{0}</b>' to finish. To create another IT application, select '<b>{1}</b>'.",

	editDescriptionLabel: "Edit the IT application details below and select '<b>{0}</b>' to finish.",

	addSODescriptionLabel: "Enter the new service organization details below and select '<b>Save and close</b>' to finish. To create another service organization, select '<b>Save and create another</b>'.",

	scotErrorMessage: 'SCOT may not be unrelated from the IT application, since there are controls related.',
	SCOTsLabels: {
		tabLabel: 'SCOTs',
		dropdownLabel: 'Relate SCOTs',
		noRelatedItems: 'No related SCOTs'
	},
	ControlsLabels: {
		tabLabel: 'Controls',
		dropdownLabel: 'Relate controls',
		noRelatedItems: 'No related controls'
	},
	strategyType: {
		1: 'Controls',
		2: 'Substantive',
		3: 'Rely',
		4: 'Not Rely'
	},
	controlType: {
		1: 'IT Application',
		2: 'IT Dependent Manual',
		3: 'Manual Prevent',
		4: 'Manual Detect'
	}
};

export const groupComponentAccountReportHeaderLabels = {
	primaryEngagementId: "案件ID",
	gaScopeName: "範圍",
	gaComponentId: "GA組成個體ID",
	shortName: "組成個體名稱",
	pocText: "聯絡人",
	accountId: "科目ID",
	accountName: "科目名稱",
	accountType: "科目名稱",
	knowledgeAssertion: "聲明",
	inherentRiskType: "固有風險",
	riskId: "風險ID",
	riskType: "風險類型",
	riskName: "風險名稱",
	isHigherRiskText: "是否為較高風險"
};

export const AccountTypeIDs = {
	1: "重大科目",
	2: "有限風險科目",
	3: "不重大科目",
	4: "科目 - 其他",
	5: "重大揭露"
};

export const InherentRiskTypeIDs = {
	1: "較高",
	2: "較低",
	3: "非常低"
};

export const riskTypeIDs = {
	1: "重大風險",
	2: "舞弊風險",
	3: 'Risks of material misstatement'
};

export const riskTypeIDsShortForm = {
	1: "SR",
	2: "FR",
	3: "ROMM"
};

export const ControlRiskTypeIDs = {
	1: "Rely",
	2: "Not Rely",
	3: "Test MP"
};

export const knowledgeAssertions = {
	1: "完整性",
	2: "存在性",
	3: "評價",
	4: "權利與義務",
	5: "表達與揭露",
	6: "完整性",
	7: "發生",
	8: "衡量",
	9: "表達與揭露",
	10: "完整性",
	11: "存在/發生",
	12: "衡量/評價",
	13: "權利與義務",
	14: "表達與揭露"
};

export const gaInstructionStatuslabels = {
	0: "Undefined",
	[instructionStatus.notSent]: "Not sent",
	[instructionStatus.pending]: "Pending",
	[instructionStatus.accepted]: "Accepted",
	[instructionStatus.rejected]: "Returned",
	[instructionStatus.systemError]: "System error",
	[instructionStatus.expired]: "Expired",
	[instructionStatus.sent]: "Sent",
	[instructionStatus.unlinked]: "Unlinked",
	[instructionStatus.queued]: "Queued"
};

export const financialStatementTypeLabels = {
	[financialStatementType.Asset]: "Asset",
	[financialStatementType.CurrentAsset]: "Current Asset",
	[financialStatementType.NonCurrentAsset]: "Non-Current Asset",
	[financialStatementType.Liability]: "Liability",
	[financialStatementType.CurrentLiability]: "Current Liability",
	[financialStatementType.NonCurrentLiability]: "Non-Current Liability",
	[financialStatementType.Equity]: "Equity",
	[financialStatementType.Revenue]: "Revenue",
	[financialStatementType.Expense]: "Expense",
	[financialStatementType.NonOperatingIncome]: "Non-Operating Income/(Expense)",
	[financialStatementType.OtherComprehensiveIncome]: "Other Comprehensive Income",
	[financialStatementType.Other]: "Other",
	[financialStatementType.AccountType]: "Account Type",
	[financialStatementType.AccountSubType]: "Account Sub-Type",
	[financialStatementType.AccountClass]: "Account Class",
	[financialStatementType.AccountSubClass]: "Account Sub-Class",
	[financialStatementType.NetIncomeExpense]: "Net (Income) / Expense",
	18: "GLAccount"
};

export const trialBalanceTypeLabels = {
	[trialBalanceType.Planning]: "Planning"
};

export const createEditRiskModalLabels = {
	createModalDescription: "Enter the new risk details below and select '<b>{0}</b>' to finish. To create another risk, select '<b>{1}</b>'.",
	editModalDescription: `Edit the risk details below and select '<b>{0}</b>' to finish.`,
	close: 'Close',
	cancel: 'Cancel',
	createRisk: 'New risk',
	editRisk: 'Edit risk',
	riskType: 'Risk type (required)',

	riskTypeOptions: [{
		value: 1,
		label: 'Significant risk'
	},
	{
		value: 2,
		label: 'Fraud risk'
	},
	{
		value: 3,
		label: 'Risk of material misstatement'
	}
	],
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	riskNameLabel: 'Risk name (required)',
	relatedAccountsAssertionsLabel: 'Related accounts and assertions (optional)',
	relateAccounts: "Relate accounts and assertions (optional)",
	assertionsLabel: 'Select relevant assertions',
	riskNameErrorMsg: "Required",
	riskTypeErrorMsg: "Required",
	assertionOptions: assertions,
	removeAccountLabel: 'Remove account',
	required: 'Required',
	assertionsRequired: 'At least one assertion should be selected'
};

export const activityTypeLabels = {
	104: 'Added',
	105: 'Removed'
};

export const superModalNavigationLabels = {
	identifyAccountsAndDisclosures: 'Identify accounts and disclosures',
	identifySCOTs: 'Identify SCOTs and relate to accounts',
	determineSCOTStrategy: 'Determine SCOT strategy',
	identifyWCGWAndControls: 'Identify WCGWs and controls',
	selectControlToTest: 'Select controls to test',
	identifyRisks: 'Identify risks',
	relateWCGWsToAssertions: 'Relate WCGWs to assertions',
	relateRisksToWCGWs: 'Relate risks to WCGWs',
	determineCRA: 'Determine CRA',
	timephase: 'Timephase',
	SCOTWT: 'Create WT',
	controlTOC: 'Create TOC',
	ITProcessUDP: 'Create UDP',
	ITGC_ITSP_TOC_OSP: 'Create IT TOC/OSP',
	accountPSP: 'Create PSP',
	accountOSP: 'Create OSP',
	relateWCGWTo: 'Relate WCGW to',
	relatedWCGWToTask: 'Relate WCGW to task',
	respondToSignificant_fraudRisks: 'Respond to significant/fraud risks',
	OST: 'OST',
	accountSummary: 'Account summary',
	SCOTSummary: 'SCOT summary',
	ITSummary: 'IT summary',
	understandITProcesses: 'Understand IT processes',
	evaluateIT: 'Evaluate IT',
	CRASummary: 'CRA summary',
	auditPlan: 'Audit plan',
	workplanSummary: 'Workplan summary',
	buildSteps: 'Build steps',
	ITApplicationsAndITProcesses: 'IT applications and IT processes',
	workPlan: 'Work plan',
	accounts: "科目",
	scots: "SCOTs",
	cra: "CRA",
	openInNewTab: 'Open in new tab'
}

export const auditPlanITProcessLabels = {
	itProcess: 'IT process',
	itProcesses: 'IT processes',
	tasks: 'Tasks',
	sectionHeading: 'IT process and related understand the process (UDP) tasks',
	subHeader: 'Understand the IT process',
	visualDistinctMessage: 'Each IT process must have at least one related UDP. Create {0} or {1}.',
	addUdp: 'New UDP',
	relatedUdp: 'Relate UDPs',
	toggleFilter: 'Show only IT processes without any related UDP',
	noResultsFound: 'No results found',
	taskTitle: 'Understand and document the IT Process: {0}',
	taskDescription: 'Document our understanding of the IT process. Attach the relevant form as evidence to support our understanding of the IT process. When ITGCs appear in the Task Attributes section, perform walkthrough procedures to confirm our understanding of the ITGCs and evaluate their design and implementation. Attach evidence of our procedures.',
	noRecordsAvailable: 'No IT processes available',
	unrelatedLabel: 'View unrelated UDPs',
	unrelatedModalHeader: 'Unrelated UDP tasks',
	noUnrelatedTaskPlaceholder: 'No unrelated UDP tasks available',
	noTaskselectedLabel: 'At least one task must be selected for deletion',
	relateITProcessTaskTitle: 'Relate UDPs to IT process',
	understandITProcesses: 'Understand IT processes',
	unrelatedTasksMustBeAssociated: 'Unrelated tasks must be associated to an IT process or deleted.'
}

export const noEvidenceReferencedReasonsLabels = {
	immaterialReason: "Immaterial: Balance/activity does not meet testing scope - further investigation waived    ",
	strikethroughMText: "m",
	waivedReason: "Waived: Amount below SAD - further investigation waived    ",
	strikethroughWText: "w"
}

export const auditPlanScotListLabels = {
	scot: 'SCOT',
	scots: "SCOTs",
	tasks: 'Tasks',
	sectionHeading: 'SCOTs and related walkthrough tasks',
	subHeader: 'Walkthrough tasks',
	visualDistinctMessage: 'Each SCOT must have at least one related walkthrough. Create {0} or {1}.',
	newWT: 'New WT',
	relatedWT: 'Relate WTs',
	toggleFilter: 'Show only SCOTs without any related WT',
	noResultsFound: 'No results found',
	noRecordsAvailable: 'No SCOTs available',
	relateScotTaskTitle: 'Relate WTs to SCOT',
	taskTitle: 'Walkthrough: {0}',
	taskDescription: '<p>For all routine and non-routine SCOTs and significant disclosure processes, we confirm our understanding every period by performing walkthrough procedures. In addition, for PCAOB audits, we perform walkthrough procedures of estimation SCOTs.<br/>For all SCOTs when we take a controls reliance strategy, and for controls that address significant risks, we confirm that relevant controls have been appropriately designed and implemented. We confirm that our decision to take a controls reliance strategy is still appropriate.<br/><br/>We conclude that our documentation accurately describes the operation of the SCOT and we have identified all appropriate WCGWs, including risks that arise from using IT, and relevant controls (when applicable).<br/><br/> For estimation SCOTs when we use a substantive only strategy, we determine whether our understanding of the estimation SCOT is appropriate based on our substantive procedures.</p>',
	unrelatedLabel: 'View unrelated WTs',
	unrelatedModalHeader: 'Unrelated WT tasks',
	noUnrelatedTaskPlaceholder: 'No unrelated WT tasks available',
	noTaskselectedLabel: 'At least one task must be selected for deletion.',
	manageScots: "管理 SCOT",
	unrelatedTasksMustBeAssociated: 'Unrelated tasks must be associated to a SCOT or deleted.'
}

export const auditPlanControlsLabels = {
	control: "控制",
	controls: 'Controls selected for testing',
	tasks: 'Tasks',
	sectionHeading: 'Controls and related test of controls',
	subHeader: 'Test of control tasks',
	visualDistinctMessage: 'Each control must have at least one related test of control. Create {0} or {1}.',
	addToc: 'New TOC',
	relatedToc: 'Relate TOCs',
	toggleFilter: 'Show only controls without any related TOC',
	noResultsFound: 'No results found',
	noRecordsAvailable: 'No controls selected for testing',
	unrelatedLabel: 'View unrelated TOCs',
	unrelatedModalHeader: 'Unrelated TOC tasks',
	noUnrelatedTaskPlaceholder: 'No unrelated TOC tasks available',
	noTaskselectedLabel: 'At least one task must be selected for deletion.',
	relateControlTaskTitle: 'Relate TOCs to Control',
	manageControl: 'Manage controls',
	taskTitleTOC: 'Test of control: {0}',
	taskDescriptionTOC: 'Design the nature, timing and extent of our tests of controls to obtain sufficient appropriate audit evidence that the control operates effectively as designed throughout the period of reliance to prevent or detect and correct material misstatements at the assertion level.<br/>Conclude on the operating effectiveness of controls, by evaluating the results of our tests of controls including when we extended our sample size and performed tests of compensating controls.',
	manageControls: "Manage controls",
	unrelatedTasksMustBeAssociated: 'Unrelated tasks must be associated to a control or deleted.'
}

export const industrySelectionGroupLabels = {
	1: 'Selected industries',
	2: 'Other industries'
}

export const knowledgeDataLabels = {
	industry: 'Industry',
	showSelected: 'Show only selected',
	noContent: 'No content is available from Knowledge for the selected industry',
	importFromKnowledge: 'Import from Knowledge',
	importAccounts: 'Import Accounts',
	importAccountsAndDisclosures: 'Import accounts and disclosures',
	accountBuild1: 'Account build step 1',
	import: 'Import',
	close: 'Close',
	cancel: 'Cancel',
	selected: 'selected',
	scotTitle: 'SCOT build 1',
	importScots: 'Import SCOTs',
	noKnowledgeDataResult: 'No content is available for the selection',
	showOnlySelectedLabel: 'Show only selected',
	scot: 'SCOT',
	scotDropdownLabel: 'SCOT for selected Industry',
	importWcgw: 'Import WCGWs',
	importFailedLabel: 'Import failed. Try to Import again.',
	wtDetailPrefix: '<p>For all routine and non-routine SCOTs and significant disclosure processes, we confirm our understanding every period by performing walkthrough procedures. In addition, for PCAOB audits, we perform walkthrough procedures of estimation SCOTs.<br/>For all SCOTs when we take a controls reliance strategy, and for controls that address significant risks, we confirm that relevant controls have been appropriately designed and implemented. We confirm that our decision to take a controls reliance strategy is still appropriate.<br/><br/>We conclude that our documentation accurately describes the operation of the SCOT and we have identified all appropriate WCGWs, including risks that arise from using IT, and relevant controls (when applicable).<br/><br/> For estimation SCOTs when we use a substantive only strategy, we determine whether our understanding of the estimation SCOT is appropriate based on our substantive procedures.</p>',
	importOSP: 'Import OSPs',
	auditPlanBuild7: 'Audit Plan Build 7',
	account: 'Account',
	accountName: 'PSP Indexes',
	wcgwName: 'WCGWs',
	selectScot: 'Select SCOT',
	wcgwTitle: 'SCOT build 3',
	noResultFound: 'No results found',
	importValidationMessage: 'A selection is required',
	searchIconHoverLabel: 'Search',
	scotsHeader: 'SCOTs',
	controlsHeader: 'Controls',
	ospsHeader: 'OSPs',
	wcgw: "WCGW",
	importControls: 'Import controls',
	accountAssertionsValidationMessage: 'Task assertions are missing',
	accountsAndDisclosures: 'Accounts and disclosures',
}

export const auditPlanITControlsLabels = {
	itcontrol: 'IT control',
	itcontrols: 'IT controls selected for testing',
	tasks: 'Tasks',
	type: "類型",
	sectionHeading: 'ITGCs, ITSPs, and related test of controls and substantive tasks',
	subHeader: 'TOC/OSP tasks',
	visualTOCDistinctMessage: 'Each ITGC must have at least one related test of control. Create {0} or {2}.',
	visualOSPDistinctMessage: 'Each ITSP must have at least one related substantive procedure. Create {1} or {3}.',
	addTOC: 'New TOC',
	addOSP: 'New OSP',
	relatedTOCOSP: 'Relate TOCs/OSPs',
	relatedTOC: 'Relate TOCs',
	relatedOSP: 'Relate OSPs',
	toggleFilter: 'Show only IT controls without any related TOC/OSP',
	noResultsFound: 'No results found',
	noRecordsAvailable: 'No ITGCs selected for testing',
	taskTitleTOC: 'Test of control: {0}',
	taskDescriptionTOC: 'Perform our designed tests of ITGCs to obtain sufficient appropriate audit evidence of their operating effectiveness throughout the period of reliance.',
	taskTitleOSP: 'Other substantative procedure: {0}',
	taskDescriptionOSP: 'Customize this task description to design the nature, timing and extent of IT-substantive procedures to obtain sufficient appropriate audit evidence that the IT risks are addressed effectively throughout the period of reliance.<br>When the IT-substantive procedure is performed as of an interim date, design and perform procedures to obtain additional evidence that the IT risks are addressed for the period covered by our interim procedures through period-end.<br>We conclude on the results of our IT-substantive procedures.',
	relateITControlTaskTitle: 'Relate TOCs/OSPs to IT control',
	relateITControlTOCTaskTitle: 'Relate TOCs to ITGC',
	relateITControlOSPTaskTitle: 'Relate OSPs to ITSP',
	unrelatedModalHeader: 'Unrelated TOC/OSP tasks',
	noUnrelatedTaskPlaceholder: 'No unrelated TOC/OSP tasks available',
	noTaskselectedLabel: 'At least one task must be selected for deletion.',
	unrelatedLabel: 'View unrelated TOCs/OSPs',
	understandITProcesses: 'Understand IT processes',
	unrelatedTasksMustBeAssociated: 'Unrelated tasks must be associated to an IT control or deleted.'
}

export const generalLabelsForMobile = {
	noRecordsFound: 'No results found within this task category',
	taskListTitle: 'My tasks',
	taskEvidenceTitle: 'Evidence',
	cameraPagesTitle: 'Pages',
	cameraTitle: 'Camera',
	taskDetailsTitle: 'Task details',
	invalidPage: 'No Page Found',
	combinedTaskLabel: 'PIC/EQR',
	picTaskLabel: 'PIC',
	eqrTaskLabel: 'EQR',
	pageLabel: 'Page',
	ofLabel: 'of',
	noTasksAvailable: 'No tasks available',
	searchLabel: 'Search...',
	noDescriptionAvailable: 'No description available.',
	knowledge: 'Knowledge',
	description: 'Description',
	knowledgeDescription: 'Knowledge description',
	customized: 'Customized',
	taskDetailsTitle: 'Task details',
	unassigned: 'Unassigned',
	assignTo: 'Assigned to',
	signOffLabel: 'Sign-offs',
	evidenceNoteLabel: 'Evidence Notes',
	attributeLabel: 'Attributes',
	addNoteLabel: "New note",
	addCommentLabel: 'Add comment',
	editCommentLabel: 'Update comment',
	addReplyNoteLabel: 'Reply to this note',
	replyNoteLabel: 'Reply',
	replyEditNoteLabel: 'Edit Reply',
	enterReplyPlaceholder: 'Enter reply',
	editNoteLabel: 'Edit',
	deleteNoteLabel: 'Delete',
	reopenNoteLabel: 'Reopen',
	closeNoteLabel: 'Close',
	clearNoteLabel: 'Clear',
	preparerAbbrv: 'P',
	reviewerAbbrv: 'R',
	uploadPhoto: 'Upload photo',
	noEvidenceFound: 'No evidence is associated to the task',
	noRegionComponentFound: 'No documents received from regional or component team',
	noEvidenceMessage: 'Click Upload photo to upload evidences',
	noNotesFound: 'No notes found',
	noNotesStatement: 'Leave a note by using the inputs below. Assign the note to a user and specify the priority and due date.',
	regionComponentEvidence: 'Region and component evidence',
	documentWarning: 'Downloaded document will be read-only. Please dispose of the file when done.',
	preparerTitle: "編製者簽名",
	reviewerTitle: "複核者簽名",
	teamLabel: 'Team',
	saveEvidenceTitle: 'Save evidence',
	saveButton: 'Save',
	cancelButton: 'Cancel',
	confirmButtonLabel: 'Confirm',
	previewButton: 'Preview',
	evidenceLable: 'Name of the evidence',
	mergingTitleLable: 'images merged to PDF.',
	showErrFileExistMsg: 'File name already exists.Please rename the file.',
	showErrForNoImgExist: 'No images available for PDF generation.',
	showErrBlankFileNameMsg: 'File name cannot be blank.',
	showIsCompletedMessage: 'File uploaded successfully.',
	uploadingTitle: 'Processing',
	showErrImgContext: 'useImages must be used within an ImagesProvider',
	PagePreviewTitle: 'Page',
	regionComponentEvidenceLabel: 'Region and component evidence',
	downloadProcessLabel: 'Downloading...',
	downloadCompleteLabel: 'Download Complete',
	taskNotes: 'Task notes',
	documentNotes: 'Document notes',
	dueDateLabel: 'Due date',
	view: 'View:',
	documentNotes: 'Document notes',
	newNote: "Add note",
	editNote: 'Edit note',
	assignedTo: 'Assigned to',
	priority: 'Priority',
	select: 'Select',
	dueDate: 'Due date',
	addNewNote: 'Add a new note',
	addNote: 'Add note',
	updateNote: 'Update note',
	enterDescription: 'Enter a description...',
	allnotes: 'All notes',
	mynotes: 'My notes',
	assignedToMe: 'Assigned to me',
	hashValue: '#',
	showLessToggle: 'Show less',
	showMoreToggle: 'Show more',
	delete: 'Delete',
	deleteNoteModalTitle: "Delete message",
	deleteReplyModalTitle: "Delete reply",
	confirmDeleteNoteLabel: 'Are you sure that you want to delete the selected note?',
	confirmDeleteReplyLabel: 'Are you sure that you want to delete your reply to this note?',
	downloadInfo: 'Downloading a file containing # character is not allowed',
	evidenceFileValidationInfo: 'File Name cannot include */ : <>\?| " characters',
	previewPageTitle: 'Preview',
	redirecting: 'Redirecting to landing page in few seconds...',
	redirectingToTask: 'Redirecting to \'My Tasks\' page in few seconds...',
	errorApplyingConstraints: 'Error applying constraints:',
	zoomIsNotSupported: 'Zoom is not supported on this device.',
	errorCheckingCameraCapability: 'Error checking camera capabilities:',
	previous: 'previous',
	next: 'next',
	after: 'after',
	redirectingToTaskDetails: 'Redirecting to task details in few seconds',
	mobileURL: '/mobile'
};

export const RNHNoteMobileStatusOptions = [{
	value: 1,
	label: 'Open'
},
{
	value: 2,
	label: 'Cleared'
},
{
	value: 3,
	label: 'Closed'
}
];

export const auditPhaseTypes = [{
	value: 1,
	label: 'Scope & Strategy'
},
{
	value: 2,
	label: 'Execution'
},
{
	value: 3,
	label: 'Conclusion'
},
];

export const CreateEditTaskSectionLabels = {
	createModalTitle: "New task group",
	editModalTitle: "Edit task group",
	createModalDescription: "Enter task group details below and select '<b>{0}</b>' to finish. To create another task group, select '<b>{1}</b>'.",
	editModalDescription: "Edit the task group details below and select '<b>{0}</b>' to finish.",
	close: 'Close',
	cancel: 'Cancel',
	save: "儲存",
	saveAndCloseLabel: "儲存並關閉",
	saveAndCreateLabel: "儲存並建立另一個",
	taskSectionNameLabel: "Task group name (required)",
	taskSectionNameErrorMsg: "Required",
	engagementPhaseOptions: auditPhaseTypes,
	engagementPhaseLabel: 'Engagement phase (required)',
	engagementPhaseErrorMsg: "Required",
};

export const auditPhaseLabels = {
	1: 'Scope & strategy',
	2: 'Execution',
	3: 'Conclusion',
	4: 'Perform preliminary engagement activities',
	5: 'Identify and assess risks',
	6: 'Respond to risks',
	7: 'Conclude and report'
};

export const ITApproachType = {
	1: 'ITGC',
	2: 'ITSP'
};

// taskbuildmilestoneid labels
export const taskBuildMilestoneId = [{
	id: 1,
	label: superModalNavigationLabels.identifyAccountsAndDisclosures
},
{
	id: 31,
	label: superModalNavigationLabels.identifyAccountsAndDisclosures
},
{
	id: 5,
	label: superModalNavigationLabels.identifySCOTs
},
{
	id: 32,
	label: superModalNavigationLabels.identifySCOTs
},
{
	id: 6,
	label: superModalNavigationLabels.determineSCOTStrategy
},
{
	id: 7,
	label: superModalNavigationLabels.identifyWCGWAndControls
},
{
	id: 38,
	label: superModalNavigationLabels.identifyWCGWAndControls
},
{
	id: 8,
	label: superModalNavigationLabels.selectControlToTest
},
{
	id: 2,
	label: superModalNavigationLabels.identifyRisks
},
{
	id: 15,
	label: superModalNavigationLabels.relateWCGWsToAssertions
},
{
	id: 30,
	label: superModalNavigationLabels.relateRisksToWCGWs
},
{
	id: 3,
	label: superModalNavigationLabels.determineCRA
},
{
	id: 18,
	label: superModalNavigationLabels.SCOTWT
},
{
	id: 19,
	label: superModalNavigationLabels.controlTOC
},
{
	id: 20,
	label: superModalNavigationLabels.ITProcessUDP
},
{
	id: 21,
	label: superModalNavigationLabels.ITGC_ITSP_TOC_OSP
},
{
	id: 25,
	label: superModalNavigationLabels.accountPSP
},
{
	id: 26,
	label: superModalNavigationLabels.accountOSP,
},
{
	id: 27,
	label: superModalNavigationLabels.respondToSignificant_fraudRisks
},
{
	id: 56,
	label: superModalNavigationLabels.respondToSignificant_fraudRisks
},
{
	id: 29,
	label: superModalNavigationLabels.relatedWCGWToTask
},
{
	id: 39,
	label: superModalNavigationLabels.respondToSignificant_fraudRisks
},
{
	id: 50,
	label: superModalNavigationLabels.OST
}
];

export const noEvidenceReferencedReasons = [{
	id: 1,
	reason: noEvidenceReferencedReasonsLabels.immaterialReason,
	glAccountTypeId: 12,
	strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughMText
},
{
	id: 2,
	reason: noEvidenceReferencedReasonsLabels.waivedReason,
	glAccountTypeId: 13,
	strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughWText
}
];


export const createEditAdjustmentLabels = {
	createModalTitle: 'New adjustment',
	editModalTitle: 'Edit adjustment',
	createModalDescription: `Enter adjustment details below and select '<b>{0}</b>' to finish. To create another adjustment, select '<b>{1}</b>'.`,
	editModalDescription: `Edit adjustment details below and select '<b>{0}</b>' to finish. To delete the adjustment click '<b>{1}</b>'.`,
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	delete: 'Delete',
	adjustmentNameLabel: 'Adjustment index (required)',
	adjustmentDescriptionLabel: 'Adjustment description (required)',
	adjustmentDescriptionPlaceholder: 'Adjustment description (required)',
	required: 'Required',
	editDescriptionModal: "Edit adjustment description",
	descriptionRequired: 'Adjustment description is required',
	uploadDocumentPlaceholder: 'Adjustment must be saved before it can be related to the evidence.',
	generalLedgerAccount: 'GL accounts (required)',
	documentHeader: "Documents (required)",
	addDocumentButton: 'Add evidence',
	glAccountPlaceholder: 'GL account is not available. To add the account click {0}.',
	adjustmentIndex: 'Adjustment index',
	addglaccountbutton: 'Add GL account',
	descriptionMaxLengthError: "Response exceeds maximum allowed.",
	glaccountTotalError: 'Total of debit entries should equal the total of credit entries',
	glaccountIdDuplicate: 'Each GL account should be used only once in the adjustment',
	placeholderText: 'No related documents. To relate a document click <a>Add evidence<a>',
	editAdjustmentDescriptionHeader: 'Edit adjustment description',
	editAdjustmentDescriptionSubHead: 'Edit adjustment description details below and select \'<b>Save</b>\' to finish.'
};

export const addUpdateGlAccountLabels = {
	addGLaccountTitle: 'Add GL account',
	glaccountDescription: `Enter GL account details below and select '<b>{0}</b>' to finish. To add another GL Account, select '<b>{1}</b>'.`,
	addAndClose: 'Add and close',
	addAnother: 'Add another',
	accountSubClassPlaceholder: 'Account sub-class',
	glAccountsPlaceholder: 'Select account sub-class to see available GL accounts.',
	glAccountListHeaderColumn: 'GL Account',
	amountLabel: 'Amount (required)',
	debitCreditOptions: [{
		id: 1,
		label: 'Debit'
	},
	{
		id: 2,
		label: 'Credit'
	}
	],
	searchPlaceholder: 'Search',
	newGlAccount: "New reconciling account",
	noResultsFound: 'No results found',
	noRecordsPlaceholder: "No reconciling accounts found for selected account sub-class. Select a different sub-class or click {0} to add reconciling account to selected account sub-class.",
	editTitleTip: "Edit reconciling account",
	removeTitleTip: "Delete reconciling account",
	custom: "Custom",
	duplicateGLAccount: "Each GL account should be used only once in the adjustment",
	updateModalTitle: "Update reconciling account",
	updateModalDescription: `Update GL account amount and debit/credit details below and select '<b>{0}</b>' to finish.`,
	accountClassLabel: "Account class",
	glAccountLabel: "GL account",
	updateLabel: "Update",
	updateGlAccountModalTitle: "Update GL account",
}

export const deleteGLAccountLabels = {
	deleteConfirmationModallHeader: "Delete reconciling account",
	deleteConfirmationModalBodyHeader: "Are you sure that you want to delete the selected reconciling account? This action cannot be undone.",
	deleteConfirmationModalAccountSubClass: 'Account sub-class:',
	deleteConfirmationModalAccountName: 'Account name:',
	deleteConfirmationModalGLAccountName: "Reconciling account name:",
	closeButtonTitle: 'Cancel',
	confirmBtnTitle: 'Delete'
}

export const glAccountListLabel = {
	accountClass: 'Account class',
	accountSubClass: 'Account sub-class',
	glAccount: 'GL account',
	debit: 'Debit',
	credit: 'Credit',
	actions: 'Actions',
	editTitleTip: 'Edit GL account',
	removeTitleTip: 'Remove GL account'
}

export const EngagementMapLabels = {
	objectivePreviewMessage: 'Hover over a map item to preview',
	noMapAvailableMessage: 'No map available.',
	takeContentUpdateMessage: 'Take a content update to get the latest map.',
	noRecordsLabel: 'No records found.',
	auditTopic: 'Audit topic',
	auditTopicPlaceholder: 'Select topic to view',
	numberSelected: '{0} topics selected',
	refreshMapTitletip: "Click here to initiate the engagement map update",
	mapUpdateInProgress: "Update in progress. It may take up to ten minutes for the update to complete.",
	refreshMapsLabel: "Refresh maps"
}

export const createEditGLAccountLabels = {
	createModalTitle: "New reconciling account",
	editModalTitle: "Edit reconciling account",
	createModalDescription: "Enter reconciling account details below and select '<b>{0}</b>' to finish. To add another reconciling account, select '<b>{1}</b>'.",
	editModalDescription: "Edit reconciling account details below and select '<b>{0}</b>' to finish.",
	accountSubClass: "Account sub-class",
	accountName: "Account name (required)",
	glAccountName: "Reconciling account name (required)",
	cancelbtn: "Cancel",
	saveAndAddbtn: "Save and add another",
	saveAndClosebtn: "Save and close",
	save: 'Save',
	required: 'Required',
}

//Receive instructions switcher
export const receiveInstructionSwitcherLabels = {

	[receiveInstructionSwitcherIds.groupInstructions]: 'Group instructions',
	[receiveInstructionSwitcherIds.groupRiskAssessment]: 'Group risk assessment',
	[receiveInstructionSwitcherIds.documents]: 'Documents'
};

export const misstatementEvidenceLabels = {
	placeholderText: 'No related evidence. At least one supporting evidence must be associated. To relate an evidence click {0}.',
	addEvidenceBtn: 'Add evidence',
};

export const misstatementTempLabels = {
	placeholderText: "No related temporary documents. To relate a temporary document click {0}.",
	addEvidenceBtn: 'Add temporary file',
};

export const inherentRiskFactorTypes = [{
	id: 1,
	label: 'Complexity',
	displayOrder: 1
},
{
	id: 2,
	label: 'Subjectivity Uncertainty',
	displayOrder: 2
},
{
	id: 3,
	label: 'Fraud or error',
	displayOrder: 3
},
{
	id: 4,
	label: 'Change',
	displayOrder: 4
},
{
	id: 5,
	label: 'Nature of account',
	displayOrder: 5
},
{
	id: 6,
	label: 'Related parties',
	displayOrder: 6
}
];

export const helixSettingsStepLabels = {
	title: "Define connection settings",
	subTitle: "Select the settings for your analyzer connection.",
	connectionNameLabel: "Connection name",
	connectionNamePlaceholder: "Connection name (required)",
	connetionTypesLabel: "Connection types",
	connectionTypeScopeAndStrategy: "Scope & Strategy",
	connectionTypeFinancionStatement: "Financial Statements",
	includeAllBusinessUnitsField: "Do you want to include all business units?",
	yes: "Yes",
	no: "No",
	businessUnitsLabel: "Business unit(s)",
	businessUnitsPlaceholder: "Business unit(s)",
	analysisPeriodLabel: "Analysis date",
	analysisPeriodPlaceholder: "Analysis date",
	comparativePeriod1Label: "Comparative date 1",
	comparativePeriod1Placeholder: "Comparative date 1 (optional)",
	comparativePeriod2Label: "Comparative date 2",
	comparativePeriod2Placeholder: "Comparative date 2 (optional)",
	currencyTypeField: "Currency type",
	reporting: "Reporting",
	functional: "Functional",
	currencyCodeField: "Currency code",
	currencyCodePlaceholder: "Currency code (required)",
	scopeAndStrategyLabel: "Scope & strategy",
	financialStatementLabel: "Financial statement",

	required: "Required",
	comparativePeriodError: "Invalid date. Select a date prior to the analysis date.",

	dataConnectionLink: 'How to manage data connections',
	helixfiscalDropDownLabel: "Date {0} - {1}",

	helixError: 'Could not connect to the selected analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	businessUnitsSelectedCount: "{0} selected",
	allBusinessUnitsLabel: "All business units"
};

export const importDataModalLabels = ({
	title,
	description,
	buttonLabel
}) => {
	return {
		title: title,
		description: description,
		entity: "Entity",
		trialBalanceName: "Trial balance name",
		reporting: "Reporting",
		functional: "Functional",
		analysisPeriod: "Analysis date",
		comparativePeriod: "Comparative date",
		secondComparativePeriod: "Second comparative date (optional)",
		includeFinancialStatements: "Include financial statements",
		carryForwardReferencesAndAdjustments: "Carry forward references and adjustments to the new import?",
		import: buttonLabel,
		businessUnitSelectedCount: "{0} business unit",
		businessUnitsSelectedCount: "{0} business units",
		allBusinessUnitsLabel: "All business units",
		businessUnitsPlaceholder: "Business unit(s)",
		required: "Required",
		comparativePeriodError: "Invalid date. Select a date prior to the analysis date.",
		secondComparativePeriodError: "Second comparative date greater or equal than comparative date.",
		equalComparativePeriodError: "Dates cannot be the same.",
		analysisDateMustBeLaterError: 'Analysis date must be later than both comparative dates.'
	};
};

export const AnalyzerHelixErrors = {
	400: "The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	403: "You are not an authorized team member of the connected analyzer. Contact the EY Helix project administrator to get access.",
	405: "Analytics are not available in the linked connection. Go to EY Helix and complete the data & analytics processing steps to continue.",
	406: "The EY Helix analyzer for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	408: "The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	411: "The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details.",
	430: "The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	800: "It looks like you have not accessed EY Helix before. Go to EY Helix, log in, and follow the instructions to set up your account.",
	801: "You are not an authorized team member of the linked project. Contact the EY Helix project administrator to get access.",
	901: "The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently delete the connection, click 'Delete' below in the more menu. Please consider if another analyzer should be connected.",
	902: "The EY Helix project for the selected connection is marked for deletion. Contact an EY Helix administrator for more details. To permanently delete the connection, click 'Delete' below in the more menu. Please consider if another analyzer should be connected.",
	903: "The EY Helix project for the selected connection is marked for storage. Contact an EY Helix administrator for more details. To permanently delete the connection, click 'Delete' below in the more menu. Please consider if another analyzer should be connected.",
	926: "The selected analyzer is not available in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.",
	927: "Analytics are not available in the linked project. Go to EY Helix and complete the data & analytics processing steps to continue.",
	928: "Invalid or missing analyzer in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.",
	929: "An error occurred related to the linked EY Helix project. Data cannot be imported."
};

export const validationLabels = {
	viewAdjustmentWithValidations: "View adjustments with validations {0}",
	validationTypeAmtMissmatch: "Sum of the debit entries does not equal the sum of the credit entries",
	validationTypeNoEvidence: "No related evidence"
};

export const canavsImportErrors = {
	400: "Import failed. The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	403: "Import failed. You are not an authorized team member of the connected analyzer. Contact the EY Helix project administrator to get access then refresh the page and try again. If the issue persists, contact the Help Desk.",
	405: "Import failed. Analytics are not available in the linked connection. Go to EY Helix and complete the data & analytics processing steps to continue. Then refresh the page and try again. If the issue persists, contact the Help Desk.",
	406: "Import failed. The EY Helix analyzer for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	408: "Import failed. The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	411: "Import failed. The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details and then refresh the page and try again. If the issue persists, contact the Help Desk.",
	430: "Import failed. The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	113082: "Analysis period must not be empty."
};
